/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { ActionItemResponse } from '../models/actionItemResponse';

import type { AgendaItemResponse } from '../models/agendaItemResponse';

import type { AgendaTemplateListResponse } from '../models/agendaTemplateListResponse';

import type { AgendaTemplateResponse } from '../models/agendaTemplateResponse';

import type { BadgeResponse } from '../models/badgeResponse';

import type { BodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost } from '../models/bodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost';

import type { BodyPreviewImportApiV1PeopleEmployeesImportPreviewPost } from '../models/bodyPreviewImportApiV1PeopleEmployeesImportPreviewPost';

import type { CancelOffboardingResponse } from '../models/cancelOffboardingResponse';

import type { ClockedInResponse } from '../models/clockedInResponse';

import type { CompensationCreate } from '../models/compensationCreate';

import type { CompensationResponse } from '../models/compensationResponse';

import type { CompensationUpdate } from '../models/compensationUpdate';

import type { Competency } from '../models/competency';

import type { CompetencyCreate } from '../models/competencyCreate';

import type { CompetencyListResponse } from '../models/competencyListResponse';

import type { CompetencyUpdate } from '../models/competencyUpdate';

import type { ContactResponse } from '../models/contactResponse';

import type { CycleProgressResponse } from '../models/cycleProgressResponse';

import type { EmployeeContactCreate } from '../models/employeeContactCreate';

import type { EmployeeContactUpdate } from '../models/employeeContactUpdate';

import type { EmployeeCreateRequest } from '../models/employeeCreateRequest';

import type { EmployeeListResponse } from '../models/employeeListResponse';

import type { EmployeeRelatedCounts } from '../models/employeeRelatedCounts';

import type { EmployeeResponse } from '../models/employeeResponse';

import type { EmployeeTerminate } from '../models/employeeTerminate';

import type { EmployeeUpdate } from '../models/employeeUpdate';

import type { EnsureDefaultTemplateRequest } from '../models/ensureDefaultTemplateRequest';

import type { ExpiringSkillListResponse } from '../models/expiringSkillListResponse';

import type { ExportAdHocReportApiV1PeopleReportsExportPostParams } from '../models/exportAdHocReportApiV1PeopleReportsExportPostParams';

import type { ExportSavedReportApiV1PeopleReportsReportIdExportGetParams } from '../models/exportSavedReportApiV1PeopleReportsReportIdExportGetParams';

import type { ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetParams } from '../models/exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetParams';

import type { Feedback } from '../models/feedback';

import type { FeedbackCreate } from '../models/feedbackCreate';

import type { FeedbackListResponse } from '../models/feedbackListResponse';

import type { FeedbackRequest } from '../models/feedbackRequest';

import type { FeedbackRequestCreate } from '../models/feedbackRequestCreate';

import type { FeedbackRequestListResponse } from '../models/feedbackRequestListResponse';

import type { FeedbackUpdate } from '../models/feedbackUpdate';

import type { GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetParams } from '../models/getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetParams';

import type { GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetParams } from '../models/getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetParams';

import type { GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetParams } from '../models/getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetParams';

import type { GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetParams } from '../models/getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetParams';

import type { GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetParams } from '../models/getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetParams';

import type { GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetParams } from '../models/getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetParams';

import type { GetLeaveCalendarApiV1PeopleLeaveCalendarGetParams } from '../models/getLeaveCalendarApiV1PeopleLeaveCalendarGetParams';

import type { GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetParams } from '../models/getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetParams';

import type { GetOrgChartApiV1PeopleOrgChartGetParams } from '../models/getOrgChartApiV1PeopleOrgChartGetParams';

import type { GetPendingReviewsApiV1PeopleReviewsPendingGetParams } from '../models/getPendingReviewsApiV1PeopleReviewsPendingGetParams';

import type { GetPeopleDashboardApiV1PeopleDashboardGetParams } from '../models/getPeopleDashboardApiV1PeopleDashboardGetParams';

import type { GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetParams } from '../models/getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetParams';

import type { GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetParams } from '../models/getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetParams';

import type { GetTimesheetApiV1PeopleTimeTimesheetGetParams } from '../models/getTimesheetApiV1PeopleTimeTimesheetGetParams';

import type { GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetParams } from '../models/getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetParams';

import type { GoalCheckInCreate } from '../models/goalCheckInCreate';

import type { GoalCheckInListResponse } from '../models/goalCheckInListResponse';

import type { GoalCheckInResponse } from '../models/goalCheckInResponse';

import type { GoalCreate } from '../models/goalCreate';

import type { GoalKeyResultCreate } from '../models/goalKeyResultCreate';

import type { GoalKeyResultListResponse } from '../models/goalKeyResultListResponse';

import type { GoalKeyResultResponse } from '../models/goalKeyResultResponse';

import type { GoalKeyResultUpdate } from '../models/goalKeyResultUpdate';

import type { GoalLevelCreate } from '../models/goalLevelCreate';

import type { GoalLevelListResponse } from '../models/goalLevelListResponse';

import type { GoalLevelResponse } from '../models/goalLevelResponse';

import type { GoalLevelUpdate } from '../models/goalLevelUpdate';

import type { GoalListResponse } from '../models/goalListResponse';

import type { GoalResponse } from '../models/goalResponse';

import type { GoalTreeNode } from '../models/goalTreeNode';

import type { GoalUpdate } from '../models/goalUpdate';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { HolidayEntryCreate } from '../models/holidayEntryCreate';

import type { HolidayEntryResponse } from '../models/holidayEntryResponse';

import type { HolidayEntryUpdate } from '../models/holidayEntryUpdate';

import type { HolidaySeedCountry } from '../models/holidaySeedCountry';

import type { HolidaySeedRequest } from '../models/holidaySeedRequest';

import type { HolidaySeedResponse } from '../models/holidaySeedResponse';

import type { ImportPreviewResponse } from '../models/importPreviewResponse';

import type { ImportRequest } from '../models/importRequest';

import type { ImportResponse } from '../models/importResponse';

import type { ImportResultResponse } from '../models/importResultResponse';

import type { IngestPunchRequest } from '../models/ingestPunchRequest';

import type { JobAssignmentCreate } from '../models/jobAssignmentCreate';

import type { JobAssignmentUpdate } from '../models/jobAssignmentUpdate';

import type { JobResponse } from '../models/jobResponse';

import type { JobTitleCreate } from '../models/jobTitleCreate';

import type { JobTitleListResponse } from '../models/jobTitleListResponse';

import type { JobTitleResponse } from '../models/jobTitleResponse';

import type { JobTitleUpdate } from '../models/jobTitleUpdate';

import type { KioskCreate } from '../models/kioskCreate';

import type { KioskListResponse } from '../models/kioskListResponse';

import type { KioskResponse } from '../models/kioskResponse';

import type { KioskTokenResponse } from '../models/kioskTokenResponse';

import type { KioskUpdate } from '../models/kioskUpdate';

import type { LeaveBalanceAdjust } from '../models/leaveBalanceAdjust';

import type { LeaveBalanceLedgerResponse } from '../models/leaveBalanceLedgerResponse';

import type { LeaveBalanceResponse } from '../models/leaveBalanceResponse';

import type { LeaveBlackoutCreate } from '../models/leaveBlackoutCreate';

import type { LeaveBlackoutListResponse } from '../models/leaveBlackoutListResponse';

import type { LeaveBlackoutResponse } from '../models/leaveBlackoutResponse';

import type { LeaveBlackoutUpdate } from '../models/leaveBlackoutUpdate';

import type { LeavePolicyAssignmentCreate } from '../models/leavePolicyAssignmentCreate';

import type { LeavePolicyAssignmentListResponse } from '../models/leavePolicyAssignmentListResponse';

import type { LeavePolicyAssignmentResponse } from '../models/leavePolicyAssignmentResponse';

import type { LeavePolicyAssignmentUpdate } from '../models/leavePolicyAssignmentUpdate';

import type { LeavePolicyCreate } from '../models/leavePolicyCreate';

import type { LeavePolicyListResponse } from '../models/leavePolicyListResponse';

import type { LeavePolicyResponse } from '../models/leavePolicyResponse';

import type { LeavePolicyUpdate } from '../models/leavePolicyUpdate';

import type { LeaveRequestCreate } from '../models/leaveRequestCreate';

import type { LeaveRequestListResponse } from '../models/leaveRequestListResponse';

import type { LeaveRequestPreviewResponse } from '../models/leaveRequestPreviewResponse';

import type { LeaveRequestResponse } from '../models/leaveRequestResponse';

import type { LeaveRequestReview } from '../models/leaveRequestReview';

import type { ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetParams } from '../models/listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetParams';

import type { ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetParams } from '../models/listApprovalPoliciesApiV1PeopleApprovalPoliciesGetParams';

import type { ListApprovalRequestsApiV1PeopleApprovalRequestsGetParams } from '../models/listApprovalRequestsApiV1PeopleApprovalRequestsGetParams';

import type { ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetParams } from '../models/listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetParams';

import type { ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetParams } from '../models/listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetParams';

import type { ListCompetenciesApiV1PeopleCompetenciesGetParams } from '../models/listCompetenciesApiV1PeopleCompetenciesGetParams';

import type { ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetParams } from '../models/listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetParams';

import type { ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetParams } from '../models/listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetParams';

import type { ListEmployeesApiV1PeopleEmployeesGetParams } from '../models/listEmployeesApiV1PeopleEmployeesGetParams';

import type { ListExpiringSkillsApiV1PeopleSkillsExpiringGetParams } from '../models/listExpiringSkillsApiV1PeopleSkillsExpiringGetParams';

import type { ListFeedbackApiV1PeopleFeedbackGetParams } from '../models/listFeedbackApiV1PeopleFeedbackGetParams';

import type { ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetParams } from '../models/listFeedbackRequestsApiV1PeopleFeedbackRequestsGetParams';

import type { ListGoalLevelsApiV1PeopleGoalLevelsGetParams } from '../models/listGoalLevelsApiV1PeopleGoalLevelsGetParams';

import type { ListGoalsApiV1PeopleGoalsGetParams } from '../models/listGoalsApiV1PeopleGoalsGetParams';

import type { ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetParams } from '../models/listHolidayCalendarsApiV1PeopleHolidayCalendarsGetParams';

import type { ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetParams } from '../models/listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetParams';

import type { ListJobTitlesApiV1PeopleJobTitlesGetParams } from '../models/listJobTitlesApiV1PeopleJobTitlesGetParams';

import type { ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetParams } from '../models/listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetParams';

import type { ListLeavePoliciesApiV1PeopleLeavePoliciesGetParams } from '../models/listLeavePoliciesApiV1PeopleLeavePoliciesGetParams';

import type { ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetParams } from '../models/listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetParams';

import type { ListLeaveRequestsApiV1PeopleLeaveRequestsGetParams } from '../models/listLeaveRequestsApiV1PeopleLeaveRequestsGetParams';

import type { ListMySurveysApiV1PeopleMeSurveysGetParams } from '../models/listMySurveysApiV1PeopleMeSurveysGetParams';

import type { ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetParams } from '../models/listMyTeamGoalsApiV1PeopleGoalsMyTeamGetParams';

import type { ListOneOnOnesApiV1PeopleOneOnOnesGetParams } from '../models/listOneOnOnesApiV1PeopleOneOnOnesGetParams';

import type { ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetParams } from '../models/listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetParams';

import type { ListPremiumRulesApiV1PeopleTimePremiumRulesGetParams } from '../models/listPremiumRulesApiV1PeopleTimePremiumRulesGetParams';

import type { ListRatingScalesApiV1PeopleRatingScalesGetParams } from '../models/listRatingScalesApiV1PeopleRatingScalesGetParams';

import type { ListRecognitionApiV1PeopleRecognitionGetParams } from '../models/listRecognitionApiV1PeopleRecognitionGetParams';

import type { ListReportSchedulesApiV1PeopleReportsSchedulesGetParams } from '../models/listReportSchedulesApiV1PeopleReportsSchedulesGetParams';

import type { ListReportsApiV1PeopleReportsGetParams } from '../models/listReportsApiV1PeopleReportsGetParams';

import type { ListReviewCyclesApiV1PeopleReviewCyclesGetParams } from '../models/listReviewCyclesApiV1PeopleReviewCyclesGetParams';

import type { ListReviewTemplatesApiV1PeopleReviewTemplatesGetParams } from '../models/listReviewTemplatesApiV1PeopleReviewTemplatesGetParams';

import type { ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetParams } from '../models/listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetParams';

import type { ListStandardReportsApiV1PeopleReportsStandardGetParams } from '../models/listStandardReportsApiV1PeopleReportsStandardGetParams';

import type { ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetParams } from '../models/listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetParams';

import type { ListSurveysApiV1PeopleSurveysGetParams } from '../models/listSurveysApiV1PeopleSurveysGetParams';

import type { ListTemplatesApiV1PeopleOnboardingTemplatesGetParams } from '../models/listTemplatesApiV1PeopleOnboardingTemplatesGetParams';

import type { ListTimeEntriesApiV1PeopleTimeEntriesGetParams } from '../models/listTimeEntriesApiV1PeopleTimeEntriesGetParams';

import type { MyActiveEntryApiV1PeopleTimeMeActiveGet200 } from '../models/myActiveEntryApiV1PeopleTimeMeActiveGet200';

import type { MyEntriesApiV1PeopleTimeMeEntriesGetParams } from '../models/myEntriesApiV1PeopleTimeMeEntriesGetParams';

import type { MyTeamResponse } from '../models/myTeamResponse';

import type { MyTeamReviewStatus } from '../models/myTeamReviewStatus';

import type { NoteResponse } from '../models/noteResponse';

import type { OnboardingInstanceListResponse } from '../models/onboardingInstanceListResponse';

import type { OnboardingTaskResponse } from '../models/onboardingTaskResponse';

import type { OnboardingTaskUpdate } from '../models/onboardingTaskUpdate';

import type { OnboardingTemplateCreate } from '../models/onboardingTemplateCreate';

import type { OnboardingTemplateUpdate } from '../models/onboardingTemplateUpdate';

import type { OneOnOneActionItemCreate } from '../models/oneOnOneActionItemCreate';

import type { OneOnOneActionItemUpdate } from '../models/oneOnOneActionItemUpdate';

import type { OneOnOneAgendaItemCreate } from '../models/oneOnOneAgendaItemCreate';

import type { OneOnOneAgendaItemUpdate } from '../models/oneOnOneAgendaItemUpdate';

import type { OneOnOneAgendaTemplateCreate } from '../models/oneOnOneAgendaTemplateCreate';

import type { OneOnOneAgendaTemplateUpdate } from '../models/oneOnOneAgendaTemplateUpdate';

import type { OneOnOneCreate } from '../models/oneOnOneCreate';

import type { OneOnOneDetailResponse } from '../models/oneOnOneDetailResponse';

import type { OneOnOneListResponse } from '../models/oneOnOneListResponse';

import type { OneOnOneNoteCreate } from '../models/oneOnOneNoteCreate';

import type { OneOnOneNoteUpdate } from '../models/oneOnOneNoteUpdate';

import type { OneOnOneReschedule } from '../models/oneOnOneReschedule';

import type { OneOnOneResponse } from '../models/oneOnOneResponse';

import type { OneOnOneUpdate } from '../models/oneOnOneUpdate';

import type { OrgNode } from '../models/orgNode';

import type { OutstandingDocumentListResponse } from '../models/outstandingDocumentListResponse';

import type { PeopleApprovalPolicyCreate } from '../models/peopleApprovalPolicyCreate';

import type { PeopleApprovalPolicyListResponse } from '../models/peopleApprovalPolicyListResponse';

import type { PeopleApprovalPolicyResponse } from '../models/peopleApprovalPolicyResponse';

import type { PeopleApprovalPolicyUpdate } from '../models/peopleApprovalPolicyUpdate';

import type { PeopleApprovalRequestDecision } from '../models/peopleApprovalRequestDecision';

import type { PeopleApprovalRequestListResponse } from '../models/peopleApprovalRequestListResponse';

import type { PeopleApprovalRequestResponse } from '../models/peopleApprovalRequestResponse';

import type { PeopleDashboard } from '../models/peopleDashboard';

import type { PeopleHeadcountTrend } from '../models/peopleHeadcountTrend';

import type { PeopleHolidayCalendarCreate } from '../models/peopleHolidayCalendarCreate';

import type { PeopleHolidayCalendarListResponse } from '../models/peopleHolidayCalendarListResponse';

import type { PeopleHolidayCalendarOverlayResponse } from '../models/peopleHolidayCalendarOverlayResponse';

import type { PeopleHolidayCalendarResponse } from '../models/peopleHolidayCalendarResponse';

import type { PeopleHolidayCalendarUpdate } from '../models/peopleHolidayCalendarUpdate';

import type { PeopleReportCatalogResponse } from '../models/peopleReportCatalogResponse';

import type { PeopleReportDefinition } from '../models/peopleReportDefinition';

import type { PeopleReportDefinitionCreate } from '../models/peopleReportDefinitionCreate';

import type { PeopleReportDefinitionListResponse } from '../models/peopleReportDefinitionListResponse';

import type { PeopleReportDefinitionUpdate } from '../models/peopleReportDefinitionUpdate';

import type { PeopleReportResultResponse } from '../models/peopleReportResultResponse';

import type { PeopleReportRunRequest } from '../models/peopleReportRunRequest';

import type { PeopleReportSchedule } from '../models/peopleReportSchedule';

import type { PeopleReportScheduleCreate } from '../models/peopleReportScheduleCreate';

import type { PeopleReportScheduleDeliveryListResponse } from '../models/peopleReportScheduleDeliveryListResponse';

import type { PeopleReportScheduleListResponse } from '../models/peopleReportScheduleListResponse';

import type { PeopleReportScheduleUpdate } from '../models/peopleReportScheduleUpdate';

import type { PeopleStandardReportLibraryResponse } from '../models/peopleStandardReportLibraryResponse';

import type { PeopleTurnoverAnalytics } from '../models/peopleTurnoverAnalytics';

import type { PremiumRuleCreate } from '../models/premiumRuleCreate';

import type { PremiumRuleListResponse } from '../models/premiumRuleListResponse';

import type { PremiumRuleResponse } from '../models/premiumRuleResponse';

import type { PremiumRuleUpdate } from '../models/premiumRuleUpdate';

import type { PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetParams } from '../models/previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetParams';

import type { PunchResponse } from '../models/punchResponse';

import type { RatingScale } from '../models/ratingScale';

import type { RatingScaleCreate } from '../models/ratingScaleCreate';

import type { RatingScaleListResponse } from '../models/ratingScaleListResponse';

import type { RatingScaleUpdate } from '../models/ratingScaleUpdate';

import type { Recognition } from '../models/recognition';

import type { RecognitionCreate } from '../models/recognitionCreate';

import type { RecognitionListResponse } from '../models/recognitionListResponse';

import type { RecognitionReactionListResponse } from '../models/recognitionReactionListResponse';

import type { RecognitionReactionToggle } from '../models/recognitionReactionToggle';

import type { ReviewAnonymityGroup } from '../models/reviewAnonymityGroup';

import type { ReviewCalibration } from '../models/reviewCalibration';

import type { ReviewCalibrationAdjustRequest } from '../models/reviewCalibrationAdjustRequest';

import type { ReviewCalibrationApplyResult } from '../models/reviewCalibrationApplyResult';

import type { ReviewCalibrationCreate } from '../models/reviewCalibrationCreate';

import type { ReviewCalibrationEntry } from '../models/reviewCalibrationEntry';

import type { ReviewCalibrationEntryListResponse } from '../models/reviewCalibrationEntryListResponse';

import type { ReviewCalibrationGrid } from '../models/reviewCalibrationGrid';

import type { ReviewCalibrationListResponse } from '../models/reviewCalibrationListResponse';

import type { ReviewCalibrationUpdate } from '../models/reviewCalibrationUpdate';

import type { ReviewCycleCreate } from '../models/reviewCycleCreate';

import type { ReviewCycleExtendRequest } from '../models/reviewCycleExtendRequest';

import type { ReviewCycleLaunchReport } from '../models/reviewCycleLaunchReport';

import type { ReviewCycleListResponse } from '../models/reviewCycleListResponse';

import type { ReviewCycleOpenPhaseResult } from '../models/reviewCycleOpenPhaseResult';

import type { ReviewCyclePreview } from '../models/reviewCyclePreview';

import type { ReviewCycleRemindResult } from '../models/reviewCycleRemindResult';

import type { ReviewCycleResponse } from '../models/reviewCycleResponse';

import type { ReviewCycleTemplateAnonymityRequest } from '../models/reviewCycleTemplateAnonymityRequest';

import type { ReviewCycleTemplateBindRequest } from '../models/reviewCycleTemplateBindRequest';

import type { ReviewCycleTemplateResponse } from '../models/reviewCycleTemplateResponse';

import type { ReviewCycleUpdate } from '../models/reviewCycleUpdate';

import type { ReviewFormResponse } from '../models/reviewFormResponse';

import type { ReviewListResponse } from '../models/reviewListResponse';

import type { ReviewParticipantListResponse } from '../models/reviewParticipantListResponse';

import type { ReviewPeerAnswers } from '../models/reviewPeerAnswers';

import type { ReviewQuestion } from '../models/reviewQuestion';

import type { ReviewQuestionCreate } from '../models/reviewQuestionCreate';

import type { ReviewQuestionUpdate } from '../models/reviewQuestionUpdate';

import type { ReviewRaterNominationRequest } from '../models/reviewRaterNominationRequest';

import type { ReviewRaterResponse } from '../models/reviewRaterResponse';

import type { ReviewReassignRequest } from '../models/reviewReassignRequest';

import type { ReviewReorderRequest } from '../models/reviewReorderRequest';

import type { ReviewResponse } from '../models/reviewResponse';

import type { ReviewResponsesUpdate } from '../models/reviewResponsesUpdate';

import type { ReviewSection } from '../models/reviewSection';

import type { ReviewSectionCreate } from '../models/reviewSectionCreate';

import type { ReviewSectionUpdate } from '../models/reviewSectionUpdate';

import type { ReviewTemplate } from '../models/reviewTemplate';

import type { ReviewTemplateCloneRequest } from '../models/reviewTemplateCloneRequest';

import type { ReviewTemplateCreate } from '../models/reviewTemplateCreate';

import type { ReviewTemplateListResponse } from '../models/reviewTemplateListResponse';

import type { ReviewTemplateUpdate } from '../models/reviewTemplateUpdate';

import type { ReviewUpdate } from '../models/reviewUpdate';

import type { RunAdHocReportApiV1PeopleReportsRunPostParams } from '../models/runAdHocReportApiV1PeopleReportsRunPostParams';

import type { RunSavedReportApiV1PeopleReportsReportIdRunGetParams } from '../models/runSavedReportApiV1PeopleReportsReportIdRunGetParams';

import type { RunStandardReportApiV1PeopleReportsStandardKeyRunGetParams } from '../models/runStandardReportApiV1PeopleReportsStandardKeyRunGetParams';

import type { SetPinRequest } from '../models/setPinRequest';

import type { SkillCreate } from '../models/skillCreate';

import type { SkillListResponse } from '../models/skillListResponse';

import type { SkillResponse } from '../models/skillResponse';

import type { SkillSummaryResponse } from '../models/skillSummaryResponse';

import type { SkillUpdate } from '../models/skillUpdate';

import type { StartOffboardingRequest } from '../models/startOffboardingRequest';

import type { StartOnboardingRequest } from '../models/startOnboardingRequest';

import type { SurveyActionCreate } from '../models/surveyActionCreate';

import type { SurveyActionListResponse } from '../models/surveyActionListResponse';

import type { SurveyActionResponse } from '../models/surveyActionResponse';

import type { SurveyBreakdown } from '../models/surveyBreakdown';

import type { SurveyCreate } from '../models/surveyCreate';

import type { SurveyInvitationListResponse } from '../models/surveyInvitationListResponse';

import type { SurveyLaunch } from '../models/surveyLaunch';

import type { SurveyListResponse } from '../models/surveyListResponse';

import type { SurveyParticipantListResponse } from '../models/surveyParticipantListResponse';

import type { SurveyQuestionCreate } from '../models/surveyQuestionCreate';

import type { SurveyQuestionResponse } from '../models/surveyQuestionResponse';

import type { SurveyQuestionUpdate } from '../models/surveyQuestionUpdate';

import type { SurveyQuestionnaire } from '../models/surveyQuestionnaire';

import type { SurveyResponseModel } from '../models/surveyResponseModel';

import type { SurveyResponseSubmit } from '../models/surveyResponseSubmit';

import type { SurveyResults } from '../models/surveyResults';

import type { SurveyTrend } from '../models/surveyTrend';

import type { SurveyUpdate } from '../models/surveyUpdate';

import type { SurveyWaveListResponse } from '../models/surveyWaveListResponse';

import type { SurveyWaveResponse } from '../models/surveyWaveResponse';

import type { TemplateListResponse } from '../models/templateListResponse';

import type { TemplateResponse } from '../models/templateResponse';

import type { TerminationResponse } from '../models/terminationResponse';

import type { TimeEntryCreate } from '../models/timeEntryCreate';

import type { TimeEntryListResponse } from '../models/timeEntryListResponse';

import type { TimeEntryResponse } from '../models/timeEntryResponse';

import type { TimeEntryUpdate } from '../models/timeEntryUpdate';

import type { TimesheetResponse } from '../models/timesheetResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * People dashboard KPIs: headcount counts, headcount-by-department, and the
upcoming approved-time-off feed.

Served through the shared KPI substrate (schema-first ``response_model`` +
``cached_kpi``); see docs/platform/dashboard-kpi-endpoints.md. The two governed-type
seams (``people.employee`` / ``people.leave_request``, both bounded SETs) and the
active-company scope are resolved HERE, outside ``cached_kpi``, per the ordering
invariant — resolving the employee scope per request is what writes the bounded
``admin_override_read`` audit row for a Full-Access admin's universal read (a cache
hit must not skip it) and what 403s a forged ``X-Active-Company-Id``. In a
restricted visibility mode every aggregate is scoped and the payload is per-viewer;
in everyone mode / for tenant admins the sets are None and the numbers are
byte-identical to today.
 * @summary Get People Dashboard
 */
export const getPeopleDashboardApiV1PeopleDashboardGet = (
  params?: GetPeopleDashboardApiV1PeopleDashboardGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleDashboard>({
    url: `/api/v1/people/dashboard`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetPeopleDashboardApiV1PeopleDashboardGetQueryKey = (
  params?: GetPeopleDashboardApiV1PeopleDashboardGetParams
) => {
  return [`/api/v1/people/dashboard`, ...(params ? [params] : [])] as const;
};

export const getGetPeopleDashboardApiV1PeopleDashboardGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetPeopleDashboardApiV1PeopleDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPeopleDashboardApiV1PeopleDashboardGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>
  > = ({ signal }) => getPeopleDashboardApiV1PeopleDashboardGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPeopleDashboardApiV1PeopleDashboardGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>
>;
export type GetPeopleDashboardApiV1PeopleDashboardGetQueryError =
  HTTPValidationError;

export function useGetPeopleDashboardApiV1PeopleDashboardGet<
  TData = Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
  TError = HTTPValidationError
>(
  params: undefined | GetPeopleDashboardApiV1PeopleDashboardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
          TError,
          Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPeopleDashboardApiV1PeopleDashboardGet<
  TData = Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetPeopleDashboardApiV1PeopleDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
          TError,
          Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPeopleDashboardApiV1PeopleDashboardGet<
  TData = Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetPeopleDashboardApiV1PeopleDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get People Dashboard
 */

export function useGetPeopleDashboardApiV1PeopleDashboardGet<
  TData = Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
  TError = HTTPValidationError
>(
  params?: GetPeopleDashboardApiV1PeopleDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPeopleDashboardApiV1PeopleDashboardGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPeopleDashboardApiV1PeopleDashboardGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all job titles with optional filters.
 * @summary List Job Titles
 */
export const listJobTitlesApiV1PeopleJobTitlesGet = (
  params?: ListJobTitlesApiV1PeopleJobTitlesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<JobTitleListResponse>({
    url: `/api/v1/people/job-titles`,
    method: 'GET',
    params,
    signal
  });
};

export const getListJobTitlesApiV1PeopleJobTitlesGetQueryKey = (
  params?: ListJobTitlesApiV1PeopleJobTitlesGetParams
) => {
  return [`/api/v1/people/job-titles`, ...(params ? [params] : [])] as const;
};

export const getListJobTitlesApiV1PeopleJobTitlesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
  TError = HTTPValidationError
>(
  params?: ListJobTitlesApiV1PeopleJobTitlesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListJobTitlesApiV1PeopleJobTitlesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>
  > = ({ signal }) => listJobTitlesApiV1PeopleJobTitlesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListJobTitlesApiV1PeopleJobTitlesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>
>;
export type ListJobTitlesApiV1PeopleJobTitlesGetQueryError =
  HTTPValidationError;

export function useListJobTitlesApiV1PeopleJobTitlesGet<
  TData = Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListJobTitlesApiV1PeopleJobTitlesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
          TError,
          Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListJobTitlesApiV1PeopleJobTitlesGet<
  TData = Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
  TError = HTTPValidationError
>(
  params?: ListJobTitlesApiV1PeopleJobTitlesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
          TError,
          Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListJobTitlesApiV1PeopleJobTitlesGet<
  TData = Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
  TError = HTTPValidationError
>(
  params?: ListJobTitlesApiV1PeopleJobTitlesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Job Titles
 */

export function useListJobTitlesApiV1PeopleJobTitlesGet<
  TData = Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
  TError = HTTPValidationError
>(
  params?: ListJobTitlesApiV1PeopleJobTitlesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobTitlesApiV1PeopleJobTitlesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListJobTitlesApiV1PeopleJobTitlesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new job title.
 * @summary Create Job Title
 */
export const createJobTitleApiV1PeopleJobTitlesPost = (
  jobTitleCreate: JobTitleCreate,
  signal?: AbortSignal
) => {
  return customInstance<JobTitleResponse>({
    url: `/api/v1/people/job-titles`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: jobTitleCreate,
    signal
  });
};

export const getCreateJobTitleApiV1PeopleJobTitlesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createJobTitleApiV1PeopleJobTitlesPost>>,
    TError,
    { data: JobTitleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createJobTitleApiV1PeopleJobTitlesPost>>,
  TError,
  { data: JobTitleCreate },
  TContext
> => {
  const mutationKey = ['createJobTitleApiV1PeopleJobTitlesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createJobTitleApiV1PeopleJobTitlesPost>>,
    { data: JobTitleCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createJobTitleApiV1PeopleJobTitlesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateJobTitleApiV1PeopleJobTitlesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createJobTitleApiV1PeopleJobTitlesPost>>
>;
export type CreateJobTitleApiV1PeopleJobTitlesPostMutationBody = JobTitleCreate;
export type CreateJobTitleApiV1PeopleJobTitlesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Job Title
 */
export const useCreateJobTitleApiV1PeopleJobTitlesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createJobTitleApiV1PeopleJobTitlesPost>>,
      TError,
      { data: JobTitleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createJobTitleApiV1PeopleJobTitlesPost>>,
  TError,
  { data: JobTitleCreate },
  TContext
> => {
  const mutationOptions =
    getCreateJobTitleApiV1PeopleJobTitlesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a job title by ID.
 * @summary Get Job Title
 */
export const getJobTitleApiV1PeopleJobTitlesJobTitleIdGet = (
  jobTitleId: string,
  signal?: AbortSignal
) => {
  return customInstance<JobTitleResponse>({
    url: `/api/v1/people/job-titles/${jobTitleId}`,
    method: 'GET',
    signal
  });
};

export const getGetJobTitleApiV1PeopleJobTitlesJobTitleIdGetQueryKey = (
  jobTitleId?: string
) => {
  return [`/api/v1/people/job-titles/${jobTitleId}`] as const;
};

export const getGetJobTitleApiV1PeopleJobTitlesJobTitleIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
  >,
  TError = HTTPValidationError
>(
  jobTitleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetJobTitleApiV1PeopleJobTitlesJobTitleIdGetQueryKey(jobTitleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>>
  > = ({ signal }) =>
    getJobTitleApiV1PeopleJobTitlesJobTitleIdGet(jobTitleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobTitleId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetJobTitleApiV1PeopleJobTitlesJobTitleIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>>
  >;
export type GetJobTitleApiV1PeopleJobTitlesJobTitleIdGetQueryError =
  HTTPValidationError;

export function useGetJobTitleApiV1PeopleJobTitlesJobTitleIdGet<
  TData = Awaited<
    ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
  >,
  TError = HTTPValidationError
>(
  jobTitleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobTitleApiV1PeopleJobTitlesJobTitleIdGet<
  TData = Awaited<
    ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
  >,
  TError = HTTPValidationError
>(
  jobTitleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobTitleApiV1PeopleJobTitlesJobTitleIdGet<
  TData = Awaited<
    ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
  >,
  TError = HTTPValidationError
>(
  jobTitleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job Title
 */

export function useGetJobTitleApiV1PeopleJobTitlesJobTitleIdGet<
  TData = Awaited<
    ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
  >,
  TError = HTTPValidationError
>(
  jobTitleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobTitleApiV1PeopleJobTitlesJobTitleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJobTitleApiV1PeopleJobTitlesJobTitleIdGetQueryOptions(
      jobTitleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a job title.
 * @summary Update Job Title
 */
export const updateJobTitleApiV1PeopleJobTitlesJobTitleIdPut = (
  jobTitleId: string,
  jobTitleUpdate: JobTitleUpdate
) => {
  return customInstance<JobTitleResponse>({
    url: `/api/v1/people/job-titles/${jobTitleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: jobTitleUpdate
  });
};

export const getUpdateJobTitleApiV1PeopleJobTitlesJobTitleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateJobTitleApiV1PeopleJobTitlesJobTitleIdPut>
      >,
      TError,
      { jobTitleId: string; data: JobTitleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateJobTitleApiV1PeopleJobTitlesJobTitleIdPut>>,
    TError,
    { jobTitleId: string; data: JobTitleUpdate },
    TContext
  > => {
    const mutationKey = ['updateJobTitleApiV1PeopleJobTitlesJobTitleIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateJobTitleApiV1PeopleJobTitlesJobTitleIdPut>
      >,
      { jobTitleId: string; data: JobTitleUpdate }
    > = (props) => {
      const { jobTitleId, data } = props ?? {};

      return updateJobTitleApiV1PeopleJobTitlesJobTitleIdPut(jobTitleId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateJobTitleApiV1PeopleJobTitlesJobTitleIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateJobTitleApiV1PeopleJobTitlesJobTitleIdPut>>
  >;
export type UpdateJobTitleApiV1PeopleJobTitlesJobTitleIdPutMutationBody =
  JobTitleUpdate;
export type UpdateJobTitleApiV1PeopleJobTitlesJobTitleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Job Title
 */
export const useUpdateJobTitleApiV1PeopleJobTitlesJobTitleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateJobTitleApiV1PeopleJobTitlesJobTitleIdPut>
      >,
      TError,
      { jobTitleId: string; data: JobTitleUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateJobTitleApiV1PeopleJobTitlesJobTitleIdPut>>,
  TError,
  { jobTitleId: string; data: JobTitleUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateJobTitleApiV1PeopleJobTitlesJobTitleIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft delete a job title.
 * @summary Delete Job Title
 */
export const deleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete = (
  jobTitleId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/job-titles/${jobTitleId}`,
    method: 'DELETE'
  });
};

export const getDeleteJobTitleApiV1PeopleJobTitlesJobTitleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete>
      >,
      TError,
      { jobTitleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete>
    >,
    TError,
    { jobTitleId: string },
    TContext
  > => {
    const mutationKey = ['deleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete>
      >,
      { jobTitleId: string }
    > = (props) => {
      const { jobTitleId } = props ?? {};

      return deleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete(jobTitleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteJobTitleApiV1PeopleJobTitlesJobTitleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete>
    >
  >;

export type DeleteJobTitleApiV1PeopleJobTitlesJobTitleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Job Title
 */
export const useDeleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete>
      >,
      TError,
      { jobTitleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteJobTitleApiV1PeopleJobTitlesJobTitleIdDelete>
  >,
  TError,
  { jobTitleId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteJobTitleApiV1PeopleJobTitlesJobTitleIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List employees with filters.
 * @summary List Employees
 */
export const listEmployeesApiV1PeopleEmployeesGet = (
  params?: ListEmployeesApiV1PeopleEmployeesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<EmployeeListResponse>({
    url: `/api/v1/people/employees`,
    method: 'GET',
    params,
    signal
  });
};

export const getListEmployeesApiV1PeopleEmployeesGetQueryKey = (
  params?: ListEmployeesApiV1PeopleEmployeesGetParams
) => {
  return [`/api/v1/people/employees`, ...(params ? [params] : [])] as const;
};

export const getListEmployeesApiV1PeopleEmployeesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
  TError = HTTPValidationError
>(
  params?: ListEmployeesApiV1PeopleEmployeesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListEmployeesApiV1PeopleEmployeesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>
  > = ({ signal }) => listEmployeesApiV1PeopleEmployeesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListEmployeesApiV1PeopleEmployeesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>
>;
export type ListEmployeesApiV1PeopleEmployeesGetQueryError =
  HTTPValidationError;

export function useListEmployeesApiV1PeopleEmployeesGet<
  TData = Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListEmployeesApiV1PeopleEmployeesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
          TError,
          Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEmployeesApiV1PeopleEmployeesGet<
  TData = Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
  TError = HTTPValidationError
>(
  params?: ListEmployeesApiV1PeopleEmployeesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
          TError,
          Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEmployeesApiV1PeopleEmployeesGet<
  TData = Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
  TError = HTTPValidationError
>(
  params?: ListEmployeesApiV1PeopleEmployeesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Employees
 */

export function useListEmployeesApiV1PeopleEmployeesGet<
  TData = Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
  TError = HTTPValidationError
>(
  params?: ListEmployeesApiV1PeopleEmployeesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEmployeesApiV1PeopleEmployeesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListEmployeesApiV1PeopleEmployeesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new employee. Open to any authenticated member of the tenant — HR
administration (terminate, offboard, settings) is what this module gates on
module-admin, not ordinary record creation.
 * @summary Create Employee
 */
export const createEmployeeApiV1PeopleEmployeesPost = (
  employeeCreateRequest: EmployeeCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<EmployeeResponse>({
    url: `/api/v1/people/employees`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeCreateRequest,
    signal
  });
};

export const getCreateEmployeeApiV1PeopleEmployeesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEmployeeApiV1PeopleEmployeesPost>>,
    TError,
    { data: EmployeeCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEmployeeApiV1PeopleEmployeesPost>>,
  TError,
  { data: EmployeeCreateRequest },
  TContext
> => {
  const mutationKey = ['createEmployeeApiV1PeopleEmployeesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEmployeeApiV1PeopleEmployeesPost>>,
    { data: EmployeeCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createEmployeeApiV1PeopleEmployeesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEmployeeApiV1PeopleEmployeesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEmployeeApiV1PeopleEmployeesPost>>
>;
export type CreateEmployeeApiV1PeopleEmployeesPostMutationBody =
  EmployeeCreateRequest;
export type CreateEmployeeApiV1PeopleEmployeesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Employee
 */
export const useCreateEmployeeApiV1PeopleEmployeesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEmployeeApiV1PeopleEmployeesPost>>,
      TError,
      { data: EmployeeCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createEmployeeApiV1PeopleEmployeesPost>>,
  TError,
  { data: EmployeeCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateEmployeeApiV1PeopleEmployeesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * The caller's own employee record — the entry point for every self-service read.

Declared BEFORE ``/employees/{employee_id}``: that route parses its path segment
as a UUID, so ``me`` would 422 there if the parameterized route matched first.

Self-access is unconditional: a user reading their own record needs no employee
scope grant, and sensitive fields are theirs by definition (§7 rule 2), so no
stripping applies. A user with no employee record gets 404 — the surface is
simply not theirs to use.
 * @summary Get My Employee
 */
export const getMyEmployeeApiV1PeopleEmployeesMeGet = (
  signal?: AbortSignal
) => {
  return customInstance<EmployeeResponse>({
    url: `/api/v1/people/employees/me`,
    method: 'GET',
    signal
  });
};

export const getGetMyEmployeeApiV1PeopleEmployeesMeGetQueryKey = () => {
  return [`/api/v1/people/employees/me`] as const;
};

export const getGetMyEmployeeApiV1PeopleEmployeesMeGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMyEmployeeApiV1PeopleEmployeesMeGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>
  > = ({ signal }) => getMyEmployeeApiV1PeopleEmployeesMeGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyEmployeeApiV1PeopleEmployeesMeGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>
>;
export type GetMyEmployeeApiV1PeopleEmployeesMeGetQueryError = unknown;

export function useGetMyEmployeeApiV1PeopleEmployeesMeGet<
  TData = Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyEmployeeApiV1PeopleEmployeesMeGet<
  TData = Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyEmployeeApiV1PeopleEmployeesMeGet<
  TData = Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get My Employee
 */

export function useGetMyEmployeeApiV1PeopleEmployeesMeGet<
  TData = Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyEmployeeApiV1PeopleEmployeesMeGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMyEmployeeApiV1PeopleEmployeesMeGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Who has not signed the handbook / accepted the policy yet.

Declared BEFORE ``/employees/{employee_id}``, which parses its path segment as
a UUID and would 422 this literal if it matched first.

**Scope — this is a far-side read.** Every row here is about a DIFFERENT
employee from the caller, so gating the caller alone would be vacuous
(``.claude/rules/rules-entity-link-far-side.md``). The bound is People's own
scope seam, ``accessible_employee_ids_set``, turned into
``people_employees:{id}`` refs and pushed into the query as
``list_outstanding(attached_to_in=...)`` — so the total and the page are
narrowed by one predicate list rather than the page being filtered in Python
afterwards, which is how a badge starts disagreeing with the rows under it.
``None`` from that seam means "no bound" (``everyone`` mode, or an admin) and
keeps only the module prefix; an EMPTY set means "this caller sees nobody" and
must return nothing, which is why it is passed through as an empty list rather
than collapsed into "no bound".

**Not module-admin, deliberately.** A manager owns their team's compliance
chasing, so the gate is ``require_auth`` plus the scope above: an HR admin sees
the tenant, a manager sees their reports, and neither needs a role the other
lacks. The one who sees nothing is the employee with no reports, whose own
outstanding items live on ``/document-requests/mine``.

Shape A paging (``ui-list-pages.md`` §11): this list accumulates a row per
document raised, so the caller pages rather than fetching it whole.

**Two bounds, not one.** The scope above says which employees this caller may
see AT ALL; People's restricted-document gate says whose PROTECTED data they
may read, and they are different questions with different answers — a manager
sees their report's row and not their report's visa. The second bound is
applied inside ``list_outstanding`` itself (it takes ``auth`` with no default
for exactly that reason), so a restricted-typed row is withheld from a caller
who fails the sensitive-field gate on its employee. That matters here even
though the file itself never travels: this surface names the employee AND the
document type, so "Right to work — outstanding" is already the disclosure.
 * @summary List Outstanding Employee Documents
 */
export const listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet =
  (
    params?: ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<OutstandingDocumentListResponse>({
      url: `/api/v1/people/employees/outstanding-documents`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetQueryKey =
  (
    params?: ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetParams
  ) => {
    return [
      `/api/v1/people/employees/outstanding-documents`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
        >
      >
    > = ({ signal }) =>
      listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
      >
    >
  >;
export type ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetQueryError =
  HTTPValidationError;

export function useListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet<
  TData = Awaited<
    ReturnType<
      typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet<
  TData = Awaited<
    ReturnType<
      typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet<
  TData = Awaited<
    ReturnType<
      typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Outstanding Employee Documents
 */

export function useListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet<
  TData = Awaited<
    ReturnType<
      typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListOutstandingEmployeeDocumentsApiV1PeopleEmployeesOutstandingDocumentsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get an employee by ID.
 * @summary Get Employee
 */
export const getEmployeeApiV1PeopleEmployeesEmployeeIdGet = (
  employeeId: string,
  signal?: AbortSignal
) => {
  return customInstance<EmployeeResponse>({
    url: `/api/v1/people/employees/${employeeId}`,
    method: 'GET',
    signal
  });
};

export const getGetEmployeeApiV1PeopleEmployeesEmployeeIdGetQueryKey = (
  employeeId?: string
) => {
  return [`/api/v1/people/employees/${employeeId}`] as const;
};

export const getGetEmployeeApiV1PeopleEmployeesEmployeeIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEmployeeApiV1PeopleEmployeesEmployeeIdGetQueryKey(employeeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>>
  > = ({ signal }) =>
    getEmployeeApiV1PeopleEmployeesEmployeeIdGet(employeeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!employeeId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEmployeeApiV1PeopleEmployeesEmployeeIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>>
  >;
export type GetEmployeeApiV1PeopleEmployeesEmployeeIdGetQueryError =
  HTTPValidationError;

export function useGetEmployeeApiV1PeopleEmployeesEmployeeIdGet<
  TData = Awaited<
    ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEmployeeApiV1PeopleEmployeesEmployeeIdGet<
  TData = Awaited<
    ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEmployeeApiV1PeopleEmployeesEmployeeIdGet<
  TData = Awaited<
    ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Employee
 */

export function useGetEmployeeApiV1PeopleEmployeesEmployeeIdGet<
  TData = Awaited<
    ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getEmployeeApiV1PeopleEmployeesEmployeeIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEmployeeApiV1PeopleEmployeesEmployeeIdGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update employee information.

If job-related fields (job_title_id, job_title_name, department_id,
office_id, manager_employee_id) are provided and differ from current values,
a new job assignment record is automatically created.
 * @summary Update Employee
 */
export const updateEmployeeApiV1PeopleEmployeesEmployeeIdPut = (
  employeeId: string,
  employeeUpdate: EmployeeUpdate
) => {
  return customInstance<EmployeeResponse>({
    url: `/api/v1/people/employees/${employeeId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: employeeUpdate
  });
};

export const getUpdateEmployeeApiV1PeopleEmployeesEmployeeIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateEmployeeApiV1PeopleEmployeesEmployeeIdPut>
      >,
      TError,
      { employeeId: string; data: EmployeeUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateEmployeeApiV1PeopleEmployeesEmployeeIdPut>>,
    TError,
    { employeeId: string; data: EmployeeUpdate },
    TContext
  > => {
    const mutationKey = ['updateEmployeeApiV1PeopleEmployeesEmployeeIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateEmployeeApiV1PeopleEmployeesEmployeeIdPut>
      >,
      { employeeId: string; data: EmployeeUpdate }
    > = (props) => {
      const { employeeId, data } = props ?? {};

      return updateEmployeeApiV1PeopleEmployeesEmployeeIdPut(employeeId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateEmployeeApiV1PeopleEmployeesEmployeeIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateEmployeeApiV1PeopleEmployeesEmployeeIdPut>>
  >;
export type UpdateEmployeeApiV1PeopleEmployeesEmployeeIdPutMutationBody =
  EmployeeUpdate;
export type UpdateEmployeeApiV1PeopleEmployeesEmployeeIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Employee
 */
export const useUpdateEmployeeApiV1PeopleEmployeesEmployeeIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateEmployeeApiV1PeopleEmployeesEmployeeIdPut>
      >,
      TError,
      { employeeId: string; data: EmployeeUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateEmployeeApiV1PeopleEmployeesEmployeeIdPut>>,
  TError,
  { employeeId: string; data: EmployeeUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateEmployeeApiV1PeopleEmployeesEmployeeIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Terminate an employee and run the offboarding transition.

Module-admin only: ending someone's employment also cuts their access, so it
is a People-admin action rather than something anyone with sensitive-field
access can do. Record-level access is still enforced on top.

Being allowed to PERFORM the termination says nothing about being allowed to
READ the leaver's restricted fields — module-admin is grantable via
``people.settings.manage`` without ``people.employee.view_restricted``. So the
response is stripped on the same sensitive-field rules as every other read
path; it is not implied by the action gate.
 * @summary Terminate Employee
 */
export const terminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost = (
  employeeId: string,
  employeeTerminate: EmployeeTerminate,
  signal?: AbortSignal
) => {
  return customInstance<TerminationResponse>({
    url: `/api/v1/people/employees/${employeeId}/terminate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeTerminate,
    signal
  });
};

export const getTerminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof terminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost
        >
      >,
      TError,
      { employeeId: string; data: EmployeeTerminate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof terminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost
      >
    >,
    TError,
    { employeeId: string; data: EmployeeTerminate },
    TContext
  > => {
    const mutationKey = [
      'terminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof terminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost
        >
      >,
      { employeeId: string; data: EmployeeTerminate }
    > = (props) => {
      const { employeeId, data } = props ?? {};

      return terminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost(
        employeeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TerminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof terminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost
      >
    >
  >;
export type TerminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePostMutationBody =
  EmployeeTerminate;
export type TerminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePostMutationError =
  HTTPValidationError;

/**
 * @summary Terminate Employee
 */
export const useTerminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof terminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost
        >
      >,
      TError,
      { employeeId: string; data: EmployeeTerminate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof terminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePost
    >
  >,
  TError,
  { employeeId: string; data: EmployeeTerminate },
  TContext
> => {
  const mutationOptions =
    getTerminateEmployeeApiV1PeopleEmployeesEmployeeIdTerminatePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get job history for an employee.

A row names its MANAGER as well as its subject, and the manager's name and work
email are bounded by the caller's own employee scope rather than by the gate on
the subject.
 * @summary Get Job History
 */
export const getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet = (
  employeeId: string,
  signal?: AbortSignal
) => {
  return customInstance<JobResponse[]>({
    url: `/api/v1/people/employees/${employeeId}/jobs`,
    method: 'GET',
    signal
  });
};

export const getGetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGetQueryKey = (
  employeeId?: string
) => {
  return [`/api/v1/people/employees/${employeeId}/jobs`] as const;
};

export const getGetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGetQueryKey(employeeId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
      >
    > = ({ signal }) =>
      getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet(employeeId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
    >
  >;
export type GetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGetQueryError =
  HTTPValidationError;

export function useGetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet<
  TData = Awaited<
    ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet<
  TData = Awaited<
    ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet<
  TData = Awaited<
    ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job History
 */

export function useGetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet<
  TData = Awaited<
    ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJobHistoryApiV1PeopleEmployeesEmployeeIdJobsGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a new job assignment (promotion, transfer, etc.).
 * @summary Add Job Assignment
 */
export const addJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost = (
  employeeId: string,
  jobAssignmentCreate: JobAssignmentCreate,
  signal?: AbortSignal
) => {
  return customInstance<JobResponse>({
    url: `/api/v1/people/employees/${employeeId}/jobs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: jobAssignmentCreate,
    signal
  });
};

export const getAddJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost
        >
      >,
      TError,
      { employeeId: string; data: JobAssignmentCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof addJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost>
    >,
    TError,
    { employeeId: string; data: JobAssignmentCreate },
    TContext
  > => {
    const mutationKey = [
      'addJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost
        >
      >,
      { employeeId: string; data: JobAssignmentCreate }
    > = (props) => {
      const { employeeId, data } = props ?? {};

      return addJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost(
        employeeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof addJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost>
    >
  >;
export type AddJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPostMutationBody =
  JobAssignmentCreate;
export type AddJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Job Assignment
 */
export const useAddJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost
        >
      >,
      TError,
      { employeeId: string; data: JobAssignmentCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof addJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPost>
  >,
  TError,
  { employeeId: string; data: JobAssignmentCreate },
  TContext
> => {
  const mutationOptions =
    getAddJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Correct an OPEN position entry in place.

A mistyped promotion is not a promotion, so it is rewritten rather than
superseded: stacking a same-day correction leaves a zero-length row that an
auditor reads as a real one-day job. Same gate as the POST — record ``update``
tier, NOT sensitive-field tier, because a position carries title/department/
level/manager and no pay (see ``get_job_history`` and
sharing-and-permissions-design.md §5) — and the service refuses outright where
the tenant requires approval for job changes, so this cannot be used to route
round the approval step.
 * @summary Correct Job Assignment
 */
export const correctJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch =
  (
    employeeId: string,
    jobId: string,
    jobAssignmentUpdate: JobAssignmentUpdate
  ) => {
    return customInstance<JobResponse>({
      url: `/api/v1/people/employees/${employeeId}/jobs/${jobId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: jobAssignmentUpdate
    });
  };

export const getCorrectJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof correctJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch
        >
      >,
      TError,
      { employeeId: string; jobId: string; data: JobAssignmentUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof correctJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch
      >
    >,
    TError,
    { employeeId: string; jobId: string; data: JobAssignmentUpdate },
    TContext
  > => {
    const mutationKey = [
      'correctJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof correctJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch
        >
      >,
      { employeeId: string; jobId: string; data: JobAssignmentUpdate }
    > = (props) => {
      const { employeeId, jobId, data } = props ?? {};

      return correctJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch(
        employeeId,
        jobId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CorrectJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof correctJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch
      >
    >
  >;
export type CorrectJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatchMutationBody =
  JobAssignmentUpdate;
export type CorrectJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Correct Job Assignment
 */
export const useCorrectJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof correctJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch
          >
        >,
        TError,
        { employeeId: string; jobId: string; data: JobAssignmentUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof correctJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatch
      >
    >,
    TError,
    { employeeId: string; jobId: string; data: JobAssignmentUpdate },
    TContext
  > => {
    const mutationOptions =
      getCorrectJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove an OPEN position entry, reopening the one it superseded.

For an entry made entirely in error. The chain closes over it, so the employee
is never left with no current position. Same gates as the PATCH above.
 * @summary Delete Job Assignment
 */
export const deleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete =
  (employeeId: string, jobId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/employees/${employeeId}/jobs/${jobId}`,
      method: 'DELETE'
    });
  };

export const getDeleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete
        >
      >,
      TError,
      { employeeId: string; jobId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete
      >
    >,
    TError,
    { employeeId: string; jobId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete
        >
      >,
      { employeeId: string; jobId: string }
    > = (props) => {
      const { employeeId, jobId } = props ?? {};

      return deleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete(
        employeeId,
        jobId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete
      >
    >
  >;

export type DeleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Job Assignment
 */
export const useDeleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete
          >
        >,
        TError,
        { employeeId: string; jobId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDelete
      >
    >,
    TError,
    { employeeId: string; jobId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteJobAssignmentApiV1PeopleEmployeesEmployeeIdJobsJobIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get compensation history for an employee. Requires sensitive field access.
 * @summary Get Compensation History
 */
export const getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet =
  (employeeId: string, signal?: AbortSignal) => {
    return customInstance<CompensationResponse[]>({
      url: `/api/v1/people/employees/${employeeId}/compensation`,
      method: 'GET',
      signal
    });
  };

export const getGetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGetQueryKey =
  (employeeId?: string) => {
    return [`/api/v1/people/employees/${employeeId}/compensation`] as const;
  };

export const getGetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGetQueryKey(
        employeeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
        >
      >
    > = ({ signal }) =>
      getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet(
        employeeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
      >
    >
  >;
export type GetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGetQueryError =
  HTTPValidationError;

export function useGetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet<
  TData = Awaited<
    ReturnType<
      typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet<
  TData = Awaited<
    ReturnType<
      typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet<
  TData = Awaited<
    ReturnType<
      typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Compensation History
 */

export function useGetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet<
  TData = Awaited<
    ReturnType<
      typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCompensationHistoryApiV1PeopleEmployeesEmployeeIdCompensationGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a new compensation record (raise, adjustment, etc.). Requires sensitive field access.
 * @summary Add Compensation
 */
export const addCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost = (
  employeeId: string,
  compensationCreate: CompensationCreate,
  signal?: AbortSignal
) => {
  return customInstance<CompensationResponse>({
    url: `/api/v1/people/employees/${employeeId}/compensation`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: compensationCreate,
    signal
  });
};

export const getAddCompensationApiV1PeopleEmployeesEmployeeIdCompensationPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost
        >
      >,
      TError,
      { employeeId: string; data: CompensationCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost
      >
    >,
    TError,
    { employeeId: string; data: CompensationCreate },
    TContext
  > => {
    const mutationKey = [
      'addCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost
        >
      >,
      { employeeId: string; data: CompensationCreate }
    > = (props) => {
      const { employeeId, data } = props ?? {};

      return addCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost(
        employeeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddCompensationApiV1PeopleEmployeesEmployeeIdCompensationPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost
      >
    >
  >;
export type AddCompensationApiV1PeopleEmployeesEmployeeIdCompensationPostMutationBody =
  CompensationCreate;
export type AddCompensationApiV1PeopleEmployeesEmployeeIdCompensationPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Compensation
 */
export const useAddCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost
          >
        >,
        TError,
        { employeeId: string; data: CompensationCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addCompensationApiV1PeopleEmployeesEmployeeIdCompensationPost
      >
    >,
    TError,
    { employeeId: string; data: CompensationCreate },
    TContext
  > => {
    const mutationOptions =
      getAddCompensationApiV1PeopleEmployeesEmployeeIdCompensationPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Correct the CURRENT compensation record in place. Requires sensitive field access.

A typo is not a pay change, so it is rewritten rather than superseded: stacking
a same-day correction leaves a zero-length row that an auditor reads as a real
one-day salary. Same gates as the POST — record ``update`` plus sensitive-field
access — and the service refuses outright where the tenant requires approval for
compensation changes, so this cannot be used to route round the approval step.
 * @summary Correct Compensation
 */
export const correctCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch =
  (
    employeeId: string,
    compensationId: string,
    compensationUpdate: CompensationUpdate
  ) => {
    return customInstance<CompensationResponse>({
      url: `/api/v1/people/employees/${employeeId}/compensation/${compensationId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: compensationUpdate
    });
  };

export const getCorrectCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof correctCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch
        >
      >,
      TError,
      { employeeId: string; compensationId: string; data: CompensationUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof correctCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch
      >
    >,
    TError,
    { employeeId: string; compensationId: string; data: CompensationUpdate },
    TContext
  > => {
    const mutationKey = [
      'correctCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof correctCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch
        >
      >,
      { employeeId: string; compensationId: string; data: CompensationUpdate }
    > = (props) => {
      const { employeeId, compensationId, data } = props ?? {};

      return correctCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch(
        employeeId,
        compensationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CorrectCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof correctCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch
      >
    >
  >;
export type CorrectCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatchMutationBody =
  CompensationUpdate;
export type CorrectCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Correct Compensation
 */
export const useCorrectCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof correctCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch
          >
        >,
        TError,
        {
          employeeId: string;
          compensationId: string;
          data: CompensationUpdate;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof correctCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatch
      >
    >,
    TError,
    { employeeId: string; compensationId: string; data: CompensationUpdate },
    TContext
  > => {
    const mutationOptions =
      getCorrectCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove the CURRENT compensation record, reopening the one it superseded.

For an entry made entirely in error. The chain closes over it, so the employee
is never left with no current pay record. Same gates as the PATCH above.
 * @summary Delete Compensation
 */
export const deleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete =
  (employeeId: string, compensationId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/employees/${employeeId}/compensation/${compensationId}`,
      method: 'DELETE'
    });
  };

export const getDeleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete
        >
      >,
      TError,
      { employeeId: string; compensationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete
      >
    >,
    TError,
    { employeeId: string; compensationId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete
        >
      >,
      { employeeId: string; compensationId: string }
    > = (props) => {
      const { employeeId, compensationId } = props ?? {};

      return deleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete(
        employeeId,
        compensationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete
      >
    >
  >;

export type DeleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Compensation
 */
export const useDeleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete
          >
        >,
        TError,
        { employeeId: string; compensationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDelete
      >
    >,
    TError,
    { employeeId: string; compensationId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteCompensationApiV1PeopleEmployeesEmployeeIdCompensationCompensationIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get contacts for an employee. Requires sensitive field access.
 * @summary Get Contacts
 */
export const getContactsApiV1PeopleEmployeesEmployeeIdContactsGet = (
  employeeId: string,
  signal?: AbortSignal
) => {
  return customInstance<ContactResponse[]>({
    url: `/api/v1/people/employees/${employeeId}/contacts`,
    method: 'GET',
    signal
  });
};

export const getGetContactsApiV1PeopleEmployeesEmployeeIdContactsGetQueryKey = (
  employeeId?: string
) => {
  return [`/api/v1/people/employees/${employeeId}/contacts`] as const;
};

export const getGetContactsApiV1PeopleEmployeesEmployeeIdContactsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet>
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetContactsApiV1PeopleEmployeesEmployeeIdContactsGetQueryKey(
        employeeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet>
      >
    > = ({ signal }) =>
      getContactsApiV1PeopleEmployeesEmployeeIdContactsGet(employeeId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetContactsApiV1PeopleEmployeesEmployeeIdContactsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet>
    >
  >;
export type GetContactsApiV1PeopleEmployeesEmployeeIdContactsGetQueryError =
  HTTPValidationError;

export function useGetContactsApiV1PeopleEmployeesEmployeeIdContactsGet<
  TData = Awaited<
    ReturnType<typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetContactsApiV1PeopleEmployeesEmployeeIdContactsGet<
  TData = Awaited<
    ReturnType<typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetContactsApiV1PeopleEmployeesEmployeeIdContactsGet<
  TData = Awaited<
    ReturnType<typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Contacts
 */

export function useGetContactsApiV1PeopleEmployeesEmployeeIdContactsGet<
  TData = Awaited<
    ReturnType<typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactsApiV1PeopleEmployeesEmployeeIdContactsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetContactsApiV1PeopleEmployeesEmployeeIdContactsGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a new contact. Requires sensitive field access.
 * @summary Add Contact
 */
export const addContactApiV1PeopleEmployeesEmployeeIdContactsPost = (
  employeeId: string,
  employeeContactCreate: EmployeeContactCreate,
  signal?: AbortSignal
) => {
  return customInstance<ContactResponse>({
    url: `/api/v1/people/employees/${employeeId}/contacts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeContactCreate,
    signal
  });
};

export const getAddContactApiV1PeopleEmployeesEmployeeIdContactsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addContactApiV1PeopleEmployeesEmployeeIdContactsPost>
      >,
      TError,
      { employeeId: string; data: EmployeeContactCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof addContactApiV1PeopleEmployeesEmployeeIdContactsPost>
    >,
    TError,
    { employeeId: string; data: EmployeeContactCreate },
    TContext
  > => {
    const mutationKey = [
      'addContactApiV1PeopleEmployeesEmployeeIdContactsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addContactApiV1PeopleEmployeesEmployeeIdContactsPost>
      >,
      { employeeId: string; data: EmployeeContactCreate }
    > = (props) => {
      const { employeeId, data } = props ?? {};

      return addContactApiV1PeopleEmployeesEmployeeIdContactsPost(
        employeeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddContactApiV1PeopleEmployeesEmployeeIdContactsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof addContactApiV1PeopleEmployeesEmployeeIdContactsPost>
    >
  >;
export type AddContactApiV1PeopleEmployeesEmployeeIdContactsPostMutationBody =
  EmployeeContactCreate;
export type AddContactApiV1PeopleEmployeesEmployeeIdContactsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Contact
 */
export const useAddContactApiV1PeopleEmployeesEmployeeIdContactsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addContactApiV1PeopleEmployeesEmployeeIdContactsPost>
      >,
      TError,
      { employeeId: string; data: EmployeeContactCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof addContactApiV1PeopleEmployeesEmployeeIdContactsPost>
  >,
  TError,
  { employeeId: string; data: EmployeeContactCreate },
  TContext
> => {
  const mutationOptions =
    getAddContactApiV1PeopleEmployeesEmployeeIdContactsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a contact. Requires sensitive field access.
 * @summary Update Contact
 */
export const updateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut = (
  employeeId: string,
  contactId: string,
  employeeContactUpdate: EmployeeContactUpdate
) => {
  return customInstance<ContactResponse>({
    url: `/api/v1/people/employees/${employeeId}/contacts/${contactId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: employeeContactUpdate
  });
};

export const getUpdateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut
        >
      >,
      TError,
      { employeeId: string; contactId: string; data: EmployeeContactUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut
      >
    >,
    TError,
    { employeeId: string; contactId: string; data: EmployeeContactUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut
        >
      >,
      { employeeId: string; contactId: string; data: EmployeeContactUpdate }
    > = (props) => {
      const { employeeId, contactId, data } = props ?? {};

      return updateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut(
        employeeId,
        contactId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut
      >
    >
  >;
export type UpdateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPutMutationBody =
  EmployeeContactUpdate;
export type UpdateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Contact
 */
export const useUpdateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut
          >
        >,
        TError,
        { employeeId: string; contactId: string; data: EmployeeContactUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPut
      >
    >,
    TError,
    { employeeId: string; contactId: string; data: EmployeeContactUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateContactApiV1PeopleEmployeesEmployeeIdContactsContactIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a contact. Requires sensitive field access.
 * @summary Delete Contact
 */
export const deleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete =
  (employeeId: string, contactId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/employees/${employeeId}/contacts/${contactId}`,
      method: 'DELETE'
    });
  };

export const getDeleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete
        >
      >,
      TError,
      { employeeId: string; contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete
      >
    >,
    TError,
    { employeeId: string; contactId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete
        >
      >,
      { employeeId: string; contactId: string }
    > = (props) => {
      const { employeeId, contactId } = props ?? {};

      return deleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete(
        employeeId,
        contactId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete
      >
    >
  >;

export type DeleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Contact
 */
export const useDeleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete
          >
        >,
        TError,
        { employeeId: string; contactId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDelete
      >
    >,
    TError,
    { employeeId: string; contactId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteContactApiV1PeopleEmployeesEmployeeIdContactsContactIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Count an employee's records per detail-page facet, in one round trip.

Feeds the tab strip's content dots, which otherwise cost one list request per
tab purely to decide whether to draw a dot. Mirrors the master_data
``BacklinksService`` related-counts seam.

Every facet's tally is built from the predicate set its own repository
declares (``employee_facet_predicates``) — the same set that repository's LIST
method applies — so a badge cannot describe a different set than the tab it
labels, structurally rather than by the authors of the two sides agreeing
(``.claude/rules/rules-entity-link-far-side.md``). ``onboarding`` and
``offboarding`` are two counts over one table for that reason: they are two
tabs, and the tally that served both omitted the ``kind`` predicate the list
routes apply.

Gated at ``enforce_employee_scope(read)`` — the same record-read tier as the
five sibling facet lists (skills / leave / onboarding / offboarding /
reviews), so this can never reveal more than opening those tabs would. That gate no-ops in
``everyone`` mode and for admins, so the existence check below is what 404s a
non-existent or soft-deleted employee there; both paths raise the same
``ErrorCode.NOT_FOUND`` at 404 with the same message, so a caller cannot
distinguish "hidden from me" from "does not exist".

``time`` is module-admin only and is OMITTED (not zeroed) otherwise —
``GET /time/entries`` is ``require_module_admin("people")`` gated, so an
unconditional tally would disclose that timesheet data exists for an employee
whose entries the caller cannot read. ``is_module_admin`` is the documented
in-handler conditional-gate seam; ``response_model_exclude_none`` drops the
key from the payload rather than sending a null.

Documents are deliberately absent: those records belong to file_management,
and counting them here would cross a module boundary. The page keeps
``useFiles`` for that tab.
 * @summary Get Employee Related Counts
 */
export const getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet =
  (employeeId: string, signal?: AbortSignal) => {
    return customInstance<EmployeeRelatedCounts>({
      url: `/api/v1/people/employees/${employeeId}/related-counts`,
      method: 'GET',
      signal
    });
  };

export const getGetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGetQueryKey =
  (employeeId?: string) => {
    return [`/api/v1/people/employees/${employeeId}/related-counts`] as const;
  };

export const getGetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGetQueryKey(
        employeeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
        >
      >
    > = ({ signal }) =>
      getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet(
        employeeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
      >
    >
  >;
export type GetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGetQueryError =
  HTTPValidationError;

export function useGetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Employee Related Counts
 */

export function useGetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEmployeeRelatedCountsApiV1PeopleEmployeesEmployeeIdRelatedCountsGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get org chart structure — the roots, each with its reporting subtree nested.

Rooted on an EMPLOYEE id: a manager with no user account is an ordinary node
of the chart, so there is no login to root it on.

``OrgNode`` is self-referential (``children: list[OrgNode]``). The
``response_model`` used to be omitted because fastapi-mcp recursed forever on
the cycle; ``mcp_schema_generator._break_openapi_ref_cycles`` now cuts the
back-edge before conversion, so the route carries a real response model and
this endpoint's MCP tool definition is generated from it.
 * @summary Get Org Chart
 */
export const getOrgChartApiV1PeopleOrgChartGet = (
  params?: GetOrgChartApiV1PeopleOrgChartGetParams,
  signal?: AbortSignal
) => {
  return customInstance<OrgNode[]>({
    url: `/api/v1/people/org-chart`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetOrgChartApiV1PeopleOrgChartGetQueryKey = (
  params?: GetOrgChartApiV1PeopleOrgChartGetParams
) => {
  return [`/api/v1/people/org-chart`, ...(params ? [params] : [])] as const;
};

export const getGetOrgChartApiV1PeopleOrgChartGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
  TError = HTTPValidationError
>(
  params?: GetOrgChartApiV1PeopleOrgChartGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetOrgChartApiV1PeopleOrgChartGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>
  > = ({ signal }) => getOrgChartApiV1PeopleOrgChartGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOrgChartApiV1PeopleOrgChartGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>
>;
export type GetOrgChartApiV1PeopleOrgChartGetQueryError = HTTPValidationError;

export function useGetOrgChartApiV1PeopleOrgChartGet<
  TData = Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
  TError = HTTPValidationError
>(
  params: undefined | GetOrgChartApiV1PeopleOrgChartGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
          TError,
          Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrgChartApiV1PeopleOrgChartGet<
  TData = Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
  TError = HTTPValidationError
>(
  params?: GetOrgChartApiV1PeopleOrgChartGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
          TError,
          Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrgChartApiV1PeopleOrgChartGet<
  TData = Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
  TError = HTTPValidationError
>(
  params?: GetOrgChartApiV1PeopleOrgChartGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Org Chart
 */

export function useGetOrgChartApiV1PeopleOrgChartGet<
  TData = Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
  TError = HTTPValidationError
>(
  params?: GetOrgChartApiV1PeopleOrgChartGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgChartApiV1PeopleOrgChartGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOrgChartApiV1PeopleOrgChartGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The caller's own direct reports — the manager surface's roster.

The manager is ``auth.current_user_id`` and is never accepted from the client
(contrast ``/org-chart/{employee_id}/reports``, which renders anyone's slice of the
public org chart). A caller with no reports gets an empty list, not an error:
"I am not a manager" is a normal state the UI renders as an empty state.

Each member carries the leave facts a manager needs at a glance — how many of
their requests are awaiting a decision, and their next absence — batch-loaded
for the whole team rather than queried per member.
 * @summary Get My Team
 */
export const getMyTeamApiV1PeopleMyTeamGet = (signal?: AbortSignal) => {
  return customInstance<MyTeamResponse>({
    url: `/api/v1/people/my-team`,
    method: 'GET',
    signal
  });
};

export const getGetMyTeamApiV1PeopleMyTeamGetQueryKey = () => {
  return [`/api/v1/people/my-team`] as const;
};

export const getGetMyTeamApiV1PeopleMyTeamGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyTeamApiV1PeopleMyTeamGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>
  > = ({ signal }) => getMyTeamApiV1PeopleMyTeamGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyTeamApiV1PeopleMyTeamGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>
>;
export type GetMyTeamApiV1PeopleMyTeamGetQueryError = unknown;

export function useGetMyTeamApiV1PeopleMyTeamGet<
  TData = Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
          TError,
          Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyTeamApiV1PeopleMyTeamGet<
  TData = Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
          TError,
          Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyTeamApiV1PeopleMyTeamGet<
  TData = Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get My Team
 */

export function useGetMyTeamApiV1PeopleMyTeamGet<
  TData = Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyTeamApiV1PeopleMyTeamGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyTeamApiV1PeopleMyTeamGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get direct reports for a manager, identified by their EMPLOYEE id.

Keyed on the employee record rather than a login, because a manager need not
have one — but a USER id is still accepted, because that is what this path
segment meant when the route shipped and a deployed client sending one would
otherwise get a silently EMPTY roster (the URL shape never changed, so it
still matches here). See resolve_manager_employee_id.
 * @summary Get Direct Reports
 */
export const getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet = (
  employeeId: string,
  signal?: AbortSignal
) => {
  return customInstance<EmployeeResponse[]>({
    url: `/api/v1/people/org-chart/${employeeId}/reports`,
    method: 'GET',
    signal
  });
};

export const getGetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGetQueryKey =
  (employeeId?: string) => {
    return [`/api/v1/people/org-chart/${employeeId}/reports`] as const;
  };

export const getGetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet>
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGetQueryKey(
        employeeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
        >
      >
    > = ({ signal }) =>
      getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet(
        employeeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet>
    >
  >;
export type GetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGetQueryError =
  HTTPValidationError;

export function useGetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet<
  TData = Awaited<
    ReturnType<typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet<
  TData = Awaited<
    ReturnType<typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet<
  TData = Awaited<
    ReturnType<typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Direct Reports
 */

export function useGetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet<
  TData = Awaited<
    ReturnType<typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDirectReportsApiV1PeopleOrgChartEmployeeIdReportsGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload and preview a CSV file for employee import.
 * @summary Preview Import
 */
export const previewImportApiV1PeopleEmployeesImportPreviewPost = (
  bodyPreviewImportApiV1PeopleEmployeesImportPreviewPost: BodyPreviewImportApiV1PeopleEmployeesImportPreviewPost,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `file`,
    bodyPreviewImportApiV1PeopleEmployeesImportPreviewPost.file
  );

  return customInstance<ImportPreviewResponse>({
    url: `/api/v1/people/employees/import/preview`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getPreviewImportApiV1PeopleEmployeesImportPreviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof previewImportApiV1PeopleEmployeesImportPreviewPost>
      >,
      TError,
      { data: BodyPreviewImportApiV1PeopleEmployeesImportPreviewPost },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof previewImportApiV1PeopleEmployeesImportPreviewPost>
    >,
    TError,
    { data: BodyPreviewImportApiV1PeopleEmployeesImportPreviewPost },
    TContext
  > => {
    const mutationKey = ['previewImportApiV1PeopleEmployeesImportPreviewPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof previewImportApiV1PeopleEmployeesImportPreviewPost>
      >,
      { data: BodyPreviewImportApiV1PeopleEmployeesImportPreviewPost }
    > = (props) => {
      const { data } = props ?? {};

      return previewImportApiV1PeopleEmployeesImportPreviewPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PreviewImportApiV1PeopleEmployeesImportPreviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof previewImportApiV1PeopleEmployeesImportPreviewPost>
    >
  >;
export type PreviewImportApiV1PeopleEmployeesImportPreviewPostMutationBody =
  BodyPreviewImportApiV1PeopleEmployeesImportPreviewPost;
export type PreviewImportApiV1PeopleEmployeesImportPreviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Preview Import
 */
export const usePreviewImportApiV1PeopleEmployeesImportPreviewPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof previewImportApiV1PeopleEmployeesImportPreviewPost>
      >,
      TError,
      { data: BodyPreviewImportApiV1PeopleEmployeesImportPreviewPost },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof previewImportApiV1PeopleEmployeesImportPreviewPost>
  >,
  TError,
  { data: BodyPreviewImportApiV1PeopleEmployeesImportPreviewPost },
  TContext
> => {
  const mutationOptions =
    getPreviewImportApiV1PeopleEmployeesImportPreviewPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Execute employee import from validated data.

Rows are parsed in memory, then handed to ``bulk_create_employees`` which
fans every DB round-trip into a single set-based pass (one contact lookup,
one employee-number block, one flush) — never a query per row.
 * @summary Execute Import
 */
export const executeImportApiV1PeopleEmployeesImportPost = (
  importRequest: ImportRequest,
  signal?: AbortSignal
) => {
  return customInstance<ImportResponse>({
    url: `/api/v1/people/employees/import`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: importRequest,
    signal
  });
};

export const getExecuteImportApiV1PeopleEmployeesImportPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof executeImportApiV1PeopleEmployeesImportPost>>,
    TError,
    { data: ImportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof executeImportApiV1PeopleEmployeesImportPost>>,
  TError,
  { data: ImportRequest },
  TContext
> => {
  const mutationKey = ['executeImportApiV1PeopleEmployeesImportPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof executeImportApiV1PeopleEmployeesImportPost>>,
    { data: ImportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return executeImportApiV1PeopleEmployeesImportPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExecuteImportApiV1PeopleEmployeesImportPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof executeImportApiV1PeopleEmployeesImportPost>>
  >;
export type ExecuteImportApiV1PeopleEmployeesImportPostMutationBody =
  ImportRequest;
export type ExecuteImportApiV1PeopleEmployeesImportPostMutationError =
  HTTPValidationError;

/**
 * @summary Execute Import
 */
export const useExecuteImportApiV1PeopleEmployeesImportPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof executeImportApiV1PeopleEmployeesImportPost>>,
      TError,
      { data: ImportRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof executeImportApiV1PeopleEmployeesImportPost>>,
  TError,
  { data: ImportRequest },
  TContext
> => {
  const mutationOptions =
    getExecuteImportApiV1PeopleEmployeesImportPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List leave policies. Member-open, deliberately.

An employee filling in a leave request has to be offered the policies they
are eligible for, and a policy is the tenant's own published entitlement
rules — no personal data. So this read stays on ``require_auth`` while the
three policy WRITES beside it take ``RequireLeaveAdmin``.
``GET /leave-policies/{id}`` is member-open for the same reason; the
per-policy ASSIGNMENT list one segment deeper is NOT, because it resolves
``employee_name`` off rules that name individuals.
 * @summary List Leave Policies
 */
export const listLeavePoliciesApiV1PeopleLeavePoliciesGet = (
  params?: ListLeavePoliciesApiV1PeopleLeavePoliciesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeavePolicyListResponse>({
    url: `/api/v1/people/leave-policies`,
    method: 'GET',
    params,
    signal
  });
};

export const getListLeavePoliciesApiV1PeopleLeavePoliciesGetQueryKey = (
  params?: ListLeavePoliciesApiV1PeopleLeavePoliciesGetParams
) => {
  return [
    `/api/v1/people/leave-policies`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListLeavePoliciesApiV1PeopleLeavePoliciesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeavePoliciesApiV1PeopleLeavePoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListLeavePoliciesApiV1PeopleLeavePoliciesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>>
  > = ({ signal }) =>
    listLeavePoliciesApiV1PeopleLeavePoliciesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListLeavePoliciesApiV1PeopleLeavePoliciesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>>
  >;
export type ListLeavePoliciesApiV1PeopleLeavePoliciesGetQueryError =
  HTTPValidationError;

export function useListLeavePoliciesApiV1PeopleLeavePoliciesGet<
  TData = Awaited<
    ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListLeavePoliciesApiV1PeopleLeavePoliciesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLeavePoliciesApiV1PeopleLeavePoliciesGet<
  TData = Awaited<
    ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeavePoliciesApiV1PeopleLeavePoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLeavePoliciesApiV1PeopleLeavePoliciesGet<
  TData = Awaited<
    ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeavePoliciesApiV1PeopleLeavePoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Leave Policies
 */

export function useListLeavePoliciesApiV1PeopleLeavePoliciesGet<
  TData = Awaited<
    ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeavePoliciesApiV1PeopleLeavePoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeavePoliciesApiV1PeopleLeavePoliciesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLeavePoliciesApiV1PeopleLeavePoliciesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new leave policy.

Admin-gated like the assignment routes one segment deeper: a policy is the
rule that decides everyone's entitlement and accrual, so minting one is HR
administration, not self-service.
 * @summary Create Leave Policy
 */
export const createLeavePolicyApiV1PeopleLeavePoliciesPost = (
  leavePolicyCreate: LeavePolicyCreate,
  signal?: AbortSignal
) => {
  return customInstance<LeavePolicyResponse>({
    url: `/api/v1/people/leave-policies`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: leavePolicyCreate,
    signal
  });
};

export const getCreateLeavePolicyApiV1PeopleLeavePoliciesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLeavePolicyApiV1PeopleLeavePoliciesPost>>,
    TError,
    { data: LeavePolicyCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLeavePolicyApiV1PeopleLeavePoliciesPost>>,
  TError,
  { data: LeavePolicyCreate },
  TContext
> => {
  const mutationKey = ['createLeavePolicyApiV1PeopleLeavePoliciesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLeavePolicyApiV1PeopleLeavePoliciesPost>>,
    { data: LeavePolicyCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createLeavePolicyApiV1PeopleLeavePoliciesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLeavePolicyApiV1PeopleLeavePoliciesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createLeavePolicyApiV1PeopleLeavePoliciesPost>>
  >;
export type CreateLeavePolicyApiV1PeopleLeavePoliciesPostMutationBody =
  LeavePolicyCreate;
export type CreateLeavePolicyApiV1PeopleLeavePoliciesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Leave Policy
 */
export const useCreateLeavePolicyApiV1PeopleLeavePoliciesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLeavePolicyApiV1PeopleLeavePoliciesPost>>,
      TError,
      { data: LeavePolicyCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createLeavePolicyApiV1PeopleLeavePoliciesPost>>,
  TError,
  { data: LeavePolicyCreate },
  TContext
> => {
  const mutationOptions =
    getCreateLeavePolicyApiV1PeopleLeavePoliciesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Who this leave policy applies to.

Returns a page of the policy's assignments — expired ones included, so an
admin can see that a population used to be covered — plus the number of
employees the policy reaches today. Paginated because a policy assigned
per-employee carries one row per employee.

Admin-gated like the mutations: ``to_dict()`` resolves ``employee_name`` off
the joined employee, so under a restricted employee-visibility mode an
ordinary caller could otherwise read the name of anyone a per-employee rule
names, without being able to see their record.
 * @summary List Leave Policy Assignments
 */
export const listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet =
  (
    policyId: string,
    params?: ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<LeavePolicyAssignmentListResponse>({
      url: `/api/v1/people/leave-policies/${policyId}/assignments`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetQueryKey =
  (
    policyId?: string,
    params?: ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetParams
  ) => {
    return [
      `/api/v1/people/leave-policies/${policyId}/assignments`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    policyId: string,
    params?: ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetQueryKey(
        policyId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
        >
      >
    > = ({ signal }) =>
      listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet(
        policyId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!policyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
      >
    >
  >;
export type ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetQueryError =
  HTTPValidationError;

export function useListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  params:
    | undefined
    | ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  params?: ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  params?: ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Leave Policy Assignments
 */

export function useListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  params?: ListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLeavePolicyAssignmentsApiV1PeopleLeavePoliciesPolicyIdAssignmentsGetQueryOptions(
      policyId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Make an employee, or a population, eligible for this policy.
 * @summary Create Leave Policy Assignment
 */
export const createLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost =
  (
    policyId: string,
    leavePolicyAssignmentCreate: LeavePolicyAssignmentCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<LeavePolicyAssignmentResponse>({
      url: `/api/v1/people/leave-policies/${policyId}/assignments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: leavePolicyAssignmentCreate,
      signal
    });
  };

export const getCreateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost
        >
      >,
      TError,
      { policyId: string; data: LeavePolicyAssignmentCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost
      >
    >,
    TError,
    { policyId: string; data: LeavePolicyAssignmentCreate },
    TContext
  > => {
    const mutationKey = [
      'createLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost
        >
      >,
      { policyId: string; data: LeavePolicyAssignmentCreate }
    > = (props) => {
      const { policyId, data } = props ?? {};

      return createLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost(
        policyId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost
      >
    >
  >;
export type CreateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPostMutationBody =
  LeavePolicyAssignmentCreate;
export type CreateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Leave Policy Assignment
 */
export const useCreateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost
          >
        >,
        TError,
        { policyId: string; data: LeavePolicyAssignmentCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPost
      >
    >,
    TError,
    { policyId: string; data: LeavePolicyAssignmentCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Re-date an assignment — end-dating is how eligibility is withdrawn.
 * @summary Update Leave Policy Assignment
 */
export const updateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut =
  (
    policyId: string,
    assignmentId: string,
    leavePolicyAssignmentUpdate: LeavePolicyAssignmentUpdate
  ) => {
    return customInstance<LeavePolicyAssignmentResponse>({
      url: `/api/v1/people/leave-policies/${policyId}/assignments/${assignmentId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: leavePolicyAssignmentUpdate
    });
  };

export const getUpdateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut
        >
      >,
      TError,
      {
        policyId: string;
        assignmentId: string;
        data: LeavePolicyAssignmentUpdate;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut
      >
    >,
    TError,
    {
      policyId: string;
      assignmentId: string;
      data: LeavePolicyAssignmentUpdate;
    },
    TContext
  > => {
    const mutationKey = [
      'updateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut
        >
      >,
      {
        policyId: string;
        assignmentId: string;
        data: LeavePolicyAssignmentUpdate;
      }
    > = (props) => {
      const { policyId, assignmentId, data } = props ?? {};

      return updateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut(
        policyId,
        assignmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut
      >
    >
  >;
export type UpdateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPutMutationBody =
  LeavePolicyAssignmentUpdate;
export type UpdateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Leave Policy Assignment
 */
export const useUpdateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut
          >
        >,
        TError,
        {
          policyId: string;
          assignmentId: string;
          data: LeavePolicyAssignmentUpdate;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPut
      >
    >,
    TError,
    {
      policyId: string;
      assignmentId: string;
      data: LeavePolicyAssignmentUpdate;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove an assignment. Balances and the ledger are left untouched.
 * @summary Delete Leave Policy Assignment
 */
export const deleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete =
  (policyId: string, assignmentId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/leave-policies/${policyId}/assignments/${assignmentId}`,
      method: 'DELETE'
    });
  };

export const getDeleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete
        >
      >,
      TError,
      { policyId: string; assignmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete
      >
    >,
    TError,
    { policyId: string; assignmentId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete
        >
      >,
      { policyId: string; assignmentId: string }
    > = (props) => {
      const { policyId, assignmentId } = props ?? {};

      return deleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete(
        policyId,
        assignmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete
      >
    >
  >;

export type DeleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Leave Policy Assignment
 */
export const useDeleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete
          >
        >,
        TError,
        { policyId: string; assignmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDelete
      >
    >,
    TError,
    { policyId: string; assignmentId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteLeavePolicyAssignmentApiV1PeopleLeavePoliciesPolicyIdAssignmentsAssignmentIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Every mutation to this employee's leave balances, newest first.

The answer to "why is my balance this number?" — each line names what
changed it, by how much, when, why, and whether a person or the nightly
accrual engine did it.
 * @summary Get Leave Balance Ledger
 */
export const getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet =
  (
    employeeId: string,
    params?: GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<LeaveBalanceLedgerResponse>({
      url: `/api/v1/people/employees/${employeeId}/leave-ledger`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetQueryKey =
  (
    employeeId?: string,
    params?: GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetParams
  ) => {
    return [
      `/api/v1/people/employees/${employeeId}/leave-ledger`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    params?: GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetQueryKey(
        employeeId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
        >
      >
    > = ({ signal }) =>
      getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet(
        employeeId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
      >
    >
  >;
export type GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetQueryError =
  HTTPValidationError;

export function useGetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet<
  TData = Awaited<
    ReturnType<
      typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params:
    | undefined
    | GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet<
  TData = Awaited<
    ReturnType<
      typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet<
  TData = Awaited<
    ReturnType<
      typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Leave Balance Ledger
 */

export function useGetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet<
  TData = Awaited<
    ReturnType<
      typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeaveBalanceLedgerApiV1PeopleEmployeesEmployeeIdLeaveLedgerGetQueryOptions(
      employeeId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a leave policy by ID.
 * @summary Get Leave Policy
 */
export const getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet = (
  policyId: string,
  signal?: AbortSignal
) => {
  return customInstance<LeavePolicyResponse>({
    url: `/api/v1/people/leave-policies/${policyId}`,
    method: 'GET',
    signal
  });
};

export const getGetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGetQueryKey = (
  policyId?: string
) => {
  return [`/api/v1/people/leave-policies/${policyId}`] as const;
};

export const getGetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
    >,
    TError = HTTPValidationError
  >(
    policyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGetQueryKey(policyId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
      >
    > = ({ signal }) =>
      getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet(policyId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!policyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
    >
  >;
export type GetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGetQueryError =
  HTTPValidationError;

export function useGetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Leave Policy
 */

export function useGetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeavePolicyApiV1PeopleLeavePoliciesPolicyIdGetQueryOptions(
      policyId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a leave policy.

Admin-gated: rewriting ``days_per_year`` or ``accrual_method`` re-bases the
entitlement the nightly accrual task credits for every employee the policy
reaches.
 * @summary Update Leave Policy
 */
export const updateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut = (
  policyId: string,
  leavePolicyUpdate: LeavePolicyUpdate
) => {
  return customInstance<LeavePolicyResponse>({
    url: `/api/v1/people/leave-policies/${policyId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: leavePolicyUpdate
  });
};

export const getUpdateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut>
      >,
      TError,
      { policyId: string; data: LeavePolicyUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut>
    >,
    TError,
    { policyId: string; data: LeavePolicyUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut>
      >,
      { policyId: string; data: LeavePolicyUpdate }
    > = (props) => {
      const { policyId, data } = props ?? {};

      return updateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut(
        policyId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut>
    >
  >;
export type UpdateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPutMutationBody =
  LeavePolicyUpdate;
export type UpdateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Leave Policy
 */
export const useUpdateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut>
      >,
      TError,
      { policyId: string; data: LeavePolicyUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPut>
  >,
  TError,
  { policyId: string; data: LeavePolicyUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateLeavePolicyApiV1PeopleLeavePoliciesPolicyIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft delete a leave policy. Balances and the ledger are left untouched.

Admin-gated: retiring a policy stops every employee it reaches from accruing.
 * @summary Delete Leave Policy
 */
export const deleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete = (
  policyId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/leave-policies/${policyId}`,
    method: 'DELETE'
  });
};

export const getDeleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete
        >
      >,
      TError,
      { policyId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete>
    >,
    TError,
    { policyId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete
        >
      >,
      { policyId: string }
    > = (props) => {
      const { policyId } = props ?? {};

      return deleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete(policyId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete>
    >
  >;

export type DeleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Leave Policy
 */
export const useDeleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete
        >
      >,
      TError,
      { policyId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDelete>
  >,
  TError,
  { policyId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteLeavePolicyApiV1PeopleLeavePoliciesPolicyIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get leave balances for an employee.
 * @summary Get Leave Balances
 */
export const getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet = (
  employeeId: string,
  params?: GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeaveBalanceResponse[]>({
    url: `/api/v1/people/employees/${employeeId}/leave-balances`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetQueryKey =
  (
    employeeId?: string,
    params?: GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetParams
  ) => {
    return [
      `/api/v1/people/employees/${employeeId}/leave-balances`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    params?: GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetQueryKey(
        employeeId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
        >
      >
    > = ({ signal }) =>
      getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet(
        employeeId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
      >
    >
  >;
export type GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetQueryError =
  HTTPValidationError;

export function useGetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet<
  TData = Awaited<
    ReturnType<
      typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params:
    | undefined
    | GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet<
  TData = Awaited<
    ReturnType<
      typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet<
  TData = Awaited<
    ReturnType<
      typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Leave Balances
 */

export function useGetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet<
  TData = Awaited<
    ReturnType<
      typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeaveBalancesApiV1PeopleEmployeesEmployeeIdLeaveBalancesGetQueryOptions(
      employeeId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Manually adjust a leave balance.
 * @summary Adjust Leave Balance
 */
export const adjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost =
  (
    employeeId: string,
    balanceId: string,
    leaveBalanceAdjust: LeaveBalanceAdjust,
    signal?: AbortSignal
  ) => {
    return customInstance<LeaveBalanceResponse>({
      url: `/api/v1/people/employees/${employeeId}/leave-balances/${balanceId}/adjust`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: leaveBalanceAdjust,
      signal
    });
  };

export const getAdjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof adjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost
        >
      >,
      TError,
      { employeeId: string; balanceId: string; data: LeaveBalanceAdjust },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof adjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost
      >
    >,
    TError,
    { employeeId: string; balanceId: string; data: LeaveBalanceAdjust },
    TContext
  > => {
    const mutationKey = [
      'adjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof adjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost
        >
      >,
      { employeeId: string; balanceId: string; data: LeaveBalanceAdjust }
    > = (props) => {
      const { employeeId, balanceId, data } = props ?? {};

      return adjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost(
        employeeId,
        balanceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AdjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof adjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost
      >
    >
  >;
export type AdjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPostMutationBody =
  LeaveBalanceAdjust;
export type AdjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPostMutationError =
  HTTPValidationError;

/**
 * @summary Adjust Leave Balance
 */
export const useAdjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof adjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost
          >
        >,
        TError,
        { employeeId: string; balanceId: string; data: LeaveBalanceAdjust },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof adjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPost
      >
    >,
    TError,
    { employeeId: string; balanceId: string; data: LeaveBalanceAdjust },
    TContext
  > => {
    const mutationOptions =
      getAdjustLeaveBalanceApiV1PeopleEmployeesEmployeeIdLeaveBalancesBalanceIdAdjustPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List one page of leave requests. Leave requests accumulate (Shape A), so
the page window, search and sort all resolve server-side.
 * @summary List Leave Requests
 */
export const listLeaveRequestsApiV1PeopleLeaveRequestsGet = (
  params?: ListLeaveRequestsApiV1PeopleLeaveRequestsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeaveRequestListResponse>({
    url: `/api/v1/people/leave-requests`,
    method: 'GET',
    params,
    signal
  });
};

export const getListLeaveRequestsApiV1PeopleLeaveRequestsGetQueryKey = (
  params?: ListLeaveRequestsApiV1PeopleLeaveRequestsGetParams
) => {
  return [
    `/api/v1/people/leave-requests`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListLeaveRequestsApiV1PeopleLeaveRequestsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeaveRequestsApiV1PeopleLeaveRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListLeaveRequestsApiV1PeopleLeaveRequestsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>>
  > = ({ signal }) =>
    listLeaveRequestsApiV1PeopleLeaveRequestsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListLeaveRequestsApiV1PeopleLeaveRequestsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>>
  >;
export type ListLeaveRequestsApiV1PeopleLeaveRequestsGetQueryError =
  HTTPValidationError;

export function useListLeaveRequestsApiV1PeopleLeaveRequestsGet<
  TData = Awaited<
    ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListLeaveRequestsApiV1PeopleLeaveRequestsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLeaveRequestsApiV1PeopleLeaveRequestsGet<
  TData = Awaited<
    ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeaveRequestsApiV1PeopleLeaveRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLeaveRequestsApiV1PeopleLeaveRequestsGet<
  TData = Awaited<
    ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeaveRequestsApiV1PeopleLeaveRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Leave Requests
 */

export function useListLeaveRequestsApiV1PeopleLeaveRequestsGet<
  TData = Awaited<
    ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeaveRequestsApiV1PeopleLeaveRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveRequestsApiV1PeopleLeaveRequestsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLeaveRequestsApiV1PeopleLeaveRequestsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Submit a new leave request.
 * @summary Create Leave Request
 */
export const createLeaveRequestApiV1PeopleLeaveRequestsPost = (
  leaveRequestCreate: LeaveRequestCreate,
  signal?: AbortSignal
) => {
  return customInstance<LeaveRequestResponse>({
    url: `/api/v1/people/leave-requests`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: leaveRequestCreate,
    signal
  });
};

export const getCreateLeaveRequestApiV1PeopleLeaveRequestsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createLeaveRequestApiV1PeopleLeaveRequestsPost>
      >,
      TError,
      { data: LeaveRequestCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createLeaveRequestApiV1PeopleLeaveRequestsPost>>,
    TError,
    { data: LeaveRequestCreate },
    TContext
  > => {
    const mutationKey = ['createLeaveRequestApiV1PeopleLeaveRequestsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createLeaveRequestApiV1PeopleLeaveRequestsPost>
      >,
      { data: LeaveRequestCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createLeaveRequestApiV1PeopleLeaveRequestsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateLeaveRequestApiV1PeopleLeaveRequestsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createLeaveRequestApiV1PeopleLeaveRequestsPost>>
  >;
export type CreateLeaveRequestApiV1PeopleLeaveRequestsPostMutationBody =
  LeaveRequestCreate;
export type CreateLeaveRequestApiV1PeopleLeaveRequestsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Leave Request
 */
export const useCreateLeaveRequestApiV1PeopleLeaveRequestsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createLeaveRequestApiV1PeopleLeaveRequestsPost>
      >,
      TError,
      { data: LeaveRequestCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createLeaveRequestApiV1PeopleLeaveRequestsPost>>,
  TError,
  { data: LeaveRequestCreate },
  TContext
> => {
  const mutationOptions =
    getCreateLeaveRequestApiV1PeopleLeaveRequestsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Cost a leave request before it is submitted.

Returns the chargeable day count with holidays and non-working days already
excluded, plus any blackout that would block or flag the request — so the
requester sees the real number and the real reason up front.
 * @summary Preview Leave Request
 */
export const previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet = (
  params: PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeaveRequestPreviewResponse>({
    url: `/api/v1/people/leave-requests/preview`,
    method: 'GET',
    params,
    signal
  });
};

export const getPreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetQueryKey =
  (params?: PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetParams) => {
    return [
      `/api/v1/people/leave-requests/preview`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getPreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet>
    >,
    TError = HTTPValidationError
  >(
    params: PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getPreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet>
      >
    > = ({ signal }) =>
      previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet>
    >
  >;
export type PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetQueryError =
  HTTPValidationError;

export function usePreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet<
  TData = Awaited<
    ReturnType<typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet>
  >,
  TError = HTTPValidationError
>(
  params: PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet<
  TData = Awaited<
    ReturnType<typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet>
  >,
  TError = HTTPValidationError
>(
  params: PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet<
  TData = Awaited<
    ReturnType<typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet>
  >,
  TError = HTTPValidationError
>(
  params: PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Preview Leave Request
 */

export function usePreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet<
  TData = Awaited<
    ReturnType<typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet>
  >,
  TError = HTTPValidationError
>(
  params: PreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewLeaveRequestApiV1PeopleLeaveRequestsPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getPreviewLeaveRequestApiV1PeopleLeaveRequestsPreviewGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Read ONE leave request.

A leave request has no page of its own, so the time-off list is its surface and
`/people/time-off?request={id}` is its deep link — from global search, and from
anything else that names the record rather than the page. Resolving that param
needs the record itself: it is very often outside the list's first page, and the
list route has no id filter, so the page cannot find it in what it already holds.

Declared BEFORE `POST /leave-requests` but AFTER the literal
`GET /leave-requests/preview`: Starlette matches in registration order, so a
parameter route ahead of a literal one swallows it (`rules-list-endpoints.md`).
 * @summary Get Leave Request
 */
export const getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet = (
  requestId: string,
  signal?: AbortSignal
) => {
  return customInstance<LeaveRequestResponse>({
    url: `/api/v1/people/leave-requests/${requestId}`,
    method: 'GET',
    signal
  });
};

export const getGetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGetQueryKey = (
  requestId?: string
) => {
  return [`/api/v1/people/leave-requests/${requestId}`] as const;
};

export const getGetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
    >,
    TError = HTTPValidationError
  >(
    requestId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGetQueryKey(requestId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
      >
    > = ({ signal }) =>
      getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet(requestId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!requestId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
    >
  >;
export type GetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGetQueryError =
  HTTPValidationError;

export function useGetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Leave Request
 */

export function useGetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getLeaveRequestApiV1PeopleLeaveRequestsRequestIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeaveRequestApiV1PeopleLeaveRequestsRequestIdGetQueryOptions(
      requestId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get leave requests for a specific employee.
 * @summary Get Employee Leave Requests
 */
export const getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet =
  (
    employeeId: string,
    params?: GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<LeaveRequestListResponse>({
      url: `/api/v1/people/employees/${employeeId}/leave-requests`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetQueryKey =
  (
    employeeId?: string,
    params?: GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetParams
  ) => {
    return [
      `/api/v1/people/employees/${employeeId}/leave-requests`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    params?: GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetQueryKey(
        employeeId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
        >
      >
    > = ({ signal }) =>
      getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet(
        employeeId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
      >
    >
  >;
export type GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetQueryError =
  HTTPValidationError;

export function useGetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params:
    | undefined
    | GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Employee Leave Requests
 */

export function useGetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEmployeeLeaveRequestsApiV1PeopleEmployeesEmployeeIdLeaveRequestsGetQueryOptions(
      employeeId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Approve or reject a leave request.
 * @summary Review Leave Request
 */
export const reviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost = (
  requestId: string,
  leaveRequestReview: LeaveRequestReview,
  signal?: AbortSignal
) => {
  return customInstance<LeaveRequestResponse>({
    url: `/api/v1/people/leave-requests/${requestId}/review`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: leaveRequestReview,
    signal
  });
};

export const getReviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost
        >
      >,
      TError,
      { requestId: string; data: LeaveRequestReview },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost
      >
    >,
    TError,
    { requestId: string; data: LeaveRequestReview },
    TContext
  > => {
    const mutationKey = [
      'reviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost
        >
      >,
      { requestId: string; data: LeaveRequestReview }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return reviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost
      >
    >
  >;
export type ReviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPostMutationBody =
  LeaveRequestReview;
export type ReviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Review Leave Request
 */
export const useReviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost
          >
        >,
        TError,
        { requestId: string; data: LeaveRequestReview },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPost
      >
    >,
    TError,
    { requestId: string; data: LeaveRequestReview },
    TContext
  > => {
    const mutationOptions =
      getReviewLeaveRequestApiV1PeopleLeaveRequestsRequestIdReviewPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Cancel a leave request.
 * @summary Cancel Leave Request
 */
export const cancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost = (
  requestId: string,
  signal?: AbortSignal
) => {
  return customInstance<LeaveRequestResponse>({
    url: `/api/v1/people/leave-requests/${requestId}/cancel`,
    method: 'POST',
    signal
  });
};

export const getCancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost
        >
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = [
      'cancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost
        >
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return cancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost(
        requestId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost
      >
    >
  >;

export type CancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Leave Request
 */
export const useCancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost
          >
        >,
        TError,
        { requestId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationOptions =
      getCancelLeaveRequestApiV1PeopleLeaveRequestsRequestIdCancelPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get approved leaves for a date range (calendar view).
 * @summary Get Leave Calendar
 */
export const getLeaveCalendarApiV1PeopleLeaveCalendarGet = (
  params: GetLeaveCalendarApiV1PeopleLeaveCalendarGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeaveRequestResponse[]>({
    url: `/api/v1/people/leave-calendar`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetLeaveCalendarApiV1PeopleLeaveCalendarGetQueryKey = (
  params?: GetLeaveCalendarApiV1PeopleLeaveCalendarGetParams
) => {
  return [
    `/api/v1/people/leave-calendar`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetLeaveCalendarApiV1PeopleLeaveCalendarGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetLeaveCalendarApiV1PeopleLeaveCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetLeaveCalendarApiV1PeopleLeaveCalendarGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>>
  > = ({ signal }) =>
    getLeaveCalendarApiV1PeopleLeaveCalendarGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLeaveCalendarApiV1PeopleLeaveCalendarGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>>
  >;
export type GetLeaveCalendarApiV1PeopleLeaveCalendarGetQueryError =
  HTTPValidationError;

export function useGetLeaveCalendarApiV1PeopleLeaveCalendarGet<
  TData = Awaited<
    ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetLeaveCalendarApiV1PeopleLeaveCalendarGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeaveCalendarApiV1PeopleLeaveCalendarGet<
  TData = Awaited<
    ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetLeaveCalendarApiV1PeopleLeaveCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeaveCalendarApiV1PeopleLeaveCalendarGet<
  TData = Awaited<
    ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetLeaveCalendarApiV1PeopleLeaveCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Leave Calendar
 */

export function useGetLeaveCalendarApiV1PeopleLeaveCalendarGet<
  TData = Awaited<
    ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetLeaveCalendarApiV1PeopleLeaveCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLeaveCalendarApiV1PeopleLeaveCalendarGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeaveCalendarApiV1PeopleLeaveCalendarGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List holiday calendars.
 * @summary List Holiday Calendars
 */
export const listHolidayCalendarsApiV1PeopleHolidayCalendarsGet = (
  params?: ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleHolidayCalendarListResponse>({
    url: `/api/v1/people/holiday-calendars`,
    method: 'GET',
    params,
    signal
  });
};

export const getListHolidayCalendarsApiV1PeopleHolidayCalendarsGetQueryKey = (
  params?: ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetParams
) => {
  return [
    `/api/v1/people/holiday-calendars`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListHolidayCalendarsApiV1PeopleHolidayCalendarsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListHolidayCalendarsApiV1PeopleHolidayCalendarsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
      >
    > = ({ signal }) =>
      listHolidayCalendarsApiV1PeopleHolidayCalendarsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
    >
  >;
export type ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetQueryError =
  HTTPValidationError;

export function useListHolidayCalendarsApiV1PeopleHolidayCalendarsGet<
  TData = Awaited<
    ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListHolidayCalendarsApiV1PeopleHolidayCalendarsGet<
  TData = Awaited<
    ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListHolidayCalendarsApiV1PeopleHolidayCalendarsGet<
  TData = Awaited<
    ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Holiday Calendars
 */

export function useListHolidayCalendarsApiV1PeopleHolidayCalendarsGet<
  TData = Awaited<
    ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHolidayCalendarsApiV1PeopleHolidayCalendarsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listHolidayCalendarsApiV1PeopleHolidayCalendarsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListHolidayCalendarsApiV1PeopleHolidayCalendarsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a holiday calendar.
 * @summary Create Holiday Calendar
 */
export const createHolidayCalendarApiV1PeopleHolidayCalendarsPost = (
  peopleHolidayCalendarCreate: PeopleHolidayCalendarCreate,
  signal?: AbortSignal
) => {
  return customInstance<PeopleHolidayCalendarResponse>({
    url: `/api/v1/people/holiday-calendars`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: peopleHolidayCalendarCreate,
    signal
  });
};

export const getCreateHolidayCalendarApiV1PeopleHolidayCalendarsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createHolidayCalendarApiV1PeopleHolidayCalendarsPost>
      >,
      TError,
      { data: PeopleHolidayCalendarCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createHolidayCalendarApiV1PeopleHolidayCalendarsPost>
    >,
    TError,
    { data: PeopleHolidayCalendarCreate },
    TContext
  > => {
    const mutationKey = [
      'createHolidayCalendarApiV1PeopleHolidayCalendarsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createHolidayCalendarApiV1PeopleHolidayCalendarsPost>
      >,
      { data: PeopleHolidayCalendarCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createHolidayCalendarApiV1PeopleHolidayCalendarsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateHolidayCalendarApiV1PeopleHolidayCalendarsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createHolidayCalendarApiV1PeopleHolidayCalendarsPost>
    >
  >;
export type CreateHolidayCalendarApiV1PeopleHolidayCalendarsPostMutationBody =
  PeopleHolidayCalendarCreate;
export type CreateHolidayCalendarApiV1PeopleHolidayCalendarsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Holiday Calendar
 */
export const useCreateHolidayCalendarApiV1PeopleHolidayCalendarsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createHolidayCalendarApiV1PeopleHolidayCalendarsPost>
      >,
      TError,
      { data: PeopleHolidayCalendarCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createHolidayCalendarApiV1PeopleHolidayCalendarsPost>
  >,
  TError,
  { data: PeopleHolidayCalendarCreate },
  TContext
> => {
  const mutationOptions =
    getCreateHolidayCalendarApiV1PeopleHolidayCalendarsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get one holiday calendar.
 * @summary Get Holiday Calendar
 */
export const getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet = (
  calendarId: string,
  signal?: AbortSignal
) => {
  return customInstance<PeopleHolidayCalendarResponse>({
    url: `/api/v1/people/holiday-calendars/${calendarId}`,
    method: 'GET',
    signal
  });
};

export const getGetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGetQueryKey =
  (calendarId?: string) => {
    return [`/api/v1/people/holiday-calendars/${calendarId}`] as const;
  };

export const getGetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    calendarId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGetQueryKey(
        calendarId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
        >
      >
    > = ({ signal }) =>
      getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet(
        calendarId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!calendarId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
      >
    >
  >;
export type GetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGetQueryError =
  HTTPValidationError;

export function useGetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet<
  TData = Awaited<
    ReturnType<
      typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
    >
  >,
  TError = HTTPValidationError
>(
  calendarId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet<
  TData = Awaited<
    ReturnType<
      typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
    >
  >,
  TError = HTTPValidationError
>(
  calendarId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet<
  TData = Awaited<
    ReturnType<
      typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
    >
  >,
  TError = HTTPValidationError
>(
  calendarId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Holiday Calendar
 */

export function useGetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet<
  TData = Awaited<
    ReturnType<
      typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
    >
  >,
  TError = HTTPValidationError
>(
  calendarId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdGetQueryOptions(
      calendarId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a holiday calendar.
 * @summary Update Holiday Calendar
 */
export const updateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut = (
  calendarId: string,
  peopleHolidayCalendarUpdate: PeopleHolidayCalendarUpdate
) => {
  return customInstance<PeopleHolidayCalendarResponse>({
    url: `/api/v1/people/holiday-calendars/${calendarId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: peopleHolidayCalendarUpdate
  });
};

export const getUpdateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut
        >
      >,
      TError,
      { calendarId: string; data: PeopleHolidayCalendarUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut
      >
    >,
    TError,
    { calendarId: string; data: PeopleHolidayCalendarUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut
        >
      >,
      { calendarId: string; data: PeopleHolidayCalendarUpdate }
    > = (props) => {
      const { calendarId, data } = props ?? {};

      return updateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut(
        calendarId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut
      >
    >
  >;
export type UpdateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPutMutationBody =
  PeopleHolidayCalendarUpdate;
export type UpdateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Holiday Calendar
 */
export const useUpdateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut
          >
        >,
        TError,
        { calendarId: string; data: PeopleHolidayCalendarUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPut
      >
    >,
    TError,
    { calendarId: string; data: PeopleHolidayCalendarUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a holiday calendar (soft delete; its entries go with it).
 * @summary Delete Holiday Calendar
 */
export const deleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete =
  (calendarId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/holiday-calendars/${calendarId}`,
      method: 'DELETE'
    });
  };

export const getDeleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete
        >
      >,
      TError,
      { calendarId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete
      >
    >,
    TError,
    { calendarId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete
        >
      >,
      { calendarId: string }
    > = (props) => {
      const { calendarId } = props ?? {};

      return deleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete(
        calendarId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete
      >
    >
  >;

export type DeleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Holiday Calendar
 */
export const useDeleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete
          >
        >,
        TError,
        { calendarId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDelete
      >
    >,
    TError,
    { calendarId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List a calendar's dated entries, optionally for one year.
 * @summary List Holiday Entries
 */
export const listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet =
  (
    calendarId: string,
    params?: ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<HolidayEntryResponse[]>({
      url: `/api/v1/people/holiday-calendars/${calendarId}/entries`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetQueryKey =
  (
    calendarId?: string,
    params?: ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetParams
  ) => {
    return [
      `/api/v1/people/holiday-calendars/${calendarId}/entries`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
      >
    >,
    TError = HTTPValidationError
  >(
    calendarId: string,
    params?: ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetQueryKey(
        calendarId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
        >
      >
    > = ({ signal }) =>
      listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet(
        calendarId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!calendarId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
      >
    >
  >;
export type ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetQueryError =
  HTTPValidationError;

export function useListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  calendarId: string,
  params:
    | undefined
    | ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  calendarId: string,
  params?: ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  calendarId: string,
  params?: ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Holiday Entries
 */

export function useListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  calendarId: string,
  params?: ListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListHolidayEntriesApiV1PeopleHolidayCalendarsCalendarIdEntriesGetQueryOptions(
      calendarId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a dated entry to a holiday calendar.
 * @summary Create Holiday Entry
 */
export const createHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost =
  (
    calendarId: string,
    holidayEntryCreate: HolidayEntryCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<HolidayEntryResponse>({
      url: `/api/v1/people/holiday-calendars/${calendarId}/entries`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: holidayEntryCreate,
      signal
    });
  };

export const getCreateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost
        >
      >,
      TError,
      { calendarId: string; data: HolidayEntryCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost
      >
    >,
    TError,
    { calendarId: string; data: HolidayEntryCreate },
    TContext
  > => {
    const mutationKey = [
      'createHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost
        >
      >,
      { calendarId: string; data: HolidayEntryCreate }
    > = (props) => {
      const { calendarId, data } = props ?? {};

      return createHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost(
        calendarId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost
      >
    >
  >;
export type CreateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPostMutationBody =
  HolidayEntryCreate;
export type CreateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Holiday Entry
 */
export const useCreateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost
          >
        >,
        TError,
        { calendarId: string; data: HolidayEntryCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPost
      >
    >,
    TError,
    { calendarId: string; data: HolidayEntryCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a holiday calendar entry.
 * @summary Update Holiday Entry
 */
export const updateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut =
  (
    calendarId: string,
    entryId: string,
    holidayEntryUpdate: HolidayEntryUpdate
  ) => {
    return customInstance<HolidayEntryResponse>({
      url: `/api/v1/people/holiday-calendars/${calendarId}/entries/${entryId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: holidayEntryUpdate
    });
  };

export const getUpdateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut
        >
      >,
      TError,
      { calendarId: string; entryId: string; data: HolidayEntryUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut
      >
    >,
    TError,
    { calendarId: string; entryId: string; data: HolidayEntryUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut
        >
      >,
      { calendarId: string; entryId: string; data: HolidayEntryUpdate }
    > = (props) => {
      const { calendarId, entryId, data } = props ?? {};

      return updateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut(
        calendarId,
        entryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut
      >
    >
  >;
export type UpdateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPutMutationBody =
  HolidayEntryUpdate;
export type UpdateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Holiday Entry
 */
export const useUpdateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut
          >
        >,
        TError,
        { calendarId: string; entryId: string; data: HolidayEntryUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPut
      >
    >,
    TError,
    { calendarId: string; entryId: string; data: HolidayEntryUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a holiday calendar entry.
 * @summary Delete Holiday Entry
 */
export const deleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete =
  (calendarId: string, entryId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/holiday-calendars/${calendarId}/entries/${entryId}`,
      method: 'DELETE'
    });
  };

export const getDeleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete
        >
      >,
      TError,
      { calendarId: string; entryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete
      >
    >,
    TError,
    { calendarId: string; entryId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete
        >
      >,
      { calendarId: string; entryId: string }
    > = (props) => {
      const { calendarId, entryId } = props ?? {};

      return deleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete(
        calendarId,
        entryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete
      >
    >
  >;

export type DeleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Holiday Entry
 */
export const useDeleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete
          >
        >,
        TError,
        { calendarId: string; entryId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDelete
      >
    >,
    TError,
    { calendarId: string; entryId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteHolidayEntryApiV1PeopleHolidayCalendarsCalendarIdEntriesEntryIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The shipped per-country holiday sets available to seed a calendar from.

Static shipped reference data — no tenant rows are read, so no DB session.
 * @summary List Holiday Seeds
 */
export const listHolidaySeedsApiV1PeopleHolidaySeedsGet = (
  signal?: AbortSignal
) => {
  return customInstance<HolidaySeedCountry[]>({
    url: `/api/v1/people/holiday-seeds`,
    method: 'GET',
    signal
  });
};

export const getListHolidaySeedsApiV1PeopleHolidaySeedsGetQueryKey = () => {
  return [`/api/v1/people/holiday-seeds`] as const;
};

export const getListHolidaySeedsApiV1PeopleHolidaySeedsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListHolidaySeedsApiV1PeopleHolidaySeedsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>
  > = ({ signal }) => listHolidaySeedsApiV1PeopleHolidaySeedsGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListHolidaySeedsApiV1PeopleHolidaySeedsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>
>;
export type ListHolidaySeedsApiV1PeopleHolidaySeedsGetQueryError = unknown;

export function useListHolidaySeedsApiV1PeopleHolidaySeedsGet<
  TData = Awaited<
    ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>
          >,
          TError,
          Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListHolidaySeedsApiV1PeopleHolidaySeedsGet<
  TData = Awaited<
    ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>
          >,
          TError,
          Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListHolidaySeedsApiV1PeopleHolidaySeedsGet<
  TData = Awaited<
    ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Holiday Seeds
 */

export function useListHolidaySeedsApiV1PeopleHolidaySeedsGet<
  TData = Awaited<
    ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHolidaySeedsApiV1PeopleHolidaySeedsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListHolidaySeedsApiV1PeopleHolidaySeedsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fill one year of a calendar from the shipped set for a country.

Replaces only previously-seeded entries — the tenant's own additions and
edits survive re-seeding.
 * @summary Seed Holiday Calendar
 */
export const seedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost =
  (
    calendarId: string,
    holidaySeedRequest: HolidaySeedRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<HolidaySeedResponse>({
      url: `/api/v1/people/holiday-calendars/${calendarId}/seed`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: holidaySeedRequest,
      signal
    });
  };

export const getSeedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof seedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost
        >
      >,
      TError,
      { calendarId: string; data: HolidaySeedRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof seedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost
      >
    >,
    TError,
    { calendarId: string; data: HolidaySeedRequest },
    TContext
  > => {
    const mutationKey = [
      'seedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof seedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost
        >
      >,
      { calendarId: string; data: HolidaySeedRequest }
    > = (props) => {
      const { calendarId, data } = props ?? {};

      return seedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost(
        calendarId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SeedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof seedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost
      >
    >
  >;
export type SeedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPostMutationBody =
  HolidaySeedRequest;
export type SeedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPostMutationError =
  HTTPValidationError;

/**
 * @summary Seed Holiday Calendar
 */
export const useSeedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof seedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost
          >
        >,
        TError,
        { calendarId: string; data: HolidaySeedRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof seedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPost
      >
    >,
    TError,
    { calendarId: string; data: HolidaySeedRequest },
    TContext
  > => {
    const mutationOptions =
      getSeedHolidayCalendarApiV1PeopleHolidayCalendarsCalendarIdSeedPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List leave blackout ranges.
 * @summary List Leave Blackouts
 */
export const listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet = (
  params?: ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<LeaveBlackoutListResponse>({
    url: `/api/v1/people/leave-blackouts`,
    method: 'GET',
    params,
    signal
  });
};

export const getListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetQueryKey = (
  params?: ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetParams
) => {
  return [
    `/api/v1/people/leave-blackouts`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>>
  > = ({ signal }) =>
    listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>>
  >;
export type ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetQueryError =
  HTTPValidationError;

export function useListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet<
  TData = Awaited<
    ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet<
  TData = Awaited<
    ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet<
  TData = Awaited<
    ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Leave Blackouts
 */

export function useListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet<
  TData = Awaited<
    ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLeaveBlackoutsApiV1PeopleLeaveBlackoutsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLeaveBlackoutsApiV1PeopleLeaveBlackoutsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a leave blackout range.
 * @summary Create Leave Blackout
 */
export const createLeaveBlackoutApiV1PeopleLeaveBlackoutsPost = (
  leaveBlackoutCreate: LeaveBlackoutCreate,
  signal?: AbortSignal
) => {
  return customInstance<LeaveBlackoutResponse>({
    url: `/api/v1/people/leave-blackouts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: leaveBlackoutCreate,
    signal
  });
};

export const getCreateLeaveBlackoutApiV1PeopleLeaveBlackoutsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createLeaveBlackoutApiV1PeopleLeaveBlackoutsPost>
      >,
      TError,
      { data: LeaveBlackoutCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createLeaveBlackoutApiV1PeopleLeaveBlackoutsPost>
    >,
    TError,
    { data: LeaveBlackoutCreate },
    TContext
  > => {
    const mutationKey = ['createLeaveBlackoutApiV1PeopleLeaveBlackoutsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createLeaveBlackoutApiV1PeopleLeaveBlackoutsPost>
      >,
      { data: LeaveBlackoutCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createLeaveBlackoutApiV1PeopleLeaveBlackoutsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateLeaveBlackoutApiV1PeopleLeaveBlackoutsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createLeaveBlackoutApiV1PeopleLeaveBlackoutsPost>>
  >;
export type CreateLeaveBlackoutApiV1PeopleLeaveBlackoutsPostMutationBody =
  LeaveBlackoutCreate;
export type CreateLeaveBlackoutApiV1PeopleLeaveBlackoutsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Leave Blackout
 */
export const useCreateLeaveBlackoutApiV1PeopleLeaveBlackoutsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createLeaveBlackoutApiV1PeopleLeaveBlackoutsPost>
      >,
      TError,
      { data: LeaveBlackoutCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createLeaveBlackoutApiV1PeopleLeaveBlackoutsPost>>,
  TError,
  { data: LeaveBlackoutCreate },
  TContext
> => {
  const mutationOptions =
    getCreateLeaveBlackoutApiV1PeopleLeaveBlackoutsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get one leave blackout.
 * @summary Get Leave Blackout
 */
export const getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet = (
  blackoutId: string,
  signal?: AbortSignal
) => {
  return customInstance<LeaveBlackoutResponse>({
    url: `/api/v1/people/leave-blackouts/${blackoutId}`,
    method: 'GET',
    signal
  });
};

export const getGetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGetQueryKey =
  (blackoutId?: string) => {
    return [`/api/v1/people/leave-blackouts/${blackoutId}`] as const;
  };

export const getGetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet>
    >,
    TError = HTTPValidationError
  >(
    blackoutId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGetQueryKey(
        blackoutId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
        >
      >
    > = ({ signal }) =>
      getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet(
        blackoutId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!blackoutId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet>
    >
  >;
export type GetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGetQueryError =
  HTTPValidationError;

export function useGetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet<
  TData = Awaited<
    ReturnType<typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet>
  >,
  TError = HTTPValidationError
>(
  blackoutId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet<
  TData = Awaited<
    ReturnType<typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet>
  >,
  TError = HTTPValidationError
>(
  blackoutId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet<
  TData = Awaited<
    ReturnType<typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet>
  >,
  TError = HTTPValidationError
>(
  blackoutId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Leave Blackout
 */

export function useGetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet<
  TData = Awaited<
    ReturnType<typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet>
  >,
  TError = HTTPValidationError
>(
  blackoutId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdGetQueryOptions(
      blackoutId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a leave blackout.
 * @summary Update Leave Blackout
 */
export const updateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut = (
  blackoutId: string,
  leaveBlackoutUpdate: LeaveBlackoutUpdate
) => {
  return customInstance<LeaveBlackoutResponse>({
    url: `/api/v1/people/leave-blackouts/${blackoutId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: leaveBlackoutUpdate
  });
};

export const getUpdateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut
        >
      >,
      TError,
      { blackoutId: string; data: LeaveBlackoutUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut
      >
    >,
    TError,
    { blackoutId: string; data: LeaveBlackoutUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut
        >
      >,
      { blackoutId: string; data: LeaveBlackoutUpdate }
    > = (props) => {
      const { blackoutId, data } = props ?? {};

      return updateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut(
        blackoutId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut
      >
    >
  >;
export type UpdateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPutMutationBody =
  LeaveBlackoutUpdate;
export type UpdateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Leave Blackout
 */
export const useUpdateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut
        >
      >,
      TError,
      { blackoutId: string; data: LeaveBlackoutUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPut>
  >,
  TError,
  { blackoutId: string; data: LeaveBlackoutUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a leave blackout.
 * @summary Delete Leave Blackout
 */
export const deleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete = (
  blackoutId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/leave-blackouts/${blackoutId}`,
    method: 'DELETE'
  });
};

export const getDeleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete
        >
      >,
      TError,
      { blackoutId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete
      >
    >,
    TError,
    { blackoutId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete
        >
      >,
      { blackoutId: string }
    > = (props) => {
      const { blackoutId } = props ?? {};

      return deleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete(
        blackoutId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete
      >
    >
  >;

export type DeleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Leave Blackout
 */
export const useDeleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete
        >
      >,
      TError,
      { blackoutId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDelete
    >
  >,
  TError,
  { blackoutId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteLeaveBlackoutApiV1PeopleLeaveBlackoutsBlackoutIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Holidays and blackouts for a date range, for the leave calendar overlay.
 * @summary Get Holiday Calendar Overlay
 */
export const getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet = (
  params: GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleHolidayCalendarOverlayResponse>({
    url: `/api/v1/people/holiday-calendar`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetQueryKey =
  (params?: GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetParams) => {
    return [
      `/api/v1/people/holiday-calendar`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet>
    >,
    TError = HTTPValidationError
  >(
    params: GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
        >
      >
    > = ({ signal }) =>
      getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet>
    >
  >;
export type GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetQueryError =
  HTTPValidationError;

export function useGetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet<
  TData = Awaited<
    ReturnType<typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet<
  TData = Awaited<
    ReturnType<typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet<
  TData = Awaited<
    ReturnType<typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Holiday Calendar Overlay
 */

export function useGetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet<
  TData = Awaited<
    ReturnType<typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHolidayCalendarOverlayApiV1PeopleHolidayCalendarGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetHolidayCalendarOverlayApiV1PeopleHolidayCalendarGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List skills for an employee.
 * @summary List Employee Skills
 */
export const listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet = (
  employeeId: string,
  signal?: AbortSignal
) => {
  return customInstance<SkillListResponse>({
    url: `/api/v1/people/employees/${employeeId}/skills`,
    method: 'GET',
    signal
  });
};

export const getListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGetQueryKey =
  (employeeId?: string) => {
    return [`/api/v1/people/employees/${employeeId}/skills`] as const;
  };

export const getListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGetQueryKey(
        employeeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
        >
      >
    > = ({ signal }) =>
      listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet(
        employeeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
      >
    >
  >;
export type ListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGetQueryError =
  HTTPValidationError;

export function useListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet<
  TData = Awaited<
    ReturnType<typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet<
  TData = Awaited<
    ReturnType<typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet<
  TData = Awaited<
    ReturnType<typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Employee Skills
 */

export function useListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet<
  TData = Awaited<
    ReturnType<typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet>
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListEmployeeSkillsApiV1PeopleEmployeesEmployeeIdSkillsGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a skill to an employee.
 * @summary Create Skill
 */
export const createSkillApiV1PeopleEmployeesEmployeeIdSkillsPost = (
  employeeId: string,
  skillCreate: SkillCreate,
  signal?: AbortSignal
) => {
  return customInstance<SkillResponse>({
    url: `/api/v1/people/employees/${employeeId}/skills`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: skillCreate,
    signal
  });
};

export const getCreateSkillApiV1PeopleEmployeesEmployeeIdSkillsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createSkillApiV1PeopleEmployeesEmployeeIdSkillsPost>
      >,
      TError,
      { employeeId: string; data: SkillCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createSkillApiV1PeopleEmployeesEmployeeIdSkillsPost>
    >,
    TError,
    { employeeId: string; data: SkillCreate },
    TContext
  > => {
    const mutationKey = ['createSkillApiV1PeopleEmployeesEmployeeIdSkillsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createSkillApiV1PeopleEmployeesEmployeeIdSkillsPost>
      >,
      { employeeId: string; data: SkillCreate }
    > = (props) => {
      const { employeeId, data } = props ?? {};

      return createSkillApiV1PeopleEmployeesEmployeeIdSkillsPost(
        employeeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateSkillApiV1PeopleEmployeesEmployeeIdSkillsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createSkillApiV1PeopleEmployeesEmployeeIdSkillsPost>
    >
  >;
export type CreateSkillApiV1PeopleEmployeesEmployeeIdSkillsPostMutationBody =
  SkillCreate;
export type CreateSkillApiV1PeopleEmployeesEmployeeIdSkillsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Skill
 */
export const useCreateSkillApiV1PeopleEmployeesEmployeeIdSkillsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createSkillApiV1PeopleEmployeesEmployeeIdSkillsPost>
      >,
      TError,
      { employeeId: string; data: SkillCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createSkillApiV1PeopleEmployeesEmployeeIdSkillsPost>
  >,
  TError,
  { employeeId: string; data: SkillCreate },
  TContext
> => {
  const mutationOptions =
    getCreateSkillApiV1PeopleEmployeesEmployeeIdSkillsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a skill.
 * @summary Update Skill
 */
export const updateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut = (
  employeeId: string,
  skillId: string,
  skillUpdate: SkillUpdate
) => {
  return customInstance<SkillResponse>({
    url: `/api/v1/people/employees/${employeeId}/skills/${skillId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: skillUpdate
  });
};

export const getUpdateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut
        >
      >,
      TError,
      { employeeId: string; skillId: string; data: SkillUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut
      >
    >,
    TError,
    { employeeId: string; skillId: string; data: SkillUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut
        >
      >,
      { employeeId: string; skillId: string; data: SkillUpdate }
    > = (props) => {
      const { employeeId, skillId, data } = props ?? {};

      return updateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut(
        employeeId,
        skillId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut
      >
    >
  >;
export type UpdateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPutMutationBody =
  SkillUpdate;
export type UpdateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Skill
 */
export const useUpdateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut
        >
      >,
      TError,
      { employeeId: string; skillId: string; data: SkillUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPut>
  >,
  TError,
  { employeeId: string; skillId: string; data: SkillUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a skill.
 * @summary Delete Skill
 */
export const deleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete = (
  employeeId: string,
  skillId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/employees/${employeeId}/skills/${skillId}`,
    method: 'DELETE'
  });
};

export const getDeleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete
        >
      >,
      TError,
      { employeeId: string; skillId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete
      >
    >,
    TError,
    { employeeId: string; skillId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete
        >
      >,
      { employeeId: string; skillId: string }
    > = (props) => {
      const { employeeId, skillId } = props ?? {};

      return deleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete(
        employeeId,
        skillId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete
      >
    >
  >;

export type DeleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Skill
 */
export const useDeleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete
        >
      >,
      TError,
      { employeeId: string; skillId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDelete
    >
  >,
  TError,
  { employeeId: string; skillId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteSkillApiV1PeopleEmployeesEmployeeIdSkillsSkillIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List certifications expiring within N days, and those already lapsed.

The window has no lower bound: rows whose ``expiry_date`` has already passed
stay on the report with a NEGATIVE ``days_remaining``. That is the point of the
surface — a licence that lapsed last month is the operational failure, and
dropping it the day it expires is how it goes unnoticed.

Scoped to the caller's accessible employees under a restricted mode (skills
cascade wholly on the employee); tenant-wide in ``everyone`` mode / for admins.
 * @summary List Expiring Skills
 */
export const listExpiringSkillsApiV1PeopleSkillsExpiringGet = (
  params?: ListExpiringSkillsApiV1PeopleSkillsExpiringGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ExpiringSkillListResponse>({
    url: `/api/v1/people/skills/expiring`,
    method: 'GET',
    params,
    signal
  });
};

export const getListExpiringSkillsApiV1PeopleSkillsExpiringGetQueryKey = (
  params?: ListExpiringSkillsApiV1PeopleSkillsExpiringGetParams
) => {
  return [
    `/api/v1/people/skills/expiring`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListExpiringSkillsApiV1PeopleSkillsExpiringGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExpiringSkillsApiV1PeopleSkillsExpiringGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListExpiringSkillsApiV1PeopleSkillsExpiringGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>>
  > = ({ signal }) =>
    listExpiringSkillsApiV1PeopleSkillsExpiringGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListExpiringSkillsApiV1PeopleSkillsExpiringGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>>
  >;
export type ListExpiringSkillsApiV1PeopleSkillsExpiringGetQueryError =
  HTTPValidationError;

export function useListExpiringSkillsApiV1PeopleSkillsExpiringGet<
  TData = Awaited<
    ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListExpiringSkillsApiV1PeopleSkillsExpiringGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListExpiringSkillsApiV1PeopleSkillsExpiringGet<
  TData = Awaited<
    ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExpiringSkillsApiV1PeopleSkillsExpiringGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListExpiringSkillsApiV1PeopleSkillsExpiringGet<
  TData = Awaited<
    ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExpiringSkillsApiV1PeopleSkillsExpiringGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Expiring Skills
 */

export function useListExpiringSkillsApiV1PeopleSkillsExpiringGet<
  TData = Awaited<
    ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExpiringSkillsApiV1PeopleSkillsExpiringGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExpiringSkillsApiV1PeopleSkillsExpiringGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListExpiringSkillsApiV1PeopleSkillsExpiringGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Skill totals grouped by category and by proficiency level.

The aggregation the closed taxonomy makes possible: with both columns under a
CHECK sourced from ``shared/config`` (WI 5313b820), a category rollup is
trustworthy — before it, free text meant 'certs' and 'certification' were
different buckets.

Same visibility seam as ``/skills/expiring``: narrowed to the caller's
accessible employees under a restricted mode, tenant-wide otherwise, so the
totals equal what the governed lists return.
 * @summary Get Skill Summary
 */
export const getSkillSummaryApiV1PeopleSkillsSummaryGet = (
  signal?: AbortSignal
) => {
  return customInstance<SkillSummaryResponse>({
    url: `/api/v1/people/skills/summary`,
    method: 'GET',
    signal
  });
};

export const getGetSkillSummaryApiV1PeopleSkillsSummaryGetQueryKey = () => {
  return [`/api/v1/people/skills/summary`] as const;
};

export const getGetSkillSummaryApiV1PeopleSkillsSummaryGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSkillSummaryApiV1PeopleSkillsSummaryGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>
  > = ({ signal }) => getSkillSummaryApiV1PeopleSkillsSummaryGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSkillSummaryApiV1PeopleSkillsSummaryGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>
>;
export type GetSkillSummaryApiV1PeopleSkillsSummaryGetQueryError = unknown;

export function useGetSkillSummaryApiV1PeopleSkillsSummaryGet<
  TData = Awaited<
    ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>
          >,
          TError,
          Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSkillSummaryApiV1PeopleSkillsSummaryGet<
  TData = Awaited<
    ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>
          >,
          TError,
          Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSkillSummaryApiV1PeopleSkillsSummaryGet<
  TData = Awaited<
    ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Skill Summary
 */

export function useGetSkillSummaryApiV1PeopleSkillsSummaryGet<
  TData = Awaited<
    ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSkillSummaryApiV1PeopleSkillsSummaryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSkillSummaryApiV1PeopleSkillsSummaryGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List checklist templates of one kind, with search, sort and pagination.

``limit`` is unset by default (full dataset, capped at ``MAX_LIST_LIMIT``) per
docs/design-system/ui-list-pages.md §11, so the template picker on the
employee onboarding/offboarding section still receives every active template.
``total`` is the count over the same predicate, never the page length.
 * @summary List Templates
 */
export const listTemplatesApiV1PeopleOnboardingTemplatesGet = (
  params?: ListTemplatesApiV1PeopleOnboardingTemplatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<TemplateListResponse>({
    url: `/api/v1/people/onboarding/templates`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTemplatesApiV1PeopleOnboardingTemplatesGetQueryKey = (
  params?: ListTemplatesApiV1PeopleOnboardingTemplatesGetParams
) => {
  return [
    `/api/v1/people/onboarding/templates`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListTemplatesApiV1PeopleOnboardingTemplatesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTemplatesApiV1PeopleOnboardingTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTemplatesApiV1PeopleOnboardingTemplatesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>>
  > = ({ signal }) =>
    listTemplatesApiV1PeopleOnboardingTemplatesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTemplatesApiV1PeopleOnboardingTemplatesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>>
  >;
export type ListTemplatesApiV1PeopleOnboardingTemplatesGetQueryError =
  HTTPValidationError;

export function useListTemplatesApiV1PeopleOnboardingTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListTemplatesApiV1PeopleOnboardingTemplatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTemplatesApiV1PeopleOnboardingTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTemplatesApiV1PeopleOnboardingTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTemplatesApiV1PeopleOnboardingTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTemplatesApiV1PeopleOnboardingTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Templates
 */

export function useListTemplatesApiV1PeopleOnboardingTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTemplatesApiV1PeopleOnboardingTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTemplatesApiV1PeopleOnboardingTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTemplatesApiV1PeopleOnboardingTemplatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a checklist template (onboarding by default; see ``kind``).
 * @summary Create Template
 */
export const createTemplateApiV1PeopleOnboardingTemplatesPost = (
  onboardingTemplateCreate: OnboardingTemplateCreate,
  signal?: AbortSignal
) => {
  return customInstance<TemplateResponse>({
    url: `/api/v1/people/onboarding/templates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: onboardingTemplateCreate,
    signal
  });
};

export const getCreateTemplateApiV1PeopleOnboardingTemplatesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createTemplateApiV1PeopleOnboardingTemplatesPost>
      >,
      TError,
      { data: OnboardingTemplateCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createTemplateApiV1PeopleOnboardingTemplatesPost>
    >,
    TError,
    { data: OnboardingTemplateCreate },
    TContext
  > => {
    const mutationKey = ['createTemplateApiV1PeopleOnboardingTemplatesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createTemplateApiV1PeopleOnboardingTemplatesPost>
      >,
      { data: OnboardingTemplateCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createTemplateApiV1PeopleOnboardingTemplatesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateTemplateApiV1PeopleOnboardingTemplatesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createTemplateApiV1PeopleOnboardingTemplatesPost>>
  >;
export type CreateTemplateApiV1PeopleOnboardingTemplatesPostMutationBody =
  OnboardingTemplateCreate;
export type CreateTemplateApiV1PeopleOnboardingTemplatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Template
 */
export const useCreateTemplateApiV1PeopleOnboardingTemplatesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createTemplateApiV1PeopleOnboardingTemplatesPost>
      >,
      TError,
      { data: OnboardingTemplateCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTemplateApiV1PeopleOnboardingTemplatesPost>>,
  TError,
  { data: OnboardingTemplateCreate },
  TContext
> => {
  const mutationOptions =
    getCreateTemplateApiV1PeopleOnboardingTemplatesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Seed this tenant's default checklist from the shipped built-in definition.

Only offboarding ships a built-in default (the standard exit checklist);
asking for an onboarding one is a 400, because there is nothing sensible to
seed a new hire's checklist from. Idempotent — if the tenant already has a
template of that kind, it is returned untouched rather than duplicated.
 * @summary Ensure Default Template
 */
export const ensureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost = (
  ensureDefaultTemplateRequest: EnsureDefaultTemplateRequest,
  signal?: AbortSignal
) => {
  return customInstance<TemplateResponse>({
    url: `/api/v1/people/onboarding/templates/default`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ensureDefaultTemplateRequest,
    signal
  });
};

export const getEnsureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof ensureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost
        >
      >,
      TError,
      { data: EnsureDefaultTemplateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof ensureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost
      >
    >,
    TError,
    { data: EnsureDefaultTemplateRequest },
    TContext
  > => {
    const mutationKey = [
      'ensureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof ensureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost
        >
      >,
      { data: EnsureDefaultTemplateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return ensureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EnsureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof ensureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost
      >
    >
  >;
export type EnsureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPostMutationBody =
  EnsureDefaultTemplateRequest;
export type EnsureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPostMutationError =
  HTTPValidationError;

/**
 * @summary Ensure Default Template
 */
export const useEnsureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof ensureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost
          >
        >,
        TError,
        { data: EnsureDefaultTemplateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof ensureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPost
      >
    >,
    TError,
    { data: EnsureDefaultTemplateRequest },
    TContext
  > => {
    const mutationOptions =
      getEnsureDefaultTemplateApiV1PeopleOnboardingTemplatesDefaultPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get an onboarding template by ID.
 * @summary Get Template
 */
export const getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet = (
  templateId: string,
  signal?: AbortSignal
) => {
  return customInstance<TemplateResponse>({
    url: `/api/v1/people/onboarding/templates/${templateId}`,
    method: 'GET',
    signal
  });
};

export const getGetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGetQueryKey =
  (templateId?: string) => {
    return [`/api/v1/people/onboarding/templates/${templateId}`] as const;
  };

export const getGetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet>
    >,
    TError = HTTPValidationError
  >(
    templateId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGetQueryKey(
        templateId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
        >
      >
    > = ({ signal }) =>
      getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet(
        templateId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!templateId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet>
    >
  >;
export type GetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGetQueryError =
  HTTPValidationError;

export function useGetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Template
 */

export function useGetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplateApiV1PeopleOnboardingTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTemplateApiV1PeopleOnboardingTemplatesTemplateIdGetQueryOptions(
      templateId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an onboarding template.
 * @summary Update Template
 */
export const updateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut = (
  templateId: string,
  onboardingTemplateUpdate: OnboardingTemplateUpdate
) => {
  return customInstance<TemplateResponse>({
    url: `/api/v1/people/onboarding/templates/${templateId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: onboardingTemplateUpdate
  });
};

export const getUpdateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut
        >
      >,
      TError,
      { templateId: string; data: OnboardingTemplateUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut
      >
    >,
    TError,
    { templateId: string; data: OnboardingTemplateUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut
        >
      >,
      { templateId: string; data: OnboardingTemplateUpdate }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return updateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut
      >
    >
  >;
export type UpdateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPutMutationBody =
  OnboardingTemplateUpdate;
export type UpdateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Template
 */
export const useUpdateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut
        >
      >,
      TError,
      { templateId: string; data: OnboardingTemplateUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPut>
  >,
  TError,
  { templateId: string; data: OnboardingTemplateUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateTemplateApiV1PeopleOnboardingTemplatesTemplateIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete an onboarding template.
 * @summary Delete Template
 */
export const deleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete = (
  templateId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/onboarding/templates/${templateId}`,
    method: 'DELETE'
  });
};

export const getDeleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete
        >
      >,
      TError,
      { templateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete
        >
      >,
      { templateId: string }
    > = (props) => {
      const { templateId } = props ?? {};

      return deleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete(
        templateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete
      >
    >
  >;

export type DeleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Template
 */
export const useDeleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete
        >
      >,
      TError,
      { templateId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDelete
    >
  >,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteTemplateApiV1PeopleOnboardingTemplatesTemplateIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Start onboarding for an employee.

Returns a LIST because the applicable defaults stack: naming no template
starts the tenant-wide checklist and the hire's departmental one, as
separate instances. Naming one starts exactly that one.
 * @summary Start Onboarding
 */
export const startOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost =
  (
    employeeId: string,
    startOnboardingRequest: StartOnboardingRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<OnboardingInstanceListResponse>({
      url: `/api/v1/people/employees/${employeeId}/onboarding/start`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: startOnboardingRequest,
      signal
    });
  };

export const getStartOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof startOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost
        >
      >,
      TError,
      { employeeId: string; data: StartOnboardingRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof startOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost
      >
    >,
    TError,
    { employeeId: string; data: StartOnboardingRequest },
    TContext
  > => {
    const mutationKey = [
      'startOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof startOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost
        >
      >,
      { employeeId: string; data: StartOnboardingRequest }
    > = (props) => {
      const { employeeId, data } = props ?? {};

      return startOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost(
        employeeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StartOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof startOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost
      >
    >
  >;
export type StartOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPostMutationBody =
  StartOnboardingRequest;
export type StartOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPostMutationError =
  HTTPValidationError;

/**
 * @summary Start Onboarding
 */
export const useStartOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof startOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost
          >
        >,
        TError,
        { employeeId: string; data: StartOnboardingRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof startOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPost
      >
    >,
    TError,
    { employeeId: string; data: StartOnboardingRequest },
    TContext
  > => {
    const mutationOptions =
      getStartOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingStartPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get an employee's ONBOARDING instances.

Scoped to the onboarding kind — an employee's exit checklists are read
through ``GET /employees/{id}/offboarding``, so neither tab can show the
other's tasks.
 * @summary Get Employee Onboarding
 */
export const getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet =
  (employeeId: string, signal?: AbortSignal) => {
    return customInstance<OnboardingInstanceListResponse>({
      url: `/api/v1/people/employees/${employeeId}/onboarding`,
      method: 'GET',
      signal
    });
  };

export const getGetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGetQueryKey =
  (employeeId?: string) => {
    return [`/api/v1/people/employees/${employeeId}/onboarding`] as const;
  };

export const getGetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGetQueryKey(
        employeeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
        >
      >
    > = ({ signal }) =>
      getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet(
        employeeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
      >
    >
  >;
export type GetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGetQueryError =
  HTTPValidationError;

export function useGetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Employee Onboarding
 */

export function useGetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEmployeeOnboardingApiV1PeopleEmployeesEmployeeIdOnboardingGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an onboarding task status.
 * @summary Update Onboarding Task
 */
export const updateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut = (
  taskId: string,
  onboardingTaskUpdate: OnboardingTaskUpdate
) => {
  return customInstance<OnboardingTaskResponse>({
    url: `/api/v1/people/onboarding/tasks/${taskId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: onboardingTaskUpdate
  });
};

export const getUpdateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut
        >
      >,
      TError,
      { taskId: string; data: OnboardingTaskUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut>
    >,
    TError,
    { taskId: string; data: OnboardingTaskUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut
        >
      >,
      { taskId: string; data: OnboardingTaskUpdate }
    > = (props) => {
      const { taskId, data } = props ?? {};

      return updateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut(
        taskId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut>
    >
  >;
export type UpdateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPutMutationBody =
  OnboardingTaskUpdate;
export type UpdateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Onboarding Task
 */
export const useUpdateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut
        >
      >,
      TError,
      { taskId: string; data: OnboardingTaskUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPut>
  >,
  TError,
  { taskId: string; data: OnboardingTaskUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateOnboardingTaskApiV1PeopleOnboardingTasksTaskIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Apply an offboarding checklist to a departing employee.

Terminating an employee already does this; this route is for applying (or
re-applying) a checklist separately — e.g. a resignation announced before the
termination is recorded, or a second template layered on after the fact.

Returns a LIST for the same reason as its onboarding twin: naming no
template applies every default that fits — the tenant-wide one and the
leaver's departmental one — as separate instances.
 * @summary Start Offboarding
 */
export const startOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost =
  (
    employeeId: string,
    startOffboardingRequest: StartOffboardingRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<OnboardingInstanceListResponse>({
      url: `/api/v1/people/employees/${employeeId}/offboarding/start`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: startOffboardingRequest,
      signal
    });
  };

export const getStartOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof startOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost
        >
      >,
      TError,
      { employeeId: string; data: StartOffboardingRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof startOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost
      >
    >,
    TError,
    { employeeId: string; data: StartOffboardingRequest },
    TContext
  > => {
    const mutationKey = [
      'startOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof startOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost
        >
      >,
      { employeeId: string; data: StartOffboardingRequest }
    > = (props) => {
      const { employeeId, data } = props ?? {};

      return startOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost(
        employeeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StartOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof startOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost
      >
    >
  >;
export type StartOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPostMutationBody =
  StartOffboardingRequest;
export type StartOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPostMutationError =
  HTTPValidationError;

/**
 * @summary Start Offboarding
 */
export const useStartOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof startOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost
          >
        >,
        TError,
        { employeeId: string; data: StartOffboardingRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof startOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPost
      >
    >,
    TError,
    { employeeId: string; data: StartOffboardingRequest },
    TContext
  > => {
    const mutationOptions =
      getStartOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingStartPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get an employee's offboarding checklists and their progress.
 * @summary Get Employee Offboarding
 */
export const getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet =
  (employeeId: string, signal?: AbortSignal) => {
    return customInstance<OnboardingInstanceListResponse>({
      url: `/api/v1/people/employees/${employeeId}/offboarding`,
      method: 'GET',
      signal
    });
  };

export const getGetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGetQueryKey =
  (employeeId?: string) => {
    return [`/api/v1/people/employees/${employeeId}/offboarding`] as const;
  };

export const getGetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGetQueryKey(
        employeeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
        >
      >
    > = ({ signal }) =>
      getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet(
        employeeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
      >
    >
  >;
export type GetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGetQueryError =
  HTTPValidationError;

export function useGetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Employee Offboarding
 */

export function useGetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEmployeeOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Undo an offboarding started in error.

Cancels the in-progress exit checklists, reinstates the employee (reopening
the job and compensation records the termination closed) and restores the
linked user account. Nothing is deleted — the cancelled checklist and the
exit-interview notes stay on the record.
 * @summary Cancel Offboarding
 */
export const cancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost =
  (employeeId: string, signal?: AbortSignal) => {
    return customInstance<CancelOffboardingResponse>({
      url: `/api/v1/people/employees/${employeeId}/offboarding/cancel`,
      method: 'POST',
      signal
    });
  };

export const getCancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost
        >
      >,
      TError,
      { employeeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost
      >
    >,
    TError,
    { employeeId: string },
    TContext
  > => {
    const mutationKey = [
      'cancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost
        >
      >,
      { employeeId: string }
    > = (props) => {
      const { employeeId } = props ?? {};

      return cancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost(
        employeeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost
      >
    >
  >;

export type CancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Offboarding
 */
export const useCancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost
          >
        >,
        TError,
        { employeeId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPost
      >
    >,
    TError,
    { employeeId: string },
    TContext
  > => {
    const mutationOptions =
      getCancelOffboardingApiV1PeopleEmployeesEmployeeIdOffboardingCancelPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the tenant's rating scales, each with its points inline.
 * @summary List Rating Scales
 */
export const listRatingScalesApiV1PeopleRatingScalesGet = (
  params?: ListRatingScalesApiV1PeopleRatingScalesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<RatingScaleListResponse>({
    url: `/api/v1/people/rating-scales`,
    method: 'GET',
    params,
    signal
  });
};

export const getListRatingScalesApiV1PeopleRatingScalesGetQueryKey = (
  params?: ListRatingScalesApiV1PeopleRatingScalesGetParams
) => {
  return [`/api/v1/people/rating-scales`, ...(params ? [params] : [])] as const;
};

export const getListRatingScalesApiV1PeopleRatingScalesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRatingScalesApiV1PeopleRatingScalesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRatingScalesApiV1PeopleRatingScalesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>
  > = ({ signal }) =>
    listRatingScalesApiV1PeopleRatingScalesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListRatingScalesApiV1PeopleRatingScalesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>
>;
export type ListRatingScalesApiV1PeopleRatingScalesGetQueryError =
  HTTPValidationError;

export function useListRatingScalesApiV1PeopleRatingScalesGet<
  TData = Awaited<
    ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListRatingScalesApiV1PeopleRatingScalesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRatingScalesApiV1PeopleRatingScalesGet<
  TData = Awaited<
    ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRatingScalesApiV1PeopleRatingScalesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRatingScalesApiV1PeopleRatingScalesGet<
  TData = Awaited<
    ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRatingScalesApiV1PeopleRatingScalesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Rating Scales
 */

export function useListRatingScalesApiV1PeopleRatingScalesGet<
  TData = Awaited<
    ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListRatingScalesApiV1PeopleRatingScalesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRatingScalesApiV1PeopleRatingScalesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListRatingScalesApiV1PeopleRatingScalesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a rating scale together with its points.
 * @summary Create Rating Scale
 */
export const createRatingScaleApiV1PeopleRatingScalesPost = (
  ratingScaleCreate: RatingScaleCreate,
  signal?: AbortSignal
) => {
  return customInstance<RatingScale>({
    url: `/api/v1/people/rating-scales`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ratingScaleCreate,
    signal
  });
};

export const getCreateRatingScaleApiV1PeopleRatingScalesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRatingScaleApiV1PeopleRatingScalesPost>>,
    TError,
    { data: RatingScaleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRatingScaleApiV1PeopleRatingScalesPost>>,
  TError,
  { data: RatingScaleCreate },
  TContext
> => {
  const mutationKey = ['createRatingScaleApiV1PeopleRatingScalesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRatingScaleApiV1PeopleRatingScalesPost>>,
    { data: RatingScaleCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createRatingScaleApiV1PeopleRatingScalesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRatingScaleApiV1PeopleRatingScalesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createRatingScaleApiV1PeopleRatingScalesPost>>
  >;
export type CreateRatingScaleApiV1PeopleRatingScalesPostMutationBody =
  RatingScaleCreate;
export type CreateRatingScaleApiV1PeopleRatingScalesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Rating Scale
 */
export const useCreateRatingScaleApiV1PeopleRatingScalesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRatingScaleApiV1PeopleRatingScalesPost>>,
      TError,
      { data: RatingScaleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createRatingScaleApiV1PeopleRatingScalesPost>>,
  TError,
  { data: RatingScaleCreate },
  TContext
> => {
  const mutationOptions =
    getCreateRatingScaleApiV1PeopleRatingScalesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get one rating scale with its points.
 * @summary Get Rating Scale
 */
export const getRatingScaleApiV1PeopleRatingScalesScaleIdGet = (
  scaleId: string,
  signal?: AbortSignal
) => {
  return customInstance<RatingScale>({
    url: `/api/v1/people/rating-scales/${scaleId}`,
    method: 'GET',
    signal
  });
};

export const getGetRatingScaleApiV1PeopleRatingScalesScaleIdGetQueryKey = (
  scaleId?: string
) => {
  return [`/api/v1/people/rating-scales/${scaleId}`] as const;
};

export const getGetRatingScaleApiV1PeopleRatingScalesScaleIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
  >,
  TError = HTTPValidationError
>(
  scaleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRatingScaleApiV1PeopleRatingScalesScaleIdGetQueryKey(scaleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>>
  > = ({ signal }) =>
    getRatingScaleApiV1PeopleRatingScalesScaleIdGet(scaleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!scaleId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRatingScaleApiV1PeopleRatingScalesScaleIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>>
  >;
export type GetRatingScaleApiV1PeopleRatingScalesScaleIdGetQueryError =
  HTTPValidationError;

export function useGetRatingScaleApiV1PeopleRatingScalesScaleIdGet<
  TData = Awaited<
    ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
  >,
  TError = HTTPValidationError
>(
  scaleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRatingScaleApiV1PeopleRatingScalesScaleIdGet<
  TData = Awaited<
    ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
  >,
  TError = HTTPValidationError
>(
  scaleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRatingScaleApiV1PeopleRatingScalesScaleIdGet<
  TData = Awaited<
    ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
  >,
  TError = HTTPValidationError
>(
  scaleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Rating Scale
 */

export function useGetRatingScaleApiV1PeopleRatingScalesScaleIdGet<
  TData = Awaited<
    ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
  >,
  TError = HTTPValidationError
>(
  scaleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getRatingScaleApiV1PeopleRatingScalesScaleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetRatingScaleApiV1PeopleRatingScalesScaleIdGetQueryOptions(
      scaleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a rating scale. Sending `points` replaces the whole set.
 * @summary Update Rating Scale
 */
export const updateRatingScaleApiV1PeopleRatingScalesScaleIdPut = (
  scaleId: string,
  ratingScaleUpdate: RatingScaleUpdate
) => {
  return customInstance<RatingScale>({
    url: `/api/v1/people/rating-scales/${scaleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: ratingScaleUpdate
  });
};

export const getUpdateRatingScaleApiV1PeopleRatingScalesScaleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateRatingScaleApiV1PeopleRatingScalesScaleIdPut>
      >,
      TError,
      { scaleId: string; data: RatingScaleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateRatingScaleApiV1PeopleRatingScalesScaleIdPut>
    >,
    TError,
    { scaleId: string; data: RatingScaleUpdate },
    TContext
  > => {
    const mutationKey = ['updateRatingScaleApiV1PeopleRatingScalesScaleIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateRatingScaleApiV1PeopleRatingScalesScaleIdPut>
      >,
      { scaleId: string; data: RatingScaleUpdate }
    > = (props) => {
      const { scaleId, data } = props ?? {};

      return updateRatingScaleApiV1PeopleRatingScalesScaleIdPut(scaleId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateRatingScaleApiV1PeopleRatingScalesScaleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateRatingScaleApiV1PeopleRatingScalesScaleIdPut>
    >
  >;
export type UpdateRatingScaleApiV1PeopleRatingScalesScaleIdPutMutationBody =
  RatingScaleUpdate;
export type UpdateRatingScaleApiV1PeopleRatingScalesScaleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Rating Scale
 */
export const useUpdateRatingScaleApiV1PeopleRatingScalesScaleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateRatingScaleApiV1PeopleRatingScalesScaleIdPut>
      >,
      TError,
      { scaleId: string; data: RatingScaleUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateRatingScaleApiV1PeopleRatingScalesScaleIdPut>
  >,
  TError,
  { scaleId: string; data: RatingScaleUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateRatingScaleApiV1PeopleRatingScalesScaleIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a rating scale (rejected while any question or cycle still uses it).
 * @summary Delete Rating Scale
 */
export const deleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete = (
  scaleId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/rating-scales/${scaleId}`,
    method: 'DELETE'
  });
};

export const getDeleteRatingScaleApiV1PeopleRatingScalesScaleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete>
      >,
      TError,
      { scaleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete>
    >,
    TError,
    { scaleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete>
      >,
      { scaleId: string }
    > = (props) => {
      const { scaleId } = props ?? {};

      return deleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete(scaleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteRatingScaleApiV1PeopleRatingScalesScaleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete>
    >
  >;

export type DeleteRatingScaleApiV1PeopleRatingScalesScaleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Rating Scale
 */
export const useDeleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete>
      >,
      TError,
      { scaleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteRatingScaleApiV1PeopleRatingScalesScaleIdDelete>
  >,
  TError,
  { scaleId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteRatingScaleApiV1PeopleRatingScalesScaleIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List the competency library, each competency with its levels inline.
 * @summary List Competencies
 */
export const listCompetenciesApiV1PeopleCompetenciesGet = (
  params?: ListCompetenciesApiV1PeopleCompetenciesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<CompetencyListResponse>({
    url: `/api/v1/people/competencies`,
    method: 'GET',
    params,
    signal
  });
};

export const getListCompetenciesApiV1PeopleCompetenciesGetQueryKey = (
  params?: ListCompetenciesApiV1PeopleCompetenciesGetParams
) => {
  return [`/api/v1/people/competencies`, ...(params ? [params] : [])] as const;
};

export const getListCompetenciesApiV1PeopleCompetenciesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCompetenciesApiV1PeopleCompetenciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCompetenciesApiV1PeopleCompetenciesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>
  > = ({ signal }) =>
    listCompetenciesApiV1PeopleCompetenciesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListCompetenciesApiV1PeopleCompetenciesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>
>;
export type ListCompetenciesApiV1PeopleCompetenciesGetQueryError =
  HTTPValidationError;

export function useListCompetenciesApiV1PeopleCompetenciesGet<
  TData = Awaited<
    ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListCompetenciesApiV1PeopleCompetenciesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCompetenciesApiV1PeopleCompetenciesGet<
  TData = Awaited<
    ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCompetenciesApiV1PeopleCompetenciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCompetenciesApiV1PeopleCompetenciesGet<
  TData = Awaited<
    ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCompetenciesApiV1PeopleCompetenciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Competencies
 */

export function useListCompetenciesApiV1PeopleCompetenciesGet<
  TData = Awaited<
    ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCompetenciesApiV1PeopleCompetenciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCompetenciesApiV1PeopleCompetenciesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCompetenciesApiV1PeopleCompetenciesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a competency together with its levelled behavioural anchors.
 * @summary Create Competency
 */
export const createCompetencyApiV1PeopleCompetenciesPost = (
  competencyCreate: CompetencyCreate,
  signal?: AbortSignal
) => {
  return customInstance<Competency>({
    url: `/api/v1/people/competencies`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: competencyCreate,
    signal
  });
};

export const getCreateCompetencyApiV1PeopleCompetenciesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCompetencyApiV1PeopleCompetenciesPost>>,
    TError,
    { data: CompetencyCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCompetencyApiV1PeopleCompetenciesPost>>,
  TError,
  { data: CompetencyCreate },
  TContext
> => {
  const mutationKey = ['createCompetencyApiV1PeopleCompetenciesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCompetencyApiV1PeopleCompetenciesPost>>,
    { data: CompetencyCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createCompetencyApiV1PeopleCompetenciesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCompetencyApiV1PeopleCompetenciesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createCompetencyApiV1PeopleCompetenciesPost>>
  >;
export type CreateCompetencyApiV1PeopleCompetenciesPostMutationBody =
  CompetencyCreate;
export type CreateCompetencyApiV1PeopleCompetenciesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Competency
 */
export const useCreateCompetencyApiV1PeopleCompetenciesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCompetencyApiV1PeopleCompetenciesPost>>,
      TError,
      { data: CompetencyCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCompetencyApiV1PeopleCompetenciesPost>>,
  TError,
  { data: CompetencyCreate },
  TContext
> => {
  const mutationOptions =
    getCreateCompetencyApiV1PeopleCompetenciesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * The tenant's own category vocabulary, for the library's filter.
 * @summary List Competency Categories
 */
export const listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet = (
  signal?: AbortSignal
) => {
  return customInstance<string[]>({
    url: `/api/v1/people/competencies/categories`,
    method: 'GET',
    signal
  });
};

export const getListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGetQueryKey =
  () => {
    return [`/api/v1/people/competencies/categories`] as const;
  };

export const getListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
        >
      >
    > = ({ signal }) =>
      listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
      >
    >
  >;
export type ListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGetQueryError =
  unknown;

export function useListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Competency Categories
 */

export function useListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCompetencyCategoriesApiV1PeopleCompetenciesCategoriesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get one competency with its rubric.
 * @summary Get Competency
 */
export const getCompetencyApiV1PeopleCompetenciesCompetencyIdGet = (
  competencyId: string,
  signal?: AbortSignal
) => {
  return customInstance<Competency>({
    url: `/api/v1/people/competencies/${competencyId}`,
    method: 'GET',
    signal
  });
};

export const getGetCompetencyApiV1PeopleCompetenciesCompetencyIdGetQueryKey = (
  competencyId?: string
) => {
  return [`/api/v1/people/competencies/${competencyId}`] as const;
};

export const getGetCompetencyApiV1PeopleCompetenciesCompetencyIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
    >,
    TError = HTTPValidationError
  >(
    competencyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCompetencyApiV1PeopleCompetenciesCompetencyIdGetQueryKey(
        competencyId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
      >
    > = ({ signal }) =>
      getCompetencyApiV1PeopleCompetenciesCompetencyIdGet(competencyId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!competencyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCompetencyApiV1PeopleCompetenciesCompetencyIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
    >
  >;
export type GetCompetencyApiV1PeopleCompetenciesCompetencyIdGetQueryError =
  HTTPValidationError;

export function useGetCompetencyApiV1PeopleCompetenciesCompetencyIdGet<
  TData = Awaited<
    ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
  >,
  TError = HTTPValidationError
>(
  competencyId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCompetencyApiV1PeopleCompetenciesCompetencyIdGet<
  TData = Awaited<
    ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
  >,
  TError = HTTPValidationError
>(
  competencyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCompetencyApiV1PeopleCompetenciesCompetencyIdGet<
  TData = Awaited<
    ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
  >,
  TError = HTTPValidationError
>(
  competencyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Competency
 */

export function useGetCompetencyApiV1PeopleCompetenciesCompetencyIdGet<
  TData = Awaited<
    ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
  >,
  TError = HTTPValidationError
>(
  competencyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCompetencyApiV1PeopleCompetenciesCompetencyIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCompetencyApiV1PeopleCompetenciesCompetencyIdGetQueryOptions(
      competencyId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a competency. Sending `levels` replaces the whole rubric.
 * @summary Update Competency
 */
export const updateCompetencyApiV1PeopleCompetenciesCompetencyIdPut = (
  competencyId: string,
  competencyUpdate: CompetencyUpdate
) => {
  return customInstance<Competency>({
    url: `/api/v1/people/competencies/${competencyId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: competencyUpdate
  });
};

export const getUpdateCompetencyApiV1PeopleCompetenciesCompetencyIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCompetencyApiV1PeopleCompetenciesCompetencyIdPut
        >
      >,
      TError,
      { competencyId: string; data: CompetencyUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateCompetencyApiV1PeopleCompetenciesCompetencyIdPut>
    >,
    TError,
    { competencyId: string; data: CompetencyUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateCompetencyApiV1PeopleCompetenciesCompetencyIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateCompetencyApiV1PeopleCompetenciesCompetencyIdPut
        >
      >,
      { competencyId: string; data: CompetencyUpdate }
    > = (props) => {
      const { competencyId, data } = props ?? {};

      return updateCompetencyApiV1PeopleCompetenciesCompetencyIdPut(
        competencyId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCompetencyApiV1PeopleCompetenciesCompetencyIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateCompetencyApiV1PeopleCompetenciesCompetencyIdPut>
    >
  >;
export type UpdateCompetencyApiV1PeopleCompetenciesCompetencyIdPutMutationBody =
  CompetencyUpdate;
export type UpdateCompetencyApiV1PeopleCompetenciesCompetencyIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Competency
 */
export const useUpdateCompetencyApiV1PeopleCompetenciesCompetencyIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCompetencyApiV1PeopleCompetenciesCompetencyIdPut
        >
      >,
      TError,
      { competencyId: string; data: CompetencyUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateCompetencyApiV1PeopleCompetenciesCompetencyIdPut>
  >,
  TError,
  { competencyId: string; data: CompetencyUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateCompetencyApiV1PeopleCompetenciesCompetencyIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a competency (rejected while any question still assesses it).
 * @summary Delete Competency
 */
export const deleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete = (
  competencyId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/competencies/${competencyId}`,
    method: 'DELETE'
  });
};

export const getDeleteCompetencyApiV1PeopleCompetenciesCompetencyIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete
        >
      >,
      TError,
      { competencyId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete
      >
    >,
    TError,
    { competencyId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete
        >
      >,
      { competencyId: string }
    > = (props) => {
      const { competencyId } = props ?? {};

      return deleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete(
        competencyId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteCompetencyApiV1PeopleCompetenciesCompetencyIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete
      >
    >
  >;

export type DeleteCompetencyApiV1PeopleCompetenciesCompetencyIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Competency
 */
export const useDeleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete
        >
      >,
      TError,
      { competencyId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteCompetencyApiV1PeopleCompetenciesCompetencyIdDelete>
  >,
  TError,
  { competencyId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteCompetencyApiV1PeopleCompetenciesCompetencyIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List review templates, each with its form, so the list can show how much
of one has been authored.
 * @summary List Review Templates
 */
export const listReviewTemplatesApiV1PeopleReviewTemplatesGet = (
  params?: ListReviewTemplatesApiV1PeopleReviewTemplatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ReviewTemplateListResponse>({
    url: `/api/v1/people/review-templates`,
    method: 'GET',
    params,
    signal
  });
};

export const getListReviewTemplatesApiV1PeopleReviewTemplatesGetQueryKey = (
  params?: ListReviewTemplatesApiV1PeopleReviewTemplatesGetParams
) => {
  return [
    `/api/v1/people/review-templates`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListReviewTemplatesApiV1PeopleReviewTemplatesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReviewTemplatesApiV1PeopleReviewTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListReviewTemplatesApiV1PeopleReviewTemplatesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>>
  > = ({ signal }) =>
    listReviewTemplatesApiV1PeopleReviewTemplatesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListReviewTemplatesApiV1PeopleReviewTemplatesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>>
  >;
export type ListReviewTemplatesApiV1PeopleReviewTemplatesGetQueryError =
  HTTPValidationError;

export function useListReviewTemplatesApiV1PeopleReviewTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListReviewTemplatesApiV1PeopleReviewTemplatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListReviewTemplatesApiV1PeopleReviewTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReviewTemplatesApiV1PeopleReviewTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListReviewTemplatesApiV1PeopleReviewTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReviewTemplatesApiV1PeopleReviewTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Review Templates
 */

export function useListReviewTemplatesApiV1PeopleReviewTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReviewTemplatesApiV1PeopleReviewTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReviewTemplatesApiV1PeopleReviewTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListReviewTemplatesApiV1PeopleReviewTemplatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create an empty review template bound to one rater type.
 * @summary Create Review Template
 */
export const createReviewTemplateApiV1PeopleReviewTemplatesPost = (
  reviewTemplateCreate: ReviewTemplateCreate,
  signal?: AbortSignal
) => {
  return customInstance<ReviewTemplate>({
    url: `/api/v1/people/review-templates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reviewTemplateCreate,
    signal
  });
};

export const getCreateReviewTemplateApiV1PeopleReviewTemplatesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createReviewTemplateApiV1PeopleReviewTemplatesPost>
      >,
      TError,
      { data: ReviewTemplateCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createReviewTemplateApiV1PeopleReviewTemplatesPost>
    >,
    TError,
    { data: ReviewTemplateCreate },
    TContext
  > => {
    const mutationKey = ['createReviewTemplateApiV1PeopleReviewTemplatesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createReviewTemplateApiV1PeopleReviewTemplatesPost>
      >,
      { data: ReviewTemplateCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createReviewTemplateApiV1PeopleReviewTemplatesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateReviewTemplateApiV1PeopleReviewTemplatesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createReviewTemplateApiV1PeopleReviewTemplatesPost>
    >
  >;
export type CreateReviewTemplateApiV1PeopleReviewTemplatesPostMutationBody =
  ReviewTemplateCreate;
export type CreateReviewTemplateApiV1PeopleReviewTemplatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Review Template
 */
export const useCreateReviewTemplateApiV1PeopleReviewTemplatesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createReviewTemplateApiV1PeopleReviewTemplatesPost>
      >,
      TError,
      { data: ReviewTemplateCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createReviewTemplateApiV1PeopleReviewTemplatesPost>
  >,
  TError,
  { data: ReviewTemplateCreate },
  TContext
> => {
  const mutationOptions =
    getCreateReviewTemplateApiV1PeopleReviewTemplatesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get one template with its whole form — sections, each with its questions.
 * @summary Get Review Template
 */
export const getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet = (
  templateId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewTemplate>({
    url: `/api/v1/people/review-templates/${templateId}`,
    method: 'GET',
    signal
  });
};

export const getGetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGetQueryKey =
  (templateId?: string) => {
    return [`/api/v1/people/review-templates/${templateId}`] as const;
  };

export const getGetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    templateId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGetQueryKey(
        templateId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
        >
      >
    > = ({ signal }) =>
      getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet(
        templateId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!templateId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
      >
    >
  >;
export type GetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGetQueryError =
  HTTPValidationError;

export function useGetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Review Template
 */

export function useGetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet>
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetReviewTemplateApiV1PeopleReviewTemplatesTemplateIdGetQueryOptions(
      templateId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a template's name, description, rater type or active flag.
 * @summary Update Review Template
 */
export const updateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut = (
  templateId: string,
  reviewTemplateUpdate: ReviewTemplateUpdate
) => {
  return customInstance<ReviewTemplate>({
    url: `/api/v1/people/review-templates/${templateId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: reviewTemplateUpdate
  });
};

export const getUpdateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut
        >
      >,
      TError,
      { templateId: string; data: ReviewTemplateUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut
      >
    >,
    TError,
    { templateId: string; data: ReviewTemplateUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut
        >
      >,
      { templateId: string; data: ReviewTemplateUpdate }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return updateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut
      >
    >
  >;
export type UpdateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPutMutationBody =
  ReviewTemplateUpdate;
export type UpdateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Review Template
 */
export const useUpdateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut
        >
      >,
      TError,
      { templateId: string; data: ReviewTemplateUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPut
    >
  >,
  TError,
  { templateId: string; data: ReviewTemplateUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateReviewTemplateApiV1PeopleReviewTemplatesTemplateIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a template (rejected while a cycle still binds it; deactivate instead).
 * @summary Delete Review Template
 */
export const deleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete = (
  templateId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/review-templates/${templateId}`,
    method: 'DELETE'
  });
};

export const getDeleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete
        >
      >,
      TError,
      { templateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete
        >
      >,
      { templateId: string }
    > = (props) => {
      const { templateId } = props ?? {};

      return deleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete(
        templateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete
      >
    >
  >;

export type DeleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Review Template
 */
export const useDeleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete
          >
        >,
        TError,
        { templateId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteReviewTemplateApiV1PeopleReviewTemplatesTemplateIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Deep-copy a template's whole form, optionally under a new name or rater type.
 * @summary Clone Review Template
 */
export const cloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost =
  (
    templateId: string,
    reviewTemplateCloneRequest: ReviewTemplateCloneRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ReviewTemplate>({
      url: `/api/v1/people/review-templates/${templateId}/clone`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reviewTemplateCloneRequest,
      signal
    });
  };

export const getCloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost
        >
      >,
      TError,
      { templateId: string; data: ReviewTemplateCloneRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost
      >
    >,
    TError,
    { templateId: string; data: ReviewTemplateCloneRequest },
    TContext
  > => {
    const mutationKey = [
      'cloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost
        >
      >,
      { templateId: string; data: ReviewTemplateCloneRequest }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return cloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost
      >
    >
  >;
export type CloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePostMutationBody =
  ReviewTemplateCloneRequest;
export type CloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePostMutationError =
  HTTPValidationError;

/**
 * @summary Clone Review Template
 */
export const useCloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost
          >
        >,
        TError,
        { templateId: string; data: ReviewTemplateCloneRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePost
      >
    >,
    TError,
    { templateId: string; data: ReviewTemplateCloneRequest },
    TContext
  > => {
    const mutationOptions =
      getCloneReviewTemplateApiV1PeopleReviewTemplatesTemplateIdClonePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Append a section to a template.
 * @summary Create Review Section
 */
export const createReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost =
  (
    templateId: string,
    reviewSectionCreate: ReviewSectionCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<ReviewSection>({
      url: `/api/v1/people/review-templates/${templateId}/sections`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reviewSectionCreate,
      signal
    });
  };

export const getCreateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost
        >
      >,
      TError,
      { templateId: string; data: ReviewSectionCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost
      >
    >,
    TError,
    { templateId: string; data: ReviewSectionCreate },
    TContext
  > => {
    const mutationKey = [
      'createReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost
        >
      >,
      { templateId: string; data: ReviewSectionCreate }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return createReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost
      >
    >
  >;
export type CreateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPostMutationBody =
  ReviewSectionCreate;
export type CreateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Review Section
 */
export const useCreateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost
          >
        >,
        TError,
        { templateId: string; data: ReviewSectionCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPost
      >
    >,
    TError,
    { templateId: string; data: ReviewSectionCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Write the new order of a template's sections (the whole set, in order).
 * @summary Reorder Review Sections
 */
export const reorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut =
  (templateId: string, reviewReorderRequest: ReviewReorderRequest) => {
    return customInstance<ReviewSection[]>({
      url: `/api/v1/people/review-templates/${templateId}/sections/reorder`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reviewReorderRequest
    });
  };

export const getReorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut
        >
      >,
      TError,
      { templateId: string; data: ReviewReorderRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut
      >
    >,
    TError,
    { templateId: string; data: ReviewReorderRequest },
    TContext
  > => {
    const mutationKey = [
      'reorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut
        >
      >,
      { templateId: string; data: ReviewReorderRequest }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return reorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut
      >
    >
  >;
export type ReorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPutMutationBody =
  ReviewReorderRequest;
export type ReorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPutMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Review Sections
 */
export const useReorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut
          >
        >,
        TError,
        { templateId: string; data: ReviewReorderRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPut
      >
    >,
    TError,
    { templateId: string; data: ReviewReorderRequest },
    TContext
  > => {
    const mutationOptions =
      getReorderReviewSectionsApiV1PeopleReviewTemplatesTemplateIdSectionsReorderPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a section's title, description, private flag or weight.
 * @summary Update Review Section
 */
export const updateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut =
  (
    templateId: string,
    sectionId: string,
    reviewSectionUpdate: ReviewSectionUpdate
  ) => {
    return customInstance<ReviewSection>({
      url: `/api/v1/people/review-templates/${templateId}/sections/${sectionId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reviewSectionUpdate
    });
  };

export const getUpdateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut
        >
      >,
      TError,
      { templateId: string; sectionId: string; data: ReviewSectionUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut
      >
    >,
    TError,
    { templateId: string; sectionId: string; data: ReviewSectionUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut
        >
      >,
      { templateId: string; sectionId: string; data: ReviewSectionUpdate }
    > = (props) => {
      const { templateId, sectionId, data } = props ?? {};

      return updateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut(
        templateId,
        sectionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut
      >
    >
  >;
export type UpdateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPutMutationBody =
  ReviewSectionUpdate;
export type UpdateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Review Section
 */
export const useUpdateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut
          >
        >,
        TError,
        { templateId: string; sectionId: string; data: ReviewSectionUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPut
      >
    >,
    TError,
    { templateId: string; sectionId: string; data: ReviewSectionUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a section and the questions it contains.
 * @summary Delete Review Section
 */
export const deleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete =
  (templateId: string, sectionId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/review-templates/${templateId}/sections/${sectionId}`,
      method: 'DELETE'
    });
  };

export const getDeleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete
        >
      >,
      TError,
      { templateId: string; sectionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete
      >
    >,
    TError,
    { templateId: string; sectionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete
        >
      >,
      { templateId: string; sectionId: string }
    > = (props) => {
      const { templateId, sectionId } = props ?? {};

      return deleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete(
        templateId,
        sectionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete
      >
    >
  >;

export type DeleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Review Section
 */
export const useDeleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete
          >
        >,
        TError,
        { templateId: string; sectionId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDelete
      >
    >,
    TError,
    { templateId: string; sectionId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteReviewSectionApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Append a question to one of the template's sections.
 * @summary Create Review Question
 */
export const createReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost =
  (
    templateId: string,
    reviewQuestionCreate: ReviewQuestionCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<ReviewQuestion>({
      url: `/api/v1/people/review-templates/${templateId}/questions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reviewQuestionCreate,
      signal
    });
  };

export const getCreateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost
        >
      >,
      TError,
      { templateId: string; data: ReviewQuestionCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost
      >
    >,
    TError,
    { templateId: string; data: ReviewQuestionCreate },
    TContext
  > => {
    const mutationKey = [
      'createReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost
        >
      >,
      { templateId: string; data: ReviewQuestionCreate }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return createReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost
      >
    >
  >;
export type CreateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPostMutationBody =
  ReviewQuestionCreate;
export type CreateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Review Question
 */
export const useCreateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost
          >
        >,
        TError,
        { templateId: string; data: ReviewQuestionCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPost
      >
    >,
    TError,
    { templateId: string; data: ReviewQuestionCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Write the new order of one section's questions (the whole set, in order).
 * @summary Reorder Review Questions
 */
export const reorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut =
  (
    templateId: string,
    sectionId: string,
    reviewReorderRequest: ReviewReorderRequest
  ) => {
    return customInstance<ReviewQuestion[]>({
      url: `/api/v1/people/review-templates/${templateId}/sections/${sectionId}/questions/reorder`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reviewReorderRequest
    });
  };

export const getReorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut
        >
      >,
      TError,
      { templateId: string; sectionId: string; data: ReviewReorderRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut
      >
    >,
    TError,
    { templateId: string; sectionId: string; data: ReviewReorderRequest },
    TContext
  > => {
    const mutationKey = [
      'reorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut
        >
      >,
      { templateId: string; sectionId: string; data: ReviewReorderRequest }
    > = (props) => {
      const { templateId, sectionId, data } = props ?? {};

      return reorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut(
        templateId,
        sectionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut
      >
    >
  >;
export type ReorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPutMutationBody =
  ReviewReorderRequest;
export type ReorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPutMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Review Questions
 */
export const useReorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut
          >
        >,
        TError,
        { templateId: string; sectionId: string; data: ReviewReorderRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPut
      >
    >,
    TError,
    { templateId: string; sectionId: string; data: ReviewReorderRequest },
    TContext
  > => {
    const mutationOptions =
      getReorderReviewQuestionsApiV1PeopleReviewTemplatesTemplateIdSectionsSectionIdQuestionsReorderPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a question — including moving it to another section of this template.
 * @summary Update Review Question
 */
export const updateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut =
  (
    templateId: string,
    questionId: string,
    reviewQuestionUpdate: ReviewQuestionUpdate
  ) => {
    return customInstance<ReviewQuestion>({
      url: `/api/v1/people/review-templates/${templateId}/questions/${questionId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reviewQuestionUpdate
    });
  };

export const getUpdateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut
        >
      >,
      TError,
      { templateId: string; questionId: string; data: ReviewQuestionUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut
      >
    >,
    TError,
    { templateId: string; questionId: string; data: ReviewQuestionUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut
        >
      >,
      { templateId: string; questionId: string; data: ReviewQuestionUpdate }
    > = (props) => {
      const { templateId, questionId, data } = props ?? {};

      return updateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut(
        templateId,
        questionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut
      >
    >
  >;
export type UpdateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPutMutationBody =
  ReviewQuestionUpdate;
export type UpdateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Review Question
 */
export const useUpdateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut
          >
        >,
        TError,
        { templateId: string; questionId: string; data: ReviewQuestionUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPut
      >
    >,
    TError,
    { templateId: string; questionId: string; data: ReviewQuestionUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a question.
 * @summary Delete Review Question
 */
export const deleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete =
  (templateId: string, questionId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/review-templates/${templateId}/questions/${questionId}`,
      method: 'DELETE'
    });
  };

export const getDeleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete
        >
      >,
      TError,
      { templateId: string; questionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete
      >
    >,
    TError,
    { templateId: string; questionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete
        >
      >,
      { templateId: string; questionId: string }
    > = (props) => {
      const { templateId, questionId } = props ?? {};

      return deleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete(
        templateId,
        questionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete
      >
    >
  >;

export type DeleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Review Question
 */
export const useDeleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete
          >
        >,
        TError,
        { templateId: string; questionId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDelete
      >
    >,
    TError,
    { templateId: string; questionId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteReviewQuestionApiV1PeopleReviewTemplatesTemplateIdQuestionsQuestionIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The caller's schedules plus every schedule on a report they share.

Visible to whoever can run the report it delivers, which is what makes "who
is being mailed this?" answerable by the team rather than only by the author.
 * @summary List Report Schedules
 */
export const listReportSchedulesApiV1PeopleReportsSchedulesGet = (
  params?: ListReportSchedulesApiV1PeopleReportsSchedulesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleReportScheduleListResponse>({
    url: `/api/v1/people/reports/schedules`,
    method: 'GET',
    params,
    signal
  });
};

export const getListReportSchedulesApiV1PeopleReportsSchedulesGetQueryKey = (
  params?: ListReportSchedulesApiV1PeopleReportsSchedulesGetParams
) => {
  return [
    `/api/v1/people/reports/schedules`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListReportSchedulesApiV1PeopleReportsSchedulesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListReportSchedulesApiV1PeopleReportsSchedulesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListReportSchedulesApiV1PeopleReportsSchedulesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
      >
    > = ({ signal }) =>
      listReportSchedulesApiV1PeopleReportsSchedulesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListReportSchedulesApiV1PeopleReportsSchedulesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
    >
  >;
export type ListReportSchedulesApiV1PeopleReportsSchedulesGetQueryError =
  HTTPValidationError;

export function useListReportSchedulesApiV1PeopleReportsSchedulesGet<
  TData = Awaited<
    ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListReportSchedulesApiV1PeopleReportsSchedulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListReportSchedulesApiV1PeopleReportsSchedulesGet<
  TData = Awaited<
    ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReportSchedulesApiV1PeopleReportsSchedulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListReportSchedulesApiV1PeopleReportsSchedulesGet<
  TData = Awaited<
    ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReportSchedulesApiV1PeopleReportsSchedulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Report Schedules
 */

export function useListReportSchedulesApiV1PeopleReportsSchedulesGet<
  TData = Awaited<
    ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReportSchedulesApiV1PeopleReportsSchedulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReportSchedulesApiV1PeopleReportsSchedulesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListReportSchedulesApiV1PeopleReportsSchedulesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Schedule a saved report for recurring delivery.
 * @summary Create Report Schedule
 */
export const createReportScheduleApiV1PeopleReportsSchedulesPost = (
  peopleReportScheduleCreate: PeopleReportScheduleCreate,
  signal?: AbortSignal
) => {
  return customInstance<PeopleReportSchedule>({
    url: `/api/v1/people/reports/schedules`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: peopleReportScheduleCreate,
    signal
  });
};

export const getCreateReportScheduleApiV1PeopleReportsSchedulesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createReportScheduleApiV1PeopleReportsSchedulesPost>
      >,
      TError,
      { data: PeopleReportScheduleCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createReportScheduleApiV1PeopleReportsSchedulesPost>
    >,
    TError,
    { data: PeopleReportScheduleCreate },
    TContext
  > => {
    const mutationKey = ['createReportScheduleApiV1PeopleReportsSchedulesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createReportScheduleApiV1PeopleReportsSchedulesPost>
      >,
      { data: PeopleReportScheduleCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createReportScheduleApiV1PeopleReportsSchedulesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateReportScheduleApiV1PeopleReportsSchedulesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createReportScheduleApiV1PeopleReportsSchedulesPost>
    >
  >;
export type CreateReportScheduleApiV1PeopleReportsSchedulesPostMutationBody =
  PeopleReportScheduleCreate;
export type CreateReportScheduleApiV1PeopleReportsSchedulesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Report Schedule
 */
export const useCreateReportScheduleApiV1PeopleReportsSchedulesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createReportScheduleApiV1PeopleReportsSchedulesPost>
      >,
      TError,
      { data: PeopleReportScheduleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createReportScheduleApiV1PeopleReportsSchedulesPost>
  >,
  TError,
  { data: PeopleReportScheduleCreate },
  TContext
> => {
  const mutationOptions =
    getCreateReportScheduleApiV1PeopleReportsSchedulesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a schedule. An omitted property is left unchanged.
 * @summary Update Report Schedule
 */
export const updateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut = (
  scheduleId: string,
  peopleReportScheduleUpdate: PeopleReportScheduleUpdate
) => {
  return customInstance<PeopleReportSchedule>({
    url: `/api/v1/people/reports/schedules/${scheduleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: peopleReportScheduleUpdate
  });
};

export const getUpdateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut
        >
      >,
      TError,
      { scheduleId: string; data: PeopleReportScheduleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut
      >
    >,
    TError,
    { scheduleId: string; data: PeopleReportScheduleUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut
        >
      >,
      { scheduleId: string; data: PeopleReportScheduleUpdate }
    > = (props) => {
      const { scheduleId, data } = props ?? {};

      return updateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut(
        scheduleId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut
      >
    >
  >;
export type UpdateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPutMutationBody =
  PeopleReportScheduleUpdate;
export type UpdateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Report Schedule
 */
export const useUpdateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut
        >
      >,
      TError,
      { scheduleId: string; data: PeopleReportScheduleUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPut
    >
  >,
  TError,
  { scheduleId: string; data: PeopleReportScheduleUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateReportScheduleApiV1PeopleReportsSchedulesScheduleIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Report Schedule
 */
export const deleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete = (
  scheduleId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/reports/schedules/${scheduleId}`,
    method: 'DELETE'
  });
};

export const getDeleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete
        >
      >,
      TError,
      { scheduleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete
      >
    >,
    TError,
    { scheduleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete
        >
      >,
      { scheduleId: string }
    > = (props) => {
      const { scheduleId } = props ?? {};

      return deleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete(
        scheduleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete
      >
    >
  >;

export type DeleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Report Schedule
 */
export const useDeleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete
          >
        >,
        TError,
        { scheduleId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDelete
      >
    >,
    TError,
    { scheduleId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteReportScheduleApiV1PeopleReportsSchedulesScheduleIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * What each recipient actually got, newest run first.

This is where a recipient who received a narrower report than the title
promises can see that they did: `withheld_column_count` is the same number
the email states.
 * @summary List Schedule Deliveries
 */
export const listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet =
  (
    scheduleId: string,
    params?: ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<PeopleReportScheduleDeliveryListResponse>({
      url: `/api/v1/people/reports/schedules/${scheduleId}/deliveries`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetQueryKey =
  (
    scheduleId?: string,
    params?: ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetParams
  ) => {
    return [
      `/api/v1/people/reports/schedules/${scheduleId}/deliveries`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
      >
    >,
    TError = HTTPValidationError
  >(
    scheduleId: string,
    params?: ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetQueryKey(
        scheduleId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
        >
      >
    > = ({ signal }) =>
      listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet(
        scheduleId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!scheduleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
      >
    >
  >;
export type ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetQueryError =
  HTTPValidationError;

export function useListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet<
  TData = Awaited<
    ReturnType<
      typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
    >
  >,
  TError = HTTPValidationError
>(
  scheduleId: string,
  params:
    | undefined
    | ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet<
  TData = Awaited<
    ReturnType<
      typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
    >
  >,
  TError = HTTPValidationError
>(
  scheduleId: string,
  params?: ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet<
  TData = Awaited<
    ReturnType<
      typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
    >
  >,
  TError = HTTPValidationError
>(
  scheduleId: string,
  params?: ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Schedule Deliveries
 */

export function useListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet<
  TData = Awaited<
    ReturnType<
      typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
    >
  >,
  TError = HTTPValidationError
>(
  scheduleId: string,
  params?: ListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListScheduleDeliveriesApiV1PeopleReportsSchedulesScheduleIdDeliveriesGetQueryOptions(
      scheduleId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The field catalog, already filtered to what THIS caller may select.

A field the caller may not see is ABSENT rather than present-and-disabled: an
absent field cannot be selected, where a disabled one is a field name plus a
hint about who earns more.
 * @summary Get Report Catalog
 */
export const getReportCatalogApiV1PeopleReportsCatalogGet = (
  signal?: AbortSignal
) => {
  return customInstance<PeopleReportCatalogResponse>({
    url: `/api/v1/people/reports/catalog`,
    method: 'GET',
    signal
  });
};

export const getGetReportCatalogApiV1PeopleReportsCatalogGetQueryKey = () => {
  return [`/api/v1/people/reports/catalog`] as const;
};

export const getGetReportCatalogApiV1PeopleReportsCatalogGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReportCatalogApiV1PeopleReportsCatalogGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>>
  > = ({ signal }) => getReportCatalogApiV1PeopleReportsCatalogGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReportCatalogApiV1PeopleReportsCatalogGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>>
  >;
export type GetReportCatalogApiV1PeopleReportsCatalogGetQueryError = unknown;

export function useGetReportCatalogApiV1PeopleReportsCatalogGet<
  TData = Awaited<
    ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetReportCatalogApiV1PeopleReportsCatalogGet<
  TData = Awaited<
    ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReportCatalogApiV1PeopleReportsCatalogGet<
  TData = Awaited<
    ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Report Catalog
 */

export function useGetReportCatalogApiV1PeopleReportsCatalogGet<
  TData = Awaited<
    ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReportCatalogApiV1PeopleReportsCatalogGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetReportCatalogApiV1PeopleReportsCatalogGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The standard report library, already filtered to what THIS caller may run.

A report addressing a restricted field is ABSENT for a caller with no
restricted-field access, not present-and-disabled — the same choice the field
catalog makes with the field itself, and for the same reason: an absent entry
cannot be picked, where a disabled one is a report title plus a hint about
what the tenant records.

Each entry carries a RUNNABLE body — its relative-date tokens already resolved
— so running one is `POST /people/reports/run` and saving a copy is
`POST /people/reports`. There is no third executor and no library-only
validation path.
 * @summary List Standard Reports
 */
export const listStandardReportsApiV1PeopleReportsStandardGet = (
  params?: ListStandardReportsApiV1PeopleReportsStandardGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleStandardReportLibraryResponse>({
    url: `/api/v1/people/reports/standard`,
    method: 'GET',
    params,
    signal
  });
};

export const getListStandardReportsApiV1PeopleReportsStandardGetQueryKey = (
  params?: ListStandardReportsApiV1PeopleReportsStandardGetParams
) => {
  return [
    `/api/v1/people/reports/standard`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListStandardReportsApiV1PeopleReportsStandardGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListStandardReportsApiV1PeopleReportsStandardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListStandardReportsApiV1PeopleReportsStandardGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>>
  > = ({ signal }) =>
    listStandardReportsApiV1PeopleReportsStandardGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListStandardReportsApiV1PeopleReportsStandardGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>>
  >;
export type ListStandardReportsApiV1PeopleReportsStandardGetQueryError =
  HTTPValidationError;

export function useListStandardReportsApiV1PeopleReportsStandardGet<
  TData = Awaited<
    ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListStandardReportsApiV1PeopleReportsStandardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListStandardReportsApiV1PeopleReportsStandardGet<
  TData = Awaited<
    ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListStandardReportsApiV1PeopleReportsStandardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListStandardReportsApiV1PeopleReportsStandardGet<
  TData = Awaited<
    ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListStandardReportsApiV1PeopleReportsStandardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Standard Reports
 */

export function useListStandardReportsApiV1PeopleReportsStandardGet<
  TData = Awaited<
    ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListStandardReportsApiV1PeopleReportsStandardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listStandardReportsApiV1PeopleReportsStandardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListStandardReportsApiV1PeopleReportsStandardGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Run a library report by key — the dashboard widgets' door.

Identical to the ad-hoc run in every respect that matters (same validator,
same executor, same three scopes); it exists so a widget can name a report
rather than carry a copy of its body, which would be a second definition of
the same question that nothing keeps in step.

A key naming no library report is a 404: the key is caller-supplied.
 * @summary Run Standard Report
 */
export const runStandardReportApiV1PeopleReportsStandardKeyRunGet = (
  key: string,
  params?: RunStandardReportApiV1PeopleReportsStandardKeyRunGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleReportResultResponse>({
    url: `/api/v1/people/reports/standard/${key}/run`,
    method: 'GET',
    params,
    signal
  });
};

export const getRunStandardReportApiV1PeopleReportsStandardKeyRunGetQueryKey = (
  key?: string,
  params?: RunStandardReportApiV1PeopleReportsStandardKeyRunGetParams
) => {
  return [
    `/api/v1/people/reports/standard/${key}/run`,
    ...(params ? [params] : [])
  ] as const;
};

export const getRunStandardReportApiV1PeopleReportsStandardKeyRunGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet>
    >,
    TError = HTTPValidationError
  >(
    key: string,
    params?: RunStandardReportApiV1PeopleReportsStandardKeyRunGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getRunStandardReportApiV1PeopleReportsStandardKeyRunGetQueryKey(
        key,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet>
      >
    > = ({ signal }) =>
      runStandardReportApiV1PeopleReportsStandardKeyRunGet(key, params, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!key,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type RunStandardReportApiV1PeopleReportsStandardKeyRunGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet>
    >
  >;
export type RunStandardReportApiV1PeopleReportsStandardKeyRunGetQueryError =
  HTTPValidationError;

export function useRunStandardReportApiV1PeopleReportsStandardKeyRunGet<
  TData = Awaited<
    ReturnType<typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet>
  >,
  TError = HTTPValidationError
>(
  key: string,
  params:
    | undefined
    | RunStandardReportApiV1PeopleReportsStandardKeyRunGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useRunStandardReportApiV1PeopleReportsStandardKeyRunGet<
  TData = Awaited<
    ReturnType<typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet>
  >,
  TError = HTTPValidationError
>(
  key: string,
  params?: RunStandardReportApiV1PeopleReportsStandardKeyRunGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useRunStandardReportApiV1PeopleReportsStandardKeyRunGet<
  TData = Awaited<
    ReturnType<typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet>
  >,
  TError = HTTPValidationError
>(
  key: string,
  params?: RunStandardReportApiV1PeopleReportsStandardKeyRunGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Run Standard Report
 */

export function useRunStandardReportApiV1PeopleReportsStandardKeyRunGet<
  TData = Awaited<
    ReturnType<typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet>
  >,
  TError = HTTPValidationError
>(
  key: string,
  params?: RunStandardReportApiV1PeopleReportsStandardKeyRunGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof runStandardReportApiV1PeopleReportsStandardKeyRunGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getRunStandardReportApiV1PeopleReportsStandardKeyRunGetQueryOptions(
      key,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Run an unsaved report — the builder's preview.
 * @summary Run Ad Hoc Report
 */
export const runAdHocReportApiV1PeopleReportsRunPost = (
  peopleReportRunRequest: PeopleReportRunRequest,
  params?: RunAdHocReportApiV1PeopleReportsRunPostParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleReportResultResponse>({
    url: `/api/v1/people/reports/run`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: peopleReportRunRequest,
    params,
    signal
  });
};

export const getRunAdHocReportApiV1PeopleReportsRunPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runAdHocReportApiV1PeopleReportsRunPost>>,
    TError,
    {
      data: PeopleReportRunRequest;
      params?: RunAdHocReportApiV1PeopleReportsRunPostParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runAdHocReportApiV1PeopleReportsRunPost>>,
  TError,
  {
    data: PeopleReportRunRequest;
    params?: RunAdHocReportApiV1PeopleReportsRunPostParams;
  },
  TContext
> => {
  const mutationKey = ['runAdHocReportApiV1PeopleReportsRunPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runAdHocReportApiV1PeopleReportsRunPost>>,
    {
      data: PeopleReportRunRequest;
      params?: RunAdHocReportApiV1PeopleReportsRunPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return runAdHocReportApiV1PeopleReportsRunPost(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunAdHocReportApiV1PeopleReportsRunPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof runAdHocReportApiV1PeopleReportsRunPost>>
>;
export type RunAdHocReportApiV1PeopleReportsRunPostMutationBody =
  PeopleReportRunRequest;
export type RunAdHocReportApiV1PeopleReportsRunPostMutationError =
  HTTPValidationError;

/**
 * @summary Run Ad Hoc Report
 */
export const useRunAdHocReportApiV1PeopleReportsRunPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runAdHocReportApiV1PeopleReportsRunPost>>,
      TError,
      {
        data: PeopleReportRunRequest;
        params?: RunAdHocReportApiV1PeopleReportsRunPostParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof runAdHocReportApiV1PeopleReportsRunPost>>,
  TError,
  {
    data: PeopleReportRunRequest;
    params?: RunAdHocReportApiV1PeopleReportsRunPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getRunAdHocReportApiV1PeopleReportsRunPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Run a saved report.

Re-validated against the catalog and against THIS caller, not the one who
saved it: a shared report naming a restricted field is refused for a
recipient who may not select that field, rather than silently losing the
column.
 * @summary Run Saved Report
 */
export const runSavedReportApiV1PeopleReportsReportIdRunGet = (
  reportId: string,
  params?: RunSavedReportApiV1PeopleReportsReportIdRunGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleReportResultResponse>({
    url: `/api/v1/people/reports/${reportId}/run`,
    method: 'GET',
    params,
    signal
  });
};

export const getRunSavedReportApiV1PeopleReportsReportIdRunGetQueryKey = (
  reportId?: string,
  params?: RunSavedReportApiV1PeopleReportsReportIdRunGetParams
) => {
  return [
    `/api/v1/people/reports/${reportId}/run`,
    ...(params ? [params] : [])
  ] as const;
};

export const getRunSavedReportApiV1PeopleReportsReportIdRunGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
  >,
  TError = HTTPValidationError
>(
  reportId: string,
  params?: RunSavedReportApiV1PeopleReportsReportIdRunGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRunSavedReportApiV1PeopleReportsReportIdRunGetQueryKey(reportId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>>
  > = ({ signal }) =>
    runSavedReportApiV1PeopleReportsReportIdRunGet(reportId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!reportId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type RunSavedReportApiV1PeopleReportsReportIdRunGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>>
  >;
export type RunSavedReportApiV1PeopleReportsReportIdRunGetQueryError =
  HTTPValidationError;

export function useRunSavedReportApiV1PeopleReportsReportIdRunGet<
  TData = Awaited<
    ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
  >,
  TError = HTTPValidationError
>(
  reportId: string,
  params: undefined | RunSavedReportApiV1PeopleReportsReportIdRunGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useRunSavedReportApiV1PeopleReportsReportIdRunGet<
  TData = Awaited<
    ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
  >,
  TError = HTTPValidationError
>(
  reportId: string,
  params?: RunSavedReportApiV1PeopleReportsReportIdRunGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useRunSavedReportApiV1PeopleReportsReportIdRunGet<
  TData = Awaited<
    ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
  >,
  TError = HTTPValidationError
>(
  reportId: string,
  params?: RunSavedReportApiV1PeopleReportsReportIdRunGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Run Saved Report
 */

export function useRunSavedReportApiV1PeopleReportsReportIdRunGet<
  TData = Awaited<
    ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
  >,
  TError = HTTPValidationError
>(
  reportId: string,
  params?: RunSavedReportApiV1PeopleReportsReportIdRunGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof runSavedReportApiV1PeopleReportsReportIdRunGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getRunSavedReportApiV1PeopleReportsReportIdRunGetQueryOptions(
      reportId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export an unsaved report as CSV or XLSX.
 * @summary Export Ad Hoc Report
 */
export const exportAdHocReportApiV1PeopleReportsExportPost = (
  peopleReportRunRequest: PeopleReportRunRequest,
  params?: ExportAdHocReportApiV1PeopleReportsExportPostParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/people/reports/export`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: peopleReportRunRequest,
    params,
    signal
  });
};

export const getExportAdHocReportApiV1PeopleReportsExportPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportAdHocReportApiV1PeopleReportsExportPost>>,
    TError,
    {
      data: PeopleReportRunRequest;
      params?: ExportAdHocReportApiV1PeopleReportsExportPostParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportAdHocReportApiV1PeopleReportsExportPost>>,
  TError,
  {
    data: PeopleReportRunRequest;
    params?: ExportAdHocReportApiV1PeopleReportsExportPostParams;
  },
  TContext
> => {
  const mutationKey = ['exportAdHocReportApiV1PeopleReportsExportPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportAdHocReportApiV1PeopleReportsExportPost>>,
    {
      data: PeopleReportRunRequest;
      params?: ExportAdHocReportApiV1PeopleReportsExportPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return exportAdHocReportApiV1PeopleReportsExportPost(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportAdHocReportApiV1PeopleReportsExportPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof exportAdHocReportApiV1PeopleReportsExportPost>>
  >;
export type ExportAdHocReportApiV1PeopleReportsExportPostMutationBody =
  PeopleReportRunRequest;
export type ExportAdHocReportApiV1PeopleReportsExportPostMutationError =
  HTTPValidationError;

/**
 * @summary Export Ad Hoc Report
 */
export const useExportAdHocReportApiV1PeopleReportsExportPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof exportAdHocReportApiV1PeopleReportsExportPost>>,
      TError,
      {
        data: PeopleReportRunRequest;
        params?: ExportAdHocReportApiV1PeopleReportsExportPostParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof exportAdHocReportApiV1PeopleReportsExportPost>>,
  TError,
  {
    data: PeopleReportRunRequest;
    params?: ExportAdHocReportApiV1PeopleReportsExportPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getExportAdHocReportApiV1PeopleReportsExportPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Export a saved report as CSV or XLSX.
 * @summary Export Saved Report
 */
export const exportSavedReportApiV1PeopleReportsReportIdExportGet = (
  reportId: string,
  params?: ExportSavedReportApiV1PeopleReportsReportIdExportGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/people/reports/${reportId}/export`,
    method: 'GET',
    params,
    signal
  });
};

export const getExportSavedReportApiV1PeopleReportsReportIdExportGetQueryKey = (
  reportId?: string,
  params?: ExportSavedReportApiV1PeopleReportsReportIdExportGetParams
) => {
  return [
    `/api/v1/people/reports/${reportId}/export`,
    ...(params ? [params] : [])
  ] as const;
};

export const getExportSavedReportApiV1PeopleReportsReportIdExportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof exportSavedReportApiV1PeopleReportsReportIdExportGet>
    >,
    TError = HTTPValidationError
  >(
    reportId: string,
    params?: ExportSavedReportApiV1PeopleReportsReportIdExportGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exportSavedReportApiV1PeopleReportsReportIdExportGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExportSavedReportApiV1PeopleReportsReportIdExportGetQueryKey(
        reportId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof exportSavedReportApiV1PeopleReportsReportIdExportGet>
      >
    > = ({ signal }) =>
      exportSavedReportApiV1PeopleReportsReportIdExportGet(
        reportId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!reportId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof exportSavedReportApiV1PeopleReportsReportIdExportGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExportSavedReportApiV1PeopleReportsReportIdExportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof exportSavedReportApiV1PeopleReportsReportIdExportGet>
    >
  >;
export type ExportSavedReportApiV1PeopleReportsReportIdExportGetQueryError =
  HTTPValidationError;

export function useExportSavedReportApiV1PeopleReportsReportIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportSavedReportApiV1PeopleReportsReportIdExportGet>
  >,
  TError = HTTPValidationError
>(
  reportId: string,
  params:
    | undefined
    | ExportSavedReportApiV1PeopleReportsReportIdExportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportSavedReportApiV1PeopleReportsReportIdExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportSavedReportApiV1PeopleReportsReportIdExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportSavedReportApiV1PeopleReportsReportIdExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportSavedReportApiV1PeopleReportsReportIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportSavedReportApiV1PeopleReportsReportIdExportGet>
  >,
  TError = HTTPValidationError
>(
  reportId: string,
  params?: ExportSavedReportApiV1PeopleReportsReportIdExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportSavedReportApiV1PeopleReportsReportIdExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportSavedReportApiV1PeopleReportsReportIdExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportSavedReportApiV1PeopleReportsReportIdExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportSavedReportApiV1PeopleReportsReportIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportSavedReportApiV1PeopleReportsReportIdExportGet>
  >,
  TError = HTTPValidationError
>(
  reportId: string,
  params?: ExportSavedReportApiV1PeopleReportsReportIdExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportSavedReportApiV1PeopleReportsReportIdExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Saved Report
 */

export function useExportSavedReportApiV1PeopleReportsReportIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportSavedReportApiV1PeopleReportsReportIdExportGet>
  >,
  TError = HTTPValidationError
>(
  reportId: string,
  params?: ExportSavedReportApiV1PeopleReportsReportIdExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportSavedReportApiV1PeopleReportsReportIdExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportSavedReportApiV1PeopleReportsReportIdExportGetQueryOptions(
      reportId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The caller's saved reports plus every shared one.

`q` narrows by name SERVER-side. Filtering the fetched page in the browser
instead would leave the pager's total describing a different set from the
rows beneath it.
 * @summary List Reports
 */
export const listReportsApiV1PeopleReportsGet = (
  params?: ListReportsApiV1PeopleReportsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleReportDefinitionListResponse>({
    url: `/api/v1/people/reports`,
    method: 'GET',
    params,
    signal
  });
};

export const getListReportsApiV1PeopleReportsGetQueryKey = (
  params?: ListReportsApiV1PeopleReportsGetParams
) => {
  return [`/api/v1/people/reports`, ...(params ? [params] : [])] as const;
};

export const getListReportsApiV1PeopleReportsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
  TError = HTTPValidationError
>(
  params?: ListReportsApiV1PeopleReportsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListReportsApiV1PeopleReportsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>
  > = ({ signal }) => listReportsApiV1PeopleReportsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListReportsApiV1PeopleReportsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>
>;
export type ListReportsApiV1PeopleReportsGetQueryError = HTTPValidationError;

export function useListReportsApiV1PeopleReportsGet<
  TData = Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListReportsApiV1PeopleReportsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
          TError,
          Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListReportsApiV1PeopleReportsGet<
  TData = Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
  TError = HTTPValidationError
>(
  params?: ListReportsApiV1PeopleReportsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
          TError,
          Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListReportsApiV1PeopleReportsGet<
  TData = Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
  TError = HTTPValidationError
>(
  params?: ListReportsApiV1PeopleReportsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Reports
 */

export function useListReportsApiV1PeopleReportsGet<
  TData = Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
  TError = HTTPValidationError
>(
  params?: ListReportsApiV1PeopleReportsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReportsApiV1PeopleReportsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListReportsApiV1PeopleReportsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Save a report definition.

Validated against the catalog before it is stored, so an unrunnable report
cannot be saved and then fail for its recipients later.
 * @summary Create Report
 */
export const createReportApiV1PeopleReportsPost = (
  peopleReportDefinitionCreate: PeopleReportDefinitionCreate,
  signal?: AbortSignal
) => {
  return customInstance<PeopleReportDefinition>({
    url: `/api/v1/people/reports`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: peopleReportDefinitionCreate,
    signal
  });
};

export const getCreateReportApiV1PeopleReportsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReportApiV1PeopleReportsPost>>,
    TError,
    { data: PeopleReportDefinitionCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReportApiV1PeopleReportsPost>>,
  TError,
  { data: PeopleReportDefinitionCreate },
  TContext
> => {
  const mutationKey = ['createReportApiV1PeopleReportsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReportApiV1PeopleReportsPost>>,
    { data: PeopleReportDefinitionCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createReportApiV1PeopleReportsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReportApiV1PeopleReportsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createReportApiV1PeopleReportsPost>>
>;
export type CreateReportApiV1PeopleReportsPostMutationBody =
  PeopleReportDefinitionCreate;
export type CreateReportApiV1PeopleReportsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Report
 */
export const useCreateReportApiV1PeopleReportsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createReportApiV1PeopleReportsPost>>,
      TError,
      { data: PeopleReportDefinitionCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createReportApiV1PeopleReportsPost>>,
  TError,
  { data: PeopleReportDefinitionCreate },
  TContext
> => {
  const mutationOptions =
    getCreateReportApiV1PeopleReportsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Report
 */
export const getReportApiV1PeopleReportsReportIdGet = (
  reportId: string,
  signal?: AbortSignal
) => {
  return customInstance<PeopleReportDefinition>({
    url: `/api/v1/people/reports/${reportId}`,
    method: 'GET',
    signal
  });
};

export const getGetReportApiV1PeopleReportsReportIdGetQueryKey = (
  reportId?: string
) => {
  return [`/api/v1/people/reports/${reportId}`] as const;
};

export const getGetReportApiV1PeopleReportsReportIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
  TError = HTTPValidationError
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReportApiV1PeopleReportsReportIdGetQueryKey(reportId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>
  > = ({ signal }) => getReportApiV1PeopleReportsReportIdGet(reportId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!reportId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReportApiV1PeopleReportsReportIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>
>;
export type GetReportApiV1PeopleReportsReportIdGetQueryError =
  HTTPValidationError;

export function useGetReportApiV1PeopleReportsReportIdGet<
  TData = Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
  TError = HTTPValidationError
>(
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
          TError,
          Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetReportApiV1PeopleReportsReportIdGet<
  TData = Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
  TError = HTTPValidationError
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
          TError,
          Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReportApiV1PeopleReportsReportIdGet<
  TData = Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
  TError = HTTPValidationError
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Report
 */

export function useGetReportApiV1PeopleReportsReportIdGet<
  TData = Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
  TError = HTTPValidationError
>(
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportApiV1PeopleReportsReportIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetReportApiV1PeopleReportsReportIdGetQueryOptions(
    reportId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a saved report. An omitted property is left unchanged.
 * @summary Update Report
 */
export const updateReportApiV1PeopleReportsReportIdPut = (
  reportId: string,
  peopleReportDefinitionUpdate: PeopleReportDefinitionUpdate
) => {
  return customInstance<PeopleReportDefinition>({
    url: `/api/v1/people/reports/${reportId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: peopleReportDefinitionUpdate
  });
};

export const getUpdateReportApiV1PeopleReportsReportIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReportApiV1PeopleReportsReportIdPut>>,
    TError,
    { reportId: string; data: PeopleReportDefinitionUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReportApiV1PeopleReportsReportIdPut>>,
  TError,
  { reportId: string; data: PeopleReportDefinitionUpdate },
  TContext
> => {
  const mutationKey = ['updateReportApiV1PeopleReportsReportIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReportApiV1PeopleReportsReportIdPut>>,
    { reportId: string; data: PeopleReportDefinitionUpdate }
  > = (props) => {
    const { reportId, data } = props ?? {};

    return updateReportApiV1PeopleReportsReportIdPut(reportId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReportApiV1PeopleReportsReportIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateReportApiV1PeopleReportsReportIdPut>>
  >;
export type UpdateReportApiV1PeopleReportsReportIdPutMutationBody =
  PeopleReportDefinitionUpdate;
export type UpdateReportApiV1PeopleReportsReportIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Report
 */
export const useUpdateReportApiV1PeopleReportsReportIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateReportApiV1PeopleReportsReportIdPut>>,
      TError,
      { reportId: string; data: PeopleReportDefinitionUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateReportApiV1PeopleReportsReportIdPut>>,
  TError,
  { reportId: string; data: PeopleReportDefinitionUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateReportApiV1PeopleReportsReportIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Report
 */
export const deleteReportApiV1PeopleReportsReportIdDelete = (
  reportId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/reports/${reportId}`,
    method: 'DELETE'
  });
};

export const getDeleteReportApiV1PeopleReportsReportIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReportApiV1PeopleReportsReportIdDelete>>,
    TError,
    { reportId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReportApiV1PeopleReportsReportIdDelete>>,
  TError,
  { reportId: string },
  TContext
> => {
  const mutationKey = ['deleteReportApiV1PeopleReportsReportIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReportApiV1PeopleReportsReportIdDelete>>,
    { reportId: string }
  > = (props) => {
    const { reportId } = props ?? {};

    return deleteReportApiV1PeopleReportsReportIdDelete(reportId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReportApiV1PeopleReportsReportIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteReportApiV1PeopleReportsReportIdDelete>>
  >;

export type DeleteReportApiV1PeopleReportsReportIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Report
 */
export const useDeleteReportApiV1PeopleReportsReportIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReportApiV1PeopleReportsReportIdDelete>>,
      TError,
      { reportId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReportApiV1PeopleReportsReportIdDelete>>,
  TError,
  { reportId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteReportApiV1PeopleReportsReportIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Turnover rate, its voluntary/involuntary split and attrition by dimension.
 * @summary Get Turnover Analytics
 */
export const getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet = (
  params?: GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleTurnoverAnalytics>({
    url: `/api/v1/people/analytics/turnover`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetQueryKey = (
  params?: GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetParams
) => {
  return [
    `/api/v1/people/analytics/turnover`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
      >
    > = ({ signal }) =>
      getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
    >
  >;
export type GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetQueryError =
  HTTPValidationError;

export function useGetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet<
  TData = Awaited<
    ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet<
  TData = Awaited<
    ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet<
  TData = Awaited<
    ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Turnover Analytics
 */

export function useGetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet<
  TData = Awaited<
    ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTurnoverAnalyticsApiV1PeopleAnalyticsTurnoverGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Headcount, joiners and leavers per month, from the effective-dated record.
 * @summary Get Headcount Trend
 */
export const getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet = (
  params?: GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleHeadcountTrend>({
    url: `/api/v1/people/analytics/headcount-trend`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetQueryKey =
  (params?: GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetParams) => {
    return [
      `/api/v1/people/analytics/headcount-trend`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
        >
      >
    > = ({ signal }) =>
      getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet>
    >
  >;
export type GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetQueryError =
  HTTPValidationError;

export function useGetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet<
  TData = Awaited<
    ReturnType<typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet<
  TData = Awaited<
    ReturnType<typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet<
  TData = Awaited<
    ReturnType<typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Headcount Trend
 */

export function useGetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet<
  TData = Awaited<
    ReturnType<typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetHeadcountTrendApiV1PeopleAnalyticsHeadcountTrendGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List review cycles with filters, server-side sort, and pagination.

``limit`` is unset by default (full dataset, capped at ``MAX_LIST_LIMIT``) per
docs/design-system/ui-list-pages.md §11 — a hidden default cap silently
truncated the set the list page then paginated over. ``total`` is the count
over the same predicate, so the page controls are honest at any page size.
 * @summary List Review Cycles
 */
export const listReviewCyclesApiV1PeopleReviewCyclesGet = (
  params?: ListReviewCyclesApiV1PeopleReviewCyclesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleListResponse>({
    url: `/api/v1/people/review-cycles`,
    method: 'GET',
    params,
    signal
  });
};

export const getListReviewCyclesApiV1PeopleReviewCyclesGetQueryKey = (
  params?: ListReviewCyclesApiV1PeopleReviewCyclesGetParams
) => {
  return [`/api/v1/people/review-cycles`, ...(params ? [params] : [])] as const;
};

export const getListReviewCyclesApiV1PeopleReviewCyclesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReviewCyclesApiV1PeopleReviewCyclesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListReviewCyclesApiV1PeopleReviewCyclesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>
  > = ({ signal }) =>
    listReviewCyclesApiV1PeopleReviewCyclesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListReviewCyclesApiV1PeopleReviewCyclesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>
>;
export type ListReviewCyclesApiV1PeopleReviewCyclesGetQueryError =
  HTTPValidationError;

export function useListReviewCyclesApiV1PeopleReviewCyclesGet<
  TData = Awaited<
    ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListReviewCyclesApiV1PeopleReviewCyclesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListReviewCyclesApiV1PeopleReviewCyclesGet<
  TData = Awaited<
    ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReviewCyclesApiV1PeopleReviewCyclesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListReviewCyclesApiV1PeopleReviewCyclesGet<
  TData = Awaited<
    ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReviewCyclesApiV1PeopleReviewCyclesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Review Cycles
 */

export function useListReviewCyclesApiV1PeopleReviewCyclesGet<
  TData = Awaited<
    ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListReviewCyclesApiV1PeopleReviewCyclesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listReviewCyclesApiV1PeopleReviewCyclesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListReviewCyclesApiV1PeopleReviewCyclesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new review cycle. Requires people module admin.
 * @summary Create Review Cycle
 */
export const createReviewCycleApiV1PeopleReviewCyclesPost = (
  reviewCycleCreate: ReviewCycleCreate,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleResponse>({
    url: `/api/v1/people/review-cycles`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reviewCycleCreate,
    signal
  });
};

export const getCreateReviewCycleApiV1PeopleReviewCyclesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReviewCycleApiV1PeopleReviewCyclesPost>>,
    TError,
    { data: ReviewCycleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReviewCycleApiV1PeopleReviewCyclesPost>>,
  TError,
  { data: ReviewCycleCreate },
  TContext
> => {
  const mutationKey = ['createReviewCycleApiV1PeopleReviewCyclesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReviewCycleApiV1PeopleReviewCyclesPost>>,
    { data: ReviewCycleCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createReviewCycleApiV1PeopleReviewCyclesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReviewCycleApiV1PeopleReviewCyclesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createReviewCycleApiV1PeopleReviewCyclesPost>>
  >;
export type CreateReviewCycleApiV1PeopleReviewCyclesPostMutationBody =
  ReviewCycleCreate;
export type CreateReviewCycleApiV1PeopleReviewCyclesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Review Cycle
 */
export const useCreateReviewCycleApiV1PeopleReviewCyclesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createReviewCycleApiV1PeopleReviewCyclesPost>>,
      TError,
      { data: ReviewCycleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createReviewCycleApiV1PeopleReviewCyclesPost>>,
  TError,
  { data: ReviewCycleCreate },
  TContext
> => {
  const mutationOptions =
    getCreateReviewCycleApiV1PeopleReviewCyclesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a review cycle by ID.
 * @summary Get Review Cycle
 */
export const getReviewCycleApiV1PeopleReviewCyclesCycleIdGet = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleResponse>({
    url: `/api/v1/people/review-cycles/${cycleId}`,
    method: 'GET',
    signal
  });
};

export const getGetReviewCycleApiV1PeopleReviewCyclesCycleIdGetQueryKey = (
  cycleId?: string
) => {
  return [`/api/v1/people/review-cycles/${cycleId}`] as const;
};

export const getGetReviewCycleApiV1PeopleReviewCyclesCycleIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReviewCycleApiV1PeopleReviewCyclesCycleIdGetQueryKey(cycleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>>
  > = ({ signal }) =>
    getReviewCycleApiV1PeopleReviewCyclesCycleIdGet(cycleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!cycleId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReviewCycleApiV1PeopleReviewCyclesCycleIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>>
  >;
export type GetReviewCycleApiV1PeopleReviewCyclesCycleIdGetQueryError =
  HTTPValidationError;

export function useGetReviewCycleApiV1PeopleReviewCyclesCycleIdGet<
  TData = Awaited<
    ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetReviewCycleApiV1PeopleReviewCyclesCycleIdGet<
  TData = Awaited<
    ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReviewCycleApiV1PeopleReviewCyclesCycleIdGet<
  TData = Awaited<
    ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Review Cycle
 */

export function useGetReviewCycleApiV1PeopleReviewCyclesCycleIdGet<
  TData = Awaited<
    ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewCycleApiV1PeopleReviewCyclesCycleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetReviewCycleApiV1PeopleReviewCyclesCycleIdGetQueryOptions(
      cycleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a review cycle. Requires people module admin.
 * @summary Update Review Cycle
 */
export const updateReviewCycleApiV1PeopleReviewCyclesCycleIdPut = (
  cycleId: string,
  reviewCycleUpdate: ReviewCycleUpdate
) => {
  return customInstance<ReviewCycleResponse>({
    url: `/api/v1/people/review-cycles/${cycleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: reviewCycleUpdate
  });
};

export const getUpdateReviewCycleApiV1PeopleReviewCyclesCycleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateReviewCycleApiV1PeopleReviewCyclesCycleIdPut>
      >,
      TError,
      { cycleId: string; data: ReviewCycleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateReviewCycleApiV1PeopleReviewCyclesCycleIdPut>
    >,
    TError,
    { cycleId: string; data: ReviewCycleUpdate },
    TContext
  > => {
    const mutationKey = ['updateReviewCycleApiV1PeopleReviewCyclesCycleIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateReviewCycleApiV1PeopleReviewCyclesCycleIdPut>
      >,
      { cycleId: string; data: ReviewCycleUpdate }
    > = (props) => {
      const { cycleId, data } = props ?? {};

      return updateReviewCycleApiV1PeopleReviewCyclesCycleIdPut(cycleId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateReviewCycleApiV1PeopleReviewCyclesCycleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateReviewCycleApiV1PeopleReviewCyclesCycleIdPut>
    >
  >;
export type UpdateReviewCycleApiV1PeopleReviewCyclesCycleIdPutMutationBody =
  ReviewCycleUpdate;
export type UpdateReviewCycleApiV1PeopleReviewCyclesCycleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Review Cycle
 */
export const useUpdateReviewCycleApiV1PeopleReviewCyclesCycleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateReviewCycleApiV1PeopleReviewCyclesCycleIdPut>
      >,
      TError,
      { cycleId: string; data: ReviewCycleUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateReviewCycleApiV1PeopleReviewCyclesCycleIdPut>
  >,
  TError,
  { cycleId: string; data: ReviewCycleUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateReviewCycleApiV1PeopleReviewCyclesCycleIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a review cycle (draft only). Requires people module admin.

Returns no body — the 204 is the whole response, same as ``remove_rater``.
 * @summary Delete Review Cycle
 */
export const deleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete = (
  cycleId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/review-cycles/${cycleId}`,
    method: 'DELETE'
  });
};

export const getDeleteReviewCycleApiV1PeopleReviewCyclesCycleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete>
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete>
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete>
      >,
      { cycleId: string }
    > = (props) => {
      const { cycleId } = props ?? {};

      return deleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete(cycleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteReviewCycleApiV1PeopleReviewCyclesCycleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete>
    >
  >;

export type DeleteReviewCycleApiV1PeopleReviewCyclesCycleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Review Cycle
 */
export const useDeleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete>
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteReviewCycleApiV1PeopleReviewCyclesCycleIdDelete>
  >,
  TError,
  { cycleId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteReviewCycleApiV1PeopleReviewCyclesCycleIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Stage a launch: exactly who it would cover and every gap. **Writes nothing.**

POST rather than GET because resolving a whole tenant's org chart is expensive
and must never be cached as if it were a static resource — the answer changes
with every hire, and a stale staging dashboard is the defect this endpoint
exists to prevent.

Requires people module admin (same gate as the launch it stages: the exclusion
list names employees and their org position).
 * @summary Preview Review Cycle
 */
export const previewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCyclePreview>({
    url: `/api/v1/people/review-cycles/${cycleId}/preview`,
    method: 'POST',
    signal
  });
};

export const getPreviewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof previewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof previewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationKey = [
      'previewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof previewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost
        >
      >,
      { cycleId: string }
    > = (props) => {
      const { cycleId } = props ?? {};

      return previewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost(
        cycleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PreviewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost
      >
    >
  >;

export type PreviewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Preview Review Cycle
 */
export const usePreviewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof previewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof previewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPost
    >
  >,
  TError,
  { cycleId: string },
  TContext
> => {
  const mutationOptions =
    getPreviewReviewCycleApiV1PeopleReviewCyclesCycleIdPreviewPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Launch a review cycle: create its participants, raters, phases and reviews.

Requires people module admin. Returns the launch report — how many participants
and reviews were created, plus every employee/rater-type pair that resolved to
nobody and why, so the launching admin sees the gaps instead of discovering
them later (contract C1; v1 reported none of them).
 * @summary Launch Review Cycle
 */
export const launchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleLaunchReport>({
    url: `/api/v1/people/review-cycles/${cycleId}/launch`,
    method: 'POST',
    signal
  });
};

export const getLaunchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof launchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof launchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationKey = [
      'launchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof launchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost
        >
      >,
      { cycleId: string }
    > = (props) => {
      const { cycleId } = props ?? {};

      return launchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost(cycleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type LaunchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof launchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost
      >
    >
  >;

export type LaunchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPostMutationError =
  HTTPValidationError;

/**
 * @summary Launch Review Cycle
 */
export const useLaunchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof launchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof launchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPost>
  >,
  TError,
  { cycleId: string },
  TContext
> => {
  const mutationOptions =
    getLaunchReviewCycleApiV1PeopleReviewCyclesCycleIdLaunchPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Close a review cycle. Requires people module admin.
 * @summary Complete Review Cycle
 */
export const completeReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleResponse>({
    url: `/api/v1/people/review-cycles/${cycleId}/complete`,
    method: 'POST',
    signal
  });
};

export const getCompleteReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof completeReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof completeReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationKey = [
      'completeReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof completeReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost
        >
      >,
      { cycleId: string }
    > = (props) => {
      const { cycleId } = props ?? {};

      return completeReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost(
        cycleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CompleteReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof completeReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost
      >
    >
  >;

export type CompleteReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePostMutationError =
  HTTPValidationError;

/**
 * @summary Complete Review Cycle
 */
export const useCompleteReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof completeReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost
          >
        >,
        TError,
        { cycleId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof completeReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationOptions =
      getCompleteReviewCycleApiV1PeopleReviewCyclesCycleIdCompletePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Close rating collection and move the cycle into calibration.
 * @summary Start Review Cycle Calibration
 */
export const startReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost =
  (cycleId: string, signal?: AbortSignal) => {
    return customInstance<ReviewCycleResponse>({
      url: `/api/v1/people/review-cycles/${cycleId}/calibrate`,
      method: 'POST',
      signal
    });
  };

export const getStartReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof startReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof startReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationKey = [
      'startReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof startReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost
        >
      >,
      { cycleId: string }
    > = (props) => {
      const { cycleId } = props ?? {};

      return startReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost(
        cycleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StartReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof startReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost
      >
    >
  >;

export type StartReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePostMutationError =
  HTTPValidationError;

/**
 * @summary Start Review Cycle Calibration
 */
export const useStartReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof startReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost
          >
        >,
        TError,
        { cycleId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof startReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationOptions =
      getStartReviewCycleCalibrationApiV1PeopleReviewCyclesCycleIdCalibratePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Abandon a review cycle before it completes. Requires people module admin.
 * @summary Cancel Review Cycle
 */
export const cancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleResponse>({
    url: `/api/v1/people/review-cycles/${cycleId}/cancel`,
    method: 'POST',
    signal
  });
};

export const getCancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationKey = [
      'cancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost
        >
      >,
      { cycleId: string }
    > = (props) => {
      const { cycleId } = props ?? {};

      return cancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost(cycleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost
      >
    >
  >;

export type CancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Review Cycle
 */
export const useCancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof cancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPost>
  >,
  TError,
  { cycleId: string },
  TContext
> => {
  const mutationOptions =
    getCancelReviewCycleApiV1PeopleReviewCyclesCycleIdCancelPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Release a cycle stranded mid-launch (``launching`` -> ``draft``).

A launch commits its fan-out in bounded batches, so one that dies part-way
leaves the cycle ``launching`` rather than rolled back. This is the only way
out: relaunching from ``draft`` tops up the rows the failed run never wrote.
Requires people module admin.
 * @summary Reset Review Cycle Launch
 */
export const resetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost =
  (cycleId: string, signal?: AbortSignal) => {
    return customInstance<ReviewCycleResponse>({
      url: `/api/v1/people/review-cycles/${cycleId}/reset-launch`,
      method: 'POST',
      signal
    });
  };

export const getResetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationKey = [
      'resetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost
        >
      >,
      { cycleId: string }
    > = (props) => {
      const { cycleId } = props ?? {};

      return resetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost(
        cycleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost
      >
    >
  >;

export type ResetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPostMutationError =
  HTTPValidationError;

/**
 * @summary Reset Review Cycle Launch
 */
export const useResetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost
          >
        >,
        TError,
        { cycleId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationOptions =
      getResetReviewCycleLaunchApiV1PeopleReviewCyclesCycleIdResetLaunchPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Reopen a completed cycle. Only permitted when the cycle allows it (C6).
 * @summary Reopen Review Cycle
 */
export const reopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleResponse>({
    url: `/api/v1/people/review-cycles/${cycleId}/reopen`,
    method: 'POST',
    signal
  });
};

export const getReopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationKey = [
      'reopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost
        >
      >,
      { cycleId: string }
    > = (props) => {
      const { cycleId } = props ?? {};

      return reopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost(cycleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost
      >
    >
  >;

export type ReopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPostMutationError =
  HTTPValidationError;

/**
 * @summary Reopen Review Cycle
 */
export const useReopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof reopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPost>
  >,
  TError,
  { cycleId: string },
  TContext
> => {
  const mutationOptions =
    getReopenReviewCycleApiV1PeopleReviewCyclesCycleIdReopenPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Push a live cycle's end date out, taking outstanding due dates with it.

Extending the cycle alone would leave every outstanding review on its old
deadline and instantly overdue, which is the opposite of what an extension is
for. Already-submitted reviews keep their original deadline.
 * @summary Extend Review Cycle
 */
export const extendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost = (
  cycleId: string,
  reviewCycleExtendRequest: ReviewCycleExtendRequest,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleResponse>({
    url: `/api/v1/people/review-cycles/${cycleId}/extend`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reviewCycleExtendRequest,
    signal
  });
};

export const getExtendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof extendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost
        >
      >,
      TError,
      { cycleId: string; data: ReviewCycleExtendRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof extendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost
      >
    >,
    TError,
    { cycleId: string; data: ReviewCycleExtendRequest },
    TContext
  > => {
    const mutationKey = [
      'extendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof extendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost
        >
      >,
      { cycleId: string; data: ReviewCycleExtendRequest }
    > = (props) => {
      const { cycleId, data } = props ?? {};

      return extendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost(
        cycleId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExtendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof extendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost
      >
    >
  >;
export type ExtendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPostMutationBody =
  ReviewCycleExtendRequest;
export type ExtendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPostMutationError =
  HTTPValidationError;

/**
 * @summary Extend Review Cycle
 */
export const useExtendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof extendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost
        >
      >,
      TError,
      { cycleId: string; data: ReviewCycleExtendRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof extendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPost>
  >,
  TError,
  { cycleId: string; data: ReviewCycleExtendRequest },
  TContext
> => {
  const mutationOptions =
    getExtendReviewCycleApiV1PeopleReviewCyclesCycleIdExtendPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Materialize the reviews a phase makes due — where nominated peers become work.

Idempotent: a rater who already has a review is skipped, so re-opening a phase
after a late nomination is approved tops up rather than duplicating.
 * @summary Open Review Cycle Phase
 */
export const openReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost =
  (
    cycleId: string,
    phase:
      | 'nomination'
      | 'self'
      | 'peer_upward'
      | 'manager'
      | 'calibration'
      | 'release'
      | 'acknowledgment',
    signal?: AbortSignal
  ) => {
    return customInstance<ReviewCycleOpenPhaseResult>({
      url: `/api/v1/people/review-cycles/${cycleId}/phases/${phase}/open`,
      method: 'POST',
      signal
    });
  };

export const getOpenReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof openReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost
        >
      >,
      TError,
      {
        cycleId: string;
        phase:
          | 'nomination'
          | 'self'
          | 'peer_upward'
          | 'manager'
          | 'calibration'
          | 'release'
          | 'acknowledgment';
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof openReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost
      >
    >,
    TError,
    {
      cycleId: string;
      phase:
        | 'nomination'
        | 'self'
        | 'peer_upward'
        | 'manager'
        | 'calibration'
        | 'release'
        | 'acknowledgment';
    },
    TContext
  > => {
    const mutationKey = [
      'openReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof openReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost
        >
      >,
      {
        cycleId: string;
        phase:
          | 'nomination'
          | 'self'
          | 'peer_upward'
          | 'manager'
          | 'calibration'
          | 'release'
          | 'acknowledgment';
      }
    > = (props) => {
      const { cycleId, phase } = props ?? {};

      return openReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost(
        cycleId,
        phase
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type OpenReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof openReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost
      >
    >
  >;

export type OpenReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPostMutationError =
  HTTPValidationError;

/**
 * @summary Open Review Cycle Phase
 */
export const useOpenReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof openReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost
          >
        >,
        TError,
        {
          cycleId: string;
          phase:
            | 'nomination'
            | 'self'
            | 'peer_upward'
            | 'manager'
            | 'calibration'
            | 'release'
            | 'acknowledgment';
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof openReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPost
      >
    >,
    TError,
    {
      cycleId: string;
      phase:
        | 'nomination'
        | 'self'
        | 'peer_upward'
        | 'manager'
        | 'calibration'
        | 'release'
        | 'acknowledgment';
    },
    TContext
  > => {
    const mutationOptions =
      getOpenReviewCyclePhaseApiV1PeopleReviewCyclesCycleIdPhasesPhaseOpenPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Nudge the raters who have not submitted yet.

Non-submitters ONLY: a reminder that also reaches everyone who already filed
is how a whole notification channel gets muted. One notification per rater
rather than per review, and the count returned is raters addressed — zero
when everybody has already filed.
 * @summary Remind Review Cycle Raters
 */
export const remindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleRemindResult>({
    url: `/api/v1/people/review-cycles/${cycleId}/remind`,
    method: 'POST',
    signal
  });
};

export const getRemindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof remindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost
        >
      >,
      TError,
      { cycleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof remindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationKey = [
      'remindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof remindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost
        >
      >,
      { cycleId: string }
    > = (props) => {
      const { cycleId } = props ?? {};

      return remindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost(
        cycleId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof remindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost
      >
    >
  >;

export type RemindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPostMutationError =
  HTTPValidationError;

/**
 * @summary Remind Review Cycle Raters
 */
export const useRemindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof remindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost
          >
        >,
        TError,
        { cycleId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof remindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPost
      >
    >,
    TError,
    { cycleId: string },
    TContext
  > => {
    const mutationOptions =
      getRemindReviewCycleRatersApiV1PeopleReviewCyclesCycleIdRemindPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The reviews in a cycle — the endpoint v1 lacked entirely (audit A4).

``ReviewRepository.list_by_cycle`` existed and was called by nothing, so the
cycle detail page could only show aggregate counts and had no way to name a
single late rater. Server-paginated and filterable by rater type, status and
overdue, with ``total`` counted over the same predicate as the page.

**Admin-gated (``RequireCycleAdmin``), and do not widen it** (WI d96283c5).
It lists every review in a cycle
tenant-wide with no per-employee scoping of any kind, so on bare
``require_auth`` any authenticated member could dump every colleague's
reviewer identities and free-text comments by guessing a ``cycle_id`` — and
contract C3 gives that data a promise it did not have before, which makes an
ungated cycle-wide reader untenable. Cycle administration is admin work
(design doc C7); a manager who wants one person's reviews uses
``GET /employees/{id}/reviews``, which is scoped per employee.

C3 still applies to the admin's OWN rows: a People admin under review must
not unmask their own upward raters, so those rows are redacted, threshold-
suppressed and reordered exactly as they would be on their own reviews list.
Applying only *part* of C3 here would be worse than applying none — a
redacted-but-present row in a withheld group is still a countable row, and
this route would then contradict ``GET /employees/{id}/reviews``, which
drops it.
 * @summary List Cycle Reviews
 */
export const listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet = (
  cycleId: string,
  params?: ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ReviewListResponse>({
    url: `/api/v1/people/review-cycles/${cycleId}/reviews`,
    method: 'GET',
    params,
    signal
  });
};

export const getListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetQueryKey =
  (
    cycleId?: string,
    params?: ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetParams
  ) => {
    return [
      `/api/v1/people/review-cycles/${cycleId}/reviews`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
      >
    >,
    TError = HTTPValidationError
  >(
    cycleId: string,
    params?: ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetQueryKey(
        cycleId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
        >
      >
    > = ({ signal }) =>
      listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet(
        cycleId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!cycleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
      >
    >
  >;
export type ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetQueryError =
  HTTPValidationError;

export function useListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet<
  TData = Awaited<
    ReturnType<typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params:
    | undefined
    | ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet<
  TData = Awaited<
    ReturnType<typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params?: ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet<
  TData = Awaited<
    ReturnType<typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params?: ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Cycle Reviews
 */

export function useListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet<
  TData = Awaited<
    ReturnType<typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params?: ListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCycleReviewsApiV1PeopleReviewCyclesCycleIdReviewsGetQueryOptions(
      cycleId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Who the cycle covers, including everyone it excluded and why.

**``RequireCycleAdmin``, and do not widen it.** The exclusion reasons are the
sensitive half: a roster of colleagues naming who was left out of a review
cycle and on what grounds is HR administration, not an employee-facing view.
It shipped on bare ``require_auth`` alongside ``list_cycle_reviews`` and was
part of the same IDOR (WI d96283c5). Fail closed.
 * @summary List Cycle Participants
 */
export const listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet =
  (
    cycleId: string,
    params?: ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<ReviewParticipantListResponse>({
      url: `/api/v1/people/review-cycles/${cycleId}/participants`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetQueryKey =
  (
    cycleId?: string,
    params?: ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetParams
  ) => {
    return [
      `/api/v1/people/review-cycles/${cycleId}/participants`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
      >
    >,
    TError = HTTPValidationError
  >(
    cycleId: string,
    params?: ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetQueryKey(
        cycleId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
        >
      >
    > = ({ signal }) =>
      listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet(
        cycleId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!cycleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
      >
    >
  >;
export type ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetQueryError =
  HTTPValidationError;

export function useListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet<
  TData = Awaited<
    ReturnType<
      typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params:
    | undefined
    | ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet<
  TData = Awaited<
    ReturnType<
      typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params?: ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet<
  TData = Awaited<
    ReturnType<
      typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params?: ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Cycle Participants
 */

export function useListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet<
  TData = Awaited<
    ReturnType<
      typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params?: ListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCycleParticipantsApiV1PeopleReviewCyclesCycleIdParticipantsGetQueryOptions(
      cycleId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Progress counts for a review cycle, per status, per rater type and overdue.
 * @summary Get Cycle Progress
 */
export const getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<CycleProgressResponse>({
    url: `/api/v1/people/review-cycles/${cycleId}/progress`,
    method: 'GET',
    signal
  });
};

export const getGetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGetQueryKey =
  (cycleId?: string) => {
    return [`/api/v1/people/review-cycles/${cycleId}/progress`] as const;
  };

export const getGetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
      >
    >,
    TError = HTTPValidationError
  >(
    cycleId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGetQueryKey(
        cycleId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
        >
      >
    > = ({ signal }) =>
      getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet(
        cycleId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!cycleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
      >
    >
  >;
export type GetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGetQueryError =
  HTTPValidationError;

export function useGetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet<
  TData = Awaited<
    ReturnType<typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet<
  TData = Awaited<
    ReturnType<typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet<
  TData = Awaited<
    ReturnType<typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Cycle Progress
 */

export function useGetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet<
  TData = Awaited<
    ReturnType<typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCycleProgressApiV1PeopleReviewCyclesCycleIdProgressGetQueryOptions(
      cycleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The cycle's rater types: which template each uses, and how anonymous it is.

Admin-gated with the rest of cycle configuration (C7) — this is the read half
of the anonymity editor, and it names every rater type the cycle collects.
 * @summary List Cycle Templates
 */
export const listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleTemplateResponse[]>({
    url: `/api/v1/people/review-cycles/${cycleId}/templates`,
    method: 'GET',
    signal
  });
};

export const getListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGetQueryKey =
  (cycleId?: string) => {
    return [`/api/v1/people/review-cycles/${cycleId}/templates`] as const;
  };

export const getListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
      >
    >,
    TError = HTTPValidationError
  >(
    cycleId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGetQueryKey(
        cycleId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
        >
      >
    > = ({ signal }) =>
      listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet(
        cycleId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!cycleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
      >
    >
  >;
export type ListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGetQueryError =
  HTTPValidationError;

export function useListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Cycle Templates
 */

export function useListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCycleTemplatesApiV1PeopleReviewCyclesCycleIdTemplatesGetQueryOptions(
      cycleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Declare that the cycle collects ``rater_type``, using the given form.

§2.2 made the presence of this row the *only* declaration that a rater type
is active — replacing v1's inert ``include_peer_review`` boolean — and
``POST /review-cycles/{id}/launch`` refuses a cycle that has none. So this
is the route the whole engine hangs off: without it a cycle can be created
through the product but never launched, and the anonymity ``PUT`` below has
no row to amend.

``PUT`` rather than ``POST`` because it is idempotent on
``(cycle, rater_type)``: there is one row per pair, and re-binding swaps the
form in place rather than adding a second. The swap deliberately leaves
contract C3's ``hide_identities`` / ``hide_comments`` alone — resetting them
would be a loosening, achieved through the back door of a form change.

Draft-only, and every guard lives in
``ReviewCycleService.bind_template``.
 * @summary Bind Cycle Template
 */
export const bindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut =
  (
    cycleId: string,
    raterType: 'self' | 'manager' | 'peer' | 'upward' | 'skip_level' | 'custom',
    reviewCycleTemplateBindRequest: ReviewCycleTemplateBindRequest
  ) => {
    return customInstance<ReviewCycleTemplateResponse>({
      url: `/api/v1/people/review-cycles/${cycleId}/templates/${raterType}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reviewCycleTemplateBindRequest
    });
  };

export const getBindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut
        >
      >,
      TError,
      {
        cycleId: string;
        raterType:
          | 'self'
          | 'manager'
          | 'peer'
          | 'upward'
          | 'skip_level'
          | 'custom';
        data: ReviewCycleTemplateBindRequest;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut
      >
    >,
    TError,
    {
      cycleId: string;
      raterType:
        | 'self'
        | 'manager'
        | 'peer'
        | 'upward'
        | 'skip_level'
        | 'custom';
      data: ReviewCycleTemplateBindRequest;
    },
    TContext
  > => {
    const mutationKey = [
      'bindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut
        >
      >,
      {
        cycleId: string;
        raterType:
          | 'self'
          | 'manager'
          | 'peer'
          | 'upward'
          | 'skip_level'
          | 'custom';
        data: ReviewCycleTemplateBindRequest;
      }
    > = (props) => {
      const { cycleId, raterType, data } = props ?? {};

      return bindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut(
        cycleId,
        raterType,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut
      >
    >
  >;
export type BindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePutMutationBody =
  ReviewCycleTemplateBindRequest;
export type BindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePutMutationError =
  HTTPValidationError;

/**
 * @summary Bind Cycle Template
 */
export const useBindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut
          >
        >,
        TError,
        {
          cycleId: string;
          raterType:
            | 'self'
            | 'manager'
            | 'peer'
            | 'upward'
            | 'skip_level'
            | 'custom';
          data: ReviewCycleTemplateBindRequest;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePut
      >
    >,
    TError,
    {
      cycleId: string;
      raterType:
        | 'self'
        | 'manager'
        | 'peer'
        | 'upward'
        | 'skip_level'
        | 'custom';
      data: ReviewCycleTemplateBindRequest;
    },
    TContext
  > => {
    const mutationOptions =
      getBindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Stop collecting ``rater_type`` for this cycle.

The counterpart to the bind above: a rater type added by mistake has to be
removable while the cycle is still being configured. Draft-only — see
``ReviewCycleService.unbind_template`` for why a launched cycle's roster is
already spent.
 * @summary Unbind Cycle Template
 */
export const unbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete =
  (
    cycleId: string,
    raterType: 'self' | 'manager' | 'peer' | 'upward' | 'skip_level' | 'custom'
  ) => {
    return customInstance<void>({
      url: `/api/v1/people/review-cycles/${cycleId}/templates/${raterType}`,
      method: 'DELETE'
    });
  };

export const getUnbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete
        >
      >,
      TError,
      {
        cycleId: string;
        raterType:
          | 'self'
          | 'manager'
          | 'peer'
          | 'upward'
          | 'skip_level'
          | 'custom';
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete
      >
    >,
    TError,
    {
      cycleId: string;
      raterType:
        | 'self'
        | 'manager'
        | 'peer'
        | 'upward'
        | 'skip_level'
        | 'custom';
    },
    TContext
  > => {
    const mutationKey = [
      'unbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete
        >
      >,
      {
        cycleId: string;
        raterType:
          | 'self'
          | 'manager'
          | 'peer'
          | 'upward'
          | 'skip_level'
          | 'custom';
      }
    > = (props) => {
      const { cycleId, raterType } = props ?? {};

      return unbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete(
        cycleId,
        raterType
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete
      >
    >
  >;

export type UnbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unbind Cycle Template
 */
export const useUnbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete
          >
        >,
        TError,
        {
          cycleId: string;
          raterType:
            | 'self'
            | 'manager'
            | 'peer'
            | 'upward'
            | 'skip_level'
            | 'custom';
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDelete
      >
    >,
    TError,
    {
      cycleId: string;
      raterType:
        | 'self'
        | 'manager'
        | 'peer'
        | 'upward'
        | 'skip_level'
        | 'custom';
    },
    TContext
  > => {
    const mutationOptions =
      getUnbindCycleTemplateApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Set contract C3's two controls for one ``(cycle, rater_type)``.

Deliberately its own route rather than a field on the cycle: the controls are
per rater type, and folding them into ``PUT /review-cycles/{id}`` would make
the ratchet below invisible next to a dozen freely-editable fields.

**One-way ratchet.** Tightening is allowed at any point; loosening is
rejected with a 400 naming the control, because the raters who already filed
wrote under the promise that was in force. See
``ReviewCycleService.set_template_anonymity``.
 * @summary Set Cycle Template Anonymity
 */
export const setCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut =
  (
    cycleId: string,
    raterType: 'self' | 'manager' | 'peer' | 'upward' | 'skip_level' | 'custom',
    reviewCycleTemplateAnonymityRequest: ReviewCycleTemplateAnonymityRequest
  ) => {
    return customInstance<ReviewCycleTemplateResponse>({
      url: `/api/v1/people/review-cycles/${cycleId}/templates/${raterType}/anonymity`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reviewCycleTemplateAnonymityRequest
    });
  };

export const getSetCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut
        >
      >,
      TError,
      {
        cycleId: string;
        raterType:
          | 'self'
          | 'manager'
          | 'peer'
          | 'upward'
          | 'skip_level'
          | 'custom';
        data: ReviewCycleTemplateAnonymityRequest;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut
      >
    >,
    TError,
    {
      cycleId: string;
      raterType:
        | 'self'
        | 'manager'
        | 'peer'
        | 'upward'
        | 'skip_level'
        | 'custom';
      data: ReviewCycleTemplateAnonymityRequest;
    },
    TContext
  > => {
    const mutationKey = [
      'setCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut
        >
      >,
      {
        cycleId: string;
        raterType:
          | 'self'
          | 'manager'
          | 'peer'
          | 'upward'
          | 'skip_level'
          | 'custom';
        data: ReviewCycleTemplateAnonymityRequest;
      }
    > = (props) => {
      const { cycleId, raterType, data } = props ?? {};

      return setCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut(
        cycleId,
        raterType,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut
      >
    >
  >;
export type SetCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPutMutationBody =
  ReviewCycleTemplateAnonymityRequest;
export type SetCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPutMutationError =
  HTTPValidationError;

/**
 * @summary Set Cycle Template Anonymity
 */
export const useSetCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut
          >
        >,
        TError,
        {
          cycleId: string;
          raterType:
            | 'self'
            | 'manager'
            | 'peer'
            | 'upward'
            | 'skip_level'
            | 'custom';
          data: ReviewCycleTemplateAnonymityRequest;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPut
      >
    >,
    TError,
    {
      cycleId: string;
      raterType:
        | 'self'
        | 'manager'
        | 'peer'
        | 'upward'
        | 'skip_level'
        | 'custom';
      data: ReviewCycleTemplateAnonymityRequest;
    },
    TContext
  > => {
    const mutationOptions =
      getSetCycleTemplateAnonymityApiV1PeopleReviewCyclesCycleIdTemplatesRaterTypeAnonymityPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * How contract C3 applies to each ``(cycle, rater_type)`` group about this employee.

This exists so the UI can **state** a suppression. Rendering an empty section
where a withheld peer group would go says "nobody had anything to say", which
is a different claim and a false one; "hidden until 3 peers respond" is the
true one, and it also tells the employee the silence is temporary.

``respondent_count`` is withheld from the employee themselves — "2 of 3" is
itself a re-identification signal. Administrators get the number.
 * @summary Get Employee Review Anonymity
 */
export const getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet =
  (employeeId: string, signal?: AbortSignal) => {
    return customInstance<ReviewAnonymityGroup[]>({
      url: `/api/v1/people/employees/${employeeId}/reviews/anonymity`,
      method: 'GET',
      signal
    });
  };

export const getGetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGetQueryKey =
  (employeeId?: string) => {
    return [
      `/api/v1/people/employees/${employeeId}/reviews/anonymity`
    ] as const;
  };

export const getGetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGetQueryKey(
        employeeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
        >
      >
    > = ({ signal }) =>
      getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet(
        employeeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
      >
    >
  >;
export type GetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGetQueryError =
  HTTPValidationError;

export function useGetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Employee Review Anonymity
 */

export function useGetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEmployeeReviewAnonymityApiV1PeopleEmployeesEmployeeIdReviewsAnonymityGetQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Everyone rating this participant, with their nomination state.

**Anonymised rater types are unmasked only for administrators.** Contract C3
withholds a rater's identity *from the employee* for any rater type the cycle
marked ``hide_identities``, so serving the stored ``rater_user_id`` to the
subject of the review would defeat the promise entirely and expose peer
reviewers to retaliation. Managers and HR keep the identities — they have to
administer the panel. (This is the re-added redaction the pre-C3 revision of
this docstring anticipated — now at the ``(cycle, rater_type)`` grain, and
with tests that prove it fires.)

Two roles, two questions. ``enforce_nomination_actor`` decides whether the
caller may be here at all; ``anonymity_actor_role`` decides what they see. They
disagree for a manager who is themselves the participant, and the anonymity
answer is the one that must win there — see its docstring.
 * @summary List Participant Raters
 */
export const listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet =
  (participantId: string, signal?: AbortSignal) => {
    return customInstance<ReviewRaterResponse[]>({
      url: `/api/v1/people/review-participants/${participantId}/raters`,
      method: 'GET',
      signal
    });
  };

export const getListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGetQueryKey =
  (participantId?: string) => {
    return [
      `/api/v1/people/review-participants/${participantId}/raters`
    ] as const;
  };

export const getListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
      >
    >,
    TError = HTTPValidationError
  >(
    participantId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGetQueryKey(
        participantId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
        >
      >
    > = ({ signal }) =>
      listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet(
        participantId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!participantId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
      >
    >
  >;
export type ListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGetQueryError =
  HTTPValidationError;

export function useListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet<
  TData = Awaited<
    ReturnType<
      typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
    >
  >,
  TError = HTTPValidationError
>(
  participantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet<
  TData = Awaited<
    ReturnType<
      typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
    >
  >,
  TError = HTTPValidationError
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet<
  TData = Awaited<
    ReturnType<
      typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
    >
  >,
  TError = HTTPValidationError
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Participant Raters
 */

export function useListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet<
  TData = Awaited<
    ReturnType<
      typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
    >
  >,
  TError = HTTPValidationError
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListParticipantRatersApiV1PeopleReviewParticipantsParticipantIdRatersGetQueryOptions(
      participantId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Put a rater forward for a participant.

Not admin-only: in ``employee_nominates`` mode the employee IS the nominator.
Gated instead on being the participant, their manager, or an HR editor —
choosing who reviews you is a workflow authority, and the read floor alone
would let any colleague stack somebody's peer panel.
 * @summary Nominate Rater
 */
export const nominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost =
  (
    participantId: string,
    reviewRaterNominationRequest: ReviewRaterNominationRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ReviewRaterResponse>({
      url: `/api/v1/people/review-participants/${participantId}/raters`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reviewRaterNominationRequest,
      signal
    });
  };

export const getNominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof nominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost
        >
      >,
      TError,
      { participantId: string; data: ReviewRaterNominationRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof nominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost
      >
    >,
    TError,
    { participantId: string; data: ReviewRaterNominationRequest },
    TContext
  > => {
    const mutationKey = [
      'nominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof nominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost
        >
      >,
      { participantId: string; data: ReviewRaterNominationRequest }
    > = (props) => {
      const { participantId, data } = props ?? {};

      return nominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost(
        participantId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type NominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof nominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost
      >
    >
  >;
export type NominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPostMutationBody =
  ReviewRaterNominationRequest;
export type NominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPostMutationError =
  HTTPValidationError;

/**
 * @summary Nominate Rater
 */
export const useNominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof nominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost
          >
        >,
        TError,
        { participantId: string; data: ReviewRaterNominationRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof nominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPost
      >
    >,
    TError,
    { participantId: string; data: ReviewRaterNominationRequest },
    TContext
  > => {
    const mutationOptions =
      getNominateRaterApiV1PeopleReviewParticipantsParticipantIdRatersPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Approve a nomination. Idempotent (C2).
 * @summary Approve Rater
 */
export const approveRaterApiV1PeopleReviewRatersRaterIdApprovePost = (
  raterId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewRaterResponse>({
    url: `/api/v1/people/review-raters/${raterId}/approve`,
    method: 'POST',
    signal
  });
};

export const getApproveRaterApiV1PeopleReviewRatersRaterIdApprovePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof approveRaterApiV1PeopleReviewRatersRaterIdApprovePost>
      >,
      TError,
      { raterId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof approveRaterApiV1PeopleReviewRatersRaterIdApprovePost>
    >,
    TError,
    { raterId: string },
    TContext
  > => {
    const mutationKey = [
      'approveRaterApiV1PeopleReviewRatersRaterIdApprovePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof approveRaterApiV1PeopleReviewRatersRaterIdApprovePost>
      >,
      { raterId: string }
    > = (props) => {
      const { raterId } = props ?? {};

      return approveRaterApiV1PeopleReviewRatersRaterIdApprovePost(raterId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApproveRaterApiV1PeopleReviewRatersRaterIdApprovePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof approveRaterApiV1PeopleReviewRatersRaterIdApprovePost>
    >
  >;

export type ApproveRaterApiV1PeopleReviewRatersRaterIdApprovePostMutationError =
  HTTPValidationError;

/**
 * @summary Approve Rater
 */
export const useApproveRaterApiV1PeopleReviewRatersRaterIdApprovePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof approveRaterApiV1PeopleReviewRatersRaterIdApprovePost>
      >,
      TError,
      { raterId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof approveRaterApiV1PeopleReviewRatersRaterIdApprovePost>
  >,
  TError,
  { raterId: string },
  TContext
> => {
  const mutationOptions =
    getApproveRaterApiV1PeopleReviewRatersRaterIdApprovePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Decline a nomination before it becomes a review.
 * @summary Reject Rater
 */
export const rejectRaterApiV1PeopleReviewRatersRaterIdRejectPost = (
  raterId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewRaterResponse>({
    url: `/api/v1/people/review-raters/${raterId}/reject`,
    method: 'POST',
    signal
  });
};

export const getRejectRaterApiV1PeopleReviewRatersRaterIdRejectPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof rejectRaterApiV1PeopleReviewRatersRaterIdRejectPost>
      >,
      TError,
      { raterId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof rejectRaterApiV1PeopleReviewRatersRaterIdRejectPost>
    >,
    TError,
    { raterId: string },
    TContext
  > => {
    const mutationKey = ['rejectRaterApiV1PeopleReviewRatersRaterIdRejectPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof rejectRaterApiV1PeopleReviewRatersRaterIdRejectPost>
      >,
      { raterId: string }
    > = (props) => {
      const { raterId } = props ?? {};

      return rejectRaterApiV1PeopleReviewRatersRaterIdRejectPost(raterId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type RejectRaterApiV1PeopleReviewRatersRaterIdRejectPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof rejectRaterApiV1PeopleReviewRatersRaterIdRejectPost>
    >
  >;

export type RejectRaterApiV1PeopleReviewRatersRaterIdRejectPostMutationError =
  HTTPValidationError;

/**
 * @summary Reject Rater
 */
export const useRejectRaterApiV1PeopleReviewRatersRaterIdRejectPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof rejectRaterApiV1PeopleReviewRatersRaterIdRejectPost>
      >,
      TError,
      { raterId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof rejectRaterApiV1PeopleReviewRatersRaterIdRejectPost>
  >,
  TError,
  { raterId: string },
  TContext
> => {
  const mutationOptions =
    getRejectRaterApiV1PeopleReviewRatersRaterIdRejectPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Remove a rater — deletes the row before their phase opens, soft-deletes
their review after (C2).
 * @summary Remove Rater
 */
export const removeRaterApiV1PeopleReviewRatersRaterIdDelete = (
  raterId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/review-raters/${raterId}`,
    method: 'DELETE'
  });
};

export const getRemoveRaterApiV1PeopleReviewRatersRaterIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeRaterApiV1PeopleReviewRatersRaterIdDelete>
      >,
      TError,
      { raterId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof removeRaterApiV1PeopleReviewRatersRaterIdDelete>>,
    TError,
    { raterId: string },
    TContext
  > => {
    const mutationKey = ['removeRaterApiV1PeopleReviewRatersRaterIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof removeRaterApiV1PeopleReviewRatersRaterIdDelete>
      >,
      { raterId: string }
    > = (props) => {
      const { raterId } = props ?? {};

      return removeRaterApiV1PeopleReviewRatersRaterIdDelete(raterId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveRaterApiV1PeopleReviewRatersRaterIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeRaterApiV1PeopleReviewRatersRaterIdDelete>>
  >;

export type RemoveRaterApiV1PeopleReviewRatersRaterIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Rater
 */
export const useRemoveRaterApiV1PeopleReviewRatersRaterIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeRaterApiV1PeopleReviewRatersRaterIdDelete>
      >,
      TError,
      { raterId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof removeRaterApiV1PeopleReviewRatersRaterIdDelete>>,
  TError,
  { raterId: string },
  TContext
> => {
  const mutationOptions =
    getRemoveRaterApiV1PeopleReviewRatersRaterIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get all reviews for an employee.

The reviewee's own view of this list is where contract C3 lands hardest — it
is the surface an employee actually reads their feedback on. Three things
happen to it and to nobody else's view: an anonymised rater type loses its
identities, a hide_comments rater type loses its wording, and a group that
has not yet reached ``anonymity_min_respondents`` is dropped whole.

``total`` is NOT recomputed after a suppressed group is dropped, and that is
deliberate: a total that shrank by exactly the number of withheld reviews
would hand the reviewee the count the suppression exists to withhold. The
companion ``/reviews/anonymity`` route is how the UI learns to *state* the
suppression instead of inferring it from arithmetic.
 * @summary Get Employee Reviews
 */
export const getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet = (
  employeeId: string,
  params?: GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ReviewListResponse>({
    url: `/api/v1/people/employees/${employeeId}/reviews`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetQueryKey =
  (
    employeeId?: string,
    params?: GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetParams
  ) => {
    return [
      `/api/v1/people/employees/${employeeId}/reviews`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
      >
    >,
    TError = HTTPValidationError
  >(
    employeeId: string,
    params?: GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetQueryKey(
        employeeId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
        >
      >
    > = ({ signal }) =>
      getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet(
        employeeId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!employeeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
      >
    >
  >;
export type GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetQueryError =
  HTTPValidationError;

export function useGetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params:
    | undefined
    | GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Employee Reviews
 */

export function useGetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet<
  TData = Awaited<
    ReturnType<
      typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
    >
  >,
  TError = HTTPValidationError
>(
  employeeId: string,
  params?: GetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEmployeeReviewsApiV1PeopleEmployeesEmployeeIdReviewsGetQueryOptions(
      employeeId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get reviews pending for the current user.

Scoped to reviews the caller RATES, so the caller is normally not their subject
— except on a self-assessment, where they are both. Redacted like every other
review read rather than reasoned about: ``redact_reviews`` leaves a row whose
subject the caller is not entirely untouched, so this costs the common case
nothing.
 * @summary Get Pending Reviews
 */
export const getPendingReviewsApiV1PeopleReviewsPendingGet = (
  params?: GetPendingReviewsApiV1PeopleReviewsPendingGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ReviewListResponse>({
    url: `/api/v1/people/reviews/pending`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetPendingReviewsApiV1PeopleReviewsPendingGetQueryKey = (
  params?: GetPendingReviewsApiV1PeopleReviewsPendingGetParams
) => {
  return [
    `/api/v1/people/reviews/pending`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetPendingReviewsApiV1PeopleReviewsPendingGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPendingReviewsApiV1PeopleReviewsPendingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPendingReviewsApiV1PeopleReviewsPendingGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>>
  > = ({ signal }) =>
    getPendingReviewsApiV1PeopleReviewsPendingGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPendingReviewsApiV1PeopleReviewsPendingGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>>
  >;
export type GetPendingReviewsApiV1PeopleReviewsPendingGetQueryError =
  HTTPValidationError;

export function useGetPendingReviewsApiV1PeopleReviewsPendingGet<
  TData = Awaited<
    ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetPendingReviewsApiV1PeopleReviewsPendingGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPendingReviewsApiV1PeopleReviewsPendingGet<
  TData = Awaited<
    ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPendingReviewsApiV1PeopleReviewsPendingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPendingReviewsApiV1PeopleReviewsPendingGet<
  TData = Awaited<
    ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPendingReviewsApiV1PeopleReviewsPendingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pending Reviews
 */

export function useGetPendingReviewsApiV1PeopleReviewsPendingGet<
  TData = Awaited<
    ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPendingReviewsApiV1PeopleReviewsPendingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPendingReviewsApiV1PeopleReviewsPendingGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPendingReviewsApiV1PeopleReviewsPendingGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Where the caller's direct reports stand in their reviews.

The manager surface's missing pane. Distinct from ``GET /reviews/pending``,
which answers "what do *I* owe"; this answers "where does my *team* stand",
and a manager mostly does not write the reviews it lists.

The team is the authenticated caller's own direct reports, resolved
server-side through ``manager_scope`` — never a client-supplied list, and
never the depth-10 subtree (§5 fixes "my team" as depth 1 on every surface
that uses the phrase). A caller who manages nobody gets an empty list, not an
error.

Deliberately NOT ``GET /review-cycles/{id}/reviews``: that one is tenant-wide
and admin-gated for C3 reasons, and narrowing it in the browser would ship
every colleague's review status there first.
 * @summary Get My Team Review Status
 */
export const getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet = (
  params?: GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetParams,
  signal?: AbortSignal
) => {
  return customInstance<MyTeamReviewStatus>({
    url: `/api/v1/people/my-team/review-status`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetQueryKey =
  (params?: GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetParams) => {
    return [
      `/api/v1/people/my-team/review-status`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet>
      >
    > = ({ signal }) =>
      getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet>
    >
  >;
export type GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetQueryError =
  HTTPValidationError;

export function useGetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet<
  TData = Awaited<
    ReturnType<typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet<
  TData = Awaited<
    ReturnType<typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet<
  TData = Awaited<
    ReturnType<typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get My Team Review Status
 */

export function useGetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet<
  TData = Awaited<
    ReturnType<typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMyTeamReviewStatusApiV1PeopleMyTeamReviewStatusGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a review by ID.

Redacted per contract C3 when the caller is the reviewee. A whole group held
below ``anonymity_min_respondents`` is a 404 here rather than an empty body:
the list route drops such a review entirely, and letting the reviewee confirm
its existence one id at a time would rebuild the count the threshold
withholds.
 * @summary Get Review
 */
export const getReviewApiV1PeopleReviewsReviewIdGet = (
  reviewId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewResponse>({
    url: `/api/v1/people/reviews/${reviewId}`,
    method: 'GET',
    signal
  });
};

export const getGetReviewApiV1PeopleReviewsReviewIdGetQueryKey = (
  reviewId?: string
) => {
  return [`/api/v1/people/reviews/${reviewId}`] as const;
};

export const getGetReviewApiV1PeopleReviewsReviewIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReviewApiV1PeopleReviewsReviewIdGetQueryKey(reviewId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>
  > = ({ signal }) => getReviewApiV1PeopleReviewsReviewIdGet(reviewId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!reviewId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReviewApiV1PeopleReviewsReviewIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>
>;
export type GetReviewApiV1PeopleReviewsReviewIdGetQueryError =
  HTTPValidationError;

export function useGetReviewApiV1PeopleReviewsReviewIdGet<
  TData = Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
  TError = HTTPValidationError
>(
  reviewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
          TError,
          Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetReviewApiV1PeopleReviewsReviewIdGet<
  TData = Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
          TError,
          Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReviewApiV1PeopleReviewsReviewIdGet<
  TData = Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Review
 */

export function useGetReviewApiV1PeopleReviewsReviewIdGet<
  TData = Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReviewApiV1PeopleReviewsReviewIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetReviewApiV1PeopleReviewsReviewIdGetQueryOptions(
    reviewId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a review (save as draft).
 * @summary Update Review
 */
export const updateReviewApiV1PeopleReviewsReviewIdPut = (
  reviewId: string,
  reviewUpdate: ReviewUpdate
) => {
  return customInstance<ReviewResponse>({
    url: `/api/v1/people/reviews/${reviewId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: reviewUpdate
  });
};

export const getUpdateReviewApiV1PeopleReviewsReviewIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReviewApiV1PeopleReviewsReviewIdPut>>,
    TError,
    { reviewId: string; data: ReviewUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReviewApiV1PeopleReviewsReviewIdPut>>,
  TError,
  { reviewId: string; data: ReviewUpdate },
  TContext
> => {
  const mutationKey = ['updateReviewApiV1PeopleReviewsReviewIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReviewApiV1PeopleReviewsReviewIdPut>>,
    { reviewId: string; data: ReviewUpdate }
  > = (props) => {
    const { reviewId, data } = props ?? {};

    return updateReviewApiV1PeopleReviewsReviewIdPut(reviewId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReviewApiV1PeopleReviewsReviewIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateReviewApiV1PeopleReviewsReviewIdPut>>
  >;
export type UpdateReviewApiV1PeopleReviewsReviewIdPutMutationBody =
  ReviewUpdate;
export type UpdateReviewApiV1PeopleReviewsReviewIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Review
 */
export const useUpdateReviewApiV1PeopleReviewsReviewIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateReviewApiV1PeopleReviewsReviewIdPut>>,
      TError,
      { reviewId: string; data: ReviewUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateReviewApiV1PeopleReviewsReviewIdPut>>,
  TError,
  { reviewId: string; data: ReviewUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateReviewApiV1PeopleReviewsReviewIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit a review.
 * @summary Submit Review
 */
export const submitReviewApiV1PeopleReviewsReviewIdSubmitPost = (
  reviewId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewResponse>({
    url: `/api/v1/people/reviews/${reviewId}/submit`,
    method: 'POST',
    signal
  });
};

export const getSubmitReviewApiV1PeopleReviewsReviewIdSubmitPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof submitReviewApiV1PeopleReviewsReviewIdSubmitPost>
      >,
      TError,
      { reviewId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof submitReviewApiV1PeopleReviewsReviewIdSubmitPost>
    >,
    TError,
    { reviewId: string },
    TContext
  > => {
    const mutationKey = ['submitReviewApiV1PeopleReviewsReviewIdSubmitPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof submitReviewApiV1PeopleReviewsReviewIdSubmitPost>
      >,
      { reviewId: string }
    > = (props) => {
      const { reviewId } = props ?? {};

      return submitReviewApiV1PeopleReviewsReviewIdSubmitPost(reviewId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type SubmitReviewApiV1PeopleReviewsReviewIdSubmitPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof submitReviewApiV1PeopleReviewsReviewIdSubmitPost>>
  >;

export type SubmitReviewApiV1PeopleReviewsReviewIdSubmitPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit Review
 */
export const useSubmitReviewApiV1PeopleReviewsReviewIdSubmitPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof submitReviewApiV1PeopleReviewsReviewIdSubmitPost>
      >,
      TError,
      { reviewId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof submitReviewApiV1PeopleReviewsReviewIdSubmitPost>>,
  TError,
  { reviewId: string },
  TContext
> => {
  const mutationOptions =
    getSubmitReviewApiV1PeopleReviewsReviewIdSubmitPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Release a submitted review to the employee it is about (C4).

Gated on ``update`` — the same right that let the rater write and submit it.
Releasing is a rater/HR act, not a reader's: it is what makes the review
visible to its subject and sends them the notification saying so.
 * @summary Release Review
 */
export const releaseReviewApiV1PeopleReviewsReviewIdReleasePost = (
  reviewId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewResponse>({
    url: `/api/v1/people/reviews/${reviewId}/release`,
    method: 'POST',
    signal
  });
};

export const getReleaseReviewApiV1PeopleReviewsReviewIdReleasePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof releaseReviewApiV1PeopleReviewsReviewIdReleasePost>
      >,
      TError,
      { reviewId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof releaseReviewApiV1PeopleReviewsReviewIdReleasePost>
    >,
    TError,
    { reviewId: string },
    TContext
  > => {
    const mutationKey = ['releaseReviewApiV1PeopleReviewsReviewIdReleasePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof releaseReviewApiV1PeopleReviewsReviewIdReleasePost>
      >,
      { reviewId: string }
    > = (props) => {
      const { reviewId } = props ?? {};

      return releaseReviewApiV1PeopleReviewsReviewIdReleasePost(reviewId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReleaseReviewApiV1PeopleReviewsReviewIdReleasePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof releaseReviewApiV1PeopleReviewsReviewIdReleasePost>
    >
  >;

export type ReleaseReviewApiV1PeopleReviewsReviewIdReleasePostMutationError =
  HTTPValidationError;

/**
 * @summary Release Review
 */
export const useReleaseReviewApiV1PeopleReviewsReviewIdReleasePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof releaseReviewApiV1PeopleReviewsReviewIdReleasePost>
      >,
      TError,
      { reviewId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof releaseReviewApiV1PeopleReviewsReviewIdReleasePost>
  >,
  TError,
  { reviewId: string },
  TContext
> => {
  const mutationOptions =
    getReleaseReviewApiV1PeopleReviewsReviewIdReleasePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Move an outstanding review to a different rater.

Cycle administration (C7), so ``RequireCycleAdmin``: choosing who rates whom
is the same authority that configured the panel in the first place. Before
this existed the only remedy for a rater who left mid-cycle was to remove
them, which soft-deletes their review and silently shrinks the cycle.
 * @summary Reassign Review
 */
export const reassignReviewApiV1PeopleReviewsReviewIdReassignPost = (
  reviewId: string,
  reviewReassignRequest: ReviewReassignRequest,
  signal?: AbortSignal
) => {
  return customInstance<ReviewResponse>({
    url: `/api/v1/people/reviews/${reviewId}/reassign`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reviewReassignRequest,
    signal
  });
};

export const getReassignReviewApiV1PeopleReviewsReviewIdReassignPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof reassignReviewApiV1PeopleReviewsReviewIdReassignPost>
      >,
      TError,
      { reviewId: string; data: ReviewReassignRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof reassignReviewApiV1PeopleReviewsReviewIdReassignPost>
    >,
    TError,
    { reviewId: string; data: ReviewReassignRequest },
    TContext
  > => {
    const mutationKey = [
      'reassignReviewApiV1PeopleReviewsReviewIdReassignPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof reassignReviewApiV1PeopleReviewsReviewIdReassignPost>
      >,
      { reviewId: string; data: ReviewReassignRequest }
    > = (props) => {
      const { reviewId, data } = props ?? {};

      return reassignReviewApiV1PeopleReviewsReviewIdReassignPost(
        reviewId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReassignReviewApiV1PeopleReviewsReviewIdReassignPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof reassignReviewApiV1PeopleReviewsReviewIdReassignPost>
    >
  >;
export type ReassignReviewApiV1PeopleReviewsReviewIdReassignPostMutationBody =
  ReviewReassignRequest;
export type ReassignReviewApiV1PeopleReviewsReviewIdReassignPostMutationError =
  HTTPValidationError;

/**
 * @summary Reassign Review
 */
export const useReassignReviewApiV1PeopleReviewsReviewIdReassignPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof reassignReviewApiV1PeopleReviewsReviewIdReassignPost>
      >,
      TError,
      { reviewId: string; data: ReviewReassignRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof reassignReviewApiV1PeopleReviewsReviewIdReassignPost>
  >,
  TError,
  { reviewId: string; data: ReviewReassignRequest },
  TContext
> => {
  const mutationOptions =
    getReassignReviewApiV1PeopleReviewsReviewIdReassignPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * The cycle's reviews as CSV — who owes what, and who is late.

Same rows, same admin gate and the **same contract C3 redaction** as
``GET /review-cycles/{id}/reviews``: an export that names the anonymous
raters of the exporting admin's own reviews would be a trivial way around a
promise the UI keeps. Paged through server-side so a large tenant is not
silently truncated to one page.
 * @summary Export Cycle Reviews
 */
export const exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet = (
  cycleId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/people/review-cycles/${cycleId}/export`,
    method: 'GET',
    signal
  });
};

export const getExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGetQueryKey =
  (cycleId?: string) => {
    return [`/api/v1/people/review-cycles/${cycleId}/export`] as const;
  };

export const getExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
      >
    >,
    TError = HTTPValidationError
  >(
    cycleId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGetQueryKey(
        cycleId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
        >
      >
    > = ({ signal }) =>
      exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet(
        cycleId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!cycleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
      >
    >
  >;
export type ExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGetQueryError =
  HTTPValidationError;

export function useExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Cycle Reviews
 */

export function useExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet>
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportCycleReviewsApiV1PeopleReviewCyclesCycleIdExportGetQueryOptions(
      cycleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Acknowledge a review.

Redacted per contract C3 like every other review response. It is the mutation
that most obviously needs it — acknowledging is normally the REVIEWEE's own act,
so this body is an employee-facing payload — but not the only one; see
``_redacted_review_payload``.
 * @summary Acknowledge Review
 */
export const acknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost = (
  reviewId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewResponse>({
    url: `/api/v1/people/reviews/${reviewId}/acknowledge`,
    method: 'POST',
    signal
  });
};

export const getAcknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof acknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost
        >
      >,
      TError,
      { reviewId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof acknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost
      >
    >,
    TError,
    { reviewId: string },
    TContext
  > => {
    const mutationKey = [
      'acknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof acknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost
        >
      >,
      { reviewId: string }
    > = (props) => {
      const { reviewId } = props ?? {};

      return acknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost(
        reviewId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AcknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof acknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost
      >
    >
  >;

export type AcknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePostMutationError =
  HTTPValidationError;

/**
 * @summary Acknowledge Review
 */
export const useAcknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof acknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost
        >
      >,
      TError,
      { reviewId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof acknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePost
    >
  >,
  TError,
  { reviewId: string },
  TContext
> => {
  const mutationOptions =
    getAcknowledgeReviewApiV1PeopleReviewsReviewIdAcknowledgePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Nudge the rater of ONE review — the per-report chase.

The narrow twin of ``POST /review-cycles/{id}/remind``, which is admin-only
and fans out across a whole cycle. A manager is not a People admin, so
without this the only way to chase one late reviewer was to nudge everyone in
the cycle.

**One route, two callers.** Both the My Team pane's per-report nudge and the
cycle detail table's row action land here, and there is deliberately no
admin-only twin: ``enforce_review_nudge``'s authority set already contains
the People admins the cycle page is gated on, so a second, stricter
registration on this path would only shadow this one and lock managers out
(which it did — see ``test_route_uniqueness``).

Authority only, no self arm (see ``enforce_review_nudge``): a reviewee must
not be able to ping their own raters. Returns ``{"reminded": 0}`` rather than
an error when the review has already been filed — the same non-submitter rule
the cycle-wide nudge and the scheduled sweep apply.
 * @summary Remind Review Rater
 */
export const remindReviewRaterApiV1PeopleReviewsReviewIdRemindPost = (
  reviewId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCycleRemindResult>({
    url: `/api/v1/people/reviews/${reviewId}/remind`,
    method: 'POST',
    signal
  });
};

export const getRemindReviewRaterApiV1PeopleReviewsReviewIdRemindPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof remindReviewRaterApiV1PeopleReviewsReviewIdRemindPost>
      >,
      TError,
      { reviewId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof remindReviewRaterApiV1PeopleReviewsReviewIdRemindPost>
    >,
    TError,
    { reviewId: string },
    TContext
  > => {
    const mutationKey = [
      'remindReviewRaterApiV1PeopleReviewsReviewIdRemindPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof remindReviewRaterApiV1PeopleReviewsReviewIdRemindPost>
      >,
      { reviewId: string }
    > = (props) => {
      const { reviewId } = props ?? {};

      return remindReviewRaterApiV1PeopleReviewsReviewIdRemindPost(reviewId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemindReviewRaterApiV1PeopleReviewsReviewIdRemindPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof remindReviewRaterApiV1PeopleReviewsReviewIdRemindPost>
    >
  >;

export type RemindReviewRaterApiV1PeopleReviewsReviewIdRemindPostMutationError =
  HTTPValidationError;

/**
 * @summary Remind Review Rater
 */
export const useRemindReviewRaterApiV1PeopleReviewsReviewIdRemindPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof remindReviewRaterApiV1PeopleReviewsReviewIdRemindPost>
      >,
      TError,
      { reviewId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof remindReviewRaterApiV1PeopleReviewsReviewIdRemindPost>
  >,
  TError,
  { reviewId: string },
  TContext
> => {
  const mutationOptions =
    getRemindReviewRaterApiV1PeopleReviewsReviewIdRemindPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * The review with its questions and answers, redacted for the reader.

Separate from ``GET /reviews/{id}`` because that endpoint's response model is
the flat generated ``Review`` schema shared with every list endpoint — nesting
a whole form inside it would put every section on the wire for each row of the
reviewer's inbox too.

For the reviewee, ``is_private`` sections are **absent** from the payload, not
flagged: a client that receives them and filters on a boolean is one bug away
from showing the manager's private assessment.
 * @summary Get Review Form
 */
export const getReviewFormApiV1PeopleReviewsReviewIdFormGet = (
  reviewId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewFormResponse>({
    url: `/api/v1/people/reviews/${reviewId}/form`,
    method: 'GET',
    signal
  });
};

export const getGetReviewFormApiV1PeopleReviewsReviewIdFormGetQueryKey = (
  reviewId?: string
) => {
  return [`/api/v1/people/reviews/${reviewId}/form`] as const;
};

export const getGetReviewFormApiV1PeopleReviewsReviewIdFormGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
  >,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReviewFormApiV1PeopleReviewsReviewIdFormGetQueryKey(reviewId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>>
  > = ({ signal }) =>
    getReviewFormApiV1PeopleReviewsReviewIdFormGet(reviewId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!reviewId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReviewFormApiV1PeopleReviewsReviewIdFormGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>>
  >;
export type GetReviewFormApiV1PeopleReviewsReviewIdFormGetQueryError =
  HTTPValidationError;

export function useGetReviewFormApiV1PeopleReviewsReviewIdFormGet<
  TData = Awaited<
    ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
  >,
  TError = HTTPValidationError
>(
  reviewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetReviewFormApiV1PeopleReviewsReviewIdFormGet<
  TData = Awaited<
    ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
  >,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReviewFormApiV1PeopleReviewsReviewIdFormGet<
  TData = Awaited<
    ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
  >,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Review Form
 */

export function useGetReviewFormApiV1PeopleReviewsReviewIdFormGet<
  TData = Awaited<
    ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
  >,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReviewFormApiV1PeopleReviewsReviewIdFormGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetReviewFormApiV1PeopleReviewsReviewIdFormGetQueryOptions(
      reviewId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Bulk-upsert this rater's answers. One row per question, rewritten on re-save.

Only the review's own rater may call this, and only while it is still open —
a submitted review needs an admin reopen before it can change again.

``overall_rating`` rides along for contract C5's ``manual`` mode. It is read
off ``model_fields_set`` rather than the parsed value because the field is
nullable: null CLEARS the rating, so a client that never renders the control
must be able to say nothing at all rather than say null on every autosave.
 * @summary Save Review Responses
 */
export const saveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut = (
  reviewId: string,
  reviewResponsesUpdate: ReviewResponsesUpdate
) => {
  return customInstance<ReviewFormResponse>({
    url: `/api/v1/people/reviews/${reviewId}/responses`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: reviewResponsesUpdate
  });
};

export const getSaveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof saveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut
        >
      >,
      TError,
      { reviewId: string; data: ReviewResponsesUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof saveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut
      >
    >,
    TError,
    { reviewId: string; data: ReviewResponsesUpdate },
    TContext
  > => {
    const mutationKey = [
      'saveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof saveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut
        >
      >,
      { reviewId: string; data: ReviewResponsesUpdate }
    > = (props) => {
      const { reviewId, data } = props ?? {};

      return saveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut(
        reviewId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SaveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof saveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut
      >
    >
  >;
export type SaveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPutMutationBody =
  ReviewResponsesUpdate;
export type SaveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPutMutationError =
  HTTPValidationError;

/**
 * @summary Save Review Responses
 */
export const useSaveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof saveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut
        >
      >,
      TError,
      { reviewId: string; data: ReviewResponsesUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof saveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPut>
  >,
  TError,
  { reviewId: string; data: ReviewResponsesUpdate },
  TContext
> => {
  const mutationOptions =
    getSaveReviewResponsesApiV1PeopleReviewsReviewIdResponsesPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * What the OTHER raters said about the same person — the split-view.

Gated on the reader's access to *this* review, not to the sibling ones: the
panel is an adjunct to the form, so whoever may open the form may see the
context beside it. What that context CONTAINS is then narrowed by C4 (only
released reviews) and C3 (anonymised identities, hidden comments, and whole
rater groups withheld below the cycle's threshold), all inside
``build_peer_answers``.

``anonymity_actor_role`` classifies the reader and fails closed to the
subject view, so the rater types a peer reads are redacted exactly as they
are for the reviewee. Only a demonstrable administrator of this employee's
panel — their manager, or People admin — reads it attributed.
 * @summary Get Review Peer Answers
 */
export const getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet = (
  reviewId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewPeerAnswers>({
    url: `/api/v1/people/reviews/${reviewId}/peers`,
    method: 'GET',
    signal
  });
};

export const getGetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGetQueryKey =
  (reviewId?: string) => {
    return [`/api/v1/people/reviews/${reviewId}/peers`] as const;
  };

export const getGetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet>
    >,
    TError = HTTPValidationError
  >(
    reviewId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGetQueryKey(
        reviewId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
        >
      >
    > = ({ signal }) =>
      getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet(reviewId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!reviewId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet>
    >
  >;
export type GetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGetQueryError =
  HTTPValidationError;

export function useGetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet<
  TData = Awaited<
    ReturnType<typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet>
  >,
  TError = HTTPValidationError
>(
  reviewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet<
  TData = Awaited<
    ReturnType<typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet>
  >,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet<
  TData = Awaited<
    ReturnType<typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet>
  >,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Review Peer Answers
 */

export function useGetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet<
  TData = Awaited<
    ReturnType<typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet>
  >,
  TError = HTTPValidationError
>(
  reviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetReviewPeerAnswersApiV1PeopleReviewsReviewIdPeersGetQueryOptions(
      reviewId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Feedback the caller is allowed to read, newest first.

Filtered by the four visibility levels in the repository base query, so the
filters above **narrow** an already-audience-scoped set — none of them can
widen it. ``total`` counts the same predicate as the page.
 * @summary List Feedback
 */
export const listFeedbackApiV1PeopleFeedbackGet = (
  params?: ListFeedbackApiV1PeopleFeedbackGetParams,
  signal?: AbortSignal
) => {
  return customInstance<FeedbackListResponse>({
    url: `/api/v1/people/feedback`,
    method: 'GET',
    params,
    signal
  });
};

export const getListFeedbackApiV1PeopleFeedbackGetQueryKey = (
  params?: ListFeedbackApiV1PeopleFeedbackGetParams
) => {
  return [`/api/v1/people/feedback`, ...(params ? [params] : [])] as const;
};

export const getListFeedbackApiV1PeopleFeedbackGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
  TError = HTTPValidationError
>(
  params?: ListFeedbackApiV1PeopleFeedbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListFeedbackApiV1PeopleFeedbackGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>
  > = ({ signal }) => listFeedbackApiV1PeopleFeedbackGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListFeedbackApiV1PeopleFeedbackGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>
>;
export type ListFeedbackApiV1PeopleFeedbackGetQueryError = HTTPValidationError;

export function useListFeedbackApiV1PeopleFeedbackGet<
  TData = Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListFeedbackApiV1PeopleFeedbackGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
          TError,
          Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFeedbackApiV1PeopleFeedbackGet<
  TData = Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
  TError = HTTPValidationError
>(
  params?: ListFeedbackApiV1PeopleFeedbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
          TError,
          Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFeedbackApiV1PeopleFeedbackGet<
  TData = Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
  TError = HTTPValidationError
>(
  params?: ListFeedbackApiV1PeopleFeedbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Feedback
 */

export function useListFeedbackApiV1PeopleFeedbackGet<
  TData = Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
  TError = HTTPValidationError
>(
  params?: ListFeedbackApiV1PeopleFeedbackGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFeedbackApiV1PeopleFeedbackGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListFeedbackApiV1PeopleFeedbackGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Give feedback about an employee, optionally answering a request.

Passing ``request_id`` marks that request answered in the same transaction,
and is allowed only for its addressee while it is still pending.

**Far side (§5).** ``subject_employee_id`` names another ``people.employee``
record, and ``FeedbackService._require_employee`` checks only that it is a live
employee of the TENANT — so under a restricted visibility mode any member who
knew an employee id could file feedback against a record they cannot open.
:func:`~modules.people.api.link_gates.enforce_employee_link` asks people's own
id-keyed visibility seam at VIEWER — giving feedback is a link, not an edit of
the subject's HR record — and answers 404 for an invisible id exactly as for an
unknown one, quoting nothing about the target. A no-op in the default
``everyone`` mode, so an untouched tenant is unchanged. Band, seam and the
reason the refusal is normalized: that module's docstring.

**Answering a REQUEST is the participant arm and is deliberately exempt.** A
pending request addressed to the caller is an explicit invitation, raised by
someone the service already restricted to their own record or their own reports
(``_require_subject_is_self_or_report``) — the peer being asked for 360 feedback
about somebody's report generally holds no grant on that record, so gating here
would break the feature's whole point. Nothing is written on the way to that
exemption: the service verifies the request exists, is addressed to this caller,
is still pending, and names THIS subject, before any row is created.
 * @summary Create Feedback
 */
export const createFeedbackApiV1PeopleFeedbackPost = (
  feedbackCreate: FeedbackCreate,
  signal?: AbortSignal
) => {
  return customInstance<Feedback>({
    url: `/api/v1/people/feedback`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: feedbackCreate,
    signal
  });
};

export const getCreateFeedbackApiV1PeopleFeedbackPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeedbackApiV1PeopleFeedbackPost>>,
    TError,
    { data: FeedbackCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFeedbackApiV1PeopleFeedbackPost>>,
  TError,
  { data: FeedbackCreate },
  TContext
> => {
  const mutationKey = ['createFeedbackApiV1PeopleFeedbackPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFeedbackApiV1PeopleFeedbackPost>>,
    { data: FeedbackCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createFeedbackApiV1PeopleFeedbackPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFeedbackApiV1PeopleFeedbackPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFeedbackApiV1PeopleFeedbackPost>>
>;
export type CreateFeedbackApiV1PeopleFeedbackPostMutationBody = FeedbackCreate;
export type CreateFeedbackApiV1PeopleFeedbackPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Feedback
 */
export const useCreateFeedbackApiV1PeopleFeedbackPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFeedbackApiV1PeopleFeedbackPost>>,
      TError,
      { data: FeedbackCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createFeedbackApiV1PeopleFeedbackPost>>,
  TError,
  { data: FeedbackCreate },
  TContext
> => {
  const mutationOptions =
    getCreateFeedbackApiV1PeopleFeedbackPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * One piece of feedback. 404 when it does not exist **or** the caller is
outside its audience — a 403 would confirm that feedback about this person
exists, which is what ``manager_only`` and ``private`` hide.
 * @summary Get Feedback
 */
export const getFeedbackApiV1PeopleFeedbackFeedbackIdGet = (
  feedbackId: string,
  signal?: AbortSignal
) => {
  return customInstance<Feedback>({
    url: `/api/v1/people/feedback/${feedbackId}`,
    method: 'GET',
    signal
  });
};

export const getGetFeedbackApiV1PeopleFeedbackFeedbackIdGetQueryKey = (
  feedbackId?: string
) => {
  return [`/api/v1/people/feedback/${feedbackId}`] as const;
};

export const getGetFeedbackApiV1PeopleFeedbackFeedbackIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>
  >,
  TError = HTTPValidationError
>(
  feedbackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFeedbackApiV1PeopleFeedbackFeedbackIdGetQueryKey(feedbackId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>>
  > = ({ signal }) =>
    getFeedbackApiV1PeopleFeedbackFeedbackIdGet(feedbackId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!feedbackId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFeedbackApiV1PeopleFeedbackFeedbackIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>>
  >;
export type GetFeedbackApiV1PeopleFeedbackFeedbackIdGetQueryError =
  HTTPValidationError;

export function useGetFeedbackApiV1PeopleFeedbackFeedbackIdGet<
  TData = Awaited<
    ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>
  >,
  TError = HTTPValidationError
>(
  feedbackId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFeedbackApiV1PeopleFeedbackFeedbackIdGet<
  TData = Awaited<
    ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>
  >,
  TError = HTTPValidationError
>(
  feedbackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFeedbackApiV1PeopleFeedbackFeedbackIdGet<
  TData = Awaited<
    ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>
  >,
  TError = HTTPValidationError
>(
  feedbackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Feedback
 */

export function useGetFeedbackApiV1PeopleFeedbackFeedbackIdGet<
  TData = Awaited<
    ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>
  >,
  TError = HTTPValidationError
>(
  feedbackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeedbackApiV1PeopleFeedbackFeedbackIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetFeedbackApiV1PeopleFeedbackFeedbackIdGetQueryOptions(
      feedbackId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Edit your own feedback — author only, whoever else can read it.

``competency_tag`` is nullable, so an explicit null must clear it while an
omitted field is left alone; ``model_fields_set`` is what tells the two
apart. No re-notification: an edit is a correction, not new feedback.
 * @summary Update Feedback
 */
export const updateFeedbackApiV1PeopleFeedbackFeedbackIdPut = (
  feedbackId: string,
  feedbackUpdate: FeedbackUpdate
) => {
  return customInstance<Feedback>({
    url: `/api/v1/people/feedback/${feedbackId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: feedbackUpdate
  });
};

export const getUpdateFeedbackApiV1PeopleFeedbackFeedbackIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateFeedbackApiV1PeopleFeedbackFeedbackIdPut>
      >,
      TError,
      { feedbackId: string; data: FeedbackUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateFeedbackApiV1PeopleFeedbackFeedbackIdPut>>,
    TError,
    { feedbackId: string; data: FeedbackUpdate },
    TContext
  > => {
    const mutationKey = ['updateFeedbackApiV1PeopleFeedbackFeedbackIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateFeedbackApiV1PeopleFeedbackFeedbackIdPut>
      >,
      { feedbackId: string; data: FeedbackUpdate }
    > = (props) => {
      const { feedbackId, data } = props ?? {};

      return updateFeedbackApiV1PeopleFeedbackFeedbackIdPut(feedbackId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateFeedbackApiV1PeopleFeedbackFeedbackIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateFeedbackApiV1PeopleFeedbackFeedbackIdPut>>
  >;
export type UpdateFeedbackApiV1PeopleFeedbackFeedbackIdPutMutationBody =
  FeedbackUpdate;
export type UpdateFeedbackApiV1PeopleFeedbackFeedbackIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Feedback
 */
export const useUpdateFeedbackApiV1PeopleFeedbackFeedbackIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateFeedbackApiV1PeopleFeedbackFeedbackIdPut>
      >,
      TError,
      { feedbackId: string; data: FeedbackUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateFeedbackApiV1PeopleFeedbackFeedbackIdPut>>,
  TError,
  { feedbackId: string; data: FeedbackUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateFeedbackApiV1PeopleFeedbackFeedbackIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete your own feedback — author only.
 * @summary Delete Feedback
 */
export const deleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete = (
  feedbackId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/feedback/${feedbackId}`,
    method: 'DELETE'
  });
};

export const getDeleteFeedbackApiV1PeopleFeedbackFeedbackIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete>
      >,
      TError,
      { feedbackId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete>
    >,
    TError,
    { feedbackId: string },
    TContext
  > => {
    const mutationKey = ['deleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete>
      >,
      { feedbackId: string }
    > = (props) => {
      const { feedbackId } = props ?? {};

      return deleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete(feedbackId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteFeedbackApiV1PeopleFeedbackFeedbackIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete>
    >
  >;

export type DeleteFeedbackApiV1PeopleFeedbackFeedbackIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Feedback
 */
export const useDeleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete>
      >,
      TError,
      { feedbackId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFeedbackApiV1PeopleFeedbackFeedbackIdDelete>>,
  TError,
  { feedbackId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteFeedbackApiV1PeopleFeedbackFeedbackIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Requests the caller raised or was asked to answer.

Only those two — the *subject* of a request never sees the request itself, at
any status. Asking a colleague about a report is a private management act;
what the subject may read is the resulting feedback, under its own level.
 * @summary List Feedback Requests
 */
export const listFeedbackRequestsApiV1PeopleFeedbackRequestsGet = (
  params?: ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<FeedbackRequestListResponse>({
    url: `/api/v1/people/feedback-requests`,
    method: 'GET',
    params,
    signal
  });
};

export const getListFeedbackRequestsApiV1PeopleFeedbackRequestsGetQueryKey = (
  params?: ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetParams
) => {
  return [
    `/api/v1/people/feedback-requests`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListFeedbackRequestsApiV1PeopleFeedbackRequestsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListFeedbackRequestsApiV1PeopleFeedbackRequestsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
      >
    > = ({ signal }) =>
      listFeedbackRequestsApiV1PeopleFeedbackRequestsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
    >
  >;
export type ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetQueryError =
  HTTPValidationError;

export function useListFeedbackRequestsApiV1PeopleFeedbackRequestsGet<
  TData = Awaited<
    ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFeedbackRequestsApiV1PeopleFeedbackRequestsGet<
  TData = Awaited<
    ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFeedbackRequestsApiV1PeopleFeedbackRequestsGet<
  TData = Awaited<
    ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Feedback Requests
 */

export function useListFeedbackRequestsApiV1PeopleFeedbackRequestsGet<
  TData = Awaited<
    ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFeedbackRequestsApiV1PeopleFeedbackRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFeedbackRequestsApiV1PeopleFeedbackRequestsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListFeedbackRequestsApiV1PeopleFeedbackRequestsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Ask a colleague for feedback about yourself or one of your reports.

Any other subject is a 403: without that gate, "ask Ada what she thinks of
Ben" would be available to anyone about anyone.
 * @summary Create Feedback Request
 */
export const createFeedbackRequestApiV1PeopleFeedbackRequestsPost = (
  feedbackRequestCreate: FeedbackRequestCreate,
  signal?: AbortSignal
) => {
  return customInstance<FeedbackRequest>({
    url: `/api/v1/people/feedback-requests`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: feedbackRequestCreate,
    signal
  });
};

export const getCreateFeedbackRequestApiV1PeopleFeedbackRequestsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createFeedbackRequestApiV1PeopleFeedbackRequestsPost>
      >,
      TError,
      { data: FeedbackRequestCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createFeedbackRequestApiV1PeopleFeedbackRequestsPost>
    >,
    TError,
    { data: FeedbackRequestCreate },
    TContext
  > => {
    const mutationKey = [
      'createFeedbackRequestApiV1PeopleFeedbackRequestsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createFeedbackRequestApiV1PeopleFeedbackRequestsPost>
      >,
      { data: FeedbackRequestCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createFeedbackRequestApiV1PeopleFeedbackRequestsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateFeedbackRequestApiV1PeopleFeedbackRequestsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createFeedbackRequestApiV1PeopleFeedbackRequestsPost>
    >
  >;
export type CreateFeedbackRequestApiV1PeopleFeedbackRequestsPostMutationBody =
  FeedbackRequestCreate;
export type CreateFeedbackRequestApiV1PeopleFeedbackRequestsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Feedback Request
 */
export const useCreateFeedbackRequestApiV1PeopleFeedbackRequestsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createFeedbackRequestApiV1PeopleFeedbackRequestsPost>
      >,
      TError,
      { data: FeedbackRequestCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createFeedbackRequestApiV1PeopleFeedbackRequestsPost>
  >,
  TError,
  { data: FeedbackRequestCreate },
  TContext
> => {
  const mutationOptions =
    getCreateFeedbackRequestApiV1PeopleFeedbackRequestsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * One request — 404 for anyone who is not one of its two parties.
 * @summary Get Feedback Request
 */
export const getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet = (
  requestId: string,
  signal?: AbortSignal
) => {
  return customInstance<FeedbackRequest>({
    url: `/api/v1/people/feedback-requests/${requestId}`,
    method: 'GET',
    signal
  });
};

export const getGetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGetQueryKey =
  (requestId?: string) => {
    return [`/api/v1/people/feedback-requests/${requestId}`] as const;
  };

export const getGetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    requestId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGetQueryKey(
        requestId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
        >
      >
    > = ({ signal }) =>
      getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet(
        requestId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!requestId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
      >
    >
  >;
export type GetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGetQueryError =
  HTTPValidationError;

export function useGetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Feedback Request
 */

export function useGetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdGetQueryOptions(
      requestId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Close a request you raised — you withdrew it, or you have what you need.

Answering is the addressee's action (``POST /feedback`` with ``request_id``);
closing is the requester's.
 * @summary Close Feedback Request
 */
export const closeFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost =
  (requestId: string, signal?: AbortSignal) => {
    return customInstance<FeedbackRequest>({
      url: `/api/v1/people/feedback-requests/${requestId}/close`,
      method: 'POST',
      signal
    });
  };

export const getCloseFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof closeFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost
        >
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof closeFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = [
      'closeFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof closeFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost
        >
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return closeFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost(
        requestId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CloseFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof closeFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost
      >
    >
  >;

export type CloseFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePostMutationError =
  HTTPValidationError;

/**
 * @summary Close Feedback Request
 */
export const useCloseFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof closeFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost
          >
        >,
        TError,
        { requestId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof closeFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationOptions =
      getCloseFeedbackRequestApiV1PeopleFeedbackRequestsRequestIdClosePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The recognition feed, newest first.

``public`` entries are visible tenant-wide; ``private`` ones only to their
recipients and author. One entry addressed to several employees appears once
in the feed and once under **each** recipient filter — the filter is a
junction-membership test, so the total never multiplies by recipient count.
 * @summary List Recognition
 */
export const listRecognitionApiV1PeopleRecognitionGet = (
  params?: ListRecognitionApiV1PeopleRecognitionGetParams,
  signal?: AbortSignal
) => {
  return customInstance<RecognitionListResponse>({
    url: `/api/v1/people/recognition`,
    method: 'GET',
    params,
    signal
  });
};

export const getListRecognitionApiV1PeopleRecognitionGetQueryKey = (
  params?: ListRecognitionApiV1PeopleRecognitionGetParams
) => {
  return [`/api/v1/people/recognition`, ...(params ? [params] : [])] as const;
};

export const getListRecognitionApiV1PeopleRecognitionGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
  TError = HTTPValidationError
>(
  params?: ListRecognitionApiV1PeopleRecognitionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListRecognitionApiV1PeopleRecognitionGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>
  > = ({ signal }) => listRecognitionApiV1PeopleRecognitionGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListRecognitionApiV1PeopleRecognitionGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>
>;
export type ListRecognitionApiV1PeopleRecognitionGetQueryError =
  HTTPValidationError;

export function useListRecognitionApiV1PeopleRecognitionGet<
  TData = Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListRecognitionApiV1PeopleRecognitionGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
          TError,
          Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRecognitionApiV1PeopleRecognitionGet<
  TData = Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
  TError = HTTPValidationError
>(
  params?: ListRecognitionApiV1PeopleRecognitionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
          TError,
          Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRecognitionApiV1PeopleRecognitionGet<
  TData = Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
  TError = HTTPValidationError
>(
  params?: ListRecognitionApiV1PeopleRecognitionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Recognition
 */

export function useListRecognitionApiV1PeopleRecognitionGet<
  TData = Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
  TError = HTTPValidationError
>(
  params?: ListRecognitionApiV1PeopleRecognitionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listRecognitionApiV1PeopleRecognitionGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListRecognitionApiV1PeopleRecognitionGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Recognize one or several employees with a single entry.

Every recipient must be a live employee of the tenant; one bad id rejects the
whole entry rather than silently praising the others.
 * @summary Create Recognition
 */
export const createRecognitionApiV1PeopleRecognitionPost = (
  recognitionCreate: RecognitionCreate,
  signal?: AbortSignal
) => {
  return customInstance<Recognition>({
    url: `/api/v1/people/recognition`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: recognitionCreate,
    signal
  });
};

export const getCreateRecognitionApiV1PeopleRecognitionPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRecognitionApiV1PeopleRecognitionPost>>,
    TError,
    { data: RecognitionCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRecognitionApiV1PeopleRecognitionPost>>,
  TError,
  { data: RecognitionCreate },
  TContext
> => {
  const mutationKey = ['createRecognitionApiV1PeopleRecognitionPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRecognitionApiV1PeopleRecognitionPost>>,
    { data: RecognitionCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createRecognitionApiV1PeopleRecognitionPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRecognitionApiV1PeopleRecognitionPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createRecognitionApiV1PeopleRecognitionPost>>
  >;
export type CreateRecognitionApiV1PeopleRecognitionPostMutationBody =
  RecognitionCreate;
export type CreateRecognitionApiV1PeopleRecognitionPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Recognition
 */
export const useCreateRecognitionApiV1PeopleRecognitionPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRecognitionApiV1PeopleRecognitionPost>>,
      TError,
      { data: RecognitionCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createRecognitionApiV1PeopleRecognitionPost>>,
  TError,
  { data: RecognitionCreate },
  TContext
> => {
  const mutationOptions =
    getCreateRecognitionApiV1PeopleRecognitionPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * One recognition entry — 404 when the caller is outside its audience.
 * @summary Get Recognition
 */
export const getRecognitionApiV1PeopleRecognitionRecognitionIdGet = (
  recognitionId: string,
  signal?: AbortSignal
) => {
  return customInstance<Recognition>({
    url: `/api/v1/people/recognition/${recognitionId}`,
    method: 'GET',
    signal
  });
};

export const getGetRecognitionApiV1PeopleRecognitionRecognitionIdGetQueryKey = (
  recognitionId?: string
) => {
  return [`/api/v1/people/recognition/${recognitionId}`] as const;
};

export const getGetRecognitionApiV1PeopleRecognitionRecognitionIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet>
    >,
    TError = HTTPValidationError
  >(
    recognitionId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetRecognitionApiV1PeopleRecognitionRecognitionIdGetQueryKey(
        recognitionId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet>
      >
    > = ({ signal }) =>
      getRecognitionApiV1PeopleRecognitionRecognitionIdGet(
        recognitionId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!recognitionId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetRecognitionApiV1PeopleRecognitionRecognitionIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet>
    >
  >;
export type GetRecognitionApiV1PeopleRecognitionRecognitionIdGetQueryError =
  HTTPValidationError;

export function useGetRecognitionApiV1PeopleRecognitionRecognitionIdGet<
  TData = Awaited<
    ReturnType<typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet>
  >,
  TError = HTTPValidationError
>(
  recognitionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRecognitionApiV1PeopleRecognitionRecognitionIdGet<
  TData = Awaited<
    ReturnType<typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet>
  >,
  TError = HTTPValidationError
>(
  recognitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRecognitionApiV1PeopleRecognitionRecognitionIdGet<
  TData = Awaited<
    ReturnType<typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet>
  >,
  TError = HTTPValidationError
>(
  recognitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Recognition
 */

export function useGetRecognitionApiV1PeopleRecognitionRecognitionIdGet<
  TData = Awaited<
    ReturnType<typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet>
  >,
  TError = HTTPValidationError
>(
  recognitionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRecognitionApiV1PeopleRecognitionRecognitionIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetRecognitionApiV1PeopleRecognitionRecognitionIdGetQueryOptions(
      recognitionId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Soft-delete your own recognition entry — author only.
 * @summary Delete Recognition
 */
export const deleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete = (
  recognitionId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/recognition/${recognitionId}`,
    method: 'DELETE'
  });
};

export const getDeleteRecognitionApiV1PeopleRecognitionRecognitionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete
        >
      >,
      TError,
      { recognitionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete
      >
    >,
    TError,
    { recognitionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete
        >
      >,
      { recognitionId: string }
    > = (props) => {
      const { recognitionId } = props ?? {};

      return deleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete(
        recognitionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteRecognitionApiV1PeopleRecognitionRecognitionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete
      >
    >
  >;

export type DeleteRecognitionApiV1PeopleRecognitionRecognitionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Recognition
 */
export const useDeleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete
        >
      >,
      TError,
      { recognitionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteRecognitionApiV1PeopleRecognitionRecognitionIdDelete
    >
  >,
  TError,
  { recognitionId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteRecognitionApiV1PeopleRecognitionRecognitionIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Add or remove your reaction, returning the entry's fresh reaction counts.

One endpoint rather than a POST/DELETE pair: the client renders a toggle, and
a single idempotent-by-emoji call means a double-tap cannot stack duplicates
or leave the two halves out of step. Gated on **readability** — you can react
to any praise you can see, unlike delete, which needs authorship.
 * @summary Toggle Recognition Reaction
 */
export const toggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost =
  (
    recognitionId: string,
    recognitionReactionToggle: RecognitionReactionToggle,
    signal?: AbortSignal
  ) => {
    return customInstance<RecognitionReactionListResponse>({
      url: `/api/v1/people/recognition/${recognitionId}/reactions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: recognitionReactionToggle,
      signal
    });
  };

export const getToggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof toggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost
        >
      >,
      TError,
      { recognitionId: string; data: RecognitionReactionToggle },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof toggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost
      >
    >,
    TError,
    { recognitionId: string; data: RecognitionReactionToggle },
    TContext
  > => {
    const mutationKey = [
      'toggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof toggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost
        >
      >,
      { recognitionId: string; data: RecognitionReactionToggle }
    > = (props) => {
      const { recognitionId, data } = props ?? {};

      return toggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost(
        recognitionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ToggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof toggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost
      >
    >
  >;
export type ToggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPostMutationBody =
  RecognitionReactionToggle;
export type ToggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Toggle Recognition Reaction
 */
export const useToggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof toggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost
          >
        >,
        TError,
        { recognitionId: string; data: RecognitionReactionToggle },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof toggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPost
      >
    >,
    TError,
    { recognitionId: string; data: RecognitionReactionToggle },
    TContext
  > => {
    const mutationOptions =
      getToggleRecognitionReactionApiV1PeopleRecognitionRecognitionIdReactionsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Calibration sessions on a cycle.

Narrowed by the service: a People admin sees every session, anyone else sees
the ones they facilitate. A list narrows rather than 403s, the same way every
scoped list in the module does.
 * @summary List Calibrations
 */
export const listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet = (
  cycleId: string,
  params?: ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCalibrationListResponse>({
    url: `/api/v1/people/review-cycles/${cycleId}/calibrations`,
    method: 'GET',
    params,
    signal
  });
};

export const getListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetQueryKey =
  (
    cycleId?: string,
    params?: ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetParams
  ) => {
    return [
      `/api/v1/people/review-cycles/${cycleId}/calibrations`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    cycleId: string,
    params?: ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetQueryKey(
        cycleId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
        >
      >
    > = ({ signal }) =>
      listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet(
        cycleId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!cycleId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
      >
    >
  >;
export type ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetQueryError =
  HTTPValidationError;

export function useListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet<
  TData = Awaited<
    ReturnType<
      typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params:
    | undefined
    | ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet<
  TData = Awaited<
    ReturnType<
      typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params?: ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet<
  TData = Awaited<
    ReturnType<
      typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params?: ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Calibrations
 */

export function useListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet<
  TData = Awaited<
    ReturnType<
      typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
    >
  >,
  TError = HTTPValidationError
>(
  cycleId: string,
  params?: ListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCalibrationsApiV1PeopleReviewCyclesCycleIdCalibrationsGetQueryOptions(
      cycleId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Open a calibration session on a cycle (People admin).
 * @summary Create Calibration
 */
export const createCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost = (
  cycleId: string,
  reviewCalibrationCreate: ReviewCalibrationCreate,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCalibration>({
    url: `/api/v1/people/review-cycles/${cycleId}/calibrations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reviewCalibrationCreate,
    signal
  });
};

export const getCreateCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost
        >
      >,
      TError,
      { cycleId: string; data: ReviewCalibrationCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost
      >
    >,
    TError,
    { cycleId: string; data: ReviewCalibrationCreate },
    TContext
  > => {
    const mutationKey = [
      'createCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost
        >
      >,
      { cycleId: string; data: ReviewCalibrationCreate }
    > = (props) => {
      const { cycleId, data } = props ?? {};

      return createCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost(
        cycleId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost
      >
    >
  >;
export type CreateCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPostMutationBody =
  ReviewCalibrationCreate;
export type CreateCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Calibration
 */
export const useCreateCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost
          >
        >,
        TError,
        { cycleId: string; data: ReviewCalibrationCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPost
      >
    >,
    TError,
    { cycleId: string; data: ReviewCalibrationCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateCalibrationApiV1PeopleReviewCyclesCycleIdCalibrationsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Get Calibration
 */
export const getCalibrationApiV1PeopleCalibrationsCalibrationIdGet = (
  calibrationId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCalibration>({
    url: `/api/v1/people/calibrations/${calibrationId}`,
    method: 'GET',
    signal
  });
};

export const getGetCalibrationApiV1PeopleCalibrationsCalibrationIdGetQueryKey =
  (calibrationId?: string) => {
    return [`/api/v1/people/calibrations/${calibrationId}`] as const;
  };

export const getGetCalibrationApiV1PeopleCalibrationsCalibrationIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet>
    >,
    TError = HTTPValidationError
  >(
    calibrationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCalibrationApiV1PeopleCalibrationsCalibrationIdGetQueryKey(
        calibrationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet>
      >
    > = ({ signal }) =>
      getCalibrationApiV1PeopleCalibrationsCalibrationIdGet(
        calibrationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!calibrationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCalibrationApiV1PeopleCalibrationsCalibrationIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet>
    >
  >;
export type GetCalibrationApiV1PeopleCalibrationsCalibrationIdGetQueryError =
  HTTPValidationError;

export function useGetCalibrationApiV1PeopleCalibrationsCalibrationIdGet<
  TData = Awaited<
    ReturnType<typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet>
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCalibrationApiV1PeopleCalibrationsCalibrationIdGet<
  TData = Awaited<
    ReturnType<typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet>
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCalibrationApiV1PeopleCalibrationsCalibrationIdGet<
  TData = Awaited<
    ReturnType<typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet>
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Calibration
 */

export function useGetCalibrationApiV1PeopleCalibrationsCalibrationIdGet<
  TData = Awaited<
    ReturnType<typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet>
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCalibrationApiV1PeopleCalibrationsCalibrationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCalibrationApiV1PeopleCalibrationsCalibrationIdGetQueryOptions(
      calibrationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Rename an open session or move its axes; lifecycle status is service-owned.
 * @summary Update Calibration
 */
export const updateCalibrationApiV1PeopleCalibrationsCalibrationIdPut = (
  calibrationId: string,
  reviewCalibrationUpdate: ReviewCalibrationUpdate
) => {
  return customInstance<ReviewCalibration>({
    url: `/api/v1/people/calibrations/${calibrationId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: reviewCalibrationUpdate
  });
};

export const getUpdateCalibrationApiV1PeopleCalibrationsCalibrationIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCalibrationApiV1PeopleCalibrationsCalibrationIdPut
        >
      >,
      TError,
      { calibrationId: string; data: ReviewCalibrationUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateCalibrationApiV1PeopleCalibrationsCalibrationIdPut
      >
    >,
    TError,
    { calibrationId: string; data: ReviewCalibrationUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateCalibrationApiV1PeopleCalibrationsCalibrationIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateCalibrationApiV1PeopleCalibrationsCalibrationIdPut
        >
      >,
      { calibrationId: string; data: ReviewCalibrationUpdate }
    > = (props) => {
      const { calibrationId, data } = props ?? {};

      return updateCalibrationApiV1PeopleCalibrationsCalibrationIdPut(
        calibrationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCalibrationApiV1PeopleCalibrationsCalibrationIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateCalibrationApiV1PeopleCalibrationsCalibrationIdPut
      >
    >
  >;
export type UpdateCalibrationApiV1PeopleCalibrationsCalibrationIdPutMutationBody =
  ReviewCalibrationUpdate;
export type UpdateCalibrationApiV1PeopleCalibrationsCalibrationIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Calibration
 */
export const useUpdateCalibrationApiV1PeopleCalibrationsCalibrationIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCalibrationApiV1PeopleCalibrationsCalibrationIdPut
        >
      >,
      TError,
      { calibrationId: string; data: ReviewCalibrationUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateCalibrationApiV1PeopleCalibrationsCalibrationIdPut>
  >,
  TError,
  { calibrationId: string; data: ReviewCalibrationUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateCalibrationApiV1PeopleCalibrationsCalibrationIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete the session. Its adjustment trail is left intact (§2.4).
 * @summary Delete Calibration
 */
export const deleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete = (
  calibrationId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/calibrations/${calibrationId}`,
    method: 'DELETE'
  });
};

export const getDeleteCalibrationApiV1PeopleCalibrationsCalibrationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete
        >
      >,
      TError,
      { calibrationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete
      >
    >,
    TError,
    { calibrationId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete
        >
      >,
      { calibrationId: string }
    > = (props) => {
      const { calibrationId } = props ?? {};

      return deleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete(
        calibrationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteCalibrationApiV1PeopleCalibrationsCalibrationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete
      >
    >
  >;

export type DeleteCalibrationApiV1PeopleCalibrationsCalibrationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Calibration
 */
export const useDeleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete
        >
      >,
      TError,
      { calibrationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteCalibrationApiV1PeopleCalibrationsCalibrationIdDelete
    >
  >,
  TError,
  { calibrationId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteCalibrationApiV1PeopleCalibrationsCalibrationIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * The whole session — axes, bands and every participant — in one payload.

The 9-box, the distribution chart, its department/office/manager slicers and
the table view all render this, so they cannot disagree about where someone
sits (§4).
 * @summary Get Calibration Grid
 */
export const getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet = (
  calibrationId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCalibrationGrid>({
    url: `/api/v1/people/calibrations/${calibrationId}/grid`,
    method: 'GET',
    signal
  });
};

export const getGetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGetQueryKey =
  (calibrationId?: string) => {
    return [`/api/v1/people/calibrations/${calibrationId}/grid`] as const;
  };

export const getGetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
      >
    >,
    TError = HTTPValidationError
  >(
    calibrationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGetQueryKey(
        calibrationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
        >
      >
    > = ({ signal }) =>
      getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet(
        calibrationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!calibrationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
      >
    >
  >;
export type GetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGetQueryError =
  HTTPValidationError;

export function useGetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet<
  TData = Awaited<
    ReturnType<
      typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
    >
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet<
  TData = Awaited<
    ReturnType<
      typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
    >
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet<
  TData = Awaited<
    ReturnType<
      typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
    >
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Calibration Grid
 */

export function useGetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet<
  TData = Awaited<
    ReturnType<
      typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
    >
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCalibrationGridApiV1PeopleCalibrationsCalibrationIdGridGetQueryOptions(
      calibrationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Move one participant to another band on the calibrated axis.

POST, not PUT: this APPENDS to the trail. A justification is required and an
adjustment without one is rejected before anything is written (§2.4).
 * @summary Adjust Calibration Participant
 */
export const adjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost =
  (
    calibrationId: string,
    reviewCalibrationAdjustRequest: ReviewCalibrationAdjustRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<ReviewCalibrationEntry>({
      url: `/api/v1/people/calibrations/${calibrationId}/entries`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reviewCalibrationAdjustRequest,
      signal
    });
  };

export const getAdjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof adjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost
        >
      >,
      TError,
      { calibrationId: string; data: ReviewCalibrationAdjustRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof adjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost
      >
    >,
    TError,
    { calibrationId: string; data: ReviewCalibrationAdjustRequest },
    TContext
  > => {
    const mutationKey = [
      'adjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof adjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost
        >
      >,
      { calibrationId: string; data: ReviewCalibrationAdjustRequest }
    > = (props) => {
      const { calibrationId, data } = props ?? {};

      return adjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost(
        calibrationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AdjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof adjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost
      >
    >
  >;
export type AdjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPostMutationBody =
  ReviewCalibrationAdjustRequest;
export type AdjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPostMutationError =
  HTTPValidationError;

/**
 * @summary Adjust Calibration Participant
 */
export const useAdjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof adjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost
          >
        >,
        TError,
        { calibrationId: string; data: ReviewCalibrationAdjustRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof adjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPost
      >
    >,
    TError,
    { calibrationId: string; data: ReviewCalibrationAdjustRequest },
    TContext
  > => {
    const mutationOptions =
      getAdjustCalibrationParticipantApiV1PeopleCalibrationsCalibrationIdEntriesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * One participant's adjustment trail, oldest first. Read-only, always.
 * @summary List Calibration Entries
 */
export const listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet =
  (calibrationId: string, participantId: string, signal?: AbortSignal) => {
    return customInstance<ReviewCalibrationEntryListResponse>({
      url: `/api/v1/people/calibrations/${calibrationId}/participants/${participantId}/entries`,
      method: 'GET',
      signal
    });
  };

export const getListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGetQueryKey =
  (calibrationId?: string, participantId?: string) => {
    return [
      `/api/v1/people/calibrations/${calibrationId}/participants/${participantId}/entries`
    ] as const;
  };

export const getListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
      >
    >,
    TError = HTTPValidationError
  >(
    calibrationId: string,
    participantId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGetQueryKey(
        calibrationId,
        participantId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
        >
      >
    > = ({ signal }) =>
      listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet(
        calibrationId,
        participantId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(calibrationId && participantId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
      >
    >
  >;
export type ListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGetQueryError =
  HTTPValidationError;

export function useListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  participantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Calibration Entries
 */

export function useListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  calibrationId: string,
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCalibrationEntriesApiV1PeopleCalibrationsCalibrationIdParticipantsParticipantIdEntriesGetQueryOptions(
      calibrationId,
      participantId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Write each agreed rating back to its manager review.

Refused for any review already released to its employee, and every refusal is
named in the result rather than a partial apply reporting success (C4/C5).
 * @summary Apply Calibration
 */
export const applyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost = (
  calibrationId: string,
  signal?: AbortSignal
) => {
  return customInstance<ReviewCalibrationApplyResult>({
    url: `/api/v1/people/calibrations/${calibrationId}/apply`,
    method: 'POST',
    signal
  });
};

export const getApplyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof applyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost
        >
      >,
      TError,
      { calibrationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof applyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost
      >
    >,
    TError,
    { calibrationId: string },
    TContext
  > => {
    const mutationKey = [
      'applyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof applyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost
        >
      >,
      { calibrationId: string }
    > = (props) => {
      const { calibrationId } = props ?? {};

      return applyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost(
        calibrationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApplyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof applyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost
      >
    >
  >;

export type ApplyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPostMutationError =
  HTTPValidationError;

/**
 * @summary Apply Calibration
 */
export const useApplyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof applyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost
          >
        >,
        TError,
        { calibrationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof applyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPost
      >
    >,
    TError,
    { calibrationId: string },
    TContext
  > => {
    const mutationOptions =
      getApplyCalibrationApiV1PeopleCalibrationsCalibrationIdApplyPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the tenant's alignment levels, shallowest (Company) first.
 * @summary List Goal Levels
 */
export const listGoalLevelsApiV1PeopleGoalLevelsGet = (
  params?: ListGoalLevelsApiV1PeopleGoalLevelsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<GoalLevelListResponse>({
    url: `/api/v1/people/goal-levels`,
    method: 'GET',
    params,
    signal
  });
};

export const getListGoalLevelsApiV1PeopleGoalLevelsGetQueryKey = (
  params?: ListGoalLevelsApiV1PeopleGoalLevelsGetParams
) => {
  return [`/api/v1/people/goal-levels`, ...(params ? [params] : [])] as const;
};

export const getListGoalLevelsApiV1PeopleGoalLevelsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
  TError = HTTPValidationError
>(
  params?: ListGoalLevelsApiV1PeopleGoalLevelsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListGoalLevelsApiV1PeopleGoalLevelsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>
  > = ({ signal }) => listGoalLevelsApiV1PeopleGoalLevelsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListGoalLevelsApiV1PeopleGoalLevelsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>
>;
export type ListGoalLevelsApiV1PeopleGoalLevelsGetQueryError =
  HTTPValidationError;

export function useListGoalLevelsApiV1PeopleGoalLevelsGet<
  TData = Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListGoalLevelsApiV1PeopleGoalLevelsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
          TError,
          Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListGoalLevelsApiV1PeopleGoalLevelsGet<
  TData = Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
  TError = HTTPValidationError
>(
  params?: ListGoalLevelsApiV1PeopleGoalLevelsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
          TError,
          Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListGoalLevelsApiV1PeopleGoalLevelsGet<
  TData = Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
  TError = HTTPValidationError
>(
  params?: ListGoalLevelsApiV1PeopleGoalLevelsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Goal Levels
 */

export function useListGoalLevelsApiV1PeopleGoalLevelsGet<
  TData = Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
  TError = HTTPValidationError
>(
  params?: ListGoalLevelsApiV1PeopleGoalLevelsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalLevelsApiV1PeopleGoalLevelsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListGoalLevelsApiV1PeopleGoalLevelsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Goal Level
 */
export const createGoalLevelApiV1PeopleGoalLevelsPost = (
  goalLevelCreate: GoalLevelCreate,
  signal?: AbortSignal
) => {
  return customInstance<GoalLevelResponse>({
    url: `/api/v1/people/goal-levels`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: goalLevelCreate,
    signal
  });
};

export const getCreateGoalLevelApiV1PeopleGoalLevelsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoalLevelApiV1PeopleGoalLevelsPost>>,
    TError,
    { data: GoalLevelCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoalLevelApiV1PeopleGoalLevelsPost>>,
  TError,
  { data: GoalLevelCreate },
  TContext
> => {
  const mutationKey = ['createGoalLevelApiV1PeopleGoalLevelsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoalLevelApiV1PeopleGoalLevelsPost>>,
    { data: GoalLevelCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createGoalLevelApiV1PeopleGoalLevelsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGoalLevelApiV1PeopleGoalLevelsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createGoalLevelApiV1PeopleGoalLevelsPost>>
  >;
export type CreateGoalLevelApiV1PeopleGoalLevelsPostMutationBody =
  GoalLevelCreate;
export type CreateGoalLevelApiV1PeopleGoalLevelsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Goal Level
 */
export const useCreateGoalLevelApiV1PeopleGoalLevelsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createGoalLevelApiV1PeopleGoalLevelsPost>>,
      TError,
      { data: GoalLevelCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createGoalLevelApiV1PeopleGoalLevelsPost>>,
  TError,
  { data: GoalLevelCreate },
  TContext
> => {
  const mutationOptions =
    getCreateGoalLevelApiV1PeopleGoalLevelsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Goal Level
 */
export const getGoalLevelApiV1PeopleGoalLevelsLevelIdGet = (
  levelId: string,
  signal?: AbortSignal
) => {
  return customInstance<GoalLevelResponse>({
    url: `/api/v1/people/goal-levels/${levelId}`,
    method: 'GET',
    signal
  });
};

export const getGetGoalLevelApiV1PeopleGoalLevelsLevelIdGetQueryKey = (
  levelId?: string
) => {
  return [`/api/v1/people/goal-levels/${levelId}`] as const;
};

export const getGetGoalLevelApiV1PeopleGoalLevelsLevelIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>
  >,
  TError = HTTPValidationError
>(
  levelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetGoalLevelApiV1PeopleGoalLevelsLevelIdGetQueryKey(levelId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>>
  > = ({ signal }) =>
    getGoalLevelApiV1PeopleGoalLevelsLevelIdGet(levelId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!levelId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetGoalLevelApiV1PeopleGoalLevelsLevelIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>>
  >;
export type GetGoalLevelApiV1PeopleGoalLevelsLevelIdGetQueryError =
  HTTPValidationError;

export function useGetGoalLevelApiV1PeopleGoalLevelsLevelIdGet<
  TData = Awaited<
    ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>
  >,
  TError = HTTPValidationError
>(
  levelId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGoalLevelApiV1PeopleGoalLevelsLevelIdGet<
  TData = Awaited<
    ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>
  >,
  TError = HTTPValidationError
>(
  levelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGoalLevelApiV1PeopleGoalLevelsLevelIdGet<
  TData = Awaited<
    ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>
  >,
  TError = HTTPValidationError
>(
  levelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Goal Level
 */

export function useGetGoalLevelApiV1PeopleGoalLevelsLevelIdGet<
  TData = Awaited<
    ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>
  >,
  TError = HTTPValidationError
>(
  levelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalLevelApiV1PeopleGoalLevelsLevelIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetGoalLevelApiV1PeopleGoalLevelsLevelIdGetQueryOptions(
      levelId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Goal Level
 */
export const updateGoalLevelApiV1PeopleGoalLevelsLevelIdPut = (
  levelId: string,
  goalLevelUpdate: GoalLevelUpdate
) => {
  return customInstance<GoalLevelResponse>({
    url: `/api/v1/people/goal-levels/${levelId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: goalLevelUpdate
  });
};

export const getUpdateGoalLevelApiV1PeopleGoalLevelsLevelIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateGoalLevelApiV1PeopleGoalLevelsLevelIdPut>
      >,
      TError,
      { levelId: string; data: GoalLevelUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateGoalLevelApiV1PeopleGoalLevelsLevelIdPut>>,
    TError,
    { levelId: string; data: GoalLevelUpdate },
    TContext
  > => {
    const mutationKey = ['updateGoalLevelApiV1PeopleGoalLevelsLevelIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateGoalLevelApiV1PeopleGoalLevelsLevelIdPut>
      >,
      { levelId: string; data: GoalLevelUpdate }
    > = (props) => {
      const { levelId, data } = props ?? {};

      return updateGoalLevelApiV1PeopleGoalLevelsLevelIdPut(levelId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateGoalLevelApiV1PeopleGoalLevelsLevelIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateGoalLevelApiV1PeopleGoalLevelsLevelIdPut>>
  >;
export type UpdateGoalLevelApiV1PeopleGoalLevelsLevelIdPutMutationBody =
  GoalLevelUpdate;
export type UpdateGoalLevelApiV1PeopleGoalLevelsLevelIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Goal Level
 */
export const useUpdateGoalLevelApiV1PeopleGoalLevelsLevelIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateGoalLevelApiV1PeopleGoalLevelsLevelIdPut>
      >,
      TError,
      { levelId: string; data: GoalLevelUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateGoalLevelApiV1PeopleGoalLevelsLevelIdPut>>,
  TError,
  { levelId: string; data: GoalLevelUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateGoalLevelApiV1PeopleGoalLevelsLevelIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Goal Level
 */
export const deleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete = (
  levelId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/goal-levels/${levelId}`,
    method: 'DELETE'
  });
};

export const getDeleteGoalLevelApiV1PeopleGoalLevelsLevelIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete>
      >,
      TError,
      { levelId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete>
    >,
    TError,
    { levelId: string },
    TContext
  > => {
    const mutationKey = ['deleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete>
      >,
      { levelId: string }
    > = (props) => {
      const { levelId } = props ?? {};

      return deleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete(levelId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteGoalLevelApiV1PeopleGoalLevelsLevelIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete>
    >
  >;

export type DeleteGoalLevelApiV1PeopleGoalLevelsLevelIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Goal Level
 */
export const useDeleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete>
      >,
      TError,
      { levelId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteGoalLevelApiV1PeopleGoalLevelsLevelIdDelete>>,
  TError,
  { levelId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteGoalLevelApiV1PeopleGoalLevelsLevelIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List goals. Private goals outside the caller's scope are absent from the
result set entirely — filtered in the repository's base query, not here.
 * @summary List Goals
 */
export const listGoalsApiV1PeopleGoalsGet = (
  params?: ListGoalsApiV1PeopleGoalsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<GoalListResponse>({
    url: `/api/v1/people/goals`,
    method: 'GET',
    params,
    signal
  });
};

export const getListGoalsApiV1PeopleGoalsGetQueryKey = (
  params?: ListGoalsApiV1PeopleGoalsGetParams
) => {
  return [`/api/v1/people/goals`, ...(params ? [params] : [])] as const;
};

export const getListGoalsApiV1PeopleGoalsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
  TError = HTTPValidationError
>(
  params?: ListGoalsApiV1PeopleGoalsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListGoalsApiV1PeopleGoalsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>
  > = ({ signal }) => listGoalsApiV1PeopleGoalsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListGoalsApiV1PeopleGoalsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>
>;
export type ListGoalsApiV1PeopleGoalsGetQueryError = HTTPValidationError;

export function useListGoalsApiV1PeopleGoalsGet<
  TData = Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListGoalsApiV1PeopleGoalsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
          TError,
          Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListGoalsApiV1PeopleGoalsGet<
  TData = Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
  TError = HTTPValidationError
>(
  params?: ListGoalsApiV1PeopleGoalsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
          TError,
          Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListGoalsApiV1PeopleGoalsGet<
  TData = Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
  TError = HTTPValidationError
>(
  params?: ListGoalsApiV1PeopleGoalsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Goals
 */

export function useListGoalsApiV1PeopleGoalsGet<
  TData = Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
  TError = HTTPValidationError
>(
  params?: ListGoalsApiV1PeopleGoalsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGoalsApiV1PeopleGoalsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListGoalsApiV1PeopleGoalsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Goal
 */
export const createGoalApiV1PeopleGoalsPost = (
  goalCreate: GoalCreate,
  signal?: AbortSignal
) => {
  return customInstance<GoalResponse>({
    url: `/api/v1/people/goals`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: goalCreate,
    signal
  });
};

export const getCreateGoalApiV1PeopleGoalsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoalApiV1PeopleGoalsPost>>,
    TError,
    { data: GoalCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoalApiV1PeopleGoalsPost>>,
  TError,
  { data: GoalCreate },
  TContext
> => {
  const mutationKey = ['createGoalApiV1PeopleGoalsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoalApiV1PeopleGoalsPost>>,
    { data: GoalCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createGoalApiV1PeopleGoalsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGoalApiV1PeopleGoalsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGoalApiV1PeopleGoalsPost>>
>;
export type CreateGoalApiV1PeopleGoalsPostMutationBody = GoalCreate;
export type CreateGoalApiV1PeopleGoalsPostMutationError = HTTPValidationError;

/**
 * @summary Create Goal
 */
export const useCreateGoalApiV1PeopleGoalsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createGoalApiV1PeopleGoalsPost>>,
      TError,
      { data: GoalCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createGoalApiV1PeopleGoalsPost>>,
  TError,
  { data: GoalCreate },
  TContext
> => {
  const mutationOptions =
    getCreateGoalApiV1PeopleGoalsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Goals owned by the caller's DIRECT reports — the same roster
``GET /people/my-team`` shows, resolved through the shared ``manager_scope``
seam. A grand-report's goals are still *readable* (the privacy scope credits
the whole subtree) via the plain goals list; they are not part of "my team".
An empty team yields an empty page, not an error.
 * @summary List My Team Goals
 */
export const listMyTeamGoalsApiV1PeopleGoalsMyTeamGet = (
  params?: ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetParams,
  signal?: AbortSignal
) => {
  return customInstance<GoalListResponse>({
    url: `/api/v1/people/goals/my-team`,
    method: 'GET',
    params,
    signal
  });
};

export const getListMyTeamGoalsApiV1PeopleGoalsMyTeamGetQueryKey = (
  params?: ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetParams
) => {
  return [`/api/v1/people/goals/my-team`, ...(params ? [params] : [])] as const;
};

export const getListMyTeamGoalsApiV1PeopleGoalsMyTeamGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
  TError = HTTPValidationError
>(
  params?: ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListMyTeamGoalsApiV1PeopleGoalsMyTeamGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>
  > = ({ signal }) => listMyTeamGoalsApiV1PeopleGoalsMyTeamGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>
>;
export type ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetQueryError =
  HTTPValidationError;

export function useListMyTeamGoalsApiV1PeopleGoalsMyTeamGet<
  TData = Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
          TError,
          Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMyTeamGoalsApiV1PeopleGoalsMyTeamGet<
  TData = Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
  TError = HTTPValidationError
>(
  params?: ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
          TError,
          Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMyTeamGoalsApiV1PeopleGoalsMyTeamGet<
  TData = Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
  TError = HTTPValidationError
>(
  params?: ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List My Team Goals
 */

export function useListMyTeamGoalsApiV1PeopleGoalsMyTeamGet<
  TData = Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
  TError = HTTPValidationError
>(
  params?: ListMyTeamGoalsApiV1PeopleGoalsMyTeamGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMyTeamGoalsApiV1PeopleGoalsMyTeamGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListMyTeamGoalsApiV1PeopleGoalsMyTeamGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 404 both for a goal that does not exist and for a private goal outside the
caller's scope — the two must be indistinguishable.
 * @summary Get Goal
 */
export const getGoalApiV1PeopleGoalsGoalIdGet = (
  goalId: string,
  signal?: AbortSignal
) => {
  return customInstance<GoalResponse>({
    url: `/api/v1/people/goals/${goalId}`,
    method: 'GET',
    signal
  });
};

export const getGetGoalApiV1PeopleGoalsGoalIdGetQueryKey = (
  goalId?: string
) => {
  return [`/api/v1/people/goals/${goalId}`] as const;
};

export const getGetGoalApiV1PeopleGoalsGoalIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetGoalApiV1PeopleGoalsGoalIdGetQueryKey(goalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>
  > = ({ signal }) => getGoalApiV1PeopleGoalsGoalIdGet(goalId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!goalId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetGoalApiV1PeopleGoalsGoalIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>
>;
export type GetGoalApiV1PeopleGoalsGoalIdGetQueryError = HTTPValidationError;

export function useGetGoalApiV1PeopleGoalsGoalIdGet<
  TData = Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
  TError = HTTPValidationError
>(
  goalId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
          TError,
          Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGoalApiV1PeopleGoalsGoalIdGet<
  TData = Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
          TError,
          Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGoalApiV1PeopleGoalsGoalIdGet<
  TData = Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Goal
 */

export function useGetGoalApiV1PeopleGoalsGoalIdGet<
  TData = Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGoalApiV1PeopleGoalsGoalIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetGoalApiV1PeopleGoalsGoalIdGetQueryOptions(
    goalId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Goal
 */
export const updateGoalApiV1PeopleGoalsGoalIdPut = (
  goalId: string,
  goalUpdate: GoalUpdate
) => {
  return customInstance<GoalResponse>({
    url: `/api/v1/people/goals/${goalId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: goalUpdate
  });
};

export const getUpdateGoalApiV1PeopleGoalsGoalIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoalApiV1PeopleGoalsGoalIdPut>>,
    TError,
    { goalId: string; data: GoalUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGoalApiV1PeopleGoalsGoalIdPut>>,
  TError,
  { goalId: string; data: GoalUpdate },
  TContext
> => {
  const mutationKey = ['updateGoalApiV1PeopleGoalsGoalIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGoalApiV1PeopleGoalsGoalIdPut>>,
    { goalId: string; data: GoalUpdate }
  > = (props) => {
    const { goalId, data } = props ?? {};

    return updateGoalApiV1PeopleGoalsGoalIdPut(goalId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGoalApiV1PeopleGoalsGoalIdPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGoalApiV1PeopleGoalsGoalIdPut>>
>;
export type UpdateGoalApiV1PeopleGoalsGoalIdPutMutationBody = GoalUpdate;
export type UpdateGoalApiV1PeopleGoalsGoalIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Goal
 */
export const useUpdateGoalApiV1PeopleGoalsGoalIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateGoalApiV1PeopleGoalsGoalIdPut>>,
      TError,
      { goalId: string; data: GoalUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateGoalApiV1PeopleGoalsGoalIdPut>>,
  TError,
  { goalId: string; data: GoalUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateGoalApiV1PeopleGoalsGoalIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete. Children are orphaned, not cascaded.
 * @summary Delete Goal
 */
export const deleteGoalApiV1PeopleGoalsGoalIdDelete = (goalId: string) => {
  return customInstance<void>({
    url: `/api/v1/people/goals/${goalId}`,
    method: 'DELETE'
  });
};

export const getDeleteGoalApiV1PeopleGoalsGoalIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoalApiV1PeopleGoalsGoalIdDelete>>,
    TError,
    { goalId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGoalApiV1PeopleGoalsGoalIdDelete>>,
  TError,
  { goalId: string },
  TContext
> => {
  const mutationKey = ['deleteGoalApiV1PeopleGoalsGoalIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGoalApiV1PeopleGoalsGoalIdDelete>>,
    { goalId: string }
  > = (props) => {
    const { goalId } = props ?? {};

    return deleteGoalApiV1PeopleGoalsGoalIdDelete(goalId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGoalApiV1PeopleGoalsGoalIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGoalApiV1PeopleGoalsGoalIdDelete>>
>;

export type DeleteGoalApiV1PeopleGoalsGoalIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Goal
 */
export const useDeleteGoalApiV1PeopleGoalsGoalIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteGoalApiV1PeopleGoalsGoalIdDelete>>,
      TError,
      { goalId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteGoalApiV1PeopleGoalsGoalIdDelete>>,
  TError,
  { goalId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteGoalApiV1PeopleGoalsGoalIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * The goal and everything aligned beneath it, breadth-first — one query per
tree level, never one per node.
 * @summary Get Goal Alignment Tree
 */
export const getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet = (
  goalId: string,
  signal?: AbortSignal
) => {
  return customInstance<GoalTreeNode>({
    url: `/api/v1/people/goals/${goalId}/alignment-tree`,
    method: 'GET',
    signal
  });
};

export const getGetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGetQueryKey =
  (goalId?: string) => {
    return [`/api/v1/people/goals/${goalId}/alignment-tree`] as const;
  };

export const getGetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
      >
    >,
    TError = HTTPValidationError
  >(
    goalId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGetQueryKey(
        goalId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
        >
      >
    > = ({ signal }) =>
      getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet(
        goalId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!goalId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
      >
    >
  >;
export type GetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGetQueryError =
  HTTPValidationError;

export function useGetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet<
  TData = Awaited<
    ReturnType<
      typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
    >
  >,
  TError = HTTPValidationError
>(
  goalId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet<
  TData = Awaited<
    ReturnType<
      typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
    >
  >,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet<
  TData = Awaited<
    ReturnType<
      typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
    >
  >,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Goal Alignment Tree
 */

export function useGetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet<
  TData = Awaited<
    ReturnType<
      typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
    >
  >,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetGoalAlignmentTreeApiV1PeopleGoalsGoalIdAlignmentTreeGetQueryOptions(
      goalId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Key Results
 */
export const listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet = (
  goalId: string,
  signal?: AbortSignal
) => {
  return customInstance<GoalKeyResultListResponse>({
    url: `/api/v1/people/goals/${goalId}/key-results`,
    method: 'GET',
    signal
  });
};

export const getListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGetQueryKey = (
  goalId?: string
) => {
  return [`/api/v1/people/goals/${goalId}/key-results`] as const;
};

export const getListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
    >,
    TError = HTTPValidationError
  >(
    goalId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGetQueryKey(goalId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
      >
    > = ({ signal }) =>
      listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet(goalId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!goalId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
    >
  >;
export type ListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGetQueryError =
  HTTPValidationError;

export function useListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet<
  TData = Awaited<
    ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
  >,
  TError = HTTPValidationError
>(
  goalId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet<
  TData = Awaited<
    ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
  >,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet<
  TData = Awaited<
    ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
  >,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Key Results
 */

export function useListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet<
  TData = Awaited<
    ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
  >,
  TError = HTTPValidationError
>(
  goalId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListKeyResultsApiV1PeopleGoalsGoalIdKeyResultsGetQueryOptions(
      goalId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Key Result
 */
export const createKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost = (
  goalId: string,
  goalKeyResultCreate: GoalKeyResultCreate,
  signal?: AbortSignal
) => {
  return customInstance<GoalKeyResultResponse>({
    url: `/api/v1/people/goals/${goalId}/key-results`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: goalKeyResultCreate,
    signal
  });
};

export const getCreateKeyResultApiV1PeopleGoalsGoalIdKeyResultsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost>
      >,
      TError,
      { goalId: string; data: GoalKeyResultCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost>
    >,
    TError,
    { goalId: string; data: GoalKeyResultCreate },
    TContext
  > => {
    const mutationKey = ['createKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost>
      >,
      { goalId: string; data: GoalKeyResultCreate }
    > = (props) => {
      const { goalId, data } = props ?? {};

      return createKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost(goalId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateKeyResultApiV1PeopleGoalsGoalIdKeyResultsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost>
    >
  >;
export type CreateKeyResultApiV1PeopleGoalsGoalIdKeyResultsPostMutationBody =
  GoalKeyResultCreate;
export type CreateKeyResultApiV1PeopleGoalsGoalIdKeyResultsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Key Result
 */
export const useCreateKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost>
      >,
      TError,
      { goalId: string; data: GoalKeyResultCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createKeyResultApiV1PeopleGoalsGoalIdKeyResultsPost>
  >,
  TError,
  { goalId: string; data: GoalKeyResultCreate },
  TContext
> => {
  const mutationOptions =
    getCreateKeyResultApiV1PeopleGoalsGoalIdKeyResultsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Key Result
 */
export const getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet = (
  keyResultId: string,
  signal?: AbortSignal
) => {
  return customInstance<GoalKeyResultResponse>({
    url: `/api/v1/people/goal-key-results/${keyResultId}`,
    method: 'GET',
    signal
  });
};

export const getGetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGetQueryKey = (
  keyResultId?: string
) => {
  return [`/api/v1/people/goal-key-results/${keyResultId}`] as const;
};

export const getGetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
    >,
    TError = HTTPValidationError
  >(
    keyResultId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGetQueryKey(
        keyResultId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
      >
    > = ({ signal }) =>
      getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet(keyResultId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!keyResultId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
    >
  >;
export type GetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGetQueryError =
  HTTPValidationError;

export function useGetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet<
  TData = Awaited<
    ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
  >,
  TError = HTTPValidationError
>(
  keyResultId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet<
  TData = Awaited<
    ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
  >,
  TError = HTTPValidationError
>(
  keyResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet<
  TData = Awaited<
    ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
  >,
  TError = HTTPValidationError
>(
  keyResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Key Result
 */

export function useGetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet<
  TData = Awaited<
    ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
  >,
  TError = HTTPValidationError
>(
  keyResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetKeyResultApiV1PeopleGoalKeyResultsKeyResultIdGetQueryOptions(
      keyResultId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Key Result
 */
export const updateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut = (
  keyResultId: string,
  goalKeyResultUpdate: GoalKeyResultUpdate
) => {
  return customInstance<GoalKeyResultResponse>({
    url: `/api/v1/people/goal-key-results/${keyResultId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: goalKeyResultUpdate
  });
};

export const getUpdateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut
        >
      >,
      TError,
      { keyResultId: string; data: GoalKeyResultUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut>
    >,
    TError,
    { keyResultId: string; data: GoalKeyResultUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut
        >
      >,
      { keyResultId: string; data: GoalKeyResultUpdate }
    > = (props) => {
      const { keyResultId, data } = props ?? {};

      return updateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut(
        keyResultId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut>
    >
  >;
export type UpdateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPutMutationBody =
  GoalKeyResultUpdate;
export type UpdateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Key Result
 */
export const useUpdateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut
        >
      >,
      TError,
      { keyResultId: string; data: GoalKeyResultUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPut>
  >,
  TError,
  { keyResultId: string; data: GoalKeyResultUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateKeyResultApiV1PeopleGoalKeyResultsKeyResultIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Key Result
 */
export const deleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete = (
  keyResultId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/goal-key-results/${keyResultId}`,
    method: 'DELETE'
  });
};

export const getDeleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete
        >
      >,
      TError,
      { keyResultId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete
      >
    >,
    TError,
    { keyResultId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete
        >
      >,
      { keyResultId: string }
    > = (props) => {
      const { keyResultId } = props ?? {};

      return deleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete(
        keyResultId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete
      >
    >
  >;

export type DeleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Key Result
 */
export const useDeleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete
        >
      >,
      TError,
      { keyResultId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDelete>
  >,
  TError,
  { keyResultId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteKeyResultApiV1PeopleGoalKeyResultsKeyResultIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * The key result's check-in trail, newest first.
 * @summary List Check Ins
 */
export const listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet = (
  keyResultId: string,
  params?: ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<GoalCheckInListResponse>({
    url: `/api/v1/people/goal-key-results/${keyResultId}/check-ins`,
    method: 'GET',
    params,
    signal
  });
};

export const getListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetQueryKey =
  (
    keyResultId?: string,
    params?: ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetParams
  ) => {
    return [
      `/api/v1/people/goal-key-results/${keyResultId}/check-ins`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
      >
    >,
    TError = HTTPValidationError
  >(
    keyResultId: string,
    params?: ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetQueryKey(
        keyResultId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
        >
      >
    > = ({ signal }) =>
      listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet(
        keyResultId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!keyResultId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
      >
    >
  >;
export type ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetQueryError =
  HTTPValidationError;

export function useListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet<
  TData = Awaited<
    ReturnType<
      typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
    >
  >,
  TError = HTTPValidationError
>(
  keyResultId: string,
  params:
    | undefined
    | ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet<
  TData = Awaited<
    ReturnType<
      typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
    >
  >,
  TError = HTTPValidationError
>(
  keyResultId: string,
  params?: ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet<
  TData = Awaited<
    ReturnType<
      typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
    >
  >,
  TError = HTTPValidationError
>(
  keyResultId: string,
  params?: ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Check Ins
 */

export function useListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet<
  TData = Awaited<
    ReturnType<
      typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
    >
  >,
  TError = HTTPValidationError
>(
  keyResultId: string,
  params?: ListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCheckInsApiV1PeopleGoalKeyResultsKeyResultIdCheckInsGetQueryOptions(
      keyResultId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The ONLY way a key result's current_value moves. The comment is mandatory,
and goal progress plus every ancestor's is recomputed in the same commit.
 * @summary Create Check In
 */
export const createCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost = (
  keyResultId: string,
  goalCheckInCreate: GoalCheckInCreate,
  signal?: AbortSignal
) => {
  return customInstance<GoalCheckInResponse>({
    url: `/api/v1/people/goal-key-results/${keyResultId}/check-ins`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: goalCheckInCreate,
    signal
  });
};

export const getCreateCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost
        >
      >,
      TError,
      { keyResultId: string; data: GoalCheckInCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost
      >
    >,
    TError,
    { keyResultId: string; data: GoalCheckInCreate },
    TContext
  > => {
    const mutationKey = [
      'createCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost
        >
      >,
      { keyResultId: string; data: GoalCheckInCreate }
    > = (props) => {
      const { keyResultId, data } = props ?? {};

      return createCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost(
        keyResultId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost
      >
    >
  >;
export type CreateCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPostMutationBody =
  GoalCheckInCreate;
export type CreateCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Check In
 */
export const useCreateCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost
          >
        >,
        TError,
        { keyResultId: string; data: GoalCheckInCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPost
      >
    >,
    TError,
    { keyResultId: string; data: GoalCheckInCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateCheckInApiV1PeopleGoalKeyResultsKeyResultIdCheckInsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The calling user's 1:1s — the ones they own and the ones they were invited to.

There is no "all 1:1s in the tenant" view, for anyone: the repository is
participant-scoped, so this endpoint cannot be widened by a query parameter.
 * @summary List One On Ones
 */
export const listOneOnOnesApiV1PeopleOneOnOnesGet = (
  params?: ListOneOnOnesApiV1PeopleOneOnOnesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<OneOnOneListResponse>({
    url: `/api/v1/people/one-on-ones`,
    method: 'GET',
    params,
    signal
  });
};

export const getListOneOnOnesApiV1PeopleOneOnOnesGetQueryKey = (
  params?: ListOneOnOnesApiV1PeopleOneOnOnesGetParams
) => {
  return [`/api/v1/people/one-on-ones`, ...(params ? [params] : [])] as const;
};

export const getListOneOnOnesApiV1PeopleOneOnOnesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
  TError = HTTPValidationError
>(
  params?: ListOneOnOnesApiV1PeopleOneOnOnesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOneOnOnesApiV1PeopleOneOnOnesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>
  > = ({ signal }) => listOneOnOnesApiV1PeopleOneOnOnesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListOneOnOnesApiV1PeopleOneOnOnesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>
>;
export type ListOneOnOnesApiV1PeopleOneOnOnesGetQueryError =
  HTTPValidationError;

export function useListOneOnOnesApiV1PeopleOneOnOnesGet<
  TData = Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListOneOnOnesApiV1PeopleOneOnOnesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
          TError,
          Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOneOnOnesApiV1PeopleOneOnOnesGet<
  TData = Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
  TError = HTTPValidationError
>(
  params?: ListOneOnOnesApiV1PeopleOneOnOnesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
          TError,
          Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOneOnOnesApiV1PeopleOneOnOnesGet<
  TData = Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
  TError = HTTPValidationError
>(
  params?: ListOneOnOnesApiV1PeopleOneOnOnesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List One On Ones
 */

export function useListOneOnOnesApiV1PeopleOneOnOnesGet<
  TData = Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
  TError = HTTPValidationError
>(
  params?: ListOneOnOnesApiV1PeopleOneOnOnesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOneOnOnesApiV1PeopleOneOnOnesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListOneOnOnesApiV1PeopleOneOnOnesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Schedule a 1:1. The caller is always its owner.
 * @summary Create One On One
 */
export const createOneOnOneApiV1PeopleOneOnOnesPost = (
  oneOnOneCreate: OneOnOneCreate,
  signal?: AbortSignal
) => {
  return customInstance<OneOnOneResponse>({
    url: `/api/v1/people/one-on-ones`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: oneOnOneCreate,
    signal
  });
};

export const getCreateOneOnOneApiV1PeopleOneOnOnesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOneOnOneApiV1PeopleOneOnOnesPost>>,
    TError,
    { data: OneOnOneCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOneOnOneApiV1PeopleOneOnOnesPost>>,
  TError,
  { data: OneOnOneCreate },
  TContext
> => {
  const mutationKey = ['createOneOnOneApiV1PeopleOneOnOnesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOneOnOneApiV1PeopleOneOnOnesPost>>,
    { data: OneOnOneCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createOneOnOneApiV1PeopleOneOnOnesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOneOnOneApiV1PeopleOneOnOnesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOneOnOneApiV1PeopleOneOnOnesPost>>
>;
export type CreateOneOnOneApiV1PeopleOneOnOnesPostMutationBody = OneOnOneCreate;
export type CreateOneOnOneApiV1PeopleOneOnOnesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create One On One
 */
export const useCreateOneOnOneApiV1PeopleOneOnOnesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOneOnOneApiV1PeopleOneOnOnesPost>>,
      TError,
      { data: OneOnOneCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createOneOnOneApiV1PeopleOneOnOnesPost>>,
  TError,
  { data: OneOnOneCreate },
  TContext
> => {
  const mutationOptions =
    getCreateOneOnOneApiV1PeopleOneOnOnesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * The meeting, its agenda, carried-forward actions, own actions and notes.

``notes`` holds only what the CALLER may read. The other party's private notes
are never selected, so they are absent from this payload rather than removed
from it.
 * @summary Get One On One
 */
export const getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet = (
  oneOnOneId: string,
  signal?: AbortSignal
) => {
  return customInstance<OneOnOneDetailResponse>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}`,
    method: 'GET',
    signal
  });
};

export const getGetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGetQueryKey = (
  oneOnOneId?: string
) => {
  return [`/api/v1/people/one-on-ones/${oneOnOneId}`] as const;
};

export const getGetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
  >,
  TError = HTTPValidationError
>(
  oneOnOneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGetQueryKey(oneOnOneId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>>
  > = ({ signal }) =>
    getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet(oneOnOneId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!oneOnOneId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>>
  >;
export type GetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGetQueryError =
  HTTPValidationError;

export function useGetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet<
  TData = Awaited<
    ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
  >,
  TError = HTTPValidationError
>(
  oneOnOneId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet<
  TData = Awaited<
    ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
  >,
  TError = HTTPValidationError
>(
  oneOnOneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet<
  TData = Awaited<
    ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
  >,
  TError = HTTPValidationError
>(
  oneOnOneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get One On One
 */

export function useGetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet<
  TData = Awaited<
    ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
  >,
  TError = HTTPValidationError
>(
  oneOnOneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOneOnOneApiV1PeopleOneOnOnesOneOnOneIdGetQueryOptions(
      oneOnOneId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Patch a 1:1's title, duration or cadence.
 * @summary Update One On One
 */
export const updateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut = (
  oneOnOneId: string,
  oneOnOneUpdate: OneOnOneUpdate
) => {
  return customInstance<OneOnOneResponse>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: oneOnOneUpdate
  });
};

export const getUpdateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut>
      >,
      TError,
      { oneOnOneId: string; data: OneOnOneUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut>>,
    TError,
    { oneOnOneId: string; data: OneOnOneUpdate },
    TContext
  > => {
    const mutationKey = ['updateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut>
      >,
      { oneOnOneId: string; data: OneOnOneUpdate }
    > = (props) => {
      const { oneOnOneId, data } = props ?? {};

      return updateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut(oneOnOneId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut>>
  >;
export type UpdateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPutMutationBody =
  OneOnOneUpdate;
export type UpdateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update One On One
 */
export const useUpdateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut>
      >,
      TError,
      { oneOnOneId: string; data: OneOnOneUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPut>>,
  TError,
  { oneOnOneId: string; data: OneOnOneUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateOneOnOneApiV1PeopleOneOnOnesOneOnOneIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete a 1:1. Only its owner may — the invitee cancels instead.
 * @summary Delete One On One
 */
export const deleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete = (
  oneOnOneId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}`,
    method: 'DELETE'
  });
};

export const getDeleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete>
      >,
      TError,
      { oneOnOneId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete>
    >,
    TError,
    { oneOnOneId: string },
    TContext
  > => {
    const mutationKey = ['deleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete>
      >,
      { oneOnOneId: string }
    > = (props) => {
      const { oneOnOneId } = props ?? {};

      return deleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete(oneOnOneId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete>
    >
  >;

export type DeleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete One On One
 */
export const useDeleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete>
      >,
      TError,
      { oneOnOneId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDelete>
  >,
  TError,
  { oneOnOneId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Move a 1:1 and notify the other party.
 * @summary Reschedule One On One
 */
export const rescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost = (
  oneOnOneId: string,
  oneOnOneReschedule: OneOnOneReschedule,
  signal?: AbortSignal
) => {
  return customInstance<OneOnOneResponse>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}/reschedule`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: oneOnOneReschedule,
    signal
  });
};

export const getRescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof rescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost
        >
      >,
      TError,
      { oneOnOneId: string; data: OneOnOneReschedule },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof rescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost
      >
    >,
    TError,
    { oneOnOneId: string; data: OneOnOneReschedule },
    TContext
  > => {
    const mutationKey = [
      'rescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof rescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost
        >
      >,
      { oneOnOneId: string; data: OneOnOneReschedule }
    > = (props) => {
      const { oneOnOneId, data } = props ?? {};

      return rescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost(
        oneOnOneId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof rescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost
      >
    >
  >;
export type RescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePostMutationBody =
  OneOnOneReschedule;
export type RescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePostMutationError =
  HTTPValidationError;

/**
 * @summary Reschedule One On One
 */
export const useRescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof rescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost
          >
        >,
        TError,
        { oneOnOneId: string; data: OneOnOneReschedule },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof rescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePost
      >
    >,
    TError,
    { oneOnOneId: string; data: OneOnOneReschedule },
    TContext
  > => {
    const mutationOptions =
      getRescheduleOneOnOneApiV1PeopleOneOnOnesOneOnOneIdReschedulePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Mark the conversation as held. Notes and actions stay editable afterwards.
 * @summary Complete One On One
 */
export const completeOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost = (
  oneOnOneId: string,
  signal?: AbortSignal
) => {
  return customInstance<OneOnOneResponse>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}/complete`,
    method: 'POST',
    signal
  });
};

export const getCompleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof completeOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost
        >
      >,
      TError,
      { oneOnOneId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof completeOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost
      >
    >,
    TError,
    { oneOnOneId: string },
    TContext
  > => {
    const mutationKey = [
      'completeOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof completeOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost
        >
      >,
      { oneOnOneId: string }
    > = (props) => {
      const { oneOnOneId } = props ?? {};

      return completeOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost(
        oneOnOneId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CompleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof completeOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost
      >
    >
  >;

export type CompleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePostMutationError =
  HTTPValidationError;

/**
 * @summary Complete One On One
 */
export const useCompleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof completeOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost
        >
      >,
      TError,
      { oneOnOneId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof completeOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePost
    >
  >,
  TError,
  { oneOnOneId: string },
  TContext
> => {
  const mutationOptions =
    getCompleteOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCompletePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Call the meeting off and notify the other party.
 * @summary Cancel One On One
 */
export const cancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost = (
  oneOnOneId: string,
  signal?: AbortSignal
) => {
  return customInstance<OneOnOneResponse>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}/cancel`,
    method: 'POST',
    signal
  });
};

export const getCancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost
        >
      >,
      TError,
      { oneOnOneId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof cancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost>
    >,
    TError,
    { oneOnOneId: string },
    TContext
  > => {
    const mutationKey = [
      'cancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost
        >
      >,
      { oneOnOneId: string }
    > = (props) => {
      const { oneOnOneId } = props ?? {};

      return cancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost(oneOnOneId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof cancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost>
    >
  >;

export type CancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel One On One
 */
export const useCancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost
        >
      >,
      TError,
      { oneOnOneId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof cancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPost>
  >,
  TError,
  { oneOnOneId: string },
  TContext
> => {
  const mutationOptions =
    getCancelOneOnOneApiV1PeopleOneOnOnesOneOnOneIdCancelPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create the next meeting in the series, one cadence interval later.

Exactly one meeting, on demand — there is no background series generator.
Open action items are not copied: they carry forward by derivation, so the new
meeting shows them the moment it exists.
 * @summary Schedule Next One On One
 */
export const scheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost =
  (oneOnOneId: string, signal?: AbortSignal) => {
    return customInstance<OneOnOneResponse>({
      url: `/api/v1/people/one-on-ones/${oneOnOneId}/schedule-next`,
      method: 'POST',
      signal
    });
  };

export const getScheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof scheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost
        >
      >,
      TError,
      { oneOnOneId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof scheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost
      >
    >,
    TError,
    { oneOnOneId: string },
    TContext
  > => {
    const mutationKey = [
      'scheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof scheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost
        >
      >,
      { oneOnOneId: string }
    > = (props) => {
      const { oneOnOneId } = props ?? {};

      return scheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost(
        oneOnOneId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ScheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof scheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost
      >
    >
  >;

export type ScheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPostMutationError =
  HTTPValidationError;

/**
 * @summary Schedule Next One On One
 */
export const useScheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof scheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost
          >
        >,
        TError,
        { oneOnOneId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof scheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPost
      >
    >,
    TError,
    { oneOnOneId: string },
    TContext
  > => {
    const mutationOptions =
      getScheduleNextOneOnOneApiV1PeopleOneOnOnesOneOnOneIdScheduleNextPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Earlier 1:1s with the same person, most recent first.
 * @summary Get One On One History
 */
export const getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet = (
  oneOnOneId: string,
  signal?: AbortSignal
) => {
  return customInstance<OneOnOneResponse[]>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}/history`,
    method: 'GET',
    signal
  });
};

export const getGetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGetQueryKey =
  (oneOnOneId?: string) => {
    return [`/api/v1/people/one-on-ones/${oneOnOneId}/history`] as const;
  };

export const getGetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
      >
    >,
    TError = HTTPValidationError
  >(
    oneOnOneId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGetQueryKey(
        oneOnOneId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
        >
      >
    > = ({ signal }) =>
      getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet(
        oneOnOneId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!oneOnOneId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
      >
    >
  >;
export type GetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGetQueryError =
  HTTPValidationError;

export function useGetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  oneOnOneId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  oneOnOneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  oneOnOneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get One On One History
 */

export function useGetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  oneOnOneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOneOnOneHistoryApiV1PeopleOneOnOnesOneOnOneIdHistoryGetQueryOptions(
      oneOnOneId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a talking point. Either party may add to the same agenda.
 * @summary Add Agenda Item
 */
export const addAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost = (
  oneOnOneId: string,
  oneOnOneAgendaItemCreate: OneOnOneAgendaItemCreate,
  signal?: AbortSignal
) => {
  return customInstance<AgendaItemResponse>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}/agenda-items`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: oneOnOneAgendaItemCreate,
    signal
  });
};

export const getAddAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost
        >
      >,
      TError,
      { oneOnOneId: string; data: OneOnOneAgendaItemCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost
      >
    >,
    TError,
    { oneOnOneId: string; data: OneOnOneAgendaItemCreate },
    TContext
  > => {
    const mutationKey = [
      'addAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost
        >
      >,
      { oneOnOneId: string; data: OneOnOneAgendaItemCreate }
    > = (props) => {
      const { oneOnOneId, data } = props ?? {};

      return addAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost(
        oneOnOneId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost
      >
    >
  >;
export type AddAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPostMutationBody =
  OneOnOneAgendaItemCreate;
export type AddAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Agenda Item
 */
export const useAddAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost
        >
      >,
      TError,
      { oneOnOneId: string; data: OneOnOneAgendaItemCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof addAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPost
    >
  >,
  TError,
  { oneOnOneId: string; data: OneOnOneAgendaItemCreate },
  TContext
> => {
  const mutationOptions =
    getAddAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Edit a talking point or tick it off as discussed.
 * @summary Update Agenda Item
 */
export const updateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut =
  (
    oneOnOneId: string,
    itemId: string,
    oneOnOneAgendaItemUpdate: OneOnOneAgendaItemUpdate
  ) => {
    return customInstance<AgendaItemResponse>({
      url: `/api/v1/people/one-on-ones/${oneOnOneId}/agenda-items/${itemId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: oneOnOneAgendaItemUpdate
    });
  };

export const getUpdateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut
        >
      >,
      TError,
      { oneOnOneId: string; itemId: string; data: OneOnOneAgendaItemUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut
      >
    >,
    TError,
    { oneOnOneId: string; itemId: string; data: OneOnOneAgendaItemUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut
        >
      >,
      { oneOnOneId: string; itemId: string; data: OneOnOneAgendaItemUpdate }
    > = (props) => {
      const { oneOnOneId, itemId, data } = props ?? {};

      return updateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut(
        oneOnOneId,
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut
      >
    >
  >;
export type UpdateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPutMutationBody =
  OneOnOneAgendaItemUpdate;
export type UpdateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Agenda Item
 */
export const useUpdateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut
          >
        >,
        TError,
        { oneOnOneId: string; itemId: string; data: OneOnOneAgendaItemUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPut
      >
    >,
    TError,
    { oneOnOneId: string; itemId: string; data: OneOnOneAgendaItemUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a talking point from the agenda.
 * @summary Delete Agenda Item
 */
export const deleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete =
  (oneOnOneId: string, itemId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/one-on-ones/${oneOnOneId}/agenda-items/${itemId}`,
      method: 'DELETE'
    });
  };

export const getDeleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete
        >
      >,
      TError,
      { oneOnOneId: string; itemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete
      >
    >,
    TError,
    { oneOnOneId: string; itemId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete
        >
      >,
      { oneOnOneId: string; itemId: string }
    > = (props) => {
      const { oneOnOneId, itemId } = props ?? {};

      return deleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete(
        oneOnOneId,
        itemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete
      >
    >
  >;

export type DeleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Agenda Item
 */
export const useDeleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete
          >
        >,
        TError,
        { oneOnOneId: string; itemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDelete
      >
    >,
    TError,
    { oneOnOneId: string; itemId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteAgendaItemApiV1PeopleOneOnOnesOneOnOneIdAgendaItemsItemIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Write a note, shared with the other party or private to you.
 * @summary Add Note
 */
export const addNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost = (
  oneOnOneId: string,
  oneOnOneNoteCreate: OneOnOneNoteCreate,
  signal?: AbortSignal
) => {
  return customInstance<NoteResponse>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}/notes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: oneOnOneNoteCreate,
    signal
  });
};

export const getAddNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost>
      >,
      TError,
      { oneOnOneId: string; data: OneOnOneNoteCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof addNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost>>,
    TError,
    { oneOnOneId: string; data: OneOnOneNoteCreate },
    TContext
  > => {
    const mutationKey = ['addNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost>
      >,
      { oneOnOneId: string; data: OneOnOneNoteCreate }
    > = (props) => {
      const { oneOnOneId, data } = props ?? {};

      return addNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost(oneOnOneId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost>>
  >;
export type AddNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPostMutationBody =
  OneOnOneNoteCreate;
export type AddNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Note
 */
export const useAddNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost>
      >,
      TError,
      { oneOnOneId: string; data: OneOnOneNoteCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPost>>,
  TError,
  { oneOnOneId: string; data: OneOnOneNoteCreate },
  TContext
> => {
  const mutationOptions =
    getAddNoteApiV1PeopleOneOnOnesOneOnOneIdNotesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Edit your own note, including changing its privacy scope.

Only the author may — a shared note is its author's words, and letting the
other party flip one to private would hide it from whoever wrote it.
 * @summary Update Note
 */
export const updateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut = (
  oneOnOneId: string,
  noteId: string,
  oneOnOneNoteUpdate: OneOnOneNoteUpdate
) => {
  return customInstance<NoteResponse>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}/notes/${noteId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: oneOnOneNoteUpdate
  });
};

export const getUpdateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut
        >
      >,
      TError,
      { oneOnOneId: string; noteId: string; data: OneOnOneNoteUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut>
    >,
    TError,
    { oneOnOneId: string; noteId: string; data: OneOnOneNoteUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut
        >
      >,
      { oneOnOneId: string; noteId: string; data: OneOnOneNoteUpdate }
    > = (props) => {
      const { oneOnOneId, noteId, data } = props ?? {};

      return updateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut(
        oneOnOneId,
        noteId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut>
    >
  >;
export type UpdateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPutMutationBody =
  OneOnOneNoteUpdate;
export type UpdateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Note
 */
export const useUpdateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut
        >
      >,
      TError,
      { oneOnOneId: string; noteId: string; data: OneOnOneNoteUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPut>
  >,
  TError,
  { oneOnOneId: string; noteId: string; data: OneOnOneNoteUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete your own note.
 * @summary Delete Note
 */
export const deleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete = (
  oneOnOneId: string,
  noteId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}/notes/${noteId}`,
    method: 'DELETE'
  });
};

export const getDeleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete
        >
      >,
      TError,
      { oneOnOneId: string; noteId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete
      >
    >,
    TError,
    { oneOnOneId: string; noteId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete
        >
      >,
      { oneOnOneId: string; noteId: string }
    > = (props) => {
      const { oneOnOneId, noteId } = props ?? {};

      return deleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete(
        oneOnOneId,
        noteId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete
      >
    >
  >;

export type DeleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Note
 */
export const useDeleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete
        >
      >,
      TError,
      { oneOnOneId: string; noteId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDelete>
  >,
  TError,
  { oneOnOneId: string; noteId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteNoteApiV1PeopleOneOnOnesOneOnOneIdNotesNoteIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Raise an action item and notify its assignee.
 * @summary Add Action Item
 */
export const addActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost = (
  oneOnOneId: string,
  oneOnOneActionItemCreate: OneOnOneActionItemCreate,
  signal?: AbortSignal
) => {
  return customInstance<ActionItemResponse>({
    url: `/api/v1/people/one-on-ones/${oneOnOneId}/action-items`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: oneOnOneActionItemCreate,
    signal
  });
};

export const getAddActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost
        >
      >,
      TError,
      { oneOnOneId: string; data: OneOnOneActionItemCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost
      >
    >,
    TError,
    { oneOnOneId: string; data: OneOnOneActionItemCreate },
    TContext
  > => {
    const mutationKey = [
      'addActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost
        >
      >,
      { oneOnOneId: string; data: OneOnOneActionItemCreate }
    > = (props) => {
      const { oneOnOneId, data } = props ?? {};

      return addActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost(
        oneOnOneId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost
      >
    >
  >;
export type AddActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPostMutationBody =
  OneOnOneActionItemCreate;
export type AddActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Action Item
 */
export const useAddActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost
        >
      >,
      TError,
      { oneOnOneId: string; data: OneOnOneActionItemCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof addActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPost
    >
  >,
  TError,
  { oneOnOneId: string; data: OneOnOneActionItemCreate },
  TContext
> => {
  const mutationOptions =
    getAddActionItemApiV1PeopleOneOnOnesOneOnOneIdActionItemsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Edit or close an action item.

Addressed without a meeting id on purpose: a carried-forward item is closed
from a LATER meeting's page than the one that raised it, so the caller does
not know its parent. The repository re-applies the participant clause on the
join, so the access rule is unchanged.
 * @summary Update Action Item
 */
export const updateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut = (
  actionItemId: string,
  oneOnOneActionItemUpdate: OneOnOneActionItemUpdate
) => {
  return customInstance<ActionItemResponse>({
    url: `/api/v1/people/one-on-one-action-items/${actionItemId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: oneOnOneActionItemUpdate
  });
};

export const getUpdateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut
        >
      >,
      TError,
      { actionItemId: string; data: OneOnOneActionItemUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut
      >
    >,
    TError,
    { actionItemId: string; data: OneOnOneActionItemUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut
        >
      >,
      { actionItemId: string; data: OneOnOneActionItemUpdate }
    > = (props) => {
      const { actionItemId, data } = props ?? {};

      return updateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut(
        actionItemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut
      >
    >
  >;
export type UpdateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPutMutationBody =
  OneOnOneActionItemUpdate;
export type UpdateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Action Item
 */
export const useUpdateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut
          >
        >,
        TError,
        { actionItemId: string; data: OneOnOneActionItemUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPut
      >
    >,
    TError,
    { actionItemId: string; data: OneOnOneActionItemUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateActionItemApiV1PeopleOneOnOneActionItemsActionItemIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove an action item.
 * @summary Delete Action Item
 */
export const deleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete =
  (actionItemId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/one-on-one-action-items/${actionItemId}`,
      method: 'DELETE'
    });
  };

export const getDeleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete
        >
      >,
      TError,
      { actionItemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete
      >
    >,
    TError,
    { actionItemId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete
        >
      >,
      { actionItemId: string }
    > = (props) => {
      const { actionItemId } = props ?? {};

      return deleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete(
        actionItemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete
      >
    >
  >;

export type DeleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Action Item
 */
export const useDeleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete
          >
        >,
        TError,
        { actionItemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDelete
      >
    >,
    TError,
    { actionItemId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteActionItemApiV1PeopleOneOnOneActionItemsActionItemIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The tenant's agenda templates. Readable by anyone scheduling a 1:1.
 * @summary List Agenda Templates
 */
export const listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet = (
  params?: ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<AgendaTemplateListResponse>({
    url: `/api/v1/people/one-on-one-agenda-templates`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetQueryKey =
  (params?: ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetParams) => {
    return [
      `/api/v1/people/one-on-one-agenda-templates`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
        >
      >
    > = ({ signal }) =>
      listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
      >
    >
  >;
export type ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetQueryError =
  HTTPValidationError;

export function useListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Agenda Templates
 */

export function useListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAgendaTemplatesApiV1PeopleOneOnOneAgendaTemplatesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create an agenda template. Requires People module admin.
 * @summary Create Agenda Template
 */
export const createAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost = (
  oneOnOneAgendaTemplateCreate: OneOnOneAgendaTemplateCreate,
  signal?: AbortSignal
) => {
  return customInstance<AgendaTemplateResponse>({
    url: `/api/v1/people/one-on-one-agenda-templates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: oneOnOneAgendaTemplateCreate,
    signal
  });
};

export const getCreateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost
        >
      >,
      TError,
      { data: OneOnOneAgendaTemplateCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost
      >
    >,
    TError,
    { data: OneOnOneAgendaTemplateCreate },
    TContext
  > => {
    const mutationKey = [
      'createAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost
        >
      >,
      { data: OneOnOneAgendaTemplateCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost
      >
    >
  >;
export type CreateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPostMutationBody =
  OneOnOneAgendaTemplateCreate;
export type CreateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Agenda Template
 */
export const useCreateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost
        >
      >,
      TError,
      { data: OneOnOneAgendaTemplateCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPost
    >
  >,
  TError,
  { data: OneOnOneAgendaTemplateCreate },
  TContext
> => {
  const mutationOptions =
    getCreateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update an agenda template. Requires People module admin.

Editing a template never rewrites a 1:1 that already used it — the meeting's
agenda is a copy, so past conversations keep the talking points they had.
 * @summary Update Agenda Template
 */
export const updateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut =
  (
    templateId: string,
    oneOnOneAgendaTemplateUpdate: OneOnOneAgendaTemplateUpdate
  ) => {
    return customInstance<AgendaTemplateResponse>({
      url: `/api/v1/people/one-on-one-agenda-templates/${templateId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: oneOnOneAgendaTemplateUpdate
    });
  };

export const getUpdateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut
        >
      >,
      TError,
      { templateId: string; data: OneOnOneAgendaTemplateUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut
      >
    >,
    TError,
    { templateId: string; data: OneOnOneAgendaTemplateUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut
        >
      >,
      { templateId: string; data: OneOnOneAgendaTemplateUpdate }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return updateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut
      >
    >
  >;
export type UpdateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPutMutationBody =
  OneOnOneAgendaTemplateUpdate;
export type UpdateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Agenda Template
 */
export const useUpdateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut
          >
        >,
        TError,
        { templateId: string; data: OneOnOneAgendaTemplateUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPut
      >
    >,
    TError,
    { templateId: string; data: OneOnOneAgendaTemplateUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Soft-delete an agenda template. Requires People module admin.

1:1s that used it keep their copied agenda; only the offer to start new
meetings from it goes away.
 * @summary Delete Agenda Template
 */
export const deleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete =
  (templateId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/one-on-one-agenda-templates/${templateId}`,
      method: 'DELETE'
    });
  };

export const getDeleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete
        >
      >,
      TError,
      { templateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete
        >
      >,
      { templateId: string }
    > = (props) => {
      const { templateId } = props ?? {};

      return deleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete(
        templateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete
      >
    >
  >;

export type DeleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Agenda Template
 */
export const useDeleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete
          >
        >,
        TError,
        { templateId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteAgendaTemplateApiV1PeopleOneOnOneAgendaTemplatesTemplateIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Premium Rules
 */
export const listPremiumRulesApiV1PeopleTimePremiumRulesGet = (
  params?: ListPremiumRulesApiV1PeopleTimePremiumRulesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PremiumRuleListResponse>({
    url: `/api/v1/people/time/premium-rules`,
    method: 'GET',
    params,
    signal
  });
};

export const getListPremiumRulesApiV1PeopleTimePremiumRulesGetQueryKey = (
  params?: ListPremiumRulesApiV1PeopleTimePremiumRulesGetParams
) => {
  return [
    `/api/v1/people/time/premium-rules`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListPremiumRulesApiV1PeopleTimePremiumRulesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPremiumRulesApiV1PeopleTimePremiumRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListPremiumRulesApiV1PeopleTimePremiumRulesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>>
  > = ({ signal }) =>
    listPremiumRulesApiV1PeopleTimePremiumRulesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListPremiumRulesApiV1PeopleTimePremiumRulesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>>
  >;
export type ListPremiumRulesApiV1PeopleTimePremiumRulesGetQueryError =
  HTTPValidationError;

export function useListPremiumRulesApiV1PeopleTimePremiumRulesGet<
  TData = Awaited<
    ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListPremiumRulesApiV1PeopleTimePremiumRulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPremiumRulesApiV1PeopleTimePremiumRulesGet<
  TData = Awaited<
    ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPremiumRulesApiV1PeopleTimePremiumRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPremiumRulesApiV1PeopleTimePremiumRulesGet<
  TData = Awaited<
    ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPremiumRulesApiV1PeopleTimePremiumRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Premium Rules
 */

export function useListPremiumRulesApiV1PeopleTimePremiumRulesGet<
  TData = Awaited<
    ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListPremiumRulesApiV1PeopleTimePremiumRulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPremiumRulesApiV1PeopleTimePremiumRulesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPremiumRulesApiV1PeopleTimePremiumRulesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Premium Rule
 */
export const createPremiumRuleApiV1PeopleTimePremiumRulesPost = (
  premiumRuleCreate: PremiumRuleCreate,
  signal?: AbortSignal
) => {
  return customInstance<PremiumRuleResponse>({
    url: `/api/v1/people/time/premium-rules`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: premiumRuleCreate,
    signal
  });
};

export const getCreatePremiumRuleApiV1PeopleTimePremiumRulesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createPremiumRuleApiV1PeopleTimePremiumRulesPost>
      >,
      TError,
      { data: PremiumRuleCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createPremiumRuleApiV1PeopleTimePremiumRulesPost>
    >,
    TError,
    { data: PremiumRuleCreate },
    TContext
  > => {
    const mutationKey = ['createPremiumRuleApiV1PeopleTimePremiumRulesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createPremiumRuleApiV1PeopleTimePremiumRulesPost>
      >,
      { data: PremiumRuleCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createPremiumRuleApiV1PeopleTimePremiumRulesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreatePremiumRuleApiV1PeopleTimePremiumRulesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createPremiumRuleApiV1PeopleTimePremiumRulesPost>>
  >;
export type CreatePremiumRuleApiV1PeopleTimePremiumRulesPostMutationBody =
  PremiumRuleCreate;
export type CreatePremiumRuleApiV1PeopleTimePremiumRulesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Premium Rule
 */
export const useCreatePremiumRuleApiV1PeopleTimePremiumRulesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createPremiumRuleApiV1PeopleTimePremiumRulesPost>
      >,
      TError,
      { data: PremiumRuleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPremiumRuleApiV1PeopleTimePremiumRulesPost>>,
  TError,
  { data: PremiumRuleCreate },
  TContext
> => {
  const mutationOptions =
    getCreatePremiumRuleApiV1PeopleTimePremiumRulesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Premium Rule
 */
export const updatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut = (
  ruleId: string,
  premiumRuleUpdate: PremiumRuleUpdate
) => {
  return customInstance<PremiumRuleResponse>({
    url: `/api/v1/people/time/premium-rules/${ruleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: premiumRuleUpdate
  });
};

export const getUpdatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut>
      >,
      TError,
      { ruleId: string; data: PremiumRuleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut>
    >,
    TError,
    { ruleId: string; data: PremiumRuleUpdate },
    TContext
  > => {
    const mutationKey = [
      'updatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut>
      >,
      { ruleId: string; data: PremiumRuleUpdate }
    > = (props) => {
      const { ruleId, data } = props ?? {};

      return updatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut(
        ruleId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut>
    >
  >;
export type UpdatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPutMutationBody =
  PremiumRuleUpdate;
export type UpdatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Premium Rule
 */
export const useUpdatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut>
      >,
      TError,
      { ruleId: string; data: PremiumRuleUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPut>
  >,
  TError,
  { ruleId: string; data: PremiumRuleUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdatePremiumRuleApiV1PeopleTimePremiumRulesRuleIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Premium Rule
 */
export const deletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete = (
  ruleId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/time/premium-rules/${ruleId}`,
    method: 'DELETE'
  });
};

export const getDeletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete
        >
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete
      >
    >,
    TError,
    { ruleId: string },
    TContext
  > => {
    const mutationKey = [
      'deletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete
        >
      >,
      { ruleId: string }
    > = (props) => {
      const { ruleId } = props ?? {};

      return deletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete(ruleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete
      >
    >
  >;

export type DeletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Premium Rule
 */
export const useDeletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete
        >
      >,
      TError,
      { ruleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDelete>
  >,
  TError,
  { ruleId: string },
  TContext
> => {
  const mutationOptions =
    getDeletePremiumRuleApiV1PeopleTimePremiumRulesRuleIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List Kiosks
 */
export const listKiosksApiV1PeopleTimeKiosksGet = (signal?: AbortSignal) => {
  return customInstance<KioskListResponse>({
    url: `/api/v1/people/time/kiosks`,
    method: 'GET',
    signal
  });
};

export const getListKiosksApiV1PeopleTimeKiosksGetQueryKey = () => {
  return [`/api/v1/people/time/kiosks`] as const;
};

export const getListKiosksApiV1PeopleTimeKiosksGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListKiosksApiV1PeopleTimeKiosksGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>
  > = ({ signal }) => listKiosksApiV1PeopleTimeKiosksGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListKiosksApiV1PeopleTimeKiosksGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>
>;
export type ListKiosksApiV1PeopleTimeKiosksGetQueryError = unknown;

export function useListKiosksApiV1PeopleTimeKiosksGet<
  TData = Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
          TError,
          Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListKiosksApiV1PeopleTimeKiosksGet<
  TData = Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
          TError,
          Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListKiosksApiV1PeopleTimeKiosksGet<
  TData = Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Kiosks
 */

export function useListKiosksApiV1PeopleTimeKiosksGet<
  TData = Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listKiosksApiV1PeopleTimeKiosksGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListKiosksApiV1PeopleTimeKiosksGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Kiosk
 */
export const createKioskApiV1PeopleTimeKiosksPost = (
  kioskCreate: KioskCreate,
  signal?: AbortSignal
) => {
  return customInstance<KioskTokenResponse>({
    url: `/api/v1/people/time/kiosks`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: kioskCreate,
    signal
  });
};

export const getCreateKioskApiV1PeopleTimeKiosksPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKioskApiV1PeopleTimeKiosksPost>>,
    TError,
    { data: KioskCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKioskApiV1PeopleTimeKiosksPost>>,
  TError,
  { data: KioskCreate },
  TContext
> => {
  const mutationKey = ['createKioskApiV1PeopleTimeKiosksPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKioskApiV1PeopleTimeKiosksPost>>,
    { data: KioskCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createKioskApiV1PeopleTimeKiosksPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateKioskApiV1PeopleTimeKiosksPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createKioskApiV1PeopleTimeKiosksPost>>
>;
export type CreateKioskApiV1PeopleTimeKiosksPostMutationBody = KioskCreate;
export type CreateKioskApiV1PeopleTimeKiosksPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Kiosk
 */
export const useCreateKioskApiV1PeopleTimeKiosksPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createKioskApiV1PeopleTimeKiosksPost>>,
      TError,
      { data: KioskCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createKioskApiV1PeopleTimeKiosksPost>>,
  TError,
  { data: KioskCreate },
  TContext
> => {
  const mutationOptions =
    getCreateKioskApiV1PeopleTimeKiosksPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Kiosk
 */
export const updateKioskApiV1PeopleTimeKiosksKioskIdPut = (
  kioskId: string,
  kioskUpdate: KioskUpdate
) => {
  return customInstance<KioskResponse>({
    url: `/api/v1/people/time/kiosks/${kioskId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: kioskUpdate
  });
};

export const getUpdateKioskApiV1PeopleTimeKiosksKioskIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateKioskApiV1PeopleTimeKiosksKioskIdPut>>,
    TError,
    { kioskId: string; data: KioskUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateKioskApiV1PeopleTimeKiosksKioskIdPut>>,
  TError,
  { kioskId: string; data: KioskUpdate },
  TContext
> => {
  const mutationKey = ['updateKioskApiV1PeopleTimeKiosksKioskIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateKioskApiV1PeopleTimeKiosksKioskIdPut>>,
    { kioskId: string; data: KioskUpdate }
  > = (props) => {
    const { kioskId, data } = props ?? {};

    return updateKioskApiV1PeopleTimeKiosksKioskIdPut(kioskId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateKioskApiV1PeopleTimeKiosksKioskIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateKioskApiV1PeopleTimeKiosksKioskIdPut>>
  >;
export type UpdateKioskApiV1PeopleTimeKiosksKioskIdPutMutationBody =
  KioskUpdate;
export type UpdateKioskApiV1PeopleTimeKiosksKioskIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Kiosk
 */
export const useUpdateKioskApiV1PeopleTimeKiosksKioskIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateKioskApiV1PeopleTimeKiosksKioskIdPut>>,
      TError,
      { kioskId: string; data: KioskUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateKioskApiV1PeopleTimeKiosksKioskIdPut>>,
  TError,
  { kioskId: string; data: KioskUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateKioskApiV1PeopleTimeKiosksKioskIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Kiosk
 */
export const deleteKioskApiV1PeopleTimeKiosksKioskIdDelete = (
  kioskId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/time/kiosks/${kioskId}`,
    method: 'DELETE'
  });
};

export const getDeleteKioskApiV1PeopleTimeKiosksKioskIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteKioskApiV1PeopleTimeKiosksKioskIdDelete>>,
    TError,
    { kioskId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteKioskApiV1PeopleTimeKiosksKioskIdDelete>>,
  TError,
  { kioskId: string },
  TContext
> => {
  const mutationKey = ['deleteKioskApiV1PeopleTimeKiosksKioskIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteKioskApiV1PeopleTimeKiosksKioskIdDelete>>,
    { kioskId: string }
  > = (props) => {
    const { kioskId } = props ?? {};

    return deleteKioskApiV1PeopleTimeKiosksKioskIdDelete(kioskId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteKioskApiV1PeopleTimeKiosksKioskIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteKioskApiV1PeopleTimeKiosksKioskIdDelete>>
  >;

export type DeleteKioskApiV1PeopleTimeKiosksKioskIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Kiosk
 */
export const useDeleteKioskApiV1PeopleTimeKiosksKioskIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteKioskApiV1PeopleTimeKiosksKioskIdDelete>>,
      TError,
      { kioskId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteKioskApiV1PeopleTimeKiosksKioskIdDelete>>,
  TError,
  { kioskId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteKioskApiV1PeopleTimeKiosksKioskIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Regenerate Kiosk Token
 */
export const regenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost =
  (kioskId: string, signal?: AbortSignal) => {
    return customInstance<KioskTokenResponse>({
      url: `/api/v1/people/time/kiosks/${kioskId}/regenerate-token`,
      method: 'POST',
      signal
    });
  };

export const getRegenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof regenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost
        >
      >,
      TError,
      { kioskId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof regenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost
      >
    >,
    TError,
    { kioskId: string },
    TContext
  > => {
    const mutationKey = [
      'regenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof regenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost
        >
      >,
      { kioskId: string }
    > = (props) => {
      const { kioskId } = props ?? {};

      return regenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost(
        kioskId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RegenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof regenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost
      >
    >
  >;

export type RegenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPostMutationError =
  HTTPValidationError;

/**
 * @summary Regenerate Kiosk Token
 */
export const useRegenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof regenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost
          >
        >,
        TError,
        { kioskId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof regenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPost
      >
    >,
    TError,
    { kioskId: string },
    TContext
  > => {
    const mutationOptions =
      getRegenerateKioskTokenApiV1PeopleTimeKiosksKioskIdRegenerateTokenPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Set Employee Pin
 */
export const setEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut = (
  employeeId: string,
  setPinRequest: SetPinRequest
) => {
  return customInstance<void>({
    url: `/api/v1/people/employees/${employeeId}/kiosk-pin`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setPinRequest
  });
};

export const getSetEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut
        >
      >,
      TError,
      { employeeId: string; data: SetPinRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof setEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut>
    >,
    TError,
    { employeeId: string; data: SetPinRequest },
    TContext
  > => {
    const mutationKey = [
      'setEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut
        >
      >,
      { employeeId: string; data: SetPinRequest }
    > = (props) => {
      const { employeeId, data } = props ?? {};

      return setEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut(
        employeeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof setEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut>
    >
  >;
export type SetEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPutMutationBody =
  SetPinRequest;
export type SetEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPutMutationError =
  HTTPValidationError;

/**
 * @summary Set Employee Pin
 */
export const useSetEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut
        >
      >,
      TError,
      { employeeId: string; data: SetPinRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof setEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPut>
  >,
  TError,
  { employeeId: string; data: SetPinRequest },
  TContext
> => {
  const mutationOptions =
    getSetEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Clear Employee Pin
 */
export const clearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete = (
  employeeId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/employees/${employeeId}/kiosk-pin`,
    method: 'DELETE'
  });
};

export const getClearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof clearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete
        >
      >,
      TError,
      { employeeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof clearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete
      >
    >,
    TError,
    { employeeId: string },
    TContext
  > => {
    const mutationKey = [
      'clearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof clearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete
        >
      >,
      { employeeId: string }
    > = (props) => {
      const { employeeId } = props ?? {};

      return clearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete(
        employeeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ClearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof clearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete
      >
    >
  >;

export type ClearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Clear Employee Pin
 */
export const useClearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof clearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete
        >
      >,
      TError,
      { employeeId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof clearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDelete
    >
  >,
  TError,
  { employeeId: string },
  TContext
> => {
  const mutationOptions =
    getClearEmployeePinApiV1PeopleEmployeesEmployeeIdKioskPinDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Issue Employee Badge
 */
export const issueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost = (
  employeeId: string,
  signal?: AbortSignal
) => {
  return customInstance<BadgeResponse>({
    url: `/api/v1/people/employees/${employeeId}/kiosk-badge`,
    method: 'POST',
    signal
  });
};

export const getIssueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof issueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost
        >
      >,
      TError,
      { employeeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof issueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost
      >
    >,
    TError,
    { employeeId: string },
    TContext
  > => {
    const mutationKey = [
      'issueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof issueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost
        >
      >,
      { employeeId: string }
    > = (props) => {
      const { employeeId } = props ?? {};

      return issueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost(
        employeeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type IssueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof issueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost
      >
    >
  >;

export type IssueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePostMutationError =
  HTTPValidationError;

/**
 * @summary Issue Employee Badge
 */
export const useIssueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof issueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost
          >
        >,
        TError,
        { employeeId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof issueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePost
      >
    >,
    TError,
    { employeeId: string },
    TContext
  > => {
    const mutationOptions =
      getIssueEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Clear Employee Badge
 */
export const clearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete =
  (employeeId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/employees/${employeeId}/kiosk-badge`,
      method: 'DELETE'
    });
  };

export const getClearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof clearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete
        >
      >,
      TError,
      { employeeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof clearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete
      >
    >,
    TError,
    { employeeId: string },
    TContext
  > => {
    const mutationKey = [
      'clearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof clearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete
        >
      >,
      { employeeId: string }
    > = (props) => {
      const { employeeId } = props ?? {};

      return clearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete(
        employeeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ClearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof clearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete
      >
    >
  >;

export type ClearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Clear Employee Badge
 */
export const useClearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof clearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete
          >
        >,
        TError,
        { employeeId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof clearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDelete
      >
    >,
    TError,
    { employeeId: string },
    TContext
  > => {
    const mutationOptions =
      getClearEmployeeBadgeApiV1PeopleEmployeesEmployeeIdKioskBadgeDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Time Entries
 */
export const listTimeEntriesApiV1PeopleTimeEntriesGet = (
  params?: ListTimeEntriesApiV1PeopleTimeEntriesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<TimeEntryListResponse>({
    url: `/api/v1/people/time/entries`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTimeEntriesApiV1PeopleTimeEntriesGetQueryKey = (
  params?: ListTimeEntriesApiV1PeopleTimeEntriesGetParams
) => {
  return [`/api/v1/people/time/entries`, ...(params ? [params] : [])] as const;
};

export const getListTimeEntriesApiV1PeopleTimeEntriesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
  TError = HTTPValidationError
>(
  params?: ListTimeEntriesApiV1PeopleTimeEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTimeEntriesApiV1PeopleTimeEntriesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>
  > = ({ signal }) => listTimeEntriesApiV1PeopleTimeEntriesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTimeEntriesApiV1PeopleTimeEntriesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>
>;
export type ListTimeEntriesApiV1PeopleTimeEntriesGetQueryError =
  HTTPValidationError;

export function useListTimeEntriesApiV1PeopleTimeEntriesGet<
  TData = Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListTimeEntriesApiV1PeopleTimeEntriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
          TError,
          Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTimeEntriesApiV1PeopleTimeEntriesGet<
  TData = Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
  TError = HTTPValidationError
>(
  params?: ListTimeEntriesApiV1PeopleTimeEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
          TError,
          Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTimeEntriesApiV1PeopleTimeEntriesGet<
  TData = Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
  TError = HTTPValidationError
>(
  params?: ListTimeEntriesApiV1PeopleTimeEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Time Entries
 */

export function useListTimeEntriesApiV1PeopleTimeEntriesGet<
  TData = Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
  TError = HTTPValidationError
>(
  params?: ListTimeEntriesApiV1PeopleTimeEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTimeEntriesApiV1PeopleTimeEntriesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListTimeEntriesApiV1PeopleTimeEntriesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Time Entry
 */
export const createTimeEntryApiV1PeopleTimeEntriesPost = (
  timeEntryCreate: TimeEntryCreate,
  signal?: AbortSignal
) => {
  return customInstance<TimeEntryResponse>({
    url: `/api/v1/people/time/entries`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: timeEntryCreate,
    signal
  });
};

export const getCreateTimeEntryApiV1PeopleTimeEntriesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTimeEntryApiV1PeopleTimeEntriesPost>>,
    TError,
    { data: TimeEntryCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTimeEntryApiV1PeopleTimeEntriesPost>>,
  TError,
  { data: TimeEntryCreate },
  TContext
> => {
  const mutationKey = ['createTimeEntryApiV1PeopleTimeEntriesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTimeEntryApiV1PeopleTimeEntriesPost>>,
    { data: TimeEntryCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createTimeEntryApiV1PeopleTimeEntriesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTimeEntryApiV1PeopleTimeEntriesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createTimeEntryApiV1PeopleTimeEntriesPost>>
  >;
export type CreateTimeEntryApiV1PeopleTimeEntriesPostMutationBody =
  TimeEntryCreate;
export type CreateTimeEntryApiV1PeopleTimeEntriesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Time Entry
 */
export const useCreateTimeEntryApiV1PeopleTimeEntriesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTimeEntryApiV1PeopleTimeEntriesPost>>,
      TError,
      { data: TimeEntryCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTimeEntryApiV1PeopleTimeEntriesPost>>,
  TError,
  { data: TimeEntryCreate },
  TContext
> => {
  const mutationOptions =
    getCreateTimeEntryApiV1PeopleTimeEntriesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Time Entry
 */
export const updateTimeEntryApiV1PeopleTimeEntriesEntryIdPut = (
  entryId: string,
  timeEntryUpdate: TimeEntryUpdate
) => {
  return customInstance<TimeEntryResponse>({
    url: `/api/v1/people/time/entries/${entryId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: timeEntryUpdate
  });
};

export const getUpdateTimeEntryApiV1PeopleTimeEntriesEntryIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTimeEntryApiV1PeopleTimeEntriesEntryIdPut>
      >,
      TError,
      { entryId: string; data: TimeEntryUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateTimeEntryApiV1PeopleTimeEntriesEntryIdPut>>,
    TError,
    { entryId: string; data: TimeEntryUpdate },
    TContext
  > => {
    const mutationKey = ['updateTimeEntryApiV1PeopleTimeEntriesEntryIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateTimeEntryApiV1PeopleTimeEntriesEntryIdPut>
      >,
      { entryId: string; data: TimeEntryUpdate }
    > = (props) => {
      const { entryId, data } = props ?? {};

      return updateTimeEntryApiV1PeopleTimeEntriesEntryIdPut(entryId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTimeEntryApiV1PeopleTimeEntriesEntryIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateTimeEntryApiV1PeopleTimeEntriesEntryIdPut>>
  >;
export type UpdateTimeEntryApiV1PeopleTimeEntriesEntryIdPutMutationBody =
  TimeEntryUpdate;
export type UpdateTimeEntryApiV1PeopleTimeEntriesEntryIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Time Entry
 */
export const useUpdateTimeEntryApiV1PeopleTimeEntriesEntryIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTimeEntryApiV1PeopleTimeEntriesEntryIdPut>
      >,
      TError,
      { entryId: string; data: TimeEntryUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTimeEntryApiV1PeopleTimeEntriesEntryIdPut>>,
  TError,
  { entryId: string; data: TimeEntryUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateTimeEntryApiV1PeopleTimeEntriesEntryIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Time Entry
 */
export const deleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete = (
  entryId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/time/entries/${entryId}`,
    method: 'DELETE'
  });
};

export const getDeleteTimeEntryApiV1PeopleTimeEntriesEntryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete>
      >,
      TError,
      { entryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete>
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationKey = ['deleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete>
      >,
      { entryId: string }
    > = (props) => {
      const { entryId } = props ?? {};

      return deleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete(entryId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTimeEntryApiV1PeopleTimeEntriesEntryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete>
    >
  >;

export type DeleteTimeEntryApiV1PeopleTimeEntriesEntryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Time Entry
 */
export const useDeleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete>
      >,
      TError,
      { entryId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteTimeEntryApiV1PeopleTimeEntriesEntryIdDelete>
  >,
  TError,
  { entryId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteTimeEntryApiV1PeopleTimeEntriesEntryIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Admin Clock In
 */
export const adminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost = (
  employeeId: string,
  signal?: AbortSignal
) => {
  return customInstance<PunchResponse>({
    url: `/api/v1/people/employees/${employeeId}/time/clock-in`,
    method: 'POST',
    signal
  });
};

export const getAdminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof adminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost
        >
      >,
      TError,
      { employeeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof adminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost
      >
    >,
    TError,
    { employeeId: string },
    TContext
  > => {
    const mutationKey = [
      'adminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof adminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost
        >
      >,
      { employeeId: string }
    > = (props) => {
      const { employeeId } = props ?? {};

      return adminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost(
        employeeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AdminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof adminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost
      >
    >
  >;

export type AdminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPostMutationError =
  HTTPValidationError;

/**
 * @summary Admin Clock In
 */
export const useAdminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof adminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost
        >
      >,
      TError,
      { employeeId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof adminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPost>
  >,
  TError,
  { employeeId: string },
  TContext
> => {
  const mutationOptions =
    getAdminClockInApiV1PeopleEmployeesEmployeeIdTimeClockInPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Admin Clock Out
 */
export const adminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost = (
  employeeId: string,
  signal?: AbortSignal
) => {
  return customInstance<PunchResponse>({
    url: `/api/v1/people/employees/${employeeId}/time/clock-out`,
    method: 'POST',
    signal
  });
};

export const getAdminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof adminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost
        >
      >,
      TError,
      { employeeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof adminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost
      >
    >,
    TError,
    { employeeId: string },
    TContext
  > => {
    const mutationKey = [
      'adminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof adminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost
        >
      >,
      { employeeId: string }
    > = (props) => {
      const { employeeId } = props ?? {};

      return adminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost(
        employeeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AdminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof adminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost
      >
    >
  >;

export type AdminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPostMutationError =
  HTTPValidationError;

/**
 * @summary Admin Clock Out
 */
export const useAdminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof adminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost
        >
      >,
      TError,
      { employeeId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof adminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPost
    >
  >,
  TError,
  { employeeId: string },
  TContext
> => {
  const mutationOptions =
    getAdminClockOutApiV1PeopleEmployeesEmployeeIdTimeClockOutPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary My Active Entry
 */
export const myActiveEntryApiV1PeopleTimeMeActiveGet = (
  signal?: AbortSignal
) => {
  return customInstance<MyActiveEntryApiV1PeopleTimeMeActiveGet200>({
    url: `/api/v1/people/time/me/active`,
    method: 'GET',
    signal
  });
};

export const getMyActiveEntryApiV1PeopleTimeMeActiveGetQueryKey = () => {
  return [`/api/v1/people/time/me/active`] as const;
};

export const getMyActiveEntryApiV1PeopleTimeMeActiveGetQueryOptions = <
  TData = Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMyActiveEntryApiV1PeopleTimeMeActiveGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>
  > = ({ signal }) => myActiveEntryApiV1PeopleTimeMeActiveGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MyActiveEntryApiV1PeopleTimeMeActiveGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>
>;
export type MyActiveEntryApiV1PeopleTimeMeActiveGetQueryError = unknown;

export function useMyActiveEntryApiV1PeopleTimeMeActiveGet<
  TData = Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
          TError,
          Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useMyActiveEntryApiV1PeopleTimeMeActiveGet<
  TData = Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
          TError,
          Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMyActiveEntryApiV1PeopleTimeMeActiveGet<
  TData = Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary My Active Entry
 */

export function useMyActiveEntryApiV1PeopleTimeMeActiveGet<
  TData = Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myActiveEntryApiV1PeopleTimeMeActiveGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getMyActiveEntryApiV1PeopleTimeMeActiveGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary My Entries
 */
export const myEntriesApiV1PeopleTimeMeEntriesGet = (
  params?: MyEntriesApiV1PeopleTimeMeEntriesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<TimeEntryListResponse>({
    url: `/api/v1/people/time/me/entries`,
    method: 'GET',
    params,
    signal
  });
};

export const getMyEntriesApiV1PeopleTimeMeEntriesGetQueryKey = (
  params?: MyEntriesApiV1PeopleTimeMeEntriesGetParams
) => {
  return [
    `/api/v1/people/time/me/entries`,
    ...(params ? [params] : [])
  ] as const;
};

export const getMyEntriesApiV1PeopleTimeMeEntriesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
  TError = HTTPValidationError
>(
  params?: MyEntriesApiV1PeopleTimeMeEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMyEntriesApiV1PeopleTimeMeEntriesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>
  > = ({ signal }) => myEntriesApiV1PeopleTimeMeEntriesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MyEntriesApiV1PeopleTimeMeEntriesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>
>;
export type MyEntriesApiV1PeopleTimeMeEntriesGetQueryError =
  HTTPValidationError;

export function useMyEntriesApiV1PeopleTimeMeEntriesGet<
  TData = Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | MyEntriesApiV1PeopleTimeMeEntriesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
          TError,
          Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useMyEntriesApiV1PeopleTimeMeEntriesGet<
  TData = Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
  TError = HTTPValidationError
>(
  params?: MyEntriesApiV1PeopleTimeMeEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
          TError,
          Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMyEntriesApiV1PeopleTimeMeEntriesGet<
  TData = Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
  TError = HTTPValidationError
>(
  params?: MyEntriesApiV1PeopleTimeMeEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary My Entries
 */

export function useMyEntriesApiV1PeopleTimeMeEntriesGet<
  TData = Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
  TError = HTTPValidationError
>(
  params?: MyEntriesApiV1PeopleTimeMeEntriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEntriesApiV1PeopleTimeMeEntriesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMyEntriesApiV1PeopleTimeMeEntriesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary My Clock In
 */
export const myClockInApiV1PeopleTimeMeClockInPost = (signal?: AbortSignal) => {
  return customInstance<PunchResponse>({
    url: `/api/v1/people/time/me/clock-in`,
    method: 'POST',
    signal
  });
};

export const getMyClockInApiV1PeopleTimeMeClockInPostMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof myClockInApiV1PeopleTimeMeClockInPost>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof myClockInApiV1PeopleTimeMeClockInPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['myClockInApiV1PeopleTimeMeClockInPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof myClockInApiV1PeopleTimeMeClockInPost>>,
    void
  > = () => {
    return myClockInApiV1PeopleTimeMeClockInPost();
  };

  return { mutationFn, ...mutationOptions };
};

export type MyClockInApiV1PeopleTimeMeClockInPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof myClockInApiV1PeopleTimeMeClockInPost>>
>;

export type MyClockInApiV1PeopleTimeMeClockInPostMutationError = unknown;

/**
 * @summary My Clock In
 */
export const useMyClockInApiV1PeopleTimeMeClockInPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof myClockInApiV1PeopleTimeMeClockInPost>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof myClockInApiV1PeopleTimeMeClockInPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getMyClockInApiV1PeopleTimeMeClockInPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary My Clock Out
 */
export const myClockOutApiV1PeopleTimeMeClockOutPost = (
  signal?: AbortSignal
) => {
  return customInstance<PunchResponse>({
    url: `/api/v1/people/time/me/clock-out`,
    method: 'POST',
    signal
  });
};

export const getMyClockOutApiV1PeopleTimeMeClockOutPostMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof myClockOutApiV1PeopleTimeMeClockOutPost>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof myClockOutApiV1PeopleTimeMeClockOutPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['myClockOutApiV1PeopleTimeMeClockOutPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof myClockOutApiV1PeopleTimeMeClockOutPost>>,
    void
  > = () => {
    return myClockOutApiV1PeopleTimeMeClockOutPost();
  };

  return { mutationFn, ...mutationOptions };
};

export type MyClockOutApiV1PeopleTimeMeClockOutPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof myClockOutApiV1PeopleTimeMeClockOutPost>>
>;

export type MyClockOutApiV1PeopleTimeMeClockOutPostMutationError = unknown;

/**
 * @summary My Clock Out
 */
export const useMyClockOutApiV1PeopleTimeMeClockOutPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof myClockOutApiV1PeopleTimeMeClockOutPost>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof myClockOutApiV1PeopleTimeMeClockOutPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getMyClockOutApiV1PeopleTimeMeClockOutPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Timesheet
 */
export const getTimesheetApiV1PeopleTimeTimesheetGet = (
  params: GetTimesheetApiV1PeopleTimeTimesheetGetParams,
  signal?: AbortSignal
) => {
  return customInstance<TimesheetResponse>({
    url: `/api/v1/people/time/timesheet`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetTimesheetApiV1PeopleTimeTimesheetGetQueryKey = (
  params?: GetTimesheetApiV1PeopleTimeTimesheetGetParams
) => {
  return [
    `/api/v1/people/time/timesheet`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetTimesheetApiV1PeopleTimeTimesheetGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
  TError = HTTPValidationError
>(
  params: GetTimesheetApiV1PeopleTimeTimesheetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTimesheetApiV1PeopleTimeTimesheetGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>
  > = ({ signal }) => getTimesheetApiV1PeopleTimeTimesheetGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTimesheetApiV1PeopleTimeTimesheetGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>
>;
export type GetTimesheetApiV1PeopleTimeTimesheetGetQueryError =
  HTTPValidationError;

export function useGetTimesheetApiV1PeopleTimeTimesheetGet<
  TData = Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
  TError = HTTPValidationError
>(
  params: GetTimesheetApiV1PeopleTimeTimesheetGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
          TError,
          Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTimesheetApiV1PeopleTimeTimesheetGet<
  TData = Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
  TError = HTTPValidationError
>(
  params: GetTimesheetApiV1PeopleTimeTimesheetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
          TError,
          Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTimesheetApiV1PeopleTimeTimesheetGet<
  TData = Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
  TError = HTTPValidationError
>(
  params: GetTimesheetApiV1PeopleTimeTimesheetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Timesheet
 */

export function useGetTimesheetApiV1PeopleTimeTimesheetGet<
  TData = Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
  TError = HTTPValidationError
>(
  params: GetTimesheetApiV1PeopleTimeTimesheetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimesheetApiV1PeopleTimeTimesheetGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTimesheetApiV1PeopleTimeTimesheetGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Currently Clocked In
 */
export const getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet = (
  signal?: AbortSignal
) => {
  return customInstance<ClockedInResponse>({
    url: `/api/v1/people/time/currently-clocked-in`,
    method: 'GET',
    signal
  });
};

export const getGetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGetQueryKey =
  () => {
    return [`/api/v1/people/time/currently-clocked-in`] as const;
  };

export const getGetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
        >
      >
    > = ({ signal }) =>
      getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
      >
    >
  >;
export type GetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGetQueryError =
  unknown;

export function useGetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet<
  TData = Awaited<
    ReturnType<typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet<
  TData = Awaited<
    ReturnType<typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet<
  TData = Awaited<
    ReturnType<typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Currently Clocked In
 */

export function useGetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet<
  TData = Awaited<
    ReturnType<typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCurrentlyClockedInApiV1PeopleTimeCurrentlyClockedInGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Export Time Entries Csv
 */
export const exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet = (
  params: ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/people/time/entries/export`,
    method: 'GET',
    params,
    signal
  });
};

export const getExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetQueryKey = (
  params?: ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetParams
) => {
  return [
    `/api/v1/people/time/entries/export`,
    ...(params ? [params] : [])
  ] as const;
};

export const getExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
    >,
    TError = HTTPValidationError
  >(
    params: ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
      >
    > = ({ signal }) =>
      exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
    >
  >;
export type ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetQueryError =
  HTTPValidationError;

export function useExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet<
  TData = Awaited<
    ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
  >,
  TError = HTTPValidationError
>(
  params: ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet<
  TData = Awaited<
    ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
  >,
  TError = HTTPValidationError
>(
  params: ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet<
  TData = Awaited<
    ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
  >,
  TError = HTTPValidationError
>(
  params: ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Time Entries Csv
 */

export function useExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet<
  TData = Awaited<
    ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
  >,
  TError = HTTPValidationError
>(
  params: ExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportTimeEntriesCsvApiV1PeopleTimeEntriesExportGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportTimeEntriesCsvApiV1PeopleTimeEntriesExportGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Import Time Entries Csv
 */
export const importTimeEntriesCsvApiV1PeopleTimeEntriesImportPost = (
  bodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost: BodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `file`,
    bodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost.file
  );

  return customInstance<ImportResultResponse>({
    url: `/api/v1/people/time/entries/import`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof importTimeEntriesCsvApiV1PeopleTimeEntriesImportPost>
      >,
      TError,
      { data: BodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof importTimeEntriesCsvApiV1PeopleTimeEntriesImportPost>
    >,
    TError,
    { data: BodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost },
    TContext
  > => {
    const mutationKey = [
      'importTimeEntriesCsvApiV1PeopleTimeEntriesImportPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof importTimeEntriesCsvApiV1PeopleTimeEntriesImportPost>
      >,
      { data: BodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost }
    > = (props) => {
      const { data } = props ?? {};

      return importTimeEntriesCsvApiV1PeopleTimeEntriesImportPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof importTimeEntriesCsvApiV1PeopleTimeEntriesImportPost>
    >
  >;
export type ImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPostMutationBody =
  BodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost;
export type ImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPostMutationError =
  HTTPValidationError;

/**
 * @summary Import Time Entries Csv
 */
export const useImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof importTimeEntriesCsvApiV1PeopleTimeEntriesImportPost>
      >,
      TError,
      { data: BodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof importTimeEntriesCsvApiV1PeopleTimeEntriesImportPost>
  >,
  TError,
  { data: BodyImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPost },
  TContext
> => {
  const mutationOptions =
    getImportTimeEntriesCsvApiV1PeopleTimeEntriesImportPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Ingest Punch
 */
export const ingestPunchApiV1PeopleTimeIngestPost = (
  ingestPunchRequest: IngestPunchRequest,
  signal?: AbortSignal
) => {
  return customInstance<PunchResponse>({
    url: `/api/v1/people/time/ingest`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: ingestPunchRequest,
    signal
  });
};

export const getIngestPunchApiV1PeopleTimeIngestPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ingestPunchApiV1PeopleTimeIngestPost>>,
    TError,
    { data: IngestPunchRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ingestPunchApiV1PeopleTimeIngestPost>>,
  TError,
  { data: IngestPunchRequest },
  TContext
> => {
  const mutationKey = ['ingestPunchApiV1PeopleTimeIngestPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ingestPunchApiV1PeopleTimeIngestPost>>,
    { data: IngestPunchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return ingestPunchApiV1PeopleTimeIngestPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type IngestPunchApiV1PeopleTimeIngestPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof ingestPunchApiV1PeopleTimeIngestPost>>
>;
export type IngestPunchApiV1PeopleTimeIngestPostMutationBody =
  IngestPunchRequest;
export type IngestPunchApiV1PeopleTimeIngestPostMutationError =
  HTTPValidationError;

/**
 * @summary Ingest Punch
 */
export const useIngestPunchApiV1PeopleTimeIngestPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ingestPunchApiV1PeopleTimeIngestPost>>,
      TError,
      { data: IngestPunchRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof ingestPunchApiV1PeopleTimeIngestPost>>,
  TError,
  { data: IngestPunchRequest },
  TContext
> => {
  const mutationOptions =
    getIngestPunchApiV1PeopleTimeIngestPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List HR approval policies. Requires People module admin.

Shape B — a tenant curates a handful of routing rules and the settings page
slices them client-side, so an omitted ``limit`` returns the whole set
(``ui-list-pages.md`` § 11).
 * @summary List Approval Policies
 */
export const listApprovalPoliciesApiV1PeopleApprovalPoliciesGet = (
  params?: ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleApprovalPolicyListResponse>({
    url: `/api/v1/people/approval-policies`,
    method: 'GET',
    params,
    signal
  });
};

export const getListApprovalPoliciesApiV1PeopleApprovalPoliciesGetQueryKey = (
  params?: ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetParams
) => {
  return [
    `/api/v1/people/approval-policies`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListApprovalPoliciesApiV1PeopleApprovalPoliciesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListApprovalPoliciesApiV1PeopleApprovalPoliciesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
      >
    > = ({ signal }) =>
      listApprovalPoliciesApiV1PeopleApprovalPoliciesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
    >
  >;
export type ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetQueryError =
  HTTPValidationError;

export function useListApprovalPoliciesApiV1PeopleApprovalPoliciesGet<
  TData = Awaited<
    ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListApprovalPoliciesApiV1PeopleApprovalPoliciesGet<
  TData = Awaited<
    ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListApprovalPoliciesApiV1PeopleApprovalPoliciesGet<
  TData = Awaited<
    ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Approval Policies
 */

export function useListApprovalPoliciesApiV1PeopleApprovalPoliciesGet<
  TData = Awaited<
    ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApprovalPoliciesApiV1PeopleApprovalPoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApprovalPoliciesApiV1PeopleApprovalPoliciesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListApprovalPoliciesApiV1PeopleApprovalPoliciesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create an HR approval policy. Requires People module admin.
 * @summary Create Approval Policy
 */
export const createApprovalPolicyApiV1PeopleApprovalPoliciesPost = (
  peopleApprovalPolicyCreate: PeopleApprovalPolicyCreate,
  signal?: AbortSignal
) => {
  return customInstance<PeopleApprovalPolicyResponse>({
    url: `/api/v1/people/approval-policies`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: peopleApprovalPolicyCreate,
    signal
  });
};

export const getCreateApprovalPolicyApiV1PeopleApprovalPoliciesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createApprovalPolicyApiV1PeopleApprovalPoliciesPost>
      >,
      TError,
      { data: PeopleApprovalPolicyCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createApprovalPolicyApiV1PeopleApprovalPoliciesPost>
    >,
    TError,
    { data: PeopleApprovalPolicyCreate },
    TContext
  > => {
    const mutationKey = ['createApprovalPolicyApiV1PeopleApprovalPoliciesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createApprovalPolicyApiV1PeopleApprovalPoliciesPost>
      >,
      { data: PeopleApprovalPolicyCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createApprovalPolicyApiV1PeopleApprovalPoliciesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateApprovalPolicyApiV1PeopleApprovalPoliciesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createApprovalPolicyApiV1PeopleApprovalPoliciesPost>
    >
  >;
export type CreateApprovalPolicyApiV1PeopleApprovalPoliciesPostMutationBody =
  PeopleApprovalPolicyCreate;
export type CreateApprovalPolicyApiV1PeopleApprovalPoliciesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Approval Policy
 */
export const useCreateApprovalPolicyApiV1PeopleApprovalPoliciesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createApprovalPolicyApiV1PeopleApprovalPoliciesPost>
      >,
      TError,
      { data: PeopleApprovalPolicyCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createApprovalPolicyApiV1PeopleApprovalPoliciesPost>
  >,
  TError,
  { data: PeopleApprovalPolicyCreate },
  TContext
> => {
  const mutationOptions =
    getCreateApprovalPolicyApiV1PeopleApprovalPoliciesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get one HR approval policy. Requires People module admin.
 * @summary Get Approval Policy
 */
export const getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet = (
  policyId: string,
  signal?: AbortSignal
) => {
  return customInstance<PeopleApprovalPolicyResponse>({
    url: `/api/v1/people/approval-policies/${policyId}`,
    method: 'GET',
    signal
  });
};

export const getGetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGetQueryKey =
  (policyId?: string) => {
    return [`/api/v1/people/approval-policies/${policyId}`] as const;
  };

export const getGetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet>
    >,
    TError = HTTPValidationError
  >(
    policyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGetQueryKey(
        policyId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
        >
      >
    > = ({ signal }) =>
      getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet(policyId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!policyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet>
    >
  >;
export type GetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGetQueryError =
  HTTPValidationError;

export function useGetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Approval Policy
 */

export function useGetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet<
  TData = Awaited<
    ReturnType<typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet>
  >,
  TError = HTTPValidationError
>(
  policyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdGetQueryOptions(
      policyId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an HR approval policy. Requires People module admin.

An omitted key is untouched; an explicit ``null`` clears the field, which for a
scope dimension WIDENS the policy to "any" — so the approver shape is re-checked
against the row as it will BE, not against the patch.
 * @summary Update Approval Policy
 */
export const updateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut = (
  policyId: string,
  peopleApprovalPolicyUpdate: PeopleApprovalPolicyUpdate
) => {
  return customInstance<PeopleApprovalPolicyResponse>({
    url: `/api/v1/people/approval-policies/${policyId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: peopleApprovalPolicyUpdate
  });
};

export const getUpdateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut
        >
      >,
      TError,
      { policyId: string; data: PeopleApprovalPolicyUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut
      >
    >,
    TError,
    { policyId: string; data: PeopleApprovalPolicyUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut
        >
      >,
      { policyId: string; data: PeopleApprovalPolicyUpdate }
    > = (props) => {
      const { policyId, data } = props ?? {};

      return updateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut(
        policyId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut
      >
    >
  >;
export type UpdateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPutMutationBody =
  PeopleApprovalPolicyUpdate;
export type UpdateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Approval Policy
 */
export const useUpdateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut
        >
      >,
      TError,
      { policyId: string; data: PeopleApprovalPolicyUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPut
    >
  >,
  TError,
  { policyId: string; data: PeopleApprovalPolicyUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retire an HR approval policy (soft delete). Requires People module admin.

Requests it already routed keep their rows — ``policy_id`` is ``ON DELETE SET
NULL`` precisely so retiring a policy cannot delete a decision waiting on it.
 * @summary Delete Approval Policy
 */
export const deleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete = (
  policyId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/approval-policies/${policyId}`,
    method: 'DELETE'
  });
};

export const getDeleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete
        >
      >,
      TError,
      { policyId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete
      >
    >,
    TError,
    { policyId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete
        >
      >,
      { policyId: string }
    > = (props) => {
      const { policyId } = props ?? {};

      return deleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete(
        policyId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete
      >
    >
  >;

export type DeleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Approval Policy
 */
export const useDeleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete
          >
        >,
        TError,
        { policyId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDelete
      >
    >,
    TError,
    { policyId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteApprovalPolicyApiV1PeopleApprovalPoliciesPolicyIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The caller's approval queue. Defaults to what is still awaiting a decision.

Shape A — the table accumulates a row per change forever, so it pages.

**Bounded to what the caller may ACT on**, never to what exists: the requests
naming them, or naming a group they belong to. A caller who approves nothing
gets an empty page rather than an unbounded read (the repository's predicate
fails closed). ``employee_id`` narrows within that bound; it can never widen it.
 * @summary List Approval Requests
 */
export const listApprovalRequestsApiV1PeopleApprovalRequestsGet = (
  params?: ListApprovalRequestsApiV1PeopleApprovalRequestsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<PeopleApprovalRequestListResponse>({
    url: `/api/v1/people/approval-requests`,
    method: 'GET',
    params,
    signal
  });
};

export const getListApprovalRequestsApiV1PeopleApprovalRequestsGetQueryKey = (
  params?: ListApprovalRequestsApiV1PeopleApprovalRequestsGetParams
) => {
  return [
    `/api/v1/people/approval-requests`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListApprovalRequestsApiV1PeopleApprovalRequestsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListApprovalRequestsApiV1PeopleApprovalRequestsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListApprovalRequestsApiV1PeopleApprovalRequestsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
      >
    > = ({ signal }) =>
      listApprovalRequestsApiV1PeopleApprovalRequestsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListApprovalRequestsApiV1PeopleApprovalRequestsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
    >
  >;
export type ListApprovalRequestsApiV1PeopleApprovalRequestsGetQueryError =
  HTTPValidationError;

export function useListApprovalRequestsApiV1PeopleApprovalRequestsGet<
  TData = Awaited<
    ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListApprovalRequestsApiV1PeopleApprovalRequestsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListApprovalRequestsApiV1PeopleApprovalRequestsGet<
  TData = Awaited<
    ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApprovalRequestsApiV1PeopleApprovalRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListApprovalRequestsApiV1PeopleApprovalRequestsGet<
  TData = Awaited<
    ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApprovalRequestsApiV1PeopleApprovalRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Approval Requests
 */

export function useListApprovalRequestsApiV1PeopleApprovalRequestsGet<
  TData = Awaited<
    ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApprovalRequestsApiV1PeopleApprovalRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApprovalRequestsApiV1PeopleApprovalRequestsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListApprovalRequestsApiV1PeopleApprovalRequestsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One approval request — for an approver, or for whoever raised it.
 * @summary Get Approval Request
 */
export const getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet = (
  requestId: string,
  signal?: AbortSignal
) => {
  return customInstance<PeopleApprovalRequestResponse>({
    url: `/api/v1/people/approval-requests/${requestId}`,
    method: 'GET',
    signal
  });
};

export const getGetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGetQueryKey =
  (requestId?: string) => {
    return [`/api/v1/people/approval-requests/${requestId}`] as const;
  };

export const getGetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    requestId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGetQueryKey(
        requestId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
        >
      >
    > = ({ signal }) =>
      getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet(
        requestId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!requestId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
      >
    >
  >;
export type GetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGetQueryError =
  HTTPValidationError;

export function useGetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Approval Request
 */

export function useGetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet>
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApprovalRequestApiV1PeopleApprovalRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetApprovalRequestApiV1PeopleApprovalRequestsRequestIdGetQueryOptions(
      requestId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Approve a staged change — this is what WRITES the effective-dated row.
 * @summary Approve Approval Request
 */
export const approveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost =
  (
    requestId: string,
    peopleApprovalRequestDecision: PeopleApprovalRequestDecision,
    signal?: AbortSignal
  ) => {
    return customInstance<PeopleApprovalRequestResponse>({
      url: `/api/v1/people/approval-requests/${requestId}/approve`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: peopleApprovalRequestDecision,
      signal
    });
  };

export const getApproveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof approveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost
        >
      >,
      TError,
      { requestId: string; data: PeopleApprovalRequestDecision },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof approveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost
      >
    >,
    TError,
    { requestId: string; data: PeopleApprovalRequestDecision },
    TContext
  > => {
    const mutationKey = [
      'approveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof approveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost
        >
      >,
      { requestId: string; data: PeopleApprovalRequestDecision }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return approveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApproveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof approveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost
      >
    >
  >;
export type ApproveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePostMutationBody =
  PeopleApprovalRequestDecision;
export type ApproveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePostMutationError =
  HTTPValidationError;

/**
 * @summary Approve Approval Request
 */
export const useApproveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof approveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost
          >
        >,
        TError,
        { requestId: string; data: PeopleApprovalRequestDecision },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof approveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePost
      >
    >,
    TError,
    { requestId: string; data: PeopleApprovalRequestDecision },
    TContext
  > => {
    const mutationOptions =
      getApproveApprovalRequestApiV1PeopleApprovalRequestsRequestIdApprovePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Refuse a staged change. Nothing is written to the effective-dated tables.
 * @summary Reject Approval Request
 */
export const rejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost =
  (
    requestId: string,
    peopleApprovalRequestDecision: PeopleApprovalRequestDecision,
    signal?: AbortSignal
  ) => {
    return customInstance<PeopleApprovalRequestResponse>({
      url: `/api/v1/people/approval-requests/${requestId}/reject`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: peopleApprovalRequestDecision,
      signal
    });
  };

export const getRejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof rejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost
        >
      >,
      TError,
      { requestId: string; data: PeopleApprovalRequestDecision },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof rejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost
      >
    >,
    TError,
    { requestId: string; data: PeopleApprovalRequestDecision },
    TContext
  > => {
    const mutationKey = [
      'rejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof rejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost
        >
      >,
      { requestId: string; data: PeopleApprovalRequestDecision }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return rejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof rejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost
      >
    >
  >;
export type RejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPostMutationBody =
  PeopleApprovalRequestDecision;
export type RejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPostMutationError =
  HTTPValidationError;

/**
 * @summary Reject Approval Request
 */
export const useRejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof rejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost
          >
        >,
        TError,
        { requestId: string; data: PeopleApprovalRequestDecision },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof rejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPost
      >
    >,
    TError,
    { requestId: string; data: PeopleApprovalRequestDecision },
    TContext
  > => {
    const mutationOptions =
      getRejectApprovalRequestApiV1PeopleApprovalRequestsRequestIdRejectPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Withdraw a staged change before a decision — the requester or an approver.
 * @summary Cancel Approval Request
 */
export const cancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost =
  (
    requestId: string,
    peopleApprovalRequestDecision: PeopleApprovalRequestDecision,
    signal?: AbortSignal
  ) => {
    return customInstance<PeopleApprovalRequestResponse>({
      url: `/api/v1/people/approval-requests/${requestId}/cancel`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: peopleApprovalRequestDecision,
      signal
    });
  };

export const getCancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost
        >
      >,
      TError,
      { requestId: string; data: PeopleApprovalRequestDecision },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost
      >
    >,
    TError,
    { requestId: string; data: PeopleApprovalRequestDecision },
    TContext
  > => {
    const mutationKey = [
      'cancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost
        >
      >,
      { requestId: string; data: PeopleApprovalRequestDecision }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return cancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost
      >
    >
  >;
export type CancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPostMutationBody =
  PeopleApprovalRequestDecision;
export type CancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Approval Request
 */
export const useCancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost
          >
        >,
        TError,
        { requestId: string; data: PeopleApprovalRequestDecision },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPost
      >
    >,
    TError,
    { requestId: string; data: PeopleApprovalRequestDecision },
    TContext
  > => {
    const mutationOptions =
      getCancelApprovalRequestApiV1PeopleApprovalRequestsRequestIdCancelPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The tenant's survey definitions.

Shape A: a survey is never deleted in normal business — a finished one is
closed and then archived — so the set only grows, and the caller pages.

`question_count` and `wave_count` are batch-loaded for the whole page — a
per-row count would be an N+1 on a list whose every row shows both.
 * @summary List Surveys
 */
export const listSurveysApiV1PeopleSurveysGet = (
  params?: ListSurveysApiV1PeopleSurveysGetParams,
  signal?: AbortSignal
) => {
  return customInstance<SurveyListResponse>({
    url: `/api/v1/people/surveys`,
    method: 'GET',
    params,
    signal
  });
};

export const getListSurveysApiV1PeopleSurveysGetQueryKey = (
  params?: ListSurveysApiV1PeopleSurveysGetParams
) => {
  return [`/api/v1/people/surveys`, ...(params ? [params] : [])] as const;
};

export const getListSurveysApiV1PeopleSurveysGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
  TError = HTTPValidationError
>(
  params?: ListSurveysApiV1PeopleSurveysGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListSurveysApiV1PeopleSurveysGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>
  > = ({ signal }) => listSurveysApiV1PeopleSurveysGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListSurveysApiV1PeopleSurveysGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>
>;
export type ListSurveysApiV1PeopleSurveysGetQueryError = HTTPValidationError;

export function useListSurveysApiV1PeopleSurveysGet<
  TData = Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListSurveysApiV1PeopleSurveysGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
          TError,
          Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListSurveysApiV1PeopleSurveysGet<
  TData = Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
  TError = HTTPValidationError
>(
  params?: ListSurveysApiV1PeopleSurveysGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
          TError,
          Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSurveysApiV1PeopleSurveysGet<
  TData = Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
  TError = HTTPValidationError
>(
  params?: ListSurveysApiV1PeopleSurveysGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Surveys
 */

export function useListSurveysApiV1PeopleSurveysGet<
  TData = Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
  TError = HTTPValidationError
>(
  params?: ListSurveysApiV1PeopleSurveysGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSurveysApiV1PeopleSurveysGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListSurveysApiV1PeopleSurveysGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Draft a survey. It has no questions and no waves yet, so it cannot be
launched until it does.
 * @summary Create Survey
 */
export const createSurveyApiV1PeopleSurveysPost = (
  surveyCreate: SurveyCreate,
  signal?: AbortSignal
) => {
  return customInstance<SurveyResponseModel>({
    url: `/api/v1/people/surveys`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: surveyCreate,
    signal
  });
};

export const getCreateSurveyApiV1PeopleSurveysPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSurveyApiV1PeopleSurveysPost>>,
    TError,
    { data: SurveyCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSurveyApiV1PeopleSurveysPost>>,
  TError,
  { data: SurveyCreate },
  TContext
> => {
  const mutationKey = ['createSurveyApiV1PeopleSurveysPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSurveyApiV1PeopleSurveysPost>>,
    { data: SurveyCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createSurveyApiV1PeopleSurveysPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSurveyApiV1PeopleSurveysPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSurveyApiV1PeopleSurveysPost>>
>;
export type CreateSurveyApiV1PeopleSurveysPostMutationBody = SurveyCreate;
export type CreateSurveyApiV1PeopleSurveysPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Survey
 */
export const useCreateSurveyApiV1PeopleSurveysPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSurveyApiV1PeopleSurveysPost>>,
      TError,
      { data: SurveyCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSurveyApiV1PeopleSurveysPost>>,
  TError,
  { data: SurveyCreate },
  TContext
> => {
  const mutationOptions =
    getCreateSurveyApiV1PeopleSurveysPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Survey
 */
export const getSurveyApiV1PeopleSurveysSurveyIdGet = (
  surveyId: string,
  signal?: AbortSignal
) => {
  return customInstance<SurveyResponseModel>({
    url: `/api/v1/people/surveys/${surveyId}`,
    method: 'GET',
    signal
  });
};

export const getGetSurveyApiV1PeopleSurveysSurveyIdGetQueryKey = (
  surveyId?: string
) => {
  return [`/api/v1/people/surveys/${surveyId}`] as const;
};

export const getGetSurveyApiV1PeopleSurveysSurveyIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSurveyApiV1PeopleSurveysSurveyIdGetQueryKey(surveyId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>
  > = ({ signal }) => getSurveyApiV1PeopleSurveysSurveyIdGet(surveyId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!surveyId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSurveyApiV1PeopleSurveysSurveyIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>
>;
export type GetSurveyApiV1PeopleSurveysSurveyIdGetQueryError =
  HTTPValidationError;

export function useGetSurveyApiV1PeopleSurveysSurveyIdGet<
  TData = Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
  TError = HTTPValidationError
>(
  surveyId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
          TError,
          Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSurveyApiV1PeopleSurveysSurveyIdGet<
  TData = Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
          TError,
          Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSurveyApiV1PeopleSurveysSurveyIdGet<
  TData = Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Survey
 */

export function useGetSurveyApiV1PeopleSurveysSurveyIdGet<
  TData = Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSurveyApiV1PeopleSurveysSurveyIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSurveyApiV1PeopleSurveysSurveyIdGetQueryOptions(
    surveyId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Patch a survey definition.

The anonymity threshold and mode are editable — a tenant may tighten or
relax them — but the service validates the range, because a threshold of 1
would silently retire the whole promise.
 * @summary Update Survey
 */
export const updateSurveyApiV1PeopleSurveysSurveyIdPut = (
  surveyId: string,
  surveyUpdate: SurveyUpdate
) => {
  return customInstance<SurveyResponseModel>({
    url: `/api/v1/people/surveys/${surveyId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: surveyUpdate
  });
};

export const getUpdateSurveyApiV1PeopleSurveysSurveyIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSurveyApiV1PeopleSurveysSurveyIdPut>>,
    TError,
    { surveyId: string; data: SurveyUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSurveyApiV1PeopleSurveysSurveyIdPut>>,
  TError,
  { surveyId: string; data: SurveyUpdate },
  TContext
> => {
  const mutationKey = ['updateSurveyApiV1PeopleSurveysSurveyIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSurveyApiV1PeopleSurveysSurveyIdPut>>,
    { surveyId: string; data: SurveyUpdate }
  > = (props) => {
    const { surveyId, data } = props ?? {};

    return updateSurveyApiV1PeopleSurveysSurveyIdPut(surveyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSurveyApiV1PeopleSurveysSurveyIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateSurveyApiV1PeopleSurveysSurveyIdPut>>
  >;
export type UpdateSurveyApiV1PeopleSurveysSurveyIdPutMutationBody =
  SurveyUpdate;
export type UpdateSurveyApiV1PeopleSurveysSurveyIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Survey
 */
export const useUpdateSurveyApiV1PeopleSurveysSurveyIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSurveyApiV1PeopleSurveysSurveyIdPut>>,
      TError,
      { surveyId: string; data: SurveyUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateSurveyApiV1PeopleSurveysSurveyIdPut>>,
  TError,
  { surveyId: string; data: SurveyUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateSurveyApiV1PeopleSurveysSurveyIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete a survey. Its waves and their responses are untouched: a
result already gathered under an anonymity promise is not an admin's to
destroy by deleting the questionnaire it came from.
 * @summary Delete Survey
 */
export const deleteSurveyApiV1PeopleSurveysSurveyIdDelete = (
  surveyId: string
) => {
  return customInstance<void>({
    url: `/api/v1/people/surveys/${surveyId}`,
    method: 'DELETE'
  });
};

export const getDeleteSurveyApiV1PeopleSurveysSurveyIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSurveyApiV1PeopleSurveysSurveyIdDelete>>,
    TError,
    { surveyId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSurveyApiV1PeopleSurveysSurveyIdDelete>>,
  TError,
  { surveyId: string },
  TContext
> => {
  const mutationKey = ['deleteSurveyApiV1PeopleSurveysSurveyIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSurveyApiV1PeopleSurveysSurveyIdDelete>>,
    { surveyId: string }
  > = (props) => {
    const { surveyId } = props ?? {};

    return deleteSurveyApiV1PeopleSurveysSurveyIdDelete(surveyId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSurveyApiV1PeopleSurveysSurveyIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteSurveyApiV1PeopleSurveysSurveyIdDelete>>
  >;

export type DeleteSurveyApiV1PeopleSurveysSurveyIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Survey
 */
export const useDeleteSurveyApiV1PeopleSurveysSurveyIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSurveyApiV1PeopleSurveysSurveyIdDelete>>,
      TError,
      { surveyId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSurveyApiV1PeopleSurveysSurveyIdDelete>>,
  TError,
  { surveyId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteSurveyApiV1PeopleSurveysSurveyIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List Survey Questions
 */
export const listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet = (
  surveyId: string,
  signal?: AbortSignal
) => {
  return customInstance<SurveyQuestionResponse[]>({
    url: `/api/v1/people/surveys/${surveyId}/questions`,
    method: 'GET',
    signal
  });
};

export const getListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGetQueryKey =
  (surveyId?: string) => {
    return [`/api/v1/people/surveys/${surveyId}/questions`] as const;
  };

export const getListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    surveyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGetQueryKey(
        surveyId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
        >
      >
    > = ({ signal }) =>
      listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet(
        surveyId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!surveyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
      >
    >
  >;
export type ListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGetQueryError =
  HTTPValidationError;

export function useListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet<
  TData = Awaited<
    ReturnType<typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet<
  TData = Awaited<
    ReturnType<typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet<
  TData = Awaited<
    ReturnType<typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Survey Questions
 */

export function useListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet<
  TData = Awaited<
    ReturnType<typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListSurveyQuestionsApiV1PeopleSurveysSurveyIdQuestionsGetQueryOptions(
      surveyId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a question. An eNPS question is given the canonical 0-10 scale and
the standard prompt wording by the service — the bands only mean what they
mean on that scale.
 * @summary Create Survey Question
 */
export const createSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost = (
  surveyId: string,
  surveyQuestionCreate: SurveyQuestionCreate,
  signal?: AbortSignal
) => {
  return customInstance<SurveyQuestionResponse>({
    url: `/api/v1/people/surveys/${surveyId}/questions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: surveyQuestionCreate,
    signal
  });
};

export const getCreateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost
        >
      >,
      TError,
      { surveyId: string; data: SurveyQuestionCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost
      >
    >,
    TError,
    { surveyId: string; data: SurveyQuestionCreate },
    TContext
  > => {
    const mutationKey = [
      'createSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost
        >
      >,
      { surveyId: string; data: SurveyQuestionCreate }
    > = (props) => {
      const { surveyId, data } = props ?? {};

      return createSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost(
        surveyId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost
      >
    >
  >;
export type CreateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPostMutationBody =
  SurveyQuestionCreate;
export type CreateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Survey Question
 */
export const useCreateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost
        >
      >,
      TError,
      { surveyId: string; data: SurveyQuestionCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPost
    >
  >,
  TError,
  { surveyId: string; data: SurveyQuestionCreate },
  TContext
> => {
  const mutationOptions =
    getCreateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Patch a question. `question_type` is deliberately absent from the update
payload: answers already stored under the old type's shape would be silently
restated as something they never were.
 * @summary Update Survey Question
 */
export const updateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut =
  (
    surveyId: string,
    questionId: string,
    surveyQuestionUpdate: SurveyQuestionUpdate
  ) => {
    return customInstance<SurveyQuestionResponse>({
      url: `/api/v1/people/surveys/${surveyId}/questions/${questionId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: surveyQuestionUpdate
    });
  };

export const getUpdateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut
        >
      >,
      TError,
      { surveyId: string; questionId: string; data: SurveyQuestionUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut
      >
    >,
    TError,
    { surveyId: string; questionId: string; data: SurveyQuestionUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut
        >
      >,
      { surveyId: string; questionId: string; data: SurveyQuestionUpdate }
    > = (props) => {
      const { surveyId, questionId, data } = props ?? {};

      return updateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut(
        surveyId,
        questionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut
      >
    >
  >;
export type UpdateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPutMutationBody =
  SurveyQuestionUpdate;
export type UpdateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Survey Question
 */
export const useUpdateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut
          >
        >,
        TError,
        { surveyId: string; questionId: string; data: SurveyQuestionUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPut
      >
    >,
    TError,
    { surveyId: string; questionId: string; data: SurveyQuestionUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Soft-delete a question. Answers already given to it stay in the table and
stop being reported — removing them would change a past wave's numbers.
 * @summary Delete Survey Question
 */
export const deleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete =
  (surveyId: string, questionId: string) => {
    return customInstance<void>({
      url: `/api/v1/people/surveys/${surveyId}/questions/${questionId}`,
      method: 'DELETE'
    });
  };

export const getDeleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete
        >
      >,
      TError,
      { surveyId: string; questionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete
      >
    >,
    TError,
    { surveyId: string; questionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete
        >
      >,
      { surveyId: string; questionId: string }
    > = (props) => {
      const { surveyId, questionId } = props ?? {};

      return deleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete(
        surveyId,
        questionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete
      >
    >
  >;

export type DeleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Survey Question
 */
export const useDeleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete
          >
        >,
        TError,
        { surveyId: string; questionId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDelete
      >
    >,
    TError,
    { surveyId: string; questionId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteSurveyQuestionApiV1PeopleSurveysSurveyIdQuestionsQuestionIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Open a wave now: resolve the audience, write the participant rows and
notify everyone who has a login.

The notification is emitted HERE rather than inside the service, so that a
scheduled sweep and this button share one launch path and differ only in who
they tell.
 * @summary Launch Survey
 */
export const launchSurveyApiV1PeopleSurveysSurveyIdLaunchPost = (
  surveyId: string,
  surveyLaunch: SurveyLaunch,
  signal?: AbortSignal
) => {
  return customInstance<SurveyWaveResponse>({
    url: `/api/v1/people/surveys/${surveyId}/launch`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: surveyLaunch,
    signal
  });
};

export const getLaunchSurveyApiV1PeopleSurveysSurveyIdLaunchPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof launchSurveyApiV1PeopleSurveysSurveyIdLaunchPost>
      >,
      TError,
      { surveyId: string; data: SurveyLaunch },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof launchSurveyApiV1PeopleSurveysSurveyIdLaunchPost>
    >,
    TError,
    { surveyId: string; data: SurveyLaunch },
    TContext
  > => {
    const mutationKey = ['launchSurveyApiV1PeopleSurveysSurveyIdLaunchPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof launchSurveyApiV1PeopleSurveysSurveyIdLaunchPost>
      >,
      { surveyId: string; data: SurveyLaunch }
    > = (props) => {
      const { surveyId, data } = props ?? {};

      return launchSurveyApiV1PeopleSurveysSurveyIdLaunchPost(surveyId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type LaunchSurveyApiV1PeopleSurveysSurveyIdLaunchPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof launchSurveyApiV1PeopleSurveysSurveyIdLaunchPost>>
  >;
export type LaunchSurveyApiV1PeopleSurveysSurveyIdLaunchPostMutationBody =
  SurveyLaunch;
export type LaunchSurveyApiV1PeopleSurveysSurveyIdLaunchPostMutationError =
  HTTPValidationError;

/**
 * @summary Launch Survey
 */
export const useLaunchSurveyApiV1PeopleSurveysSurveyIdLaunchPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof launchSurveyApiV1PeopleSurveysSurveyIdLaunchPost>
      >,
      TError,
      { surveyId: string; data: SurveyLaunch },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof launchSurveyApiV1PeopleSurveysSurveyIdLaunchPost>>,
  TError,
  { surveyId: string; data: SurveyLaunch },
  TContext
> => {
  const mutationOptions =
    getLaunchSurveyApiV1PeopleSurveysSurveyIdLaunchPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Every run of this survey, oldest first. Not paginated: a wave list is as
long as the survey has been running, which is single digits per year.
 * @summary List Survey Waves
 */
export const listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet = (
  surveyId: string,
  signal?: AbortSignal
) => {
  return customInstance<SurveyWaveListResponse>({
    url: `/api/v1/people/surveys/${surveyId}/waves`,
    method: 'GET',
    signal
  });
};

export const getListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGetQueryKey = (
  surveyId?: string
) => {
  return [`/api/v1/people/surveys/${surveyId}/waves`] as const;
};

export const getListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
    >,
    TError = HTTPValidationError
  >(
    surveyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGetQueryKey(surveyId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
      >
    > = ({ signal }) =>
      listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet(surveyId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!surveyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
    >
  >;
export type ListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGetQueryError =
  HTTPValidationError;

export function useListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet<
  TData = Awaited<
    ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet<
  TData = Awaited<
    ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet<
  TData = Awaited<
    ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Survey Waves
 */

export function useListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet<
  TData = Awaited<
    ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listSurveyWavesApiV1PeopleSurveysSurveyIdWavesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListSurveyWavesApiV1PeopleSurveysSurveyIdWavesGetQueryOptions(
      surveyId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Stop accepting responses. Idempotent — closing a closed wave is a no-op
rather than a refusal, because the auto-close sweep and an admin's button can
legitimately race.
 * @summary Close Survey Wave
 */
export const closeSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost = (
  surveyId: string,
  waveId: string,
  signal?: AbortSignal
) => {
  return customInstance<SurveyWaveResponse>({
    url: `/api/v1/people/surveys/${surveyId}/waves/${waveId}/close`,
    method: 'POST',
    signal
  });
};

export const getCloseSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof closeSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost
        >
      >,
      TError,
      { surveyId: string; waveId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof closeSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost
      >
    >,
    TError,
    { surveyId: string; waveId: string },
    TContext
  > => {
    const mutationKey = [
      'closeSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof closeSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost
        >
      >,
      { surveyId: string; waveId: string }
    > = (props) => {
      const { surveyId, waveId } = props ?? {};

      return closeSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost(
        surveyId,
        waveId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CloseSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof closeSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost
      >
    >
  >;

export type CloseSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePostMutationError =
  HTTPValidationError;

/**
 * @summary Close Survey Wave
 */
export const useCloseSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof closeSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost
          >
        >,
        TError,
        { surveyId: string; waveId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof closeSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePost
      >
    >,
    TError,
    { surveyId: string; waveId: string },
    TContext
  > => {
    const mutationOptions =
      getCloseSurveyWaveApiV1PeopleSurveysSurveyIdWavesWaveIdClosePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * One wave's numbers, per question, ALREADY suppressed.

A suppressed group's VALUES do not travel: a score withheld only by a
`hidden` prop is still in the network tab, and this is precisely the surface
where that matters. The service is what withholds them, and it is the only
layer that does — suppression is never re-decided here.

The suppressed question itself DOES travel, carrying `suppressed: true`, its
reason and its respondent count. Dropping the row would be § A2's other
failure: rendering nothing says "nobody answered this", which is a different
and false claim, and it leaves the reader unable to tell a withheld question
from a question that was never asked.
 * @summary Get Survey Wave Results
 */
export const getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet =
  (surveyId: string, waveId: string, signal?: AbortSignal) => {
    return customInstance<SurveyResults>({
      url: `/api/v1/people/surveys/${surveyId}/waves/${waveId}/results`,
      method: 'GET',
      signal
    });
  };

export const getGetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGetQueryKey =
  (surveyId?: string, waveId?: string) => {
    return [
      `/api/v1/people/surveys/${surveyId}/waves/${waveId}/results`
    ] as const;
  };

export const getGetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
      >
    >,
    TError = HTTPValidationError
  >(
    surveyId: string,
    waveId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGetQueryKey(
        surveyId,
        waveId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
        >
      >
    > = ({ signal }) =>
      getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet(
        surveyId,
        waveId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(surveyId && waveId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
      >
    >
  >;
export type GetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGetQueryError =
  HTTPValidationError;

export function useGetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet<
  TData = Awaited<
    ReturnType<
      typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet<
  TData = Awaited<
    ReturnType<
      typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet<
  TData = Awaited<
    ReturnType<
      typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Survey Wave Results
 */

export function useGetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet<
  TData = Awaited<
    ReturnType<
      typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSurveyWaveResultsApiV1PeopleSurveysSurveyIdWavesWaveIdResultsGetQueryOptions(
      surveyId,
      waveId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One wave split by department, office or tenure band — suppressed group by
group.

In strong mode the number of suppressed groups is never exactly one, so a
withheld group cannot be recovered by subtracting the visible ones from the
wave total (§ A3).
 * @summary Get Survey Wave Breakdown
 */
export const getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet =
  (
    surveyId: string,
    waveId: string,
    params?: GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<SurveyBreakdown>({
      url: `/api/v1/people/surveys/${surveyId}/waves/${waveId}/breakdown`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetQueryKey =
  (
    surveyId?: string,
    waveId?: string,
    params?: GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetParams
  ) => {
    return [
      `/api/v1/people/surveys/${surveyId}/waves/${waveId}/breakdown`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
      >
    >,
    TError = HTTPValidationError
  >(
    surveyId: string,
    waveId: string,
    params?: GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetQueryKey(
        surveyId,
        waveId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
        >
      >
    > = ({ signal }) =>
      getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet(
        surveyId,
        waveId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(surveyId && waveId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
      >
    >
  >;
export type GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetQueryError =
  HTTPValidationError;

export function useGetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet<
  TData = Awaited<
    ReturnType<
      typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  params:
    | undefined
    | GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet<
  TData = Awaited<
    ReturnType<
      typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  params?: GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet<
  TData = Awaited<
    ReturnType<
      typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  params?: GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Survey Wave Breakdown
 */

export function useGetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet<
  TData = Awaited<
    ReturnType<
      typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  params?: GetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSurveyWaveBreakdownApiV1PeopleSurveysSurveyIdWavesWaveIdBreakdownGetQueryOptions(
      surveyId,
      waveId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One question's series across every wave, each point suppressed on its own.

A wave that did not clear the threshold is a GAP, never a zero: a zero on an
eNPS chart reads as neutral engagement, which is a claim about people rather
than about a wave nobody answered.
 * @summary Get Survey Trend
 */
export const getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet = (
  surveyId: string,
  params: GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetParams,
  signal?: AbortSignal
) => {
  return customInstance<SurveyTrend>({
    url: `/api/v1/people/surveys/${surveyId}/trend`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetQueryKey = (
  surveyId?: string,
  params?: GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetParams
) => {
  return [
    `/api/v1/people/surveys/${surveyId}/trend`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  params: GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetQueryKey(
      surveyId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>>
  > = ({ signal }) =>
    getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet(surveyId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!surveyId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>>
  >;
export type GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetQueryError =
  HTTPValidationError;

export function useGetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet<
  TData = Awaited<
    ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  params: GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet<
  TData = Awaited<
    ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  params: GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet<
  TData = Awaited<
    ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  params: GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Survey Trend
 */

export function useGetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet<
  TData = Awaited<
    ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  params: GetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSurveyTrendApiV1PeopleSurveysSurveyIdTrendGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSurveyTrendApiV1PeopleSurveysSurveyIdTrendGetQueryOptions(
      surveyId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Who was invited and who has answered — NOT what anyone said.

Participation is identified and answers are not, and the invitation copy
says so in as many words. This route is what makes the reminder sweep and the
participation rate possible; nothing here joins to a response.

Paged, unlike the wave and action lists beside it: a whole-company wave's
audience is the tenant's headcount.
 * @summary List Survey Participants
 */
export const listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet =
  (
    surveyId: string,
    waveId: string,
    params?: ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<SurveyParticipantListResponse>({
      url: `/api/v1/people/surveys/${surveyId}/waves/${waveId}/participants`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetQueryKey =
  (
    surveyId?: string,
    waveId?: string,
    params?: ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetParams
  ) => {
    return [
      `/api/v1/people/surveys/${surveyId}/waves/${waveId}/participants`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
      >
    >,
    TError = HTTPValidationError
  >(
    surveyId: string,
    waveId: string,
    params?: ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetQueryKey(
        surveyId,
        waveId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
        >
      >
    > = ({ signal }) =>
      listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet(
        surveyId,
        waveId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(surveyId && waveId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
      >
    >
  >;
export type ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetQueryError =
  HTTPValidationError;

export function useListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet<
  TData = Awaited<
    ReturnType<
      typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  params:
    | undefined
    | ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet<
  TData = Awaited<
    ReturnType<
      typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  params?: ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet<
  TData = Awaited<
    ReturnType<
      typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  params?: ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Survey Participants
 */

export function useListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet<
  TData = Awaited<
    ReturnType<
      typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  params?: ListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListSurveyParticipantsApiV1PeopleSurveysSurveyIdWavesWaveIdParticipantsGetQueryOptions(
      surveyId,
      waveId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The follow-up Tasks raised from this wave, filtered to the ones this
caller may see.

The visibility answer is the Tasks module's, asked through its public seam:
a task on a board this reader is not a member of is simply absent, and
`total` is the LENGTH of that filtered list rather than a separate count —
one filtered set, so the badge cannot describe a set the list does not show.
 * @summary List Survey Actions
 */
export const listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet =
  (surveyId: string, waveId: string, signal?: AbortSignal) => {
    return customInstance<SurveyActionListResponse>({
      url: `/api/v1/people/surveys/${surveyId}/waves/${waveId}/actions`,
      method: 'GET',
      signal
    });
  };

export const getListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGetQueryKey =
  (surveyId?: string, waveId?: string) => {
    return [
      `/api/v1/people/surveys/${surveyId}/waves/${waveId}/actions`
    ] as const;
  };

export const getListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    surveyId: string,
    waveId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGetQueryKey(
        surveyId,
        waveId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
        >
      >
    > = ({ signal }) =>
      listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet(
        surveyId,
        waveId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(surveyId && waveId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
      >
    >
  >;
export type ListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGetQueryError =
  HTTPValidationError;

export function useListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet<
  TData = Awaited<
    ReturnType<
      typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet<
  TData = Awaited<
    ReturnType<
      typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet<
  TData = Awaited<
    ReturnType<
      typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Survey Actions
 */

export function useListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet<
  TData = Awaited<
    ReturnType<
      typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
    >
  >,
  TError = HTTPValidationError
>(
  surveyId: string,
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListSurveyActionsApiV1PeopleSurveysSurveyIdWavesWaveIdActionsGetQueryOptions(
      surveyId,
      waveId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Turn a result into a tracked Task on a board the caller names.

The board is named in the BODY, so the People admin gate in front of this
route says nothing about it. Planting a task here must cost exactly what
planting one on that board directly costs
(`.claude/rules/rules-entity-link-far-side.md`).

People does not write `tasks_tasks`: the task is created through the Tasks
module's own seam and this module keeps only the link row.
 * @summary Create Survey Action
 */
export const createSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost =
  (
    surveyId: string,
    waveId: string,
    surveyActionCreate: SurveyActionCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<SurveyActionResponse>({
      url: `/api/v1/people/surveys/${surveyId}/waves/${waveId}/actions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: surveyActionCreate,
      signal
    });
  };

export const getCreateSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost
        >
      >,
      TError,
      { surveyId: string; waveId: string; data: SurveyActionCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost
      >
    >,
    TError,
    { surveyId: string; waveId: string; data: SurveyActionCreate },
    TContext
  > => {
    const mutationKey = [
      'createSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost
        >
      >,
      { surveyId: string; waveId: string; data: SurveyActionCreate }
    > = (props) => {
      const { surveyId, waveId, data } = props ?? {};

      return createSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost(
        surveyId,
        waveId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost
      >
    >
  >;
export type CreateSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPostMutationBody =
  SurveyActionCreate;
export type CreateSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Survey Action
 */
export const useCreateSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost
          >
        >,
        TError,
        { surveyId: string; waveId: string; data: SurveyActionCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPost
      >
    >,
    TError,
    { surveyId: string; waveId: string; data: SurveyActionCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateSurveyActionApiV1PeopleSurveysSurveyIdWavesWaveIdActionsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The calling employee's open invitations, soonest deadline first.

Bounded by the caller's own participant rows — there is no parameter that
could widen it, which is why this route needs no gate beyond authentication.
 * @summary List My Surveys
 */
export const listMySurveysApiV1PeopleMeSurveysGet = (
  params?: ListMySurveysApiV1PeopleMeSurveysGetParams,
  signal?: AbortSignal
) => {
  return customInstance<SurveyInvitationListResponse>({
    url: `/api/v1/people/me/surveys`,
    method: 'GET',
    params,
    signal
  });
};

export const getListMySurveysApiV1PeopleMeSurveysGetQueryKey = (
  params?: ListMySurveysApiV1PeopleMeSurveysGetParams
) => {
  return [`/api/v1/people/me/surveys`, ...(params ? [params] : [])] as const;
};

export const getListMySurveysApiV1PeopleMeSurveysGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
  TError = HTTPValidationError
>(
  params?: ListMySurveysApiV1PeopleMeSurveysGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListMySurveysApiV1PeopleMeSurveysGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>
  > = ({ signal }) => listMySurveysApiV1PeopleMeSurveysGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListMySurveysApiV1PeopleMeSurveysGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>
>;
export type ListMySurveysApiV1PeopleMeSurveysGetQueryError =
  HTTPValidationError;

export function useListMySurveysApiV1PeopleMeSurveysGet<
  TData = Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListMySurveysApiV1PeopleMeSurveysGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
          TError,
          Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMySurveysApiV1PeopleMeSurveysGet<
  TData = Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
  TError = HTTPValidationError
>(
  params?: ListMySurveysApiV1PeopleMeSurveysGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
          TError,
          Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMySurveysApiV1PeopleMeSurveysGet<
  TData = Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
  TError = HTTPValidationError
>(
  params?: ListMySurveysApiV1PeopleMeSurveysGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List My Surveys
 */

export function useListMySurveysApiV1PeopleMeSurveysGet<
  TData = Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
  TError = HTTPValidationError
>(
  params?: ListMySurveysApiV1PeopleMeSurveysGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMySurveysApiV1PeopleMeSurveysGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListMySurveysApiV1PeopleMeSurveysGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The questionnaire to answer.

A wave the caller was not invited to — or has already answered — is a 404,
not a 403: a distinct refusal would confirm that a survey exists and that
somebody in the caller's reach was asked.
 * @summary Get My Survey
 */
export const getMySurveyApiV1PeopleMeSurveysWaveIdGet = (
  waveId: string,
  signal?: AbortSignal
) => {
  return customInstance<SurveyQuestionnaire>({
    url: `/api/v1/people/me/surveys/${waveId}`,
    method: 'GET',
    signal
  });
};

export const getGetMySurveyApiV1PeopleMeSurveysWaveIdGetQueryKey = (
  waveId?: string
) => {
  return [`/api/v1/people/me/surveys/${waveId}`] as const;
};

export const getGetMySurveyApiV1PeopleMeSurveysWaveIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
  TError = HTTPValidationError
>(
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMySurveyApiV1PeopleMeSurveysWaveIdGetQueryKey(waveId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>
  > = ({ signal }) => getMySurveyApiV1PeopleMeSurveysWaveIdGet(waveId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!waveId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMySurveyApiV1PeopleMeSurveysWaveIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>
>;
export type GetMySurveyApiV1PeopleMeSurveysWaveIdGetQueryError =
  HTTPValidationError;

export function useGetMySurveyApiV1PeopleMeSurveysWaveIdGet<
  TData = Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
  TError = HTTPValidationError
>(
  waveId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
          TError,
          Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMySurveyApiV1PeopleMeSurveysWaveIdGet<
  TData = Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
  TError = HTTPValidationError
>(
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
          TError,
          Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMySurveyApiV1PeopleMeSurveysWaveIdGet<
  TData = Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
  TError = HTTPValidationError
>(
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get My Survey
 */

export function useGetMySurveyApiV1PeopleMeSurveysWaveIdGet<
  TData = Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
  TError = HTTPValidationError
>(
  waveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMySurveyApiV1PeopleMeSurveysWaveIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMySurveyApiV1PeopleMeSurveysWaveIdGetQueryOptions(
    waveId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Submit the questionnaire. Two writes, deliberately unlinked.

The response carries the respondent's GROUP — department, office, tenure
band — and nothing else; the participant row is stamped 'responded' so the
reminder sweep stops nudging them. Nothing joins the two, and this route
returns 204 rather than the stored response precisely because there is no
response for this caller to be handed back: it is not theirs any more.
 * @summary Submit My Survey Response
 */
export const submitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost = (
  waveId: string,
  surveyResponseSubmit: SurveyResponseSubmit,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `/api/v1/people/me/surveys/${waveId}/responses`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: surveyResponseSubmit,
    signal
  });
};

export const getSubmitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof submitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost
        >
      >,
      TError,
      { waveId: string; data: SurveyResponseSubmit },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof submitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost
      >
    >,
    TError,
    { waveId: string; data: SurveyResponseSubmit },
    TContext
  > => {
    const mutationKey = [
      'submitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof submitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost
        >
      >,
      { waveId: string; data: SurveyResponseSubmit }
    > = (props) => {
      const { waveId, data } = props ?? {};

      return submitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost(
        waveId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SubmitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof submitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost
      >
    >
  >;
export type SubmitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPostMutationBody =
  SurveyResponseSubmit;
export type SubmitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit My Survey Response
 */
export const useSubmitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof submitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost
          >
        >,
        TError,
        { waveId: string; data: SurveyResponseSubmit },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof submitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPost
      >
    >,
    TError,
    { waveId: string; data: SurveyResponseSubmit },
    TContext
  > => {
    const mutationOptions =
      getSubmitMySurveyResponseApiV1PeopleMeSurveysWaveIdResponsesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
